/*! Synot Games (c) 2025, Games Library, version: 1.5.141 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("NeoCommon"));
	else if(typeof define === 'function' && define.amd)
		define(["NeoCommon"], factory);
	else if(typeof exports === 'object')
		exports["NeoGames"] = factory(require("NeoCommon"));
	else
		root["NeoGames"] = factory(root["NeoCommon"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	neo_common_1.libraryInitialize();
	var ClientHost = __webpack_require__(2);
	exports.ClientHost = ClientHost;
	var GameEngine = __webpack_require__(17);
	exports.GameEngine = GameEngine;
	var Communication = __webpack_require__(43);
	exports.Communication = Communication;
	var RealityCheck = __webpack_require__(132);
	exports.RealityCheck = RealityCheck;
	var Platforms = __webpack_require__(10);
	exports.Platforms = Platforms;
	var Plugins = __webpack_require__(14);
	exports.Plugins = Plugins;


/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var ClientHostBase_1 = __webpack_require__(3);
	exports.ClientHostBase = ClientHostBase_1.ClientHostBase;
	var ClientHostConsumerBase_1 = __webpack_require__(4);
	exports.ClientHostConsumerBase = ClientHostConsumerBase_1.ClientHostConsumerBase;
	var ClientHostFactory_1 = __webpack_require__(5);
	exports.ClientHostFactory = ClientHostFactory_1.ClientHostFactory;
	exports.registerClientHost = ClientHostFactory_1.registerClientHost;
	var ClientHostDesktop_1 = __webpack_require__(6);
	exports.ClientHostDesktop = ClientHostDesktop_1.ClientHostDesktop;
	var ClientHostDefault_1 = __webpack_require__(9);
	exports.ClientHostDefault = ClientHostDefault_1.ClientHostDefault;
	var Types = __webpack_require__(7);
	exports.Types = Types;
	var Consts = __webpack_require__(8);
	exports.Consts = Consts;
	var GameEvents_1 = __webpack_require__(42);
	exports.GameEvents = GameEvents_1.GameEvents;


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	function eventEmitterLogMessage(isError, group, message, error) {
	    if (false) {
	        if (isError) {
	            neo_common_1.Logger.errorGroup(group, error, message);
	        }
	        else {
	            neo_common_1.Logger.debugGroup(group, message);
	        }
	    }
	}
	var ClientHostBase = (function () {
	    function ClientHostBase(clientHostConsumer) {
	        this._clientHostConsumer = clientHostConsumer;
	        this._eventEmitter = new neo_common_1.EventEmitterCached(neo_common_1.createEventEmmiter(), 5, this.type, eventEmitterLogMessage);
	        this.dispatchAction = this.dispatchAction.bind(this);
	        this.dispatchExit = this.dispatchExit.bind(this);
	    }
	    ClientHostBase.prototype.initialize = function (appContext) {
	        this._appContext = appContext;
	        return this.doInitialize();
	    };
	    Object.defineProperty(ClientHostBase.prototype, "version", {
	        get: function () { },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClientHostBase.prototype, "type", {
	        get: function () { },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClientHostBase.prototype, "supports", {
	        get: function () { },
	        enumerable: true,
	        configurable: true
	    });
	    ClientHostBase.prototype.on = function (event, callback) {
	        this._eventEmitter.on(event, callback);
	    };
	    ClientHostBase.prototype.removeEventListener = function (event) {
	        try {
	            this._eventEmitter.removeAllListeners(event);
	        }
	        catch (err) {
	            neo_common_1.Logger.errorGroup(this.type, "remote all listeners for event '" + event + "' throws error.", err);
	        }
	    };
	    ClientHostBase.prototype.emitEvent = function (event) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        try {
	            (_a = this._eventEmitter).emit.apply(_a, [event].concat(args));
	        }
	        catch (err) {
	            neo_common_1.Logger.errorGroup(this.type, "emit event '" + event + "' throws error.", err);
	        }
	        var _a;
	    };
	    ClientHostBase.prototype.dispatchAction = function (actionGroup, action) {
	        this._clientHostConsumer.handleAction(actionGroup.toString(), action);
	    };
	    ClientHostBase.prototype.dispatchExit = function (request, callback) {
	        this._clientHostConsumer.handleExit(request, callback);
	    };
	    ClientHostBase.prototype.dispatchRefreshAccount = function () {
	        this._clientHostConsumer.handleRefreshAccount();
	    };
	    ClientHostBase.prototype.dispatchError = function (error, data) {
	        this._clientHostConsumer.handleError(error, data);
	    };
	    ClientHostBase.prototype.dispatchPaytableRequest = function (request) {
	        this._clientHostConsumer.handlePaytableRequest(request);
	    };
	    ClientHostBase.prototype.emitEventExternalMessage = function (message, externalSourceId) {
	        this.emitEvent('external-message', message, externalSourceId);
	    };
	    ClientHostBase.prototype.sendMessageToExternal = function (message, targetExternalIds) {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), ("sendMessageToExternal(targetExternalId: " + JSON.stringify(targetExternalIds) + ") ") +
	                ("message: " + JSON.stringify(message)));
	        }
	    };
	    return ClientHostBase;
	}());
	exports.ClientHostBase = ClientHostBase;


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var ClientHostConsumerBase = (function () {
	    function ClientHostConsumerBase(app) {
	        neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(app, 'app');
	        this._app = app;
	    }
	    return ClientHostConsumerBase;
	}());
	exports.ClientHostConsumerBase = ClientHostConsumerBase;
	function updateClientHost(clientHostConsumer, clientHost) {
	    clientHostConsumer._clientHost = clientHost;
	}
	exports.updateClientHost = updateClientHost;


/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var ClientHostFactory = (function () {
	    function ClientHostFactory() {
	    }
	    ClientHostFactory.register = function (component, componentType) {
	        var cmpName = component.name;
	        if (cmpName === undefined || cmpName === '') {
	            throw new Error('[ClientHostFactory] specified component does not contain property "name"');
	        }
	        if (componentType === undefined || componentType === '') {
	            throw new Error('[ClientHostFactory] component type was not specified!');
	        }
	        var list = ClientHostFactory.list;
	        var reg = list[componentType];
	        if (!reg) {
	            list[componentType] = {
	                component: component,
	                type: componentType
	            };
	            this.count++;
	            if (false) {
	                neo_common_1.Logger.debugGroup('Register client host', ("Client host '" + cmpName + "' (type: " + componentType + ")")
	                    + (" was successfully registered (" + this.count + " so far)."));
	            }
	        }
	        else {
	            throw new Error(("[ClientHostFactory] Client host \"" + cmpName + "\" (type: " + componentType + ")")
	                + " is already registered!");
	        }
	    };
	    ClientHostFactory.create = function (type, consumer) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(type, 'type');
	        var list = ClientHostFactory.list;
	        var reg = neo_common_1.lodash.find(list, function (item) { return neo_common_1.StringUtils.equals(item.type, type, true); });
	        if (reg) {
	            var classType = reg.component;
	            return new classType(consumer);
	        }
	        if (false) {
	            neo_common_1.Logger.debugGroup('[ClientHostFactory]', "Create('" + type + "') could not found client host with such type!");
	        }
	        return null;
	    };
	    ClientHostFactory.list = {};
	    ClientHostFactory.count = 0;
	    return ClientHostFactory;
	}());
	exports.ClientHostFactory = ClientHostFactory;
	function registerClientHost(componentType) {
	    return function (component) {
	        ClientHostFactory.register(component, componentType);
	        component.prototype.__componentName__ = component.name;
	        component.prototype.__componentType__ = componentType;
	    };
	}
	exports.registerClientHost = registerClientHost;
	var isBrowser = typeof window !== 'undefined';
	if (isBrowser) {
	    var win = window;
	    win['registerClientHost'] = registerClientHost;
	}


/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(1);
	var ClientHostFactory_1 = __webpack_require__(5);
	var Types_1 = __webpack_require__(7);
	var Constants_1 = __webpack_require__(8);
	var ClientHostDefault_1 = __webpack_require__(9);
	var version = '1';
	var typeName = 'Desktop';
	var ClientHostDesktop = (function (_super) {
	    __extends(ClientHostDesktop, _super);
	    function ClientHostDesktop(clientHostConsumer) {
	        _super.call(this, clientHostConsumer);
	        this.handleKeySpacebar = this.handleKeySpacebar.bind(this);
	        neo_common_1.KeyboardUtils.bindKeyRelease('space', this.handleKeySpacebar);
	    }
	    ClientHostDesktop.prototype.getLogger = function () {
	        return 'ClientHostDesktop';
	    };
	    ClientHostDesktop.prototype.handleKeySpacebar = function () {
	        this.dispatchAction(Types_1.ClientHostActionGroup.Default, Constants_1.DefaultGameActions.ActionSpinOrStop);
	    };
	    Object.defineProperty(ClientHostDesktop.prototype, "version", {
	        get: function () {
	            return version;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClientHostDesktop.prototype, "type", {
	        get: function () {
	            return typeName;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ClientHostDesktop = __decorate([
	        ClientHostFactory_1.registerClientHost(typeName)
	    ], ClientHostDesktop);
	    return ClientHostDesktop;
	}(ClientHostDefault_1.ClientHostDefault));
	exports.ClientHostDesktop = ClientHostDesktop;


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	(function (ClientHostActionGroup) {
	    ClientHostActionGroup[ClientHostActionGroup["Default"] = 'default'] = "Default";
	    ClientHostActionGroup[ClientHostActionGroup["Terminal"] = 'terminal'] = "Terminal";
	})(exports.ClientHostActionGroup || (exports.ClientHostActionGroup = {}));
	var ClientHostActionGroup = exports.ClientHostActionGroup;
	(function (ClientHostPaytableActions) {
	    ClientHostPaytableActions[ClientHostPaytableActions["LoadPaytable"] = 'LoadPaytable'] = "LoadPaytable";
	    ClientHostPaytableActions[ClientHostPaytableActions["ShowPaytable"] = 'ShowPaytable'] = "ShowPaytable";
	    ClientHostPaytableActions[ClientHostPaytableActions["PaytableLoaded"] = 'PaytableLoaded'] = "PaytableLoaded";
	    ClientHostPaytableActions[ClientHostPaytableActions["PaytableAction"] = 'PaytableAction'] = "PaytableAction";
	})(exports.ClientHostPaytableActions || (exports.ClientHostPaytableActions = {}));
	var ClientHostPaytableActions = exports.ClientHostPaytableActions;
	(function (ClientHostDialogType) {
	    ClientHostDialogType[ClientHostDialogType["Normal"] = 'Normal'] = "Normal";
	    ClientHostDialogType[ClientHostDialogType["Error"] = 'Error'] = "Error";
	    ClientHostDialogType[ClientHostDialogType["Responsible1"] = 'Responsible1'] = "Responsible1";
	})(exports.ClientHostDialogType || (exports.ClientHostDialogType = {}));
	var ClientHostDialogType = exports.ClientHostDialogType;
	(function (ClientHostMetadataTypes) {
	    ClientHostMetadataTypes[ClientHostMetadataTypes["BackgroundMusic"] = 0] = "BackgroundMusic";
	    ClientHostMetadataTypes[ClientHostMetadataTypes["MuteVolumeAllowed"] = 1] = "MuteVolumeAllowed";
	})(exports.ClientHostMetadataTypes || (exports.ClientHostMetadataTypes = {}));
	var ClientHostMetadataTypes = exports.ClientHostMetadataTypes;
	var ClientHostPaytableRequests = (function () {
	    function ClientHostPaytableRequests() {
	    }
	    ClientHostPaytableRequests.createLoadPaytable = function (url) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(url, 'url');
	        var _action = ClientHostPaytableActions.LoadPaytable.toString();
	        var result = {
	            action: _action,
	            url: url
	        };
	        return result;
	    };
	    ClientHostPaytableRequests.createShowPaytable = function (initData) {
	        var _action = ClientHostPaytableActions.ShowPaytable.toString();
	        var result = {
	            action: _action,
	            initData: initData
	        };
	        return result;
	    };
	    ClientHostPaytableRequests.createActionWithValue = function (type, value) {
	        var _action = ClientHostPaytableActions.PaytableAction.toString();
	        var result = {
	            action: _action,
	            type: type,
	            value: value
	        };
	        return result;
	    };
	    ClientHostPaytableRequests.createPaytableLoaded = function (loadSucceed) {
	        var _action = ClientHostPaytableActions.PaytableLoaded.toString();
	        var result = {
	            action: _action,
	            loadSucceed: loadSucceed
	        };
	        return result;
	    };
	    return ClientHostPaytableRequests;
	}());
	exports.ClientHostPaytableRequests = ClientHostPaytableRequests;
	(function (OnOffState) {
	    OnOffState[OnOffState["On"] = 'on'] = "On";
	    OnOffState[OnOffState["Off"] = 'off'] = "Off";
	})(exports.OnOffState || (exports.OnOffState = {}));
	var OnOffState = exports.OnOffState;
	(function (AutoplayAction) {
	    AutoplayAction[AutoplayAction["Stop"] = 'stop'] = "Stop";
	    AutoplayAction[AutoplayAction["Enable"] = 'enable'] = "Enable";
	    AutoplayAction[AutoplayAction["Disable"] = 'disable'] = "Disable";
	})(exports.AutoplayAction || (exports.AutoplayAction = {}));
	var AutoplayAction = exports.AutoplayAction;
	(function (GamePlayAction) {
	    GamePlayAction[GamePlayAction["Enable"] = 'enable'] = "Enable";
	    GamePlayAction[GamePlayAction["Disable"] = 'disable'] = "Disable";
	})(exports.GamePlayAction || (exports.GamePlayAction = {}));
	var GamePlayAction = exports.GamePlayAction;


/***/ },
/* 8 */
/***/ function(module, exports) {

	"use strict";
	var DefaultGameActions = (function () {
	    function DefaultGameActions() {
	    }
	    Object.defineProperty(DefaultGameActions, "ActionSpin", {
	        get: function () {
	            return 'SPIN';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameActions, "ActionSpinStop", {
	        get: function () {
	            return 'SPIN_STOP';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameActions, "ActionSpinOrStop", {
	        get: function () {
	            return 'SPIN_OR_STOP';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameActions, "ActionCollect", {
	        get: function () {
	            return 'COLLECT';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameActions, "ActionAutoplay", {
	        get: function () {
	            return 'AUTOPLAY';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameActions, "ActionAutoplayStop", {
	        get: function () {
	            return 'AUTOPLAY_STOP';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameActions, "ActionBetPlus", {
	        get: function () {
	            return 'BET_PLUS';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameActions, "ActionBetMinus", {
	        get: function () {
	            return 'BET_MINUS';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameActions, "ActionMaxBet", {
	        get: function () {
	            return 'MAX_BET';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return DefaultGameActions;
	}());
	exports.DefaultGameActions = DefaultGameActions;
	var DefaultGameEventTypes = (function () {
	    function DefaultGameEventTypes() {
	    }
	    Object.defineProperty(DefaultGameEventTypes, "PrimaryGameEscrow", {
	        get: function () {
	            return 'PrimaryGameEscrow';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "PrimaryGameStarted", {
	        get: function () {
	            return 'PrimaryGameStarted';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "PrimaryGameEnded", {
	        get: function () {
	            return 'PrimaryGameEnded';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "SecondaryGameEntered", {
	        get: function () {
	            return 'SecondaryGameEntered';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "SecondaryGameHalved", {
	        get: function () {
	            return 'SecondaryGameHalved';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "SecondaryGameEscrow", {
	        get: function () {
	            return 'SecondaryGameEscrow';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "SecondaryGameStarted", {
	        get: function () {
	            return 'SecondaryGameStarted';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "GameCollectEscrow", {
	        get: function () {
	            return 'GameCollectEscrow';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "SecondaryGameCollectEscrow", {
	        get: function () {
	            return 'SecondaryGameCollectEscrow';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "SecondaryGameEnded", {
	        get: function () {
	            return 'SecondaryGameEnded';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "GameEnded", {
	        get: function () {
	            return 'GameEnded';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "AutoPlayStarted", {
	        get: function () {
	            return 'AutoPlayStarted';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "AutoPlayEnded", {
	        get: function () {
	            return 'AutoPlayEnded';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "GamePlayEnabled", {
	        get: function () {
	            return 'GamePlayEnabled';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "GamePlayDisabled", {
	        get: function () {
	            return 'GamePlayDisabled';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "BonusGameStarted", {
	        get: function () {
	            return 'BonusGameStarted';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "BonusGameTriggered", {
	        get: function () {
	            return 'BonusGameTriggered';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "BonusGameEscrow", {
	        get: function () {
	            return 'BonusGameEscrow';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "BonusGameEnded", {
	        get: function () {
	            return 'BonusGameEnded';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultGameEventTypes, "GameLoaded", {
	        get: function () {
	            return 'GameLoaded';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return DefaultGameEventTypes;
	}());
	exports.DefaultGameEventTypes = DefaultGameEventTypes;


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(1);
	var ClientHostFactory_1 = __webpack_require__(5);
	var ClientHostBase_1 = __webpack_require__(3);
	var Types_1 = __webpack_require__(7);
	var Platforms_1 = __webpack_require__(10);
	var version = '1';
	var typeName = 'Default';
	var ClientHostDefault = (function (_super) {
	    __extends(ClientHostDefault, _super);
	    function ClientHostDefault(clientHostConsumer) {
	        _super.call(this, clientHostConsumer);
	        this._backgroundMusic = Types_1.OnOffState.On;
	    }
	    ClientHostDefault.prototype.getLogger = function () {
	        return 'ClientHostDefault';
	    };
	    Object.defineProperty(ClientHostDefault.prototype, "version", {
	        get: function () {
	            return version;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClientHostDefault.prototype, "type", {
	        get: function () {
	            return typeName;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ClientHostDefault.prototype, "supports", {
	        get: function () {
	            return {
	                paytable: false,
	                volume: false,
	                serverConfigurationRequestAllowed: true,
	                denomination: false,
	                settings: false,
	                externalMessage: false
	            };
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ClientHostDefault.prototype.doInitialize = function () {
	        return Promise.resolve();
	    };
	    ClientHostDefault.prototype.actionsUpdated = function (actions) {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), "Received actionsUpdated: ", actions);
	        }
	    };
	    ClientHostDefault.prototype.endGame = function (app, request) {
	        var exitUrl = app.gameConfiguration.ExitUrl;
	        if (Platforms_1.Platforms.handleGameExit) {
	            return;
	        }
	        if (!neo_common_1.StringUtils.isNullOrEmpty(exitUrl)) {
	            if (false) {
	                neo_common_1.Logger.debugGroup(this.getLogger(), "endGame() - Redirecting to exit url: ", exitUrl);
	            }
	            window.location.replace(exitUrl);
	        }
	        else if (window.history.length > 1) {
	            if (false) {
	                neo_common_1.Logger.warnGroup(this.getLogger(), "endGame() - Exit url was NOT found in game configuration, will do browser history back.");
	            }
	            window.history.go(-1);
	        }
	        else {
	            this.showEndGameDialog();
	        }
	    };
	    ClientHostDefault.prototype.history = function (app) {
	        var historyUrl = app.gameConfiguration.HistoryUrl;
	        if (!neo_common_1.StringUtils.isNullOrEmpty(historyUrl)) {
	            if (false) {
	                neo_common_1.Logger.debugGroup(this.getLogger(), "Redirecting to history url: ", historyUrl);
	            }
	            window.open(historyUrl, '_blank');
	        }
	        else {
	            if (false) {
	                neo_common_1.Logger.warnGroup(this.getLogger(), "History url was NOT found in game configuration, will do nothing.");
	            }
	        }
	    };
	    ClientHostDefault.prototype.continue = function (app) {
	    };
	    ClientHostDefault.prototype.showDialog = function (request) {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), "showDialog(), request: ", request);
	        }
	        this._clientHostConsumer.handleShowDialog(request);
	    };
	    ClientHostDefault.prototype.showEndGameDialog = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), "handleShowEndGameDialog()");
	        }
	        this._clientHostConsumer.handleShowEndGameDialog();
	    };
	    ClientHostDefault.prototype.closeDialog = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), "closeDialog()");
	        }
	        this._clientHostConsumer.handleCloseDialog();
	    };
	    ClientHostDefault.prototype.sendRequestToPaytable = function (request) {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), "received event \"sendRequestToPaytable\" request: " + JSON.stringify(request));
	        }
	    };
	    ClientHostDefault.prototype.getVolume = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), "getVolume() returns null (does not support 'volume' feature)");
	        }
	        return null;
	    };
	    ClientHostDefault.prototype.setVolume = function (stepNo) {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), "setVolume() does nothing (does not support 'volume' feature)");
	        }
	    };
	    ClientHostDefault.prototype.getMetadata = function (type) {
	        switch (type) {
	            case Types_1.ClientHostMetadataTypes.BackgroundMusic:
	                return true;
	            case Types_1.ClientHostMetadataTypes.MuteVolumeAllowed:
	                return true;
	        }
	        return undefined;
	    };
	    ClientHostDefault.prototype.gameLoaded = function (app) {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), "inside gameLoaded(), loadingSucceed = ", app.loadingSucceed);
	        }
	    };
	    ClientHostDefault.prototype.getLanguage = function () {
	        var query = neo_common_1.Utils.getURIQuery();
	        return neo_common_1.Utils.valueOrDefault(query['lang'], '');
	    };
	    ClientHostDefault.prototype.getAllowedLanguages = function () {
	        return neo_common_1.StringsFactory.getLanguages();
	    };
	    ClientHostDefault.prototype.getDenomination = function () {
	        return null;
	    };
	    ClientHostDefault.prototype.setDenomination = function (denomination) {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), "setDenomination(" + denomination + ") called.");
	        }
	    };
	    ClientHostDefault.prototype.setLanguage = function (language) {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.getLogger(), "setLanguage('" + language + "') called.");
	        }
	    };
	    ClientHostDefault.prototype.notifyEventFromGame = function (eventName, eventData) {
	        if (false) {
	            var data = '-';
	            if (!neo_common_1.Utils.isNullOrUndefined(eventData)) {
	                data = JSON.stringify(eventData);
	            }
	            neo_common_1.Logger.debugGroup(this.getLogger(), "notifyEventFromGame(evetName: " + JSON.stringify(eventName) + ", eventData: " + data + "') called.");
	        }
	    };
	    ClientHostDefault.prototype.getBackgroundMusic = function () {
	        return this._backgroundMusic;
	    };
	    ClientHostDefault.prototype.getGameSetting = function (key) {
	        return undefined;
	    };
	    ClientHostDefault.prototype.getSharedSetting = function (key) {
	        return undefined;
	    };
	    ClientHostDefault.prototype.setBackgroundMusic = function (value) {
	        this._backgroundMusic = value;
	    };
	    ClientHostDefault.prototype.updateGameSetting = function (key, value) {
	        throw new Error('Not supported - updateGameSetting');
	    };
	    ClientHostDefault.prototype.updateSharedSetting = function (key, value) {
	        throw new Error('Not supported - updateSharedSetting');
	    };
	    ClientHostDefault.prototype.setLEDStripe = function (rgb, mode) {
	        throw new Error('Not supported - setLEDStripe');
	    };
	    ClientHostDefault.prototype.updateGameConfiguration = function (gameConfiguration) {
	        return Promise.resolve();
	    };
	    ClientHostDefault = __decorate([
	        ClientHostFactory_1.registerClientHost(typeName)
	    ], ClientHostDefault);
	    return ClientHostDefault;
	}(ClientHostBase_1.ClientHostBase));
	exports.ClientHostDefault = ClientHostDefault;


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var PlatformDummy_1 = __webpack_require__(11);
	exports.PlatformDummy = PlatformDummy_1.PlatformDummy;
	var PlatformGan_1 = __webpack_require__(32);
	exports.PlatformGan = PlatformGan_1.PlatformGan;
	var PlatformGel_1 = __webpack_require__(33);
	exports.PlatformGel = PlatformGel_1.PlatformGel;
	var PlatformIforium_1 = __webpack_require__(13);
	exports.PlatformIforium = PlatformIforium_1.PlatformIforium;
	var PlatformEveryMatrix_1 = __webpack_require__(34);
	exports.PlatformEveryMatrix = PlatformEveryMatrix_1.PlatformEveryMatrix;
	var PlatformRelax_1 = __webpack_require__(35);
	exports.PlatformRelax = PlatformRelax_1.PlatformRelax;
	var PlatformRelaxFEIM_1 = __webpack_require__(37);
	exports.PlatformRelaxFEIM = PlatformRelaxFEIM_1.PlatformRelaxFEIM;
	var PlatformPariplay_1 = __webpack_require__(36);
	exports.PlatformPariplay = PlatformPariplay_1.PlatformPariplay;
	var PlatformSynotAPI_1 = __webpack_require__(39);
	exports.PlatformSynotAPI = PlatformSynotAPI_1.PlatformSynotAPI;
	var PlatformPlaytech_1 = __webpack_require__(40);
	exports.PlatformPlaytech = PlatformPlaytech_1.PlatformPlaytech;
	var Platforms_1 = __webpack_require__(12);
	exports.Platforms = Platforms_1.Platforms;


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var Plugins_1 = __webpack_require__(14);
	var PlatformDummy = (function () {
	    function PlatformDummy() {
	        this._messageHeight = 0;
	    }
	    PlatformDummy.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        if (false) {
	            this.log('create');
	        }
	        window.addEventListener('message', this.receiveMessage.bind(this));
	        this.createMessage();
	        this.showMessage('Dummy message');
	        this.createIframe();
	    };
	    PlatformDummy.prototype.loadProgress = function (progress) {
	        if (false) {
	            this.log('loadProgress');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.progress', 'data': { 'progress': progress }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.gameReady = function () {
	        if (false) {
	            this.log('gameReady');
	        }
	        if (Platforms_1.Platforms.gameOrigin != null && Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.loaded',
	                'data': {
	                    'gameOrigin': Platforms_1.Platforms.gameOrigin
	                }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.gameFailed = function () {
	        if (false) {
	            this.log('gameFailed');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.failed'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.gameClosing = function () {
	        if (false) {
	            this.log('gameClosing');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.end'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.gameReloading = function () { };
	    PlatformDummy.prototype.gameChange = function (gameCode) {
	        if (false) {
	            this.log('gameChange');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.change', 'data': { 'gameCode': gameCode }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.error = function (code, message) {
	        if (false) {
	            this.log('error');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.error', 'data': { 'code': code, 'message': message }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.clientError = function (id, message) { };
	    PlatformDummy.prototype.roundInit = function () { };
	    PlatformDummy.prototype.roundStarted = function () {
	        if (false) {
	            this.log('roundStarted');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.round.started'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.spinStarted = function () {
	        if (false) {
	            this.log('spinStarted');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.spin.started'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.spinReceived = function () { };
	    PlatformDummy.prototype.spinEnded = function () {
	        if (false) {
	            this.log('spinEnded');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.spin.ended'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.roundEnded = function () {
	        if (false) {
	            this.log('roundEnded');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.round.ended'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.featureStarted = function () {
	        if (false) {
	            this.log('featureStarted');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.feature.started'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.featureInit = function () {
	        if (false) {
	            this.log('featureInit');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.feature.init'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.featureFinished = function () {
	        if (false) {
	            this.log('featureFinished');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.feature.finished'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.autoplayStarted = function () {
	        if (false) {
	            this.log('autoplayStarted');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.autoplay.started'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.autoplayFinished = function () {
	        if (false) {
	            this.log('autoplayFinished');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.autoplay.finished'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.gotoCasier = function () {
	        if (false) {
	            this.log('gotoCasier');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.goto.cashier'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.gotoHistory = function () {
	        if (false) {
	            this.log('gotoHistory');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.goto.history'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.gotoHelp = function () { };
	    PlatformDummy.prototype.gotoPaytable = function () { };
	    PlatformDummy.prototype.balanceUpdated = function () { };
	    PlatformDummy.prototype.sendPluginMessage = function (message) {
	        if (false) {
	            this.log('sendPluginMessage');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.handleWalletMessage', 'data': { 'message': message }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.setVolume = function (level) {
	        if (false) {
	            this.log('setVolume');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.setVolume', 'data': { 'level': level }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.quickSpinEnabled = function (enabled) {
	        if (false) {
	            this.log('bet');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.quickSpin.enabled', 'data': { 'enabled': enabled }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.bet = function (value) {
	        if (false) {
	            this.log('bet');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.bet', 'data': { 'bet': value }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.win = function (value) {
	        if (false) {
	            this.log('win');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.win', 'data': { 'win': value }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.userAction = function (action, data) {
	        if (false) {
	            this.log('userAction');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.userAction', 'data': { 'action': action, 'data': data }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformDummy.prototype.gameDataLoaded = function (args) { };
	    PlatformDummy.prototype.dialogOpened = function (type, isOpen) { };
	    PlatformDummy.prototype.fullscreen = function (enabled) { };
	    PlatformDummy.prototype.receiveMessage = function (event) {
	        if (false) {
	            this.log('receiveMessage');
	        }
	        if (event != null && event.data != null) {
	            if (event.data.method != null) {
	                switch (event.data.method) {
	                    case 'dummy.autoPlay.stop':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.stopAutoplay();
	                        }
	                        break;
	                    case 'dummy.gamePlay.stop':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayStop();
	                        }
	                        break;
	                    case 'dummy.gamePlay.resume':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayResume();
	                        }
	                        break;
	                    case 'dummy.gamePlay.freeze':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayFreeze();
	                        }
	                        break;
	                    case 'dummy.gamePlay.unfreeze':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayUnfreeze();
	                        }
	                        break;
	                    case 'dummy.audio.enable':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gameAudioEnable();
	                        }
	                        break;
	                    case 'dummy.audio.mute':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gameAudioMute();
	                        }
	                        break;
	                    case 'dummy.quickSpin.enable':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.quickSpinEnabled(true);
	                        }
	                        break;
	                    case 'dummy.quickSpin.disable':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.quickSpinEnabled(false);
	                        }
	                        break;
	                    case 'showPlugin':
	                        if (this.checkOrigin(event.origin)) {
	                            this.showPlugin();
	                        }
	                        break;
	                    case 'hidePlugin':
	                        if (this.checkOrigin(event.origin)) {
	                            this.hidePlugin();
	                        }
	                        break;
	                    case 'showHelp':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.showHelp();
	                        }
	                        break;
	                    case 'hideHelp':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.hideHelp();
	                        }
	                        break;
	                    case 'toggleHelp':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.toggleHelp();
	                        }
	                        break;
	                    case 'hidePaytable':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.hidePaytable();
	                        }
	                        break;
	                    case 'showPaytable':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.showPaytable();
	                        }
	                        break;
	                    case 'togglePaytable':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.togglePaytable();
	                        }
	                        break;
	                    case 'dummy.balance.reload':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.refreshBalance();
	                        }
	                        break;
	                }
	            }
	        }
	    };
	    PlatformDummy.prototype.checkOrigin = function (origin) {
	        if (Platforms_1.Platforms.pluginOrigin !== '*' && origin !== Platforms_1.Platforms.pluginOrigin) {
	            return false;
	        }
	        return true;
	    };
	    PlatformDummy.prototype.createMessage = function () {
	        if (false) {
	            this.log('createMessage');
	        }
	    };
	    PlatformDummy.prototype.showMessage = function (message) {
	        if (false) {
	            this.log('showMessage');
	        }
	        var statusBar = Plugins_1.StatusBar.getInstance();
	        statusBar.add(Plugins_1.StatusBar.Types.Message, 'dummyPlatformMsg', message);
	    };
	    PlatformDummy.prototype.createIframe = function () {
	        if (false) {
	            this.log('createIframe');
	        }
	        this._iframe = (document.createElement('iframe'));
	        this._iframe.id = 'topIframe';
	        this._iframe.src = 'http://static.dev.int';
	        this._iframe.classList.add('_disabled');
	        document.body.appendChild(this._iframe);
	    };
	    PlatformDummy.prototype.showPlugin = function () {
	        if (false) {
	            this.log('showPlugin');
	        }
	        if (this._iframe != null) {
	            if (this._iframe.classList.contains('_disabled')) {
	                this._iframe.classList.remove('_disabled');
	            }
	        }
	    };
	    PlatformDummy.prototype.hidePlugin = function () {
	        if (false) {
	            this.log('hidePlugin');
	        }
	        if (this._iframe != null) {
	            if (!this._iframe.classList.contains('_disabled')) {
	                this._iframe.classList.add('_disabled');
	            }
	        }
	    };
	    PlatformDummy.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('Dummy', 'Dummy' + s);
	        }
	    };
	    return PlatformDummy;
	}());
	exports.PlatformDummy = PlatformDummy;


/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var PlatformIforium_1 = __webpack_require__(13);
	var PlatformGan_1 = __webpack_require__(32);
	var PlatformGel_1 = __webpack_require__(33);
	var PlatformEveryMatrix_1 = __webpack_require__(34);
	var PlatformRelax_1 = __webpack_require__(35);
	var PlatformDummy_1 = __webpack_require__(11);
	var PlatformPariplay_1 = __webpack_require__(36);
	var neo_common_1 = __webpack_require__(1);
	var PlatformRelaxFEIM_1 = __webpack_require__(37);
	var PlatformBetFair_1 = __webpack_require__(38);
	var PlatformSynotAPI_1 = __webpack_require__(39);
	var PlatformPlaytech_1 = __webpack_require__(40);
	var index_1 = __webpack_require__(14);
	var PlatformMicrogaming_1 = __webpack_require__(41);
	var Platforms = (function () {
	    function Platforms() {
	    }
	    Platforms.createEmitter = function () {
	        Platforms.eventEmitter = neo_common_1.createEventEmmiter();
	    };
	    Platforms.create = function (platform, pluginUrl, pluginOrigin, additionalData) {
	        Platforms.pluginUrl = pluginUrl;
	        Platforms.pluginOrigin = Platforms.getUrlOrigin(pluginOrigin);
	        Platforms.gameOrigin = window.location.origin;
	        if (additionalData != null) {
	            Platforms.gameKey = additionalData.gameKey;
	            Platforms.lang = additionalData.lang;
	        }
	        switch (platform) {
	            case 'iforium':
	                Platforms.platform = new PlatformIforium_1.PlatformIforium();
	                break;
	            case 'gan':
	                Platforms.platform = new PlatformGan_1.PlatformGan();
	                break;
	            case 'gel':
	                Platforms.platform = new PlatformGel_1.PlatformGel();
	                break;
	            case 'everymatrix':
	                Platforms.platform = new PlatformEveryMatrix_1.PlatformEveryMatrix();
	                break;
	            case 'betfair':
	                Platforms.platform = new PlatformBetFair_1.PlatformBetFair();
	                break;
	            case 'relax':
	                Platforms.platform = new PlatformRelax_1.PlatformRelax();
	                break;
	            case 'relaxFEIM':
	                Platforms.platform = new PlatformRelaxFEIM_1.PlatformRelaxFEIM();
	                break;
	            case 'dummy':
	                Platforms.platform = new PlatformDummy_1.PlatformDummy();
	                break;
	            case 'pariplay':
	                Platforms.platform = new PlatformPariplay_1.PlatformPariplay();
	                break;
	            case 'synotAPI':
	                Platforms.platform = new PlatformSynotAPI_1.PlatformSynotAPI();
	                break;
	            case 'playtech':
	                Platforms.platform = new PlatformPlaytech_1.PlatformPlaytech();
	                break;
	            case 'microgaming':
	                Platforms.platform = new PlatformMicrogaming_1.PlatformMicrogaming();
	                break;
	            default:
	                Platforms.platform = null;
	                break;
	        }
	        Platforms.eventTracker = new index_1.EventTracker();
	        Platforms.eventTracker.on(index_1.EventTracker.EVENTS_TRACKER, function (data) { Platforms.createNotification(data); });
	        Platforms.playerRetentionManager = new index_1.PlayerRetentionManager(additionalData.clientHub);
	        if (Platforms.platform != null) {
	            Platforms.platform.create();
	        }
	    };
	    Platforms.getUrlOrigin = function (url) {
	        if (url == null || url === '' || url === '*') {
	            return '*';
	        }
	        try {
	            var uri = new URL(url);
	            return uri.origin;
	        }
	        catch (e) {
	            if (false) {
	                neo_common_1.Logger.debugGroup('Platforms', "Provided url for getting origin is not valid, returning '*'.");
	            }
	        }
	        return '*';
	    };
	    Platforms.loadProgress = function (progress) {
	        if (Platforms.platform != null) {
	            Platforms.platform.loadProgress(progress);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.loadProgress(progress);
	        }
	    };
	    Platforms.gameReady = function () {
	        if (Platforms.platform != null) {
	            Platforms.platform.gameReady();
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.gameReady();
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.gameReady();
	        }
	    };
	    Platforms.gameFailed = function () {
	        if (Platforms.platform != null) {
	            Platforms.platform.gameFailed();
	        }
	    };
	    Platforms.gameClosing = function () {
	        if (Platforms.platform != null) {
	            Platforms.platform.gameClosing();
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.gameClosing(Platforms.exitHandler);
	        }
	    };
	    Platforms.gameReloading = function () {
	        if (Platforms.platform != null) {
	            Platforms.platform.gameReloading();
	        }
	    };
	    Platforms.gameChange = function (gameCode) {
	        if (Platforms.platform != null) {
	            Platforms.platform.gameChange(gameCode);
	        }
	    };
	    Platforms.error = function (code, message) {
	        if (Platforms.platform != null) {
	            Platforms.platform.error(code, message);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.error(code, message);
	        }
	    };
	    Platforms.clientError = function (id, message) {
	        if (Platforms.platform != null) {
	            Platforms.platform.clientError(id, message);
	        }
	    };
	    Platforms.roundInit = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.roundInit(args);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.roundInit();
	        }
	    };
	    Platforms.roundStarted = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.roundStarted(args);
	            Platforms.roundStartedFlag = true;
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.roundStarted(args);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.roundStarted();
	        }
	    };
	    Platforms.spinStarted = function () {
	        if (Platforms.platform != null) {
	            Platforms.platform.spinStarted();
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.spinStarted();
	        }
	    };
	    Platforms.spinReceived = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.spinReceived(args);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.spinReceived(args);
	        }
	    };
	    Platforms.spinEnded = function () {
	        if (Platforms.platform != null) {
	            Platforms.platform.spinEnded();
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.spinEnded();
	        }
	    };
	    Platforms.roundEnded = function (args) {
	        if (Platforms.platform != null && Platforms.roundStartedFlag) {
	            Platforms.platform.roundEnded(args);
	            Platforms.roundStartedFlag = false;
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.roundEnded(args);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.roundEnded();
	        }
	    };
	    Platforms.featureStarted = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.featureStarted(args);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.featureStarted();
	        }
	    };
	    Platforms.featureInit = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.featureInit(args);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.featureInit();
	        }
	    };
	    Platforms.featureFinished = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.featureFinished(args);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.featureFinished();
	        }
	    };
	    Platforms.autoplayStarted = function () {
	        if (Platforms.platform != null) {
	            Platforms.platform.autoplayStarted();
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.autoplay(true);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.autoplayStarted();
	        }
	    };
	    Platforms.autoplayFinished = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.autoplayFinished(args);
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.autoplay(false);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.autoplayFinished(args);
	        }
	    };
	    Platforms.autoplayStop = function () {
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.autoplayStop();
	        }
	    };
	    Platforms.gotoCasier = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.gotoCasier(args);
	        }
	    };
	    Platforms.gotoHistory = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.gotoHistory(args);
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.gotoHistory(args);
	        }
	    };
	    Platforms.gotoHelp = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.gotoHelp(args);
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.gotoHelp(args);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.gotoHelp();
	        }
	    };
	    Platforms.gotoPaytable = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.gotoPaytable(args);
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.gotoPaytable(args);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.gotoPaytable();
	        }
	    };
	    Platforms.gotoSettings = function () {
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.gotoSettings();
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.gotoSettings();
	        }
	    };
	    Platforms.balanceUpdated = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.balanceUpdated(args);
	        }
	    };
	    Platforms.sendPluginMessage = function (message) {
	        if (Platforms.platform != null) {
	            Platforms.platform.sendPluginMessage(message);
	        }
	    };
	    Platforms.setVolume = function (level) {
	        if (Platforms.platform != null) {
	            Platforms.platform.setVolume(level);
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.setVolume(level);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.setVolume(level);
	        }
	    };
	    Platforms.quickSpinEnabled = function (enabled) {
	        if (Platforms.platform != null) {
	            Platforms.platform.quickSpinEnabled(enabled);
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.quickSpinEnabled(enabled);
	        }
	    };
	    Platforms.quickSpinDialog = function (result) {
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.quickSpinDialog(result);
	        }
	    };
	    Platforms.bet = function (betData) {
	        if (Platforms.platform != null) {
	            Platforms.platform.bet(betData.totalBet);
	        }
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.bet(betData);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.betChanged(betData);
	        }
	    };
	    Platforms.win = function (value, cumulative) {
	        if (Platforms.platform != null) {
	            Platforms.platform.win(value, cumulative);
	        }
	    };
	    Platforms.userAction = function (action, data) {
	        if (Platforms.platform != null) {
	            Platforms.platform.userAction(action, data);
	        }
	    };
	    Platforms.gameDataLoaded = function (args) {
	        if (Platforms.platform != null) {
	            Platforms.platform.gameDataLoaded(args);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.gameStarted(args);
	        }
	    };
	    Platforms.dialogOpened = function (type, isOpen) {
	        if (Platforms.platform != null) {
	            Platforms.platform.dialogOpened(type, isOpen);
	        }
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.dialogOpened(type, isOpen);
	        }
	    };
	    Platforms.fullscreen = function (enabled) {
	        if (Platforms.platform != null) {
	            Platforms.platform.fullscreen(enabled);
	        }
	    };
	    Platforms.gameCloseMenu = function () {
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.closeMenu();
	        }
	    };
	    Platforms.rendererType = function (rendererType) {
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.rendererType(rendererType);
	        }
	    };
	    Platforms.webSocketsInitialized = function () {
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.webSocketsInitialized();
	        }
	    };
	    Platforms.iconsCountAvailable = function (count) {
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.iconsCountAvailable(count);
	        }
	    };
	    Platforms.clockSync = function (syncDiff) {
	        if (Platforms.eventTracker != null) {
	            Platforms.eventTracker.clockSync(syncDiff);
	        }
	    };
	    Platforms.stopAutoplay = function () {
	        Platforms.eventEmitter.emit(Platforms.AutoplayStop);
	    };
	    Platforms.restoreAutoplay = function (args) {
	        Platforms.eventEmitter.emit(Platforms.RestoreAutoplay, args);
	    };
	    Platforms.resizeGame = function () {
	        Platforms.eventEmitter.emit(Platforms.ResizeGame);
	    };
	    Platforms.refreshBalance = function () {
	        Platforms.eventEmitter.emit(Platforms.RefreshBalance);
	    };
	    Platforms.gamePlayStop = function (disableChannel) {
	        if (disableChannel === void 0) { disableChannel = false; }
	        Platforms.eventEmitter.emit(Platforms.GamePlayStop, disableChannel);
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.gamePlayStop();
	        }
	    };
	    Platforms.gamePlayResume = function () {
	        Platforms.canSpinOnCollect = true;
	        Platforms.eventEmitter.emit(Platforms.GamePlayResume);
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.gamePlayResume();
	        }
	    };
	    Platforms.gamePlayFreeze = function () {
	        Platforms.eventEmitter.emit(Platforms.GamePlayFreeze);
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.gamePlayFreeze();
	        }
	    };
	    Platforms.gamePlayUnfreeze = function () {
	        Platforms.canSpinOnCollect = true;
	        Platforms.eventEmitter.emit(Platforms.GamePlayUnfreeze);
	        if (Platforms.playerRetentionManager != null) {
	            Platforms.playerRetentionManager.gamePlayUnfreeze();
	        }
	    };
	    Platforms.gamePlaySupressSpinOnCollect = function () {
	        Platforms.canSpinOnCollect = false;
	    };
	    Platforms.gameAudioEnable = function () {
	        Platforms.eventEmitter.emit(Platforms.GameAudioEnable);
	    };
	    Platforms.gameAudioMute = function () {
	        Platforms.eventEmitter.emit(Platforms.GameAudioMute);
	    };
	    Platforms.gameAudioSet = function (level) {
	        Platforms.eventEmitter.emit(Platforms.GameAudioSet, level);
	    };
	    Platforms.gameQuickSpin = function (enable) {
	        Platforms.eventEmitter.emit(Platforms.GameQuickSpin, enable);
	    };
	    Platforms.showHelp = function () {
	        Platforms.eventEmitter.emit(Platforms.ShowHelp);
	    };
	    Platforms.hideHelp = function () {
	        Platforms.eventEmitter.emit(Platforms.HideHelp);
	    };
	    Platforms.toggleHelp = function () {
	        Platforms.eventEmitter.emit(Platforms.ToggleHelp);
	    };
	    Platforms.showPaytable = function () {
	        Platforms.eventEmitter.emit(Platforms.ShowPaytable);
	    };
	    Platforms.hidePaytable = function () {
	        Platforms.eventEmitter.emit(Platforms.HidePaytable);
	    };
	    Platforms.togglePaytable = function () {
	        Platforms.eventEmitter.emit(Platforms.TogglePaytable);
	    };
	    Platforms.platformErrorMessageDismissed = function () {
	        Platforms.eventEmitter.emit(Platforms.PlatformErrorMessageDismissed);
	    };
	    Platforms.closeMenu = function () {
	        Platforms.eventEmitter.emit(Platforms.PlatformCloseMenu);
	    };
	    Platforms.closeGame = function () {
	        Platforms.eventEmitter.emit(Platforms.PlatformCloseGame);
	    };
	    Platforms.updateUI = function () {
	        Platforms.eventEmitter.emit(Platforms.PlatformUpdateUI);
	    };
	    Platforms.createNotification = function (data) {
	        Platforms.eventEmitter.emit(Platforms.CreateNotification, data);
	    };
	    Platforms.getTimeData = function () {
	        if (Platforms.getTimeDataFnc != null) {
	            return Platforms.getTimeDataFnc();
	        }
	        return null;
	    };
	    Platforms.getGameTime = function (utcTime) {
	        if (Platforms.getGameTimeFnc != null) {
	            return Platforms.getGameTimeFnc(utcTime);
	        }
	        return null;
	    };
	    Platforms.AutoplayStop = 'autoplayStop';
	    Platforms.RestoreAutoplay = 'restoreAutoplay';
	    Platforms.ResizeGame = 'resizeGame';
	    Platforms.RefreshBalance = 'refreshBalance';
	    Platforms.GamePlayStop = 'gamePlayStop';
	    Platforms.GamePlayResume = 'gamePlayResume';
	    Platforms.GamePlayFreeze = 'gamePlayFreeze';
	    Platforms.GamePlayUnfreeze = 'gamePlayUnfreeze';
	    Platforms.GameAudioEnable = 'gameAudioEnable';
	    Platforms.GameAudioMute = 'gameAudioMute';
	    Platforms.GameAudioSet = 'gameAudioSet';
	    Platforms.GameQuickSpin = 'gameQuickSpin';
	    Platforms.ShowHelp = 'showHelp';
	    Platforms.HideHelp = 'hideHelp';
	    Platforms.ToggleHelp = 'toggleHelp';
	    Platforms.ShowPaytable = 'showPaytable';
	    Platforms.HidePaytable = 'hidePaytable';
	    Platforms.TogglePaytable = 'togglePaytable';
	    Platforms.PlatformErrorMessageDismissed = 'platformErrorMessageDismissed';
	    Platforms.PlatformCloseMenu = 'platformCloseMenu';
	    Platforms.PlatformCloseGame = 'platformCloseGame';
	    Platforms.PlatformUpdateUI = 'platformUpdateUI';
	    Platforms.CreateNotification = 'createNotification';
	    Platforms.externalWrappersWidth = 0;
	    Platforms.externalWrappersHeight = 0;
	    Platforms.canPlay = true;
	    Platforms.canSpinOnCollect = true;
	    Platforms.handleShowErrorDialog = false;
	    Platforms.handleOpenCashierPage = false;
	    Platforms.handleOpenHistoryPage = false;
	    Platforms.handleGameExit = false;
	    Platforms.handleGameReload = false;
	    Platforms.handleChangeGame = false;
	    Platforms.exitHandler = '';
	    Platforms.handleFullscreen = false;
	    Platforms.roundStartedFlag = true;
	    return Platforms;
	}());
	exports.Platforms = Platforms;


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var Plugins_1 = __webpack_require__(14);
	var PlatformIforium = (function () {
	    function PlatformIforium() {
	        this._messageHeight = 0;
	    }
	    PlatformIforium.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = false;
	        if (false) {
	            this.log('create');
	        }
	        this.createMessage();
	        this.createIframe();
	        window.addEventListener('message', this.receiveMessage.bind(this));
	    };
	    PlatformIforium.prototype.loadProgress = function (progress) { };
	    PlatformIforium.prototype.gameReady = function () {
	        if (false) {
	            this.log('gameReady');
	        }
	        if (this._iframe != null && Platforms_1.Platforms.gameOrigin != null && Platforms_1.Platforms.pluginOrigin != null) {
	            this._iframe.contentWindow.postMessage({
	                'method': 'gameReady',
	                'data': {
	                    'gameOrigin': Platforms_1.Platforms.gameOrigin
	                }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformIforium.prototype.gameFailed = function () { };
	    PlatformIforium.prototype.gameClosing = function () { };
	    PlatformIforium.prototype.gameReloading = function () { };
	    PlatformIforium.prototype.gameChange = function (gameCode) { };
	    PlatformIforium.prototype.error = function (code, message) { };
	    PlatformIforium.prototype.clientError = function (id, message) { };
	    PlatformIforium.prototype.roundInit = function () { };
	    PlatformIforium.prototype.roundStarted = function () {
	        if (false) {
	            this.log('roundStarted');
	        }
	        if (this._iframe != null && Platforms_1.Platforms.pluginOrigin != null) {
	            this._iframe.contentWindow.postMessage({
	                'method': 'spinStarted',
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformIforium.prototype.spinStarted = function () { };
	    PlatformIforium.prototype.spinReceived = function () { };
	    PlatformIforium.prototype.spinEnded = function () { };
	    PlatformIforium.prototype.roundEnded = function () {
	        if (false) {
	            this.log('roundEnded');
	        }
	        if (this._iframe != null && Platforms_1.Platforms.pluginOrigin != null) {
	            this._iframe.contentWindow.postMessage({
	                'method': 'spinEnded',
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformIforium.prototype.featureStarted = function () { };
	    PlatformIforium.prototype.featureInit = function () { };
	    PlatformIforium.prototype.featureFinished = function () { };
	    PlatformIforium.prototype.autoplayStarted = function () { };
	    PlatformIforium.prototype.autoplayFinished = function () { };
	    PlatformIforium.prototype.gotoCasier = function () { };
	    PlatformIforium.prototype.gotoHistory = function () { };
	    PlatformIforium.prototype.gotoHelp = function () { };
	    PlatformIforium.prototype.gotoPaytable = function () { };
	    PlatformIforium.prototype.balanceUpdated = function () { };
	    PlatformIforium.prototype.sendPluginMessage = function (message) { };
	    PlatformIforium.prototype.setVolume = function (level) { };
	    PlatformIforium.prototype.quickSpinEnabled = function (enabled) { };
	    PlatformIforium.prototype.bet = function (value) { };
	    PlatformIforium.prototype.win = function (value) { };
	    PlatformIforium.prototype.userAction = function (action, data) { };
	    PlatformIforium.prototype.gameDataLoaded = function (args) { };
	    PlatformIforium.prototype.dialogOpened = function (type, isOpen) { };
	    PlatformIforium.prototype.fullscreen = function (enabled) { };
	    PlatformIforium.prototype.createMessage = function () {
	        if (false) {
	            this.log('createMessage');
	        }
	    };
	    PlatformIforium.prototype.createIframe = function () {
	        if (false) {
	            this.log('createIframe');
	        }
	        if (Platforms_1.Platforms.pluginUrl != null) {
	            this._iframe = (document.createElement('iframe'));
	            this._iframe.id = 'topIframe';
	            this._iframe.src = Platforms_1.Platforms.pluginUrl;
	            this._iframe.classList.add('_disabled');
	            document.body.appendChild(this._iframe);
	        }
	    };
	    PlatformIforium.prototype.receiveMessage = function (event) {
	        if (false) {
	            this.log('receiveMessage');
	        }
	        if (event != null && event.data != null) {
	            if (event.data.method != null) {
	                switch (event.data.method) {
	                    case 'pluginReady':
	                        this.pluginReady();
	                        break;
	                    case 'showMessage':
	                        if (this.checkOrigin(event.origin)) {
	                            if (event.data.data != null && event.data.data.message != null) {
	                                this.showMessage(event.data.data.message);
	                            }
	                        }
	                        break;
	                    case 'hideMessage':
	                        if (this.checkOrigin(event.origin)) {
	                            this.hideMessage();
	                        }
	                        break;
	                    case 'showPlugin':
	                        if (this.checkOrigin(event.origin)) {
	                            this.showPlugin();
	                        }
	                        break;
	                    case 'hidePlugin':
	                        if (this.checkOrigin(event.origin)) {
	                            this.hidePlugin();
	                        }
	                        break;
	                    case 'stopAutoplay':
	                        if (this.checkOrigin(event.origin)) {
	                            this.stopAutoplay();
	                        }
	                        break;
	                }
	            }
	        }
	    };
	    PlatformIforium.prototype.checkOrigin = function (origin) {
	        if (origin !== Platforms_1.Platforms.pluginOrigin) {
	            return false;
	        }
	        return true;
	    };
	    PlatformIforium.prototype.pluginReady = function () {
	        if (false) {
	            this.log('pluginReady');
	        }
	        Platforms_1.Platforms.canPlay = true;
	    };
	    PlatformIforium.prototype.stopAutoplay = function () {
	        if (false) {
	            this.log('stopAutoplay');
	        }
	        Platforms_1.Platforms.stopAutoplay();
	    };
	    PlatformIforium.prototype.showMessage = function (message) {
	        if (false) {
	            this.log('showMessage');
	        }
	        var statusBar = Plugins_1.StatusBar.getInstance();
	        statusBar.add(Plugins_1.StatusBar.Types.Message, 'iforiumMsg', message);
	    };
	    PlatformIforium.prototype.hideMessage = function () {
	        if (false) {
	            this.log('hideMessage');
	        }
	        var statusBar = Plugins_1.StatusBar.getInstance();
	        statusBar.remove('iforiumMsg');
	        Platforms_1.Platforms.resizeGame();
	    };
	    PlatformIforium.prototype.showPlugin = function () {
	        if (false) {
	            this.log('showPlugin');
	        }
	        if (this._iframe != null) {
	            if (this._iframe.classList.contains('_disabled')) {
	                this._iframe.classList.remove('_disabled');
	            }
	        }
	    };
	    PlatformIforium.prototype.hidePlugin = function () {
	        if (false) {
	            this.log('hidePlugin');
	        }
	        if (this._iframe != null) {
	            if (!this._iframe.classList.contains('_disabled')) {
	                this._iframe.classList.add('_disabled');
	            }
	        }
	    };
	    PlatformIforium.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('Iforium', 'Iforium ' + s);
	        }
	    };
	    return PlatformIforium;
	}());
	exports.PlatformIforium = PlatformIforium;


/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var StatusBar_1 = __webpack_require__(15);
	exports.StatusBar = StatusBar_1.StatusBar;
	var EventTracker_1 = __webpack_require__(16);
	exports.EventTracker = EventTracker_1.EventTracker;
	var PlayerRetentionManager_1 = __webpack_require__(29);
	exports.PlayerRetentionManager = PlayerRetentionManager_1.PlayerRetentionManager;


/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var StatusBar = (function () {
	    function StatusBar() {
	        this.statusBarHolder = (document.createElement('div'));
	        this.statusBarHolder.id = 'statusBar';
	        this.statusBarHolder.classList.add('_disabled');
	        document.body.appendChild(this.statusBarHolder);
	    }
	    StatusBar.getInstance = function () {
	        if (neo_common_1.Utils.isNullOrUndefined(StatusBar.Instance)) {
	            StatusBar.Instance = new StatusBar();
	        }
	        return StatusBar.Instance;
	    };
	    StatusBar.prototype.add = function (type, id, text, customData) {
	        switch (type) {
	            case StatusBar.Types.StatusBarMessage:
	            case StatusBar.Types.Message:
	                this.message(id, text, customData);
	                break;
	            case StatusBar.Types.RTP:
	                this.rtp(id, text, customData);
	                break;
	            case StatusBar.Types.TOTAL_GAIN:
	                this.totalGain(id, text, customData);
	                break;
	            case StatusBar.Types.MaxPayoutProbability:
	                this.maxPayoutProbability(id, text, customData);
	                break;
	        }
	        StatusBar.updateHeight();
	    };
	    StatusBar.prototype.remove = function (id) {
	        if (this.hasElement(id)) {
	            var elem = this.getElement(id);
	            if (elem.parentElement != null) {
	                elem.parentElement.removeChild(elem);
	            }
	        }
	        StatusBar.updateHeight();
	    };
	    StatusBar.prototype.hasActiveWidget = function (widgetId) {
	        if (widgetId === void 0) { widgetId = null; }
	        if (widgetId == null) {
	            return StatusBar.StatusBarHeight !== 0;
	        }
	        return this.hasElement(widgetId);
	    };
	    StatusBar.updateHeight = function () {
	        var holder = document.getElementById('statusBar');
	        if (holder != null) {
	            var height = parseInt(window.getComputedStyle(holder, null).getPropertyValue('height')) +
	                parseInt(window.getComputedStyle(holder, null).getPropertyValue('padding-top'));
	            StatusBar.StatusBarHeight = -height;
	        }
	    };
	    StatusBar.prototype.message = function (id, text, customData) {
	        var elem = this.getElement(id);
	        elem.innerHTML = text;
	        elem.setAttribute('style', 'text-align: center; flex: 1; order: 4');
	        this.appendChild(elem);
	    };
	    StatusBar.prototype.rtp = function (id, text, customData) {
	        var elem = this.getElement(id);
	        elem.innerHTML = text;
	        elem.setAttribute('style', 'text-align: center; order: 1');
	        this.appendChild(elem);
	    };
	    StatusBar.prototype.totalGain = function (id, text, customData) {
	        var elem = this.getElement(id);
	        elem.innerHTML = text;
	        elem.setAttribute('style', 'text-align: center; order: 3');
	        this.appendChild(elem);
	    };
	    StatusBar.prototype.maxPayoutProbability = function (id, text, customData) {
	        var elem = this.getElement(id);
	        elem.innerHTML = text;
	        elem.setAttribute('style', 'text-align: center; order: 2');
	        this.appendChild(elem);
	    };
	    StatusBar.prototype.getElement = function (id) {
	        id = id + StatusBar.IdPrefix;
	        var elem = document.getElementById(id);
	        if (elem == null) {
	            elem = document.createElement('div');
	            elem.setAttribute('id', id);
	        }
	        return elem;
	    };
	    StatusBar.prototype.hasElement = function (id) {
	        id = id + StatusBar.IdPrefix;
	        return document.getElementById(id) != null;
	    };
	    StatusBar.prototype.appendChild = function (elem) {
	        if (this.statusBarHolder != null) {
	            if (!this.hasElement(elem.id)) {
	                this.statusBarHolder.appendChild(elem);
	            }
	            this.statusBarHolder.classList.remove('_disabled');
	        }
	    };
	    StatusBar.Types = {
	        RTP: 'rtp',
	        TOTAL_GAIN: 'totalGain',
	        Message: 'message',
	        MaxPayoutProbability: 'maxPayoutProbability',
	        StatusBarMessage: 'statusBarMessage'
	    };
	    StatusBar.StatusBarHeight = 0;
	    StatusBar.StatusBarWidth = 0;
	    StatusBar.IdPrefix = 'StatusBar';
	    return StatusBar;
	}());
	exports.StatusBar = StatusBar;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var GameEngine_1 = __webpack_require__(17);
	var EventTracker = (function () {
	    function EventTracker() {
	        this.eventEmitter = neo_common_1.createEventEmmiter();
	        this.eventsPerSession = [];
	        this.eventsPerGameRoundsTemp = {};
	        this.eventsPerGameRounds = {};
	        this.eventsAfterDelay = {};
	        this.gameReadyEvents = [];
	        this.enabledEvents = [];
	        var appContext = GameEngine_1.AppContextBase.getInstance();
	        if (appContext.gameConfiguration != null) {
	            this.enabledEvents = this.getEnabledEvents(appContext.gameConfiguration.EventTrackerEnabledEvents);
	        }
	        this.initEventsPerGameRounds();
	    }
	    EventTracker.prototype.getEnabledEvents = function (config) {
	        var result = [];
	        if (config === '') {
	            return [];
	        }
	        var splittedConfig = config.split(' ');
	        if (splittedConfig.indexOf('*') > -1) {
	            return EventTracker.EventsList.GameRoundEvents.concat(EventTracker.EventsList.SessionEvents, EventTracker.EventsList.DelayedEvents, EventTracker.EventsList.InstantEvents, EventTracker.EventsList.GameReadyEvents);
	        }
	        for (var i = 0; i < splittedConfig.length; i++) {
	            var category = splittedConfig[i].split(':');
	            var categoryData = [];
	            if (category.length === 2) {
	                categoryData = category[1].split('|');
	            }
	            var events = EventTracker.EventsList[category[0]];
	            if (events != null) {
	                if (categoryData.length > 0) {
	                    for (var j = 0; j < categoryData.length; j++) {
	                        if (events.indexOf(categoryData[j]) > -1) {
	                            result.push(categoryData[j]);
	                        }
	                    }
	                }
	                else {
	                    result.push.apply(result, events);
	                }
	            }
	        }
	        return result;
	    };
	    EventTracker.prototype.initEventsPerGameRounds = function () {
	        this.eventsPerGameRounds['GameLeftHandMode'] = document.body.classList.contains('reverse').toString();
	        this.eventsPerGameRounds['GamePortraitMode'] = document.body.classList.contains('portrait').toString();
	        this.eventsPerGameRounds['GameAutoplay'] = 'false';
	        this.eventsPerGameRounds['GameAutoplayStop'] = 'false';
	        this.eventsPerGameRounds['GameQuickSpin'] = 'false';
	        this.eventsPerGameRounds['UserAction'] = 'false';
	    };
	    EventTracker.prototype.quickSpinEnabled = function (enabled) {
	        this.eventsPerGameRounds['GameQuickSpin'] = enabled.toString();
	    };
	    EventTracker.prototype.autoplay = function (enabled) {
	        this.eventsPerGameRounds['GameAutoplay'] = enabled.toString();
	    };
	    EventTracker.prototype.autoplayStop = function () {
	        this.eventsPerGameRounds['GameAutoplayStop'] = 'true';
	    };
	    EventTracker.prototype.roundStarted = function (args) {
	        if (args == null) {
	            return;
	        }
	        this.eventsPerGameRounds['UserAction'] = args.userAction.toString();
	    };
	    EventTracker.prototype.roundEnded = function (args) {
	        this.eventsPerGameRounds['GameLeftHandMode'] = document.body.classList.contains('reverse').toString();
	        this.eventsPerGameRounds['GamePortraitMode'] = document.body.classList.contains('portrait').toString();
	        var updatedGameRoundData = this.getUpdatedGameRoundsData();
	        var eventsArray = [this.createTrackedEvent('GameRoundEnded', 'data', null, updatedGameRoundData)];
	        if (this.screenSize.width !== window.innerWidth || this.screenSize.height !== window.innerHeight) {
	            this.screenSize = { width: window.innerWidth, height: window.innerHeight };
	            eventsArray.push(this.createTrackedEvent('ScreenSize', 'data', null, this.screenSize));
	        }
	        if (this.afterDelayTimerId > -1) {
	            clearTimeout(this.afterDelayTimerId);
	            eventsArray = this.createArrayOfEvents(this.eventsAfterDelay).concat(eventsArray);
	            this.eventsAfterDelay = {};
	        }
	        this.sendEvents(eventsArray);
	        this.eventsPerGameRounds['GameAutoplayStop'] = 'false';
	        this.updateGameRoundsTempData();
	    };
	    EventTracker.prototype.getUpdatedGameRoundsData = function () {
	        var result = {};
	        for (var key in this.eventsPerGameRounds) {
	            if (this.eventsPerGameRounds[key] !== this.eventsPerGameRoundsTemp[key]) {
	                result[key] = this.eventsPerGameRounds[key];
	            }
	        }
	        return result;
	    };
	    EventTracker.prototype.updateGameRoundsTempData = function () {
	        this.eventsPerGameRoundsTemp = {};
	        for (var key in this.eventsPerGameRounds) {
	            this.eventsPerGameRoundsTemp[key] = this.eventsPerGameRounds[key];
	        }
	    };
	    EventTracker.prototype.gotoPaytable = function (args) {
	        if (this.eventsPerSession.indexOf('GameGoToPaytable') > -1) {
	            return;
	        }
	        this.eventsPerSession.push('GameGoToPaytable');
	        var data = this.createTrackedEvent('GameGoToPaytable', 'true');
	        this.sendEvents([data]);
	    };
	    EventTracker.prototype.gotoHelp = function (args) {
	        if (this.eventsPerSession.indexOf('GameGoToHelp') > -1) {
	            return;
	        }
	        this.eventsPerSession.push('GameGoToHelp');
	        var data = this.createTrackedEvent('GameGoToHelp', 'true');
	        this.sendEvents([data]);
	    };
	    EventTracker.prototype.gotoHistory = function (args) {
	        if (this.eventsPerSession.indexOf('GameGoToHistory') > -1) {
	            return;
	        }
	        this.eventsPerSession.push('GameGoToHistory');
	        var data = this.createTrackedEvent('GameGoToHistory', 'true');
	        this.sendEvents([data]);
	    };
	    EventTracker.prototype.gotoSettings = function () {
	        if (this.eventsPerSession.indexOf('GameGoToSettings') > -1) {
	            return;
	        }
	        this.eventsPerSession.push('GameGoToSettings');
	        var data = this.createTrackedEvent('GameGoToSettings', 'true');
	        this.sendEvents([data]);
	    };
	    EventTracker.prototype.quickSpinDialog = function (result) {
	        if (this.eventsPerSession.indexOf('GameQuickSpinDialog') > -1) {
	            return;
	        }
	        this.eventsPerSession.push('GameQuickSpinDialog');
	        var data = this.createTrackedEvent('GameQuickSpinDialog', result.toString());
	        this.sendEvents([data]);
	    };
	    EventTracker.prototype.setVolume = function (level) {
	        var _self = this;
	        if (this.afterDelayTimerId > -1) {
	            clearTimeout(this.afterDelayTimerId);
	        }
	        this.eventsAfterDelay['GameSetVolume'] = this.createTrackedEvent('GameSetVolume', null, level);
	        this.afterDelayTimerId = setTimeout(function () {
	            _self.sendEvents(_self.createArrayOfEvents(_self.eventsAfterDelay));
	            _self.eventsAfterDelay = {};
	        }, EventTracker.DELAY_TIME * 1000);
	    };
	    EventTracker.prototype.bet = function (betData) {
	        var _self = this;
	        if (this.afterDelayTimerId > -1) {
	            clearTimeout(this.afterDelayTimerId);
	        }
	        this.eventsAfterDelay['GameBetChange'] = this.createTrackedEvent('GameBetChange', 'data', null, betData);
	        this.afterDelayTimerId = setTimeout(function () {
	            _self.sendEvents(_self.createArrayOfEvents(_self.eventsAfterDelay));
	            _self.eventsAfterDelay = {};
	        }, EventTracker.DELAY_TIME * 1000);
	    };
	    EventTracker.prototype.gameClosing = function (exitHandler) {
	        if (this.afterDelayTimerId > -1) {
	            clearTimeout(this.afterDelayTimerId);
	        }
	        this.sendEvents([this.createTrackedEvent('GameExit', exitHandler)].concat(this.createArrayOfEvents(this.eventsAfterDelay)));
	        this.eventsAfterDelay = {};
	    };
	    EventTracker.prototype.rendererType = function (rendererType) {
	        this.gameReadyEvents.push(this.createTrackedEvent('RendererType', rendererType));
	    };
	    EventTracker.prototype.clockSync = function (syncDiff) {
	        this.gameReadyEvents.push(this.createTrackedEvent('SyncDiff', null, syncDiff));
	    };
	    EventTracker.prototype.gameReady = function () {
	        this.screenSize = { width: window.innerWidth, height: window.innerHeight };
	        this.gameReadyEvents.push(this.createTrackedEvent('ScreenSize', 'data', null, this.screenSize));
	        this.sendEvents(this.gameReadyEvents);
	    };
	    EventTracker.prototype.createTrackedEvent = function (eventType, label, value, customData) {
	        var eventData = {
	            eventType: eventType
	        };
	        if (!neo_common_1.StringUtils.isNullOrEmpty(label)) {
	            eventData.label = label;
	        }
	        if (value != null) {
	            eventData.value = value;
	        }
	        if (customData != null) {
	            eventData.customData = customData;
	        }
	        return eventData;
	    };
	    EventTracker.prototype.createArrayOfEvents = function (events) {
	        var eventsArray = [];
	        for (var key in events) {
	            if (events[key] != null) {
	                eventsArray.push(events[key]);
	            }
	        }
	        return eventsArray;
	    };
	    EventTracker.prototype.filterEnabledEvents = function (events) {
	        var result = [];
	        for (var i = 0; i < events.length; i++) {
	            var event_1 = events[i];
	            if (this.enabledEvents.indexOf(event_1.eventType) > -1) {
	                result.push(event_1);
	            }
	        }
	        return result;
	    };
	    EventTracker.prototype.sendEvents = function (events) {
	        if (events == null || events.length === 0) {
	            return;
	        }
	        events = this.filterEnabledEvents(events);
	        this.emit(EventTracker.EVENTS_TRACKER, events);
	    };
	    EventTracker.prototype.on = function (event, context) {
	        this.eventEmitter.on(event, context);
	    };
	    EventTracker.prototype.emit = function (event, args) {
	        this.eventEmitter.emit(event, args);
	    };
	    EventTracker.EVENTS_TRACKER = 'onEventsTracker';
	    EventTracker.DELAY_TIME = 10;
	    EventTracker.EventsList = {
	        GameRoundEvents: ['GameRoundEnded'],
	        SessionEvents: ['GameGoToPaytable', 'GameGoToHelp', 'GameGoToHistory', 'GameGoToSettings', 'GameQuickSpinDialog'],
	        DelayedEvents: ['GameSetVolume', 'GameBetChange'],
	        InstantEvents: ['GameExit'],
	        GameReadyEvents: ['RendererType', 'ScreenSize', 'SyncDiff']
	    };
	    return EventTracker;
	}());
	exports.EventTracker = EventTracker;


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var AppBase_1 = __webpack_require__(18);
	exports.AppBase = AppBase_1.AppBase;
	var AppContextBase_1 = __webpack_require__(19);
	exports.AppContextBase = AppContextBase_1.AppContextBase;
	var GameConfigurationBase_1 = __webpack_require__(21);
	exports.GameConfigurationBase = GameConfigurationBase_1.GameConfigurationBase;
	var GameDefinitionBase_1 = __webpack_require__(22);
	exports.GameDefinitionBase = GameDefinitionBase_1.GameDefinitionBase;
	var GameAppBase_1 = __webpack_require__(23);
	exports.GameAppBase = GameAppBase_1.GameAppBase;
	var GameClientHostConsumerBase_1 = __webpack_require__(26);
	exports.GameClientHostConsumerBase = GameClientHostConsumerBase_1.GameClientHostConsumerBase;
	var PaytableAppBase_1 = __webpack_require__(27);
	exports.PaytableAppBase = PaytableAppBase_1.PaytableAppBase;
	var PaytableClientHostConsumerBase_1 = __webpack_require__(28);
	exports.PaytableClientHostConsumerBase = PaytableClientHostConsumerBase_1.PaytableClientHostConsumerBase;
	var Types = __webpack_require__(20);
	exports.Types = Types;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var AppContextBase_1 = __webpack_require__(19);
	var Types_1 = __webpack_require__(20);
	var ClientHostConsumerBase_1 = __webpack_require__(4);
	var ClientHostFactory_1 = __webpack_require__(5);
	var DefaultAppBaseOptions = {
	    preloaderOptions: {
	        file: 'files.xml',
	        versionFile: 'version.txt',
	        progressTextElementId: 'progressNumber',
	        progressBarContainerElementId: 'progressBarCont',
	        progressBarElementId: 'progressBar',
	        preloaderProvider: null
	    },
	    gameDefinition: {
	        file: 'definition.json'
	    },
	    gameConfiguration: {
	        file: 'configuration.json'
	    },
	    clientHost: {
	        defaultClientHostType: 'Default'
	    }
	};
	var AppBase = (function () {
	    function AppBase() {
	        this._loadResult = {
	            status: Types_1.AppLoadStatus.Unknown,
	            error: null
	        };
	        this.stringsLoadCompleted = this.stringsLoadCompleted.bind(this);
	        this._options = neo_common_1.ObjectUtils.clone(DefaultAppBaseOptions);
	        this._options.preloaderOptions.preloaderProvider = this.createPreloaderProvider();
	    }
	    Object.defineProperty(AppBase.prototype, "supportsRealityCheck", {
	        get: function () { },
	        enumerable: true,
	        configurable: true
	    });
	    AppBase.prototype.load = function () {
	        var _this = this;
	        this._loadResult.status = Types_1.AppLoadStatus.Loading;
	        this._loadResult.error = null;
	        return this.prepareLoad()
	            .then(function (canLoad) {
	            if (!canLoad) {
	                return;
	            }
	            return _this.loadVersion()
	                .then(function () { return _this.loadStrings(); })
	                .then(function () { return _this.loadGameDefinition(); })
	                .then(function () { return _this.loadClientHost(); })
	                .then(function () { return _this.loadGameConfiguration(); })
	                .then(function () { return _this.initAppContext(); })
	                .then(function () { return _this.internalInitClientHost(); })
	                .then(function () { return _this.updateGameConfiguration(); })
	                .then(function () { return _this.loadResources(); })
	                .catch(function (err) { return _this.handleLoadError(err); })
	                .finally(function () { return _this.loadCompleted(); });
	        });
	    };
	    Object.defineProperty(AppBase.prototype, "preloaderVersionId", {
	        get: function () {
	            return this._preloader ? this._preloader.versionId : null;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppBase.prototype, "loadingSucceed", {
	        get: function () {
	            return this._loadResult.status === Types_1.AppLoadStatus.Success;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppBase.prototype, "hasGameConfiguration", {
	        get: function () {
	            return !neo_common_1.Utils.isNullOrUndefined(this._gameConfiguration);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppBase.prototype, "hasGameDefinition", {
	        get: function () {
	            return !neo_common_1.Utils.isNullOrUndefined(this._gameDefinition);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppBase.prototype, "gameDefinition", {
	        get: function () {
	            return this._gameDefinition;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppBase.prototype, "gameConfiguration", {
	        get: function () {
	            return this._gameConfiguration;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppBase.prototype, "clientHost", {
	        get: function () {
	            return this._clientHost;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppBase.prototype, "appTypeName", {
	        get: function () { },
	        enumerable: true,
	        configurable: true
	    });
	    AppBase.prototype.updateGameConfiguration = function () {
	        var _this = this;
	        return Promise.resolve()
	            .then(function () {
	            if (!neo_common_1.Utils.isNullOrUndefined(_this._clientHost)) {
	                var cfg = _this._gameConfiguration;
	                if (cfg) {
	                    return _this._clientHost.updateGameConfiguration(cfg);
	                }
	            }
	        });
	    };
	    AppBase.prototype.internalInitClientHost = function () {
	        var _this = this;
	        return neo_common_1.Utils.isNullOrUndefined(this._clientHost)
	            ? Promise.resolve()
	            : this._clientHost.initialize(this._appContext)
	                .then(function () { return _this.initClientHost(); })
	                .then(function () { return _this.applyChangesFromClientHost(); });
	    };
	    AppBase.prototype.applyChangesFromClientHost = function () {
	        var _this = this;
	        return Promise.resolve()
	            .then(function () {
	            if (!neo_common_1.Utils.isNullOrUndefined(_this._clientHost)) {
	                var clientHostLanguage = _this._clientHost.getLanguage();
	                if (!neo_common_1.Utils.isNullOrUndefined(clientHostLanguage) && neo_common_1.StringsFactory.currentLanguage !== clientHostLanguage) {
	                    if (false) {
	                        var clientHostType = _this._gameDefinition.ClientHostType;
	                        neo_common_1.Logger.debugGroup(_this.loggerGroup + "/applyChangesFromClientHost", ("Client host '" + clientHostType + "' returns different lang '" + clientHostLanguage + "' than current '" + neo_common_1.StringsFactory.currentLanguage + "', ") +
	                            ("changing to new lang '" + clientHostLanguage + "' now..."));
	                    }
	                    return neo_common_1.StringsFactory.change(clientHostLanguage);
	                }
	            }
	        });
	    };
	    AppBase.prototype.initClientHost = function () {
	        return Promise.resolve();
	    };
	    AppBase.prototype.validateClientHost = function () { };
	    Object.defineProperty(AppBase.prototype, "loggerGroup", {
	        get: function () {
	            return "App-" + this.appTypeName;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AppBase.prototype.loadVersion = function () {
	        if (!neo_common_1.Utils.isNullOrUndefined(this._preloader)) {
	            throw new Error(this.appTypeName + " preloader is already created, could not be created more than once!");
	        }
	        this._preloader = new neo_common_1.Preloader(this._options.preloaderOptions);
	        return this._preloader.loadVersion();
	    };
	    AppBase.prototype.stringsLoadCompleted = function (lang) {
	        if (!neo_common_1.Utils.isNullOrUndefined(this._appContext)) {
	            if (false) {
	                neo_common_1.Logger.debugGroup(this.loggerGroup + "/stringsLoadCompleted", "Calling handleStringsLoadCompleted('" + lang + "')");
	            }
	            this.handleStringsLoadCompleted(lang);
	        }
	        else {
	            if (false) {
	                neo_common_1.Logger.debugGroup(this.loggerGroup + "/stringsLoadCompleted", "Skipping handleStringsLoadCompleted('" + lang + "') because AppContext is not created yet.");
	            }
	        }
	    };
	    AppBase.prototype.loadStrings = function () {
	        var _this = this;
	        this.requireStrings();
	        var self = this;
	        var stringsOptions = {
	            versionId: this.preloaderVersionId,
	            initLoadCallback: function () {
	                var query = neo_common_1.Utils.getURIQuery();
	                var lang = neo_common_1.Utils.valueOrDefault(query['lang'], '');
	                return {
	                    initialLanguage: lang
	                };
	            },
	            loadComplete: self.stringsLoadCompleted
	        };
	        return neo_common_1.StringsFactory.initialize(stringsOptions)
	            .then(function (lang) {
	            if (false) {
	                neo_common_1.Logger.debugGroup(_this.loggerGroup + "/loadStrings", 'strings loaded for lang: ' + lang);
	            }
	            return lang;
	        })
	            .catch(function (err) {
	            if (false) {
	                neo_common_1.Logger.errorGroup(_this.loggerGroup + "/loadStrings", 'Error loading localized strings, ' + neo_common_1.Utils.getErrorMsg(err));
	            }
	            throw err;
	        });
	    };
	    AppBase.prototype.loadGameDefinition = function () {
	        var _this = this;
	        var gameDefinitionFileName = this._options.gameDefinition.file;
	        if (false) {
	            var overwriteFile = window['DEFINITION_FILE'];
	            if (!neo_common_1.StringUtils.isNullOrEmpty(overwriteFile)) {
	                gameDefinitionFileName = overwriteFile;
	                neo_common_1.Logger.debugGroup(this.loggerGroup + "/loadGameDefinition", "Found overwrite setting 'DEFINITION_FILE' in window, using value '" + overwriteFile + "' as definition file!");
	            }
	        }
	        gameDefinitionFileName = neo_common_1.UriHelper.setTimeStamp(gameDefinitionFileName, this.preloaderVersionId);
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerGroup + "/loadGameDefinition", "Loading game definition from file '" + gameDefinitionFileName + "' ...");
	        }
	        return neo_common_1.FileUtils.readLocalJsonFile(gameDefinitionFileName)
	            .then(function (json) {
	            if (!neo_common_1.ObjectUtils.isNullOrEmpty(json)) {
	                _this._gameDefinition = _this.createGameDefinition(json);
	                if (false) {
	                    neo_common_1.Logger.debugGroup(_this.loggerGroup + "/loadGameDefinition", "Loaded game definition from file '" + gameDefinitionFileName + "': ", json);
	                }
	            }
	            else {
	                if (false) {
	                    neo_common_1.Logger.errorGroup(_this.loggerGroup + "/loadGameDefinition", "Loaded game definition from file '" + gameDefinitionFileName + "' has empty content!");
	                }
	            }
	        })
	            .catch(function (err) {
	            if (false) {
	                neo_common_1.Logger.errorGroup(_this.loggerGroup + "/loadGameDefinition", "Error loading game definition from file '" + gameDefinitionFileName + "'.", err);
	            }
	            throw err;
	        });
	    };
	    AppBase.prototype.loadGameConfiguration = function () {
	        var configFile = null;
	        var timestamp = null;
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerGroup + "/loadGameConfiguration", "Resetting preloaderVersionId to null to load latest game configuration.json (date ticks will be used)");
	        }
	        if (false) {
	            var overwriteFile = window['CONFIGURATION_FILE'];
	            if (!neo_common_1.StringUtils.isNullOrEmpty(overwriteFile)) {
	                configFile = neo_common_1.UriHelper.setTimeStamp(overwriteFile, timestamp);
	                neo_common_1.Logger.debugGroup(this.loggerGroup + "/loadGameConfiguration", "Found overwrite setting 'CONFIGURATION_FILE' in window, using value '" + overwriteFile + "' as definition file!");
	            }
	        }
	        if (this.hasLocalStorageConfiguration()) {
	            return this.loadGameConfigurationPacketJSON();
	        }
	        else {
	            return this.loadGameConfigurationLocalFile(configFile, timestamp);
	        }
	    };
	    AppBase.prototype.hasLocalStorageConfiguration = function () {
	        if (neo_common_1.UriHelper.getPacketsMode()) {
	            if (neo_common_1.UriHelper.getPacketSetName(neo_common_1.Utils.getURIQuery()) === 'jsonData') {
	                return localStorage.getItem('jsonData') !== null && localStorage.getItem('jsonData') !== '';
	            }
	        }
	        return false;
	    };
	    AppBase.prototype.loadGameConfigurationPacketJSON = function () {
	        var data = localStorage.getItem('jsonData');
	        try {
	            var jsonData = JSON.parse(data);
	            if (jsonData['Configuration'] != null) {
	                this._gameConfiguration = this.createGameConfiguration(jsonData['Configuration']);
	                return Promise.resolve(this._gameConfiguration);
	            }
	        }
	        catch (err) {
	            if (false) {
	                neo_common_1.Logger.errorGroup(this.loggerGroup + "/loadGameConfiguration", "Error loading game configuration from local storage.", err);
	            }
	            throw err;
	        }
	    };
	    AppBase.prototype.loadGameConfigurationLocalFile = function (configFile, timestamp) {
	        var _this = this;
	        if (configFile === null) {
	            configFile = neo_common_1.UriHelper.setTimeStamp(this._options.gameConfiguration.file, timestamp);
	        }
	        return neo_common_1.FileUtils.readLocalJsonFile(configFile)
	            .then(function (json) {
	            if (!neo_common_1.ObjectUtils.isNullOrEmpty(json)) {
	                _this._gameConfiguration = _this.createGameConfiguration(json);
	                if (false) {
	                    neo_common_1.Logger.debugGroup(_this.loggerGroup + "/loadGameConfiguration", "Loaded game configuration from file '" + configFile + "': ", json);
	                }
	            }
	            return _this._gameConfiguration;
	        })
	            .catch(function (err) {
	            if (false) {
	                neo_common_1.Logger.errorGroup(_this.loggerGroup + "/loadGameConfiguration", "Error loading game configuration.", err);
	            }
	            throw err;
	        });
	    };
	    AppBase.prototype.initAppContext = function () {
	        this._appContext = this.createAppContext();
	        if (neo_common_1.Utils.isNullOrUndefined(this._appContext)) {
	            throw new Error(this.loggerGroup + " - createAppContext must return non-null new instance of AppContext.");
	        }
	        AppContextBase_1.updateClientHost(this._appContext, this._clientHost, this._clientHostConsumer);
	        return Promise.resolve();
	    };
	    AppBase.prototype.loadResources = function () {
	        var loadingGroups = [];
	        if (this._gameConfiguration != null) {
	            if (this._gameConfiguration.SplashScreen) {
	                loadingGroups.push('SPLASH');
	            }
	            this.prepareGameSkin();
	            this.loadExtraContent();
	        }
	        return this._preloader.load(loadingGroups);
	    };
	    AppBase.prototype.prepareGameSkin = function () {
	        if (this._gameConfiguration.GameSkin === '') {
	            return;
	        }
	        window['GAME_SKIN'] = this._gameConfiguration.GameSkin;
	        document.body.classList.add("gameSkin-" + this._gameConfiguration.GameSkin);
	    };
	    AppBase.prototype.loadExtraContent = function () {
	        if (this._gameConfiguration != null) {
	            var extraContent = [];
	            if (this._gameConfiguration.MaxButton) {
	                var path = "Css/Extra/" + window['QUALITY'] + "/maxButton.css";
	                if (false) {
	                    if (window['DEV']) {
	                        path = 'Platform/Desktop/' + path;
	                    }
	                }
	                extraContent.push(path);
	            }
	            if (this._gameConfiguration.FRBFreeSpins) {
	                var path = "Css/Extra/FRBFreeSpins.css";
	                if (false) {
	                    if (window['DEV']) {
	                        path = ("Quality/" + window['QUALITY'] + "/") + path;
	                    }
	                }
	                extraContent.push(path);
	            }
	            for (var i = 0; i < extraContent.length; i++) {
	                this.addExtraCssContent(extraContent[i]);
	            }
	        }
	    };
	    AppBase.prototype.addExtraCssContent = function (filePath) {
	        var head = document.head;
	        var link = document.createElement('link');
	        var mainLink = head.getElementsByTagName('link')[0];
	        var version = "";
	        if (mainLink != null) {
	            var pathVersion = mainLink.getAttribute('href').split('?')[1];
	            if (pathVersion != null) {
	                version = "?" + pathVersion;
	            }
	        }
	        link.type = 'text/css';
	        link.rel = 'stylesheet';
	        link.href = "" + filePath + version;
	        head.appendChild(link);
	    };
	    AppBase.prototype.handleLoadError = function (err) {
	        this._loadResult.error = err;
	        this._loadResult.status = Types_1.AppLoadStatus.Failure;
	        if (false) {
	            neo_common_1.Logger.errorGroup(this.loggerGroup, err);
	        }
	    };
	    AppBase.prototype.loadClientHost = function () {
	        var _this = this;
	        return new Promise(function (resolve, reject) {
	            var defaultClientHostType = _this._options.clientHost.defaultClientHostType;
	            var clientHostType = _this._gameDefinition.ClientHostType;
	            _this._clientHostConsumer = _this.createClientHostConsumer();
	            if (neo_common_1.Utils.isNullOrUndefined(_this._clientHostConsumer)) {
	                if (false) {
	                    neo_common_1.Logger.errorGroup(_this.loggerGroup + "/loadClientHost", 'CreateClientHostConsumer must return non-null new instance of descendant from ClientHostConsumerBase type.');
	                }
	                throw new Error('Error loading client host');
	            }
	            try {
	                _this._clientHost = _this.createClientHost(clientHostType, _this._clientHostConsumer);
	            }
	            catch (err) {
	                if (false) {
	                    var fallbackClientHostType = window['CLIENTHOST_TYPE'];
	                    if (!neo_common_1.StringUtils.isNullOrEmpty(fallbackClientHostType)) {
	                        neo_common_1.Logger.errorGroup(_this.loggerGroup + "/loadClientHost", ("Error loading client host '" + clientHostType + "' (defined by game definition)") +
	                            (", will try to load fallback client host '" + fallbackClientHostType + "' defined in WINDOW['CLIENTHOST_TYPE'] ..."));
	                        _this._clientHost = _this.createClientHost(fallbackClientHostType, _this._clientHostConsumer);
	                        if (neo_common_1.Utils.isNullOrUndefined(_this._clientHost)) {
	                            throw err;
	                        }
	                    }
	                }
	                else {
	                    throw err;
	                }
	            }
	            if (neo_common_1.Utils.isNullOrUndefined(_this._clientHost)) {
	                if (false) {
	                    neo_common_1.Logger.errorGroup(_this.loggerGroup + "/loadClientHost", ("Could not load client host '" + clientHostType + "' (defined by game definition)") +
	                        (", will try to load default client host '" + defaultClientHostType + "'..."));
	                }
	                _this._clientHost = _this.createClientHost(defaultClientHostType, _this._clientHostConsumer);
	            }
	            if (neo_common_1.Utils.isNullOrUndefined(_this._clientHost)) {
	                if (false) {
	                    neo_common_1.Logger.errorGroup(_this.loggerGroup + "/loadClientHost", "Could not load any valid client host ('" + clientHostType + "' or '" + defaultClientHostType + "')!");
	                }
	                throw new Error('Error loading client host');
	            }
	            _this.validateClientHost();
	            if (false) {
	                neo_common_1.Logger.debugGroup(_this.loggerGroup + "/loadClientHost", ("Successfully initialized client host '" + _this._clientHost.type + "' version '" + _this._clientHost.version + "'") +
	                    ", supports : " + JSON.stringify(_this._clientHost.supports));
	            }
	            return resolve(_this._clientHost);
	        });
	    };
	    AppBase.prototype.createClientHost = function (clientHostType, clientHostConsumer) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(clientHostType, 'clientHostType');
	        neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(clientHostConsumer, 'clientHostConsumer');
	        var clientHost = ClientHostFactory_1.ClientHostFactory.create(clientHostType, clientHostConsumer);
	        if (!neo_common_1.Utils.isNullOrUndefined(clientHost)) {
	            ClientHostConsumerBase_1.updateClientHost(clientHostConsumer, clientHost);
	        }
	        return clientHost;
	    };
	    AppBase.prototype.loadCompleted = function () {
	        var configsLoaded = this.hasGameConfiguration && this.hasGameDefinition;
	        var preloaderSucceed = neo_common_1.PreloaderInfo.instance.loadSucceed;
	        var appLoadSucceed = preloaderSucceed && configsLoaded;
	        if (this._loadResult.status === Types_1.AppLoadStatus.Loading && appLoadSucceed) {
	            this._loadResult.status = Types_1.AppLoadStatus.Success;
	        }
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerGroup + "/loadCompleted", "Loading result: " + Types_1.AppLoadStatus[this._loadResult.status]);
	            if (this.hasGameDefinition) {
	                neo_common_1.Logger.debugGroup(this.loggerGroup + "/loadCompleted", "Using game definition: ", this._gameDefinition.getRaw());
	            }
	            if (this.hasGameConfiguration) {
	                var testValue = 123.456;
	                var fmtRes = neo_common_1.NumberUtils.formatNumber(testValue, this._gameConfiguration.NumberFormat);
	                neo_common_1.Logger.debugGroup('GameConfiguration', ("Test number formatting of value '" + testValue + "' (format ") +
	                    ("'" + this._gameConfiguration.NumberFormat + "' from config) => '" + fmtRes + "'"));
	            }
	        }
	        try {
	            this.finalizeLoad();
	            if (this._clientHost) {
	                if (false) {
	                    var clientHostType = this._gameDefinition.ClientHostType;
	                    neo_common_1.Logger.debugGroup(this.loggerGroup + "/loadCompleted", "Calling 'gameLoaded(" + this.loadingSucceed + ")' on client host '" + clientHostType + "'");
	                }
	                this._clientHost.gameLoaded(this);
	            }
	            if (this.supportsRealityCheck) {
	                this.startRealityCheck();
	            }
	            this._preloader = null;
	            if (false) {
	                neo_common_1.Logger.debugGroup(this.loggerGroup + "/loadCompleted", "Preloader resources was cleaned up.");
	            }
	        }
	        catch (err) {
	            if (false) {
	                neo_common_1.Logger.errorGroup(this.loggerGroup + "/loadCompleted", "Calling 'finalizeLoad' failed on error", err);
	            }
	        }
	    };
	    return AppBase;
	}());
	exports.AppBase = AppBase;


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Types_1 = __webpack_require__(7);
	var AppContextBase = (function () {
	    function AppContextBase(gameConfiguration, gameDefinition, gameKey) {
	        this._gameConfiguration = gameConfiguration;
	        this._gameDefinition = gameDefinition;
	        this._gameKey = gameKey;
	        var query = neo_common_1.Utils.getURIQuery();
	        this._currency = query['currency'];
	        AppContextBase._context = this;
	    }
	    AppContextBase.getInstance = function () {
	        return AppContextBase._context;
	    };
	    Object.defineProperty(AppContextBase.prototype, "gameKey", {
	        get: function () {
	            return this._gameKey;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppContextBase.prototype, "currency", {
	        get: function () {
	            return this._currency;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppContextBase.prototype, "gameConfiguration", {
	        get: function () {
	            return this._gameConfiguration;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppContextBase.prototype, "gameDefinition", {
	        get: function () {
	            return this._gameDefinition;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppContextBase.prototype, "clientHost", {
	        get: function () {
	            return this._clientHost;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppContextBase.prototype, "clientHostConsumer", {
	        get: function () {
	            return this._clientHostConsumer;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppContextBase.prototype, "forceToolEnabled", {
	        get: function () {
	            return this.gameConfiguration.ForceToolEnabled;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AppContextBase.prototype.formatNumber = function (value) {
	        return neo_common_1.NumberUtils.formatNumber(value, this.gameConfiguration.NumberFormat);
	    };
	    AppContextBase.prototype.getVolume = function () {
	        var result = null;
	        if (this._clientHost) {
	            if (false) {
	                if (!this._clientHost.supports.volume) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not get volume because client host '" + this._gameDefinition.ClientHostType + "'") +
	                        " does not support this feature!");
	                }
	            }
	            result = this._clientHost.supports.volume ? this._clientHost.getVolume() : null;
	        }
	        return result;
	    };
	    Object.defineProperty(AppContextBase.prototype, "isBackgroundMusicEnabled", {
	        get: function () {
	            if (this._clientHost) {
	                return this._clientHost.getMetadata(Types_1.ClientHostMetadataTypes.BackgroundMusic);
	            }
	            return true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AppContextBase.prototype, "isMuteVolumeAllowed", {
	        get: function () {
	            if (this._clientHost) {
	                return this._clientHost.getMetadata(Types_1.ClientHostMetadataTypes.MuteVolumeAllowed);
	            }
	            return true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AppContextBase.prototype.setDenomination = function (denomination) {
	        if (this._clientHost) {
	            var supportsDenomination = this._clientHost.supports.denomination;
	            if (false) {
	                if (!supportsDenomination) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not set denomination because client host '" + this._gameDefinition.ClientHostType + "'") +
	                        " does not support this feature!");
	                    return;
	                }
	            }
	            if (supportsDenomination) {
	                if (false) {
	                    neo_common_1.Logger.debugGroup('AppContext', "'" + this._gameDefinition.ClientHostType + "' trying to set denomination to '" + denomination + "'..");
	                }
	                this._clientHost.setDenomination(denomination);
	                if (false) {
	                    neo_common_1.Logger.debugGroup('AppContext', "'" + this._gameDefinition.ClientHostType + "' successfully sets denomination to '" + denomination + "'.");
	                }
	            }
	        }
	    };
	    AppContextBase.prototype.getAllowedLanguages = function () {
	        var availableLanguages = neo_common_1.StringsFactory.getLanguages();
	        var result = [];
	        if (this._clientHost) {
	            var clientHostLanguages = this._clientHost.getAllowedLanguages();
	            if (clientHostLanguages && clientHostLanguages.length > 0) {
	                result = neo_common_1.lodash.filter(clientHostLanguages, function (lang) { return availableLanguages.indexOf(lang) > -1; });
	            }
	            if (result.length === 0) {
	                var language = neo_common_1.lodash.find(availableLanguages, function (lang) { return lang === 'en'; });
	                if (language === null && availableLanguages.length > 0) {
	                    language = availableLanguages[0];
	                }
	                result.push(language);
	            }
	        }
	        return result;
	    };
	    AppContextBase.prototype.getCurrentLanguage = function () {
	        return neo_common_1.StringsFactory.currentLanguage;
	    };
	    AppContextBase.prototype.getDenomination = function () {
	        if (this._clientHost) {
	            var supportsDenomination = this._clientHost.supports.denomination;
	            if (false) {
	                if (!supportsDenomination) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not get denomination because client host '" + this._gameDefinition.ClientHostType + "'") +
	                        " does not support this feature!");
	                    return;
	                }
	            }
	            if (supportsDenomination) {
	                return this._clientHost.getDenomination();
	            }
	        }
	        return null;
	    };
	    AppContextBase.prototype.setVolume = function (stepNo) {
	        if (this._clientHost) {
	            var supportsVolume = this._clientHost.supports.volume;
	            if (false) {
	                if (!supportsVolume) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not set volume because client host '" + this._gameDefinition.ClientHostType + "'") +
	                        " does not support this feature!");
	                    return;
	                }
	            }
	            if (supportsVolume) {
	                if (stepNo >= 0 && stepNo <= 3) {
	                    var currentVolume = this.getVolume();
	                    if (!neo_common_1.Utils.isNullOrUndefined(currentVolume)) {
	                        this._clientHost.setVolume(stepNo);
	                        if (false) {
	                            neo_common_1.Logger.debugGroup('AppContext', "'" + this._gameDefinition.ClientHostType + "' volume was set by step " + stepNo);
	                        }
	                    }
	                    else {
	                        if (false) {
	                            neo_common_1.Logger.errorGroup('AppContext', "Could not set volume by step '" + stepNo + "', could not get current volume settings!");
	                        }
	                    }
	                }
	                else {
	                    if (false) {
	                        neo_common_1.Logger.errorGroup('AppContext', "Could not set volume by step '" + stepNo + "' which is outside of allowed range 0-3!");
	                    }
	                }
	            }
	        }
	    };
	    AppContextBase.prototype.showDialog = function (text, isError, code, errorId, gameRoundId, customData) {
	        if (code === void 0) { code = ''; }
	        if (errorId === void 0) { errorId = ''; }
	        if (gameRoundId === void 0) { gameRoundId = ''; }
	        if (customData === void 0) { customData = null; }
	        if (this._clientHost) {
	            var request = {
	                text: text,
	                type: isError ? Types_1.ClientHostDialogType.Error : Types_1.ClientHostDialogType.Normal,
	                error: null,
	                data: customData
	            };
	            if (isError) {
	                if (neo_common_1.StringUtils.isNullOrEmpty(errorId)) {
	                    errorId = '0';
	                }
	                var fullErrorCode = this._gameKey + "-" + code + "-" + gameRoundId + "-" + errorId;
	                request.error = {
	                    errorCode: code,
	                    errorMessageTitle: text,
	                    errorMessageDescription: fullErrorCode
	                };
	            }
	            if (false) {
	                neo_common_1.Logger.debugGroup('AppContext', "'" + this._gameDefinition.ClientHostType + "'.showDialog(), request: ", request);
	            }
	            this._clientHost.showDialog(request);
	        }
	    };
	    AppContextBase.prototype.closeDialog = function () {
	        if (this._clientHost) {
	            if (false) {
	                neo_common_1.Logger.debugGroup('AppContext', "'" + this._gameDefinition.ClientHostType + "'.closeDialog()");
	            }
	            this._clientHost.closeDialog();
	        }
	    };
	    AppContextBase.prototype.setLanguage = function (language) {
	        neo_common_1.StringsFactory.change(language);
	        if (this._clientHost) {
	            if (false) {
	                neo_common_1.Logger.debugGroup('AppContext', "'" + this._gameDefinition.ClientHostType + "'.setLanguage('" + language + "')");
	            }
	            this._clientHost.setLanguage(language);
	        }
	    };
	    AppContextBase.prototype.getBackgroundMusic = function () {
	        if (this._clientHost) {
	            var supportsBackgroundMusic = this.isBackgroundMusicEnabled;
	            if (false) {
	                if (!supportsBackgroundMusic) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not get background music because client host '" + this._gameDefinition.ClientHostType + "' ") +
	                        "does not support background music!");
	                    return;
	                }
	            }
	            if (supportsBackgroundMusic) {
	                return this._clientHost.getBackgroundMusic() === Types_1.OnOffState.On;
	            }
	        }
	        return true;
	    };
	    AppContextBase.prototype.setBackgroundMusic = function (on) {
	        if (this._clientHost) {
	            var supportsBackgroundMusic = this.isBackgroundMusicEnabled;
	            if (false) {
	                if (!supportsBackgroundMusic) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not set background music because client host '" + this._gameDefinition.ClientHostType + "' ") +
	                        "does not support background music!");
	                    return;
	                }
	            }
	            if (supportsBackgroundMusic) {
	                var value = on ? Types_1.OnOffState.On : Types_1.OnOffState.Off;
	                if (false) {
	                    neo_common_1.Logger.debugGroup('AppContext', "'" + this._gameDefinition.ClientHostType + "' trying to set background music to '" + value + "'..");
	                }
	                this._clientHost.setBackgroundMusic(value);
	                if (false) {
	                    neo_common_1.Logger.debugGroup('AppContext', "'" + this._gameDefinition.ClientHostType + "' successfully sets background music to '" + value + "'.");
	                }
	            }
	        }
	    };
	    AppContextBase.prototype.getSharedSetting = function (key) {
	        if (this._clientHost) {
	            var supportsSettings = this._clientHost.supports.settings;
	            if (false) {
	                if (!supportsSettings) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not get shared setting because client host '" + this._gameDefinition.ClientHostType + "' ") +
	                        "does not support this feature!");
	                    return;
	                }
	            }
	            if (supportsSettings) {
	                return this._clientHost.getSharedSetting(key);
	            }
	        }
	        return undefined;
	    };
	    AppContextBase.prototype.getGameSetting = function (key) {
	        if (this._clientHost) {
	            var supportsSettings = this._clientHost.supports.settings;
	            if (false) {
	                if (!supportsSettings) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not get shared setting because client host '" + this._gameDefinition.ClientHostType + "' ") +
	                        "does not support this feature!");
	                    return;
	                }
	            }
	            if (supportsSettings) {
	                return this._clientHost.getGameSetting(key);
	            }
	        }
	        return undefined;
	    };
	    AppContextBase.prototype.updateSharedSetting = function (key, value) {
	        if (this._clientHost) {
	            var supportsSettings = this._clientHost.supports.settings;
	            if (false) {
	                if (!supportsSettings) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not set shared setting because client host '" + this._gameDefinition.ClientHostType + "' ") +
	                        "does not support this feature!");
	                    return;
	                }
	            }
	            if (supportsSettings) {
	                this._clientHost.updateSharedSetting(key, value);
	            }
	        }
	    };
	    AppContextBase.prototype.updateGameSetting = function (key, value) {
	        if (this._clientHost) {
	            var supportsSettings = this._clientHost.supports.settings;
	            if (false) {
	                if (!supportsSettings) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not set game setting because client host '" + this._gameDefinition.ClientHostType + "' ") +
	                        "does not support this feature!");
	                    return;
	                }
	            }
	            if (supportsSettings) {
	                this._clientHost.updateGameSetting(key, value);
	            }
	        }
	    };
	    AppContextBase.prototype.sendMessageToExternal = function (message, targetExternalId) {
	        if (this._clientHost) {
	            var supportsExternalMessage = this._clientHost.supports.externalMessage;
	            if (false) {
	                if (!supportsExternalMessage) {
	                    neo_common_1.Logger.debugGroup('AppContext', ("Could not send external message because client host '" + this._gameDefinition.ClientHostType + "'") +
	                        " does not support this feature!");
	                    return;
	                }
	            }
	            if (supportsExternalMessage) {
	                if (false) {
	                    neo_common_1.Logger.debugGroup('AppContext', "'" + this._gameDefinition.ClientHostType + "' sending external message ...");
	                }
	                this._clientHost.sendMessageToExternal(message, targetExternalId);
	            }
	        }
	    };
	    AppContextBase._context = null;
	    return AppContextBase;
	}());
	exports.AppContextBase = AppContextBase;
	function updateClientHost(appContext, clientHost, clientHostConsumer) {
	    neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(appContext, 'appContext');
	    neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(clientHost, 'clientHost');
	    neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(clientHostConsumer, 'clientHostConsumer');
	    appContext._clientHost = clientHost;
	    appContext._clientHostConsumer = clientHostConsumer;
	}
	exports.updateClientHost = updateClientHost;


/***/ },
/* 20 */
/***/ function(module, exports) {

	"use strict";
	(function (AppLoadStatus) {
	    AppLoadStatus[AppLoadStatus["Unknown"] = 0] = "Unknown";
	    AppLoadStatus[AppLoadStatus["Loading"] = 1] = "Loading";
	    AppLoadStatus[AppLoadStatus["Success"] = 2] = "Success";
	    AppLoadStatus[AppLoadStatus["Failure"] = 3] = "Failure";
	})(exports.AppLoadStatus || (exports.AppLoadStatus = {}));
	var AppLoadStatus = exports.AppLoadStatus;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var key_NumberFormat = 'NumberFormat';
	var key_ForceToolEnabled = 'ForceToolEnabled';
	var key_ForceToolDebugEnabled = 'ForceToolDebugEnabled';
	var key_ForceToolDemoPINHash = 'ForceToolDemoPINHash';
	var key_ExitUrl = 'ExitUrl';
	var key_HistoryUrl = 'HistoryUrl';
	var key_RealityCheckStartInterval = 'RealityCheckStartInterval';
	var key_RealityCheckInterval = 'RealityCheckInterval';
	var key_ServerRequestTimeout = 'ServerRequestTimeout';
	var key_Workarounds = 'Workarounds';
	var key_KeepAliveInterval = 'KeepAliveInterval';
	var key_KeepAliveRefreshInterval = 'KeepAliveRefreshInterval';
	var key_SplashScreen = 'SplashScreen';
	var key_GameSkin = 'GameSkin';
	var key_MaxButton = 'MaxButton';
	var key_FRBFreeSpins = 'FRBFreeSpins';
	var key_PlayerRetentionPlugins = 'PlayerRetentionPlugins';
	var key_EventTrackerEnabledEvents = 'EventTrackerEnabledEvents';
	var key_TournamentEventTrackerEnabled = 'TournamentEventTrackerEnabled';
	var GameConfigurationBase = (function () {
	    function GameConfigurationBase(configuration) {
	        if (false) {
	            if (neo_common_1.Utils.isNullOrUndefined(configuration)) {
	                neo_common_1.Logger.errorGroup('GameConfiguration', "Parameter \"configuration\" must not be null!");
	            }
	        }
	        this._configuration = neo_common_1.Utils.valueOrDefault(configuration, {});
	    }
	    GameConfigurationBase.prototype.getRaw = function () {
	        return this._configuration;
	    };
	    GameConfigurationBase.prototype.merge = function (otherConfiguration, fileName) {
	        if (!neo_common_1.Utils.isNullOrUndefined(otherConfiguration)) {
	            neo_common_1.ObjectUtils.assign(this._configuration, otherConfiguration);
	            if (false) {
	                neo_common_1.Logger.debugGroup('GameConfiguration', "Game configuration merged with file '" + fileName + "', merge result: ", this._configuration);
	            }
	        }
	    };
	    GameConfigurationBase.prototype.setValue = function (key, value) {
	        if (neo_common_1.Utils.isNullOrUndefined(this._configuration)) {
	            this._configuration = {};
	        }
	        this._configuration[key] = value;
	        if (false) {
	            neo_common_1.Logger.debugGroup('GameConfiguration', "Setting game configuration key '" + key + "' with value '" + value + "' using proxy.");
	        }
	    };
	    GameConfigurationBase.prototype.getValue = function (key, defaultValue) {
	        var result = defaultValue;
	        if (this._configuration && this._configuration.hasOwnProperty(key)) {
	            result = this._configuration[key];
	            if (!neo_common_1.Utils.isNullOrUndefined(result)) {
	                var resultValueType = typeof result;
	                var expectedValueType = typeof defaultValue;
	                var incompatibleTypes = resultValueType !== expectedValueType;
	                if (incompatibleTypes) {
	                    if (expectedValueType === 'number' && resultValueType === 'string') {
	                        var parsedResult = neo_common_1.NumberUtils.tryParseNumber(result);
	                        if (parsedResult.isValid) {
	                            result = parsedResult.value;
	                            incompatibleTypes = false;
	                        }
	                    }
	                    else if (expectedValueType === 'boolean' && resultValueType === 'string' && !neo_common_1.StringUtils.isNullOrEmpty(result)) {
	                        var bstr = result.toLowerCase();
	                        if (bstr === 'true') {
	                            result = true;
	                            incompatibleTypes = false;
	                        }
	                        else if (bstr === 'false') {
	                            result = false;
	                            incompatibleTypes = false;
	                        }
	                    }
	                    if (incompatibleTypes) {
	                        if (false) {
	                            neo_common_1.Logger.errorGroup('GameConfiguration', ("Incompatible value type (" + resultValueType + ") of key \"" + key + "\" from configuration file, ") +
	                                ("expected value type (" + expectedValueType + "), returning default value '" + defaultValue + "'"));
	                        }
	                        result = defaultValue;
	                    }
	                }
	            }
	        }
	        return result;
	    };
	    Object.defineProperty(GameConfigurationBase.prototype, "NumberFormat", {
	        get: function () {
	            return this.getValue(key_NumberFormat, '0.00');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "ForceToolEnabled", {
	        get: function () {
	            return this.getValue(key_ForceToolEnabled, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "ForceToolDebugEnabled", {
	        get: function () {
	            return this.getValue(key_ForceToolDebugEnabled, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "ForceToolDemoPINHash", {
	        get: function () {
	            return '';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "ExitUrl", {
	        get: function () {
	            return this.getValue(key_ExitUrl, '');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "HistoryUrl", {
	        get: function () {
	            return this.getValue(key_HistoryUrl, '');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "SplashScreen", {
	        get: function () {
	            return this.getValue(key_SplashScreen, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "RealityCheckStartInterval", {
	        get: function () {
	            return this.getValue(key_RealityCheckStartInterval, -1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "RealityCheckInterval", {
	        get: function () {
	            return this.getValue(key_RealityCheckInterval, -1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "ServerRequestTimeout", {
	        get: function () {
	            return this.getValue(key_ServerRequestTimeout, -1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "Workarounds", {
	        get: function () {
	            return this.getValue(key_Workarounds, null);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GameConfigurationBase.prototype.getWorkaround = function (workaroundId) {
	        var w = this.Workarounds;
	        return neo_common_1.ObjectUtils.isNullOrEmpty(w) ? null : w[workaroundId];
	    };
	    Object.defineProperty(GameConfigurationBase.prototype, "KeepAliveInterval", {
	        get: function () {
	            return this.getValue(key_KeepAliveInterval, 8 * 60);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "KeepAliveRefreshInterval", {
	        get: function () {
	            return this.getValue(key_KeepAliveRefreshInterval, 60);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "MaxButton", {
	        get: function () {
	            return this.getValue(key_MaxButton, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "FRBFreeSpins", {
	        get: function () {
	            return this.getValue(key_FRBFreeSpins, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "GameSkin", {
	        get: function () {
	            return this.getValue(key_GameSkin, '');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "EventTrackerEnabledEvents", {
	        get: function () {
	            return this.getValue(key_EventTrackerEnabledEvents, '');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "TournamentEventTrackerEnabled", {
	        get: function () {
	            return this.getValue(key_TournamentEventTrackerEnabled, false);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameConfigurationBase.prototype, "PlayerRetentionPlugins", {
	        get: function () {
	            var data = this.getValue(key_PlayerRetentionPlugins, []);
	            if (data == null || data.length === 0) {
	                var uriData = neo_common_1.UriHelper.parseUrl(window.location.href, true);
	                var pluginsData = uriData.query['plugins'];
	                if (pluginsData != null) {
	                    data = pluginsData.split('|');
	                }
	            }
	            return data;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return GameConfigurationBase;
	}());
	exports.GameConfigurationBase = GameConfigurationBase;


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var key_ClientHostType = 'ClientHostType';
	var key_RealityCheckType = 'RealityCheckType';
	var key_GameClientCallsRealityCheckUrls = 'GameClientCallsRealityCheckUrls';
	var GameDefinitionBase = (function () {
	    function GameDefinitionBase(definition) {
	        if (false) {
	            if (neo_common_1.Utils.isNullOrUndefined(definition)) {
	                neo_common_1.Logger.errorGroup('GameDefinition', "Parameter \"definition\" must not be null!");
	            }
	        }
	        this._definition = neo_common_1.Utils.valueOrDefault(definition, {});
	    }
	    GameDefinitionBase.prototype.getRaw = function () {
	        return this._definition;
	    };
	    GameDefinitionBase.prototype.getValue = function (key, defaultValue) {
	        var result = defaultValue;
	        if (this._definition && this._definition.hasOwnProperty(key)) {
	            result = this._definition[key];
	            if (!neo_common_1.Utils.isNullOrUndefined(result)) {
	                var resultValueType = typeof result;
	                var expectedValueType = typeof defaultValue;
	                if (resultValueType !== expectedValueType) {
	                    if (false) {
	                        neo_common_1.Logger.errorGroup('GameDefinition', ("Incompatible value type (" + resultValueType + ") of key \"" + key + "\" from definition file, ") +
	                            ("expected value type (" + expectedValueType + "), returning default value '" + defaultValue + "'"));
	                    }
	                    result = defaultValue;
	                }
	            }
	        }
	        return result;
	    };
	    Object.defineProperty(GameDefinitionBase.prototype, "ClientHostType", {
	        get: function () {
	            return this.getValue(key_ClientHostType, 'Default');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameDefinitionBase.prototype, "RealityCheckType", {
	        get: function () {
	            return this.getValue(key_RealityCheckType, 'Default');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameDefinitionBase.prototype, "GameClientCallsRealityCheckUrls", {
	        get: function () {
	            return this.getValue(key_GameClientCallsRealityCheckUrls, true);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return GameDefinitionBase;
	}());
	exports.GameDefinitionBase = GameDefinitionBase;


/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var AppBase_1 = __webpack_require__(18);
	var GameClientOptions_1 = __webpack_require__(24);
	var RealityCheckFactory_1 = __webpack_require__(25);
	var defaultQualities = {
	    'FHD': {
	        width: 1920,
	        height: 1080
	    },
	    'HD': {
	        width: 1280,
	        height: 720
	    },
	    'QHD': {
	        width: 960,
	        height: 540
	    }
	};
	var appTypeName = 'Game';
	var GameAppBase = (function (_super) {
	    __extends(GameAppBase, _super);
	    function GameAppBase() {
	        _super.call(this);
	        this._qualities = this.createGameQualities();
	        this._gameClient = null;
	        this._currentBrowser = neo_common_1.BrowserUtils.getNameAndVersion();
	        this._realityCheck = null;
	        this.handleRealityCheckTimerExpired = this.handleRealityCheckTimerExpired.bind(this);
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerGroup, "Detected browser: ", this._currentBrowser);
	        }
	    }
	    Object.defineProperty(GameAppBase.prototype, "supportsRealityCheck", {
	        get: function () {
	            return true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameAppBase.prototype, "appTypeName", {
	        get: function () {
	            return appTypeName;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GameAppBase.prototype.createGameQualities = function () {
	        return neo_common_1.ObjectUtils.clone(defaultQualities);
	    };
	    GameAppBase.prototype.loadGameConfiguration = function () {
	        var _this = this;
	        var self = this;
	        var loggerGroup = this.loggerGroup + "/loadGameConfiguration";
	        return _super.prototype.loadGameConfiguration.call(this)
	            .then(function () {
	            if (!neo_common_1.Utils.isNullOrUndefined(self._clientHost) && !neo_common_1.Utils.isNullOrUndefined(self._clientHost.supports)) {
	                var serverConfigurationRequestAllowed = neo_common_1.Utils.valueOrDefault(self._clientHost.supports.serverConfigurationRequestAllowed, true);
	                if (!serverConfigurationRequestAllowed) {
	                    if (false) {
	                        neo_common_1.Logger.debugGroup(loggerGroup, "Loading game configuration from server was disallowed by client host '" + self._clientHost.type + "'.");
	                    }
	                    return;
	                }
	            }
	            if (false) {
	                neo_common_1.Logger.debugGroup(loggerGroup, "Loading game configuration from server...");
	            }
	            var options = GameClientOptions_1.GameClientOptions.get();
	            options.disableKeepAlive();
	            var configGameClient = self.createGameClient(options);
	            var version = _this._preloader ? _this._preloader.versionId : '';
	            return configGameClient.sendConfigurationRequest(version)
	                .then(function (configResponse) {
	                var hasConfigResponse = !neo_common_1.ObjectUtils.isNullOrEmpty(configResponse);
	                if (false) {
	                    neo_common_1.Logger.debugGroup(loggerGroup, "Loading game configuration from server, received config from server? " + (hasConfigResponse ? 'YES' : 'NO'));
	                }
	                if (hasConfigResponse && self._gameConfiguration) {
	                    if (false) {
	                        neo_common_1.Logger.debugGroup(loggerGroup, 'Game configuration before merge from server: ', self._gameConfiguration.getRaw());
	                    }
	                    self._gameConfiguration.merge(configResponse, 'SERVER URL');
	                    if (false) {
	                        neo_common_1.Logger.debugGroup(loggerGroup, 'Final game configuration: ', self._gameConfiguration.getRaw());
	                    }
	                }
	                else {
	                    if (!neo_common_1.UriHelper.getPacketsMode()) {
	                        self._gameConfiguration = null;
	                        throw new Error("Failed to request server configuration");
	                    }
	                }
	            })
	                .catch(function (err) {
	                if (err) {
	                    neo_common_1.Logger.warnGroup(loggerGroup, "Failed to request server configuration");
	                }
	                throw err;
	            });
	        });
	    };
	    GameAppBase.prototype.getGameClientOptions = function () {
	        var options = GameClientOptions_1.GameClientOptions.get();
	        if (this._appContext != null && this._appContext.gameConfiguration) {
	            options.enabledKeepAlive(this._appContext.gameConfiguration.KeepAliveInterval);
	            options.setKeepAliveRefreshTime(this._appContext.gameConfiguration.KeepAliveRefreshInterval);
	            options.setServerRequestTimeout(this._appContext.gameConfiguration.ServerRequestTimeout);
	        }
	        return options;
	    };
	    GameAppBase.prototype.initGameClient = function () {
	        var self = this;
	        if (this._gameClient === null) {
	            var gameClient = null;
	            if (false) {
	                var packetMode = neo_common_1.UriHelper.getPacketsMode();
	                if (packetMode) {
	                    var gameKey = neo_common_1.UriHelper.getGameKey();
	                    var PacketGameClient = require('../../Tools/PacketClient/PacketClient').PacketGameClient;
	                    gameClient = new PacketGameClient(gameKey);
	                }
	            }
	            if (gameClient === null) {
	                gameClient = this.createGameClient(this.getGameClientOptions());
	            }
	            var forceToolExternalSetup = window['ForceToolExternalSetup'];
	            if (!neo_common_1.Utils.isNullOrUndefined(forceToolExternalSetup) && !neo_common_1.Utils.isNullOrUndefined(forceToolExternalSetup.initialize) &&
	                typeof (forceToolExternalSetup.initialize) === 'function') {
	                var fns = {
	                    isForceToolEnabled: function () {
	                        return self._appContext.gameConfiguration.ForceToolEnabled;
	                    },
	                    isForceToolDebugEnabled: function () {
	                        return self._appContext.gameConfiguration.ForceToolDebugEnabled;
	                    },
	                    forceToolDemoPINHash: function () {
	                        return self._appContext.gameConfiguration.ForceToolDemoPINHash;
	                    },
	                    isGameCollectable: function () {
	                        return false;
	                    }
	                };
	                forceToolExternalSetup.initialize(fns);
	            }
	            this._gameClient = gameClient;
	            if (false) {
	                if (neo_common_1.Utils.isNullOrUndefined(this._gameClient)) {
	                    neo_common_1.Logger.errorGroup(this.loggerGroup, "Game client was NOT initialized.");
	                }
	                else {
	                    neo_common_1.Logger.debugGroup(this.loggerGroup, "Game client was initialized.");
	                }
	            }
	        }
	    };
	    GameAppBase.prototype.beforeExit = function () {
	        return Promise.resolve();
	    };
	    Object.defineProperty(GameAppBase.prototype, "fallbackQuality", {
	        get: function () {
	            return 'HD';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GameAppBase.prototype.loadVersion = function () {
	        this.initStage();
	        return _super.prototype.loadVersion.call(this);
	    };
	    GameAppBase.prototype.loadResources = function () {
	        this.applyWorkarounds();
	        return _super.prototype.loadResources.call(this);
	    };
	    GameAppBase.prototype.applyWorkarounds = function () {
	        var workaroundId = 'preloader_audio';
	        if (this._gameConfiguration != null) {
	            var workaround_definition = this._gameConfiguration.getWorkaround(workaroundId);
	            if (!neo_common_1.Utils.isNullOrUndefined(workaround_definition)) {
	                if (false) {
	                    neo_common_1.Logger.debugGroup(this.loggerGroup, "Found workaround '" + workaroundId + "' definition: ", workaround_definition);
	                }
	                var workaroundActive = neo_common_1.BrowserUtils.checkExact(workaround_definition);
	                if (workaroundActive) {
	                    if (false) {
	                        neo_common_1.Logger.debugGroup(this.loggerGroup, "Workaround '" + workaroundId + "' will be applied, definition match current browser: ", this._currentBrowser);
	                    }
	                    this._preloader.skipAudioResources = true;
	                    if (false) {
	                        neo_common_1.Logger.debugGroup(this.loggerGroup, "Workaround '" + workaroundId + "' -> skip loading audio resources was set!");
	                    }
	                }
	                else {
	                    if (false) {
	                        neo_common_1.Logger.debugGroup(this.loggerGroup, "Workaround '" + workaroundId + "' will not be applied, definition does not match current browser: ", this._currentBrowser);
	                    }
	                }
	            }
	        }
	    };
	    GameAppBase.prototype.initStage = function () {
	        var qualityKey = window['QUALITY'] || '';
	        var qualitySize = neo_common_1.StringUtils.isNullOrEmpty(qualityKey) ? null : this._qualities[qualityKey];
	        if (neo_common_1.Utils.isNullOrUndefined(qualitySize)) {
	            if (false) {
	                neo_common_1.Logger.errorGroup(this.loggerGroup, ("Could not find quality settings for '" + qualityKey + "',") +
	                    (" using fallback quality '" + this.fallbackQuality + "'."));
	            }
	            qualityKey = this.fallbackQuality;
	            qualitySize = this._qualities[qualityKey];
	        }
	        if (qualitySize.width <= 0 || qualitySize.height <= 0) {
	            qualitySize = this._qualities[qualityKey];
	        }
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerGroup, "Initializing stage for quality '" + qualityKey + "', width: " + qualitySize.width + " and height: " + qualitySize.height);
	        }
	        this.createStage(qualityKey, qualitySize);
	    };
	    GameAppBase.prototype.prepareLoad = function () {
	        return Promise.resolve()
	            .then(function () {
	            var uriQuery = neo_common_1.Utils.getURIQuery();
	            var gameKey = neo_common_1.UriHelper.getGameKey();
	            var prepared = true;
	            if (false) {
	                var packetsMode = neo_common_1.UriHelper.getPacketsMode(uriQuery);
	                var packetsSetName = neo_common_1.UriHelper.getPacketSetName(uriQuery);
	                prepared = !packetsMode;
	                if (packetsMode) {
	                    var OfflinePackets = require('../../Tools/PacketClient/OfflinePackets').OfflinePackets;
	                    var PacketPlayer = require('../../Tools/PacketClient/PacketPlayer').PacketPlayer;
	                    if (!neo_common_1.Utils.isNullOrUndefined(packetsSetName)) {
	                        return OfflinePackets.hasLoadedSet(packetsSetName, gameKey)
	                            .then(function (hasLoadedSet) {
	                            return hasLoadedSet;
	                        });
	                    }
	                    new PacketPlayer(gameKey);
	                }
	            }
	            return Promise.resolve(prepared);
	        });
	    };
	    GameAppBase.prototype.loadClientHost = function () {
	        var _this = this;
	        var self = this;
	        return _super.prototype.loadClientHost.call(this)
	            .then(function (clientHost) {
	            if (_this._clientHostConsumer) {
	                _this._clientHostConsumer._exitGameFunc = function () {
	                    return self.exit();
	                };
	            }
	            return clientHost;
	        });
	    };
	    GameAppBase.prototype.loadCompleted = function () {
	        this.initGameClient();
	        _super.prototype.loadCompleted.call(this);
	    };
	    GameAppBase.prototype.exit = function () {
	        var self = this;
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerGroup, "Calling exit()...");
	        }
	        return this.beforeExit()
	            .finally(function () { return self._clientHost.endGame(self, { reason: '' }); });
	    };
	    GameAppBase.prototype.history = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerGroup, "Calling history()...");
	        }
	        this._clientHost.history(this);
	        return Promise.resolve();
	    };
	    GameAppBase.prototype.continue = function () {
	        var self = this;
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerGroup, "Calling continue()...");
	        }
	        return Promise.resolve()
	            .then(function () {
	            if (self._gameDefinition.GameClientCallsRealityCheckUrls) {
	                if (false) {
	                    neo_common_1.Logger.debugGroup(self.loggerGroup, "continue() -> calling 'reset reality check player url' ...");
	                }
	                return self._gameClient.resetRealityCheck();
	            }
	        })
	            .then(function () {
	            self.resetRealityCheck();
	        })
	            .then(function () {
	            return self._clientHost.continue(self);
	        });
	    };
	    GameAppBase.prototype.getRealityCheckInfo = function () {
	        var self = this;
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerGroup, "Calling continue()...");
	        }
	        return Promise.resolve()
	            .then(function () {
	            return self._gameClient.getRealityCheckInfo();
	        });
	    };
	    GameAppBase.prototype.closeRealityCheck = function () {
	        var self = this;
	        return Promise.resolve()
	            .then(function () {
	            if (self._gameDefinition.GameClientCallsRealityCheckUrls) {
	                if (false) {
	                    neo_common_1.Logger.debugGroup(self.loggerGroup, "continue() -> calling 'reset reality check player url' ...");
	                }
	                return self._gameClient.resetRealityCheck();
	            }
	        })
	            .then(function () {
	            self.resetRealityCheck();
	        });
	    };
	    GameAppBase.prototype.resetRealityCheck = function () {
	        if (this._realityCheck) {
	            if (false) {
	                neo_common_1.Logger.debugGroup(this.loggerGroup, "reality check - calling reset.");
	            }
	            return this._realityCheck.reset();
	        }
	    };
	    GameAppBase.prototype.startRealityCheck = function () {
	        if (this.loadingSucceed) {
	            var realityCheckInterval = this.gameConfiguration.RealityCheckInterval;
	            var realityCheckStartInterval = this.gameConfiguration.RealityCheckStartInterval;
	            var enableRealityCheck = realityCheckInterval > -1 && realityCheckStartInterval > -1;
	            if (false) {
	                var realityCheckInfo = "(realityCheckInterval: " + realityCheckInterval + " sec, realityCheckStartInterval: " + realityCheckStartInterval + " sec)";
	                if (enableRealityCheck) {
	                    neo_common_1.Logger.debugGroup(this.loggerGroup, "startRealityCheck() -> detected and enabled 'Reality Check' from game configuration " + realityCheckInfo);
	                }
	                else {
	                    neo_common_1.Logger.debugGroup(this.loggerGroup, "startRealityCheck() -> 'Reality Check' was not detected thus not enabled " + realityCheckInfo);
	                }
	            }
	            if (enableRealityCheck) {
	                var realityCheckType = this._gameDefinition.RealityCheckType;
	                if (false) {
	                    neo_common_1.Logger.debugGroup("" + this.loggerGroup, "startRealityCheck() -> Defined reality check type '" + realityCheckType + "' ...");
	                }
	                this._realityCheck = RealityCheckFactory_1.RealityCheckFactory.create(realityCheckType);
	                if (false) {
	                    if (neo_common_1.Utils.isNullOrUndefined(this._realityCheck)) {
	                        neo_common_1.Logger.debugGroup(this.loggerGroup, "startRealityCheck() -> Could not create implementation of reality check, " +
	                            ("RealityCheckFactory does not create valid reality check (Type: '" + realityCheckType + "') !"));
	                    }
	                    else {
	                        neo_common_1.Logger.debugGroup(this.loggerGroup, "startRealityCheck() -> Created reality check '" + this._realityCheck.name + "' v'" + this._realityCheck.version + "' (Type: '" + realityCheckType + "')");
	                    }
	                }
	                if (this._realityCheck) {
	                    this._realityCheck.initialize(this, this.handleRealityCheckTimerExpired);
	                    this._realityCheck.start();
	                }
	            }
	        }
	        else {
	            if (false) {
	                neo_common_1.Logger.debugGroup(this.loggerGroup, "startRealityCheck() -> Coult not create/start reality check because app was not successfully loaded (app.loadingSucceed -> " + this.loadingSucceed + ")");
	            }
	        }
	    };
	    GameAppBase.prototype.handleRealityCheckTimerExpired = function (request) {
	        this._clientHost.showDialog(request);
	    };
	    return GameAppBase;
	}(AppBase_1.AppBase));
	exports.GameAppBase = GameAppBase;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var GameClientOptions = (function (_super) {
	    __extends(GameClientOptions, _super);
	    function GameClientOptions() {
	        _super.apply(this, arguments);
	    }
	    GameClientOptions.get = function () {
	        if (false) {
	            var packetMode = neo_common_1.UriHelper.getPacketsMode();
	            if (packetMode) {
	                return new GameClientOptions('dummy', 'dummy', false, 0);
	            }
	        }
	        var uri = neo_common_1.Utils.getURIQuery();
	        var serverUrl = uri['serverUrl'];
	        var token = neo_common_1.UriHelper.getHashGroupValue('token', '');
	        if (neo_common_1.StringUtils.isNullOrEmpty(token)) {
	            throw new Error("Could not found #token hash in url, which is required!");
	        }
	        return new GameClientOptions(serverUrl, token, false, 0);
	    };
	    return GameClientOptions;
	}(neo_common_1.ApiClientCommunication.ApiClientOptions));
	exports.GameClientOptions = GameClientOptions;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var RealityCheckFactory = (function () {
	    function RealityCheckFactory() {
	    }
	    RealityCheckFactory.register = function (component, componentType) {
	        var cmpName = component.name;
	        if (cmpName === undefined || cmpName === '') {
	            throw new Error('[RealityCheckFactory] specified component does not contain property "name"');
	        }
	        if (componentType === undefined || componentType === '') {
	            throw new Error('[RealityCheckFactory] component type was not specified!');
	        }
	        var list = RealityCheckFactory.list;
	        var reg = list[componentType];
	        if (!reg) {
	            list[componentType] = {
	                component: component,
	                type: componentType
	            };
	            this.count++;
	            if (false) {
	                neo_common_1.Logger.debugGroup('Register reality check', ("Reality check '" + cmpName + "' (type: " + componentType + ")")
	                    + (" was successfully registered (" + this.count + " so far)."));
	            }
	        }
	        else {
	            throw new Error(("[RealityCheckFactory] Reality check \"" + cmpName + "\" (type: " + componentType + ")")
	                + " is already registered!");
	        }
	    };
	    RealityCheckFactory.create = function (type) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(type, 'type');
	        var list = RealityCheckFactory.list;
	        var reg = neo_common_1.lodash.find(list, function (item) { return neo_common_1.StringUtils.equals(item.type, type, true); });
	        if (reg) {
	            var classType = reg.component;
	            return new classType();
	        }
	        if (false) {
	            neo_common_1.Logger.debugGroup('[RealityCheckFactory]', "Create('" + type + "') could not found reality check with such type!");
	        }
	        return null;
	    };
	    RealityCheckFactory.list = {};
	    RealityCheckFactory.count = 0;
	    return RealityCheckFactory;
	}());
	exports.RealityCheckFactory = RealityCheckFactory;
	function registerRealityCheck(componentType) {
	    return function (component) {
	        RealityCheckFactory.register(component, componentType);
	        component.prototype.__componentName__ = component.name;
	        component.prototype.__componentType__ = componentType;
	    };
	}
	exports.registerRealityCheck = registerRealityCheck;
	var isBrowser = typeof window !== 'undefined';
	if (isBrowser) {
	    window['registerRealityCheck'] = registerRealityCheck;
	}


/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ClientHostConsumerBase_1 = __webpack_require__(4);
	var neo_common_1 = __webpack_require__(1);
	var GameClientHostConsumerBase = (function (_super) {
	    __extends(GameClientHostConsumerBase, _super);
	    function GameClientHostConsumerBase(app) {
	        _super.call(this, app);
	    }
	    GameClientHostConsumerBase.prototype.handleExit = function (request, callback) {
	        if (false) {
	            console.log("GameClientHostConsumerBase, Received \"handleExit\" event, request: " + JSON.stringify(request) + "'");
	        }
	        var gameCollect = neo_common_1.Utils.valueOrDefault(request.GameCollect, true);
	        if (false) {
	            console.log("GameClientHostConsumerBase, handleExit -> gameCollect = " + gameCollect);
	        }
	        var canExitNow = !gameCollect || this.terminateOnCollect();
	        if (false) {
	            console.log("GameClientHostConsumerBase, canExitNow: " + canExitNow);
	        }
	        if (canExitNow) {
	            this._app.exit();
	        }
	    };
	    return GameClientHostConsumerBase;
	}(ClientHostConsumerBase_1.ClientHostConsumerBase));
	exports.GameClientHostConsumerBase = GameClientHostConsumerBase;


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var AppBase_1 = __webpack_require__(18);
	var appTypeName = 'Paytable';
	var PaytableAppBase = (function (_super) {
	    __extends(PaytableAppBase, _super);
	    function PaytableAppBase() {
	        _super.call(this);
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerGroup, 'start, user agent: ' + window.navigator.userAgent);
	        }
	    }
	    Object.defineProperty(PaytableAppBase.prototype, "supportsRealityCheck", {
	        get: function () {
	            return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PaytableAppBase.prototype.startRealityCheck = function () {
	        throw new Error('Not supported.');
	    };
	    Object.defineProperty(PaytableAppBase.prototype, "appTypeName", {
	        get: function () {
	            return appTypeName;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PaytableAppBase.prototype.prepareLoad = function () {
	        return Promise.resolve(true);
	    };
	    PaytableAppBase.prototype.validateClientHost = function () {
	        _super.prototype.validateClientHost.call(this);
	        if (!this._clientHost.supports.paytable) {
	            if (false) {
	                neo_common_1.Logger.errorGroup("" + this.loggerGroup, "Could not initialize paytable from client host '" + this._clientHost.type + "' which does not supports paytable!");
	            }
	            throw new Error("Error in loading paytable!");
	        }
	    };
	    PaytableAppBase.prototype.exit = function () {
	        throw new Error('Not supported.');
	    };
	    PaytableAppBase.prototype.history = function () {
	        throw new Error('Not supported.');
	    };
	    PaytableAppBase.prototype.continue = function () {
	        throw new Error('Not supported.');
	    };
	    return PaytableAppBase;
	}(AppBase_1.AppBase));
	exports.PaytableAppBase = PaytableAppBase;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var ClientHostConsumerBase_1 = __webpack_require__(4);
	var PaytableClientHostConsumerBase = (function (_super) {
	    __extends(PaytableClientHostConsumerBase, _super);
	    function PaytableClientHostConsumerBase(app) {
	        _super.call(this, app);
	    }
	    PaytableClientHostConsumerBase.prototype.handleAction = function (actionGroup, action) {
	    };
	    PaytableClientHostConsumerBase.prototype.handleExit = function (request, callback) {
	    };
	    PaytableClientHostConsumerBase.prototype.handleAccountUpdate = function (balance, forceShow) {
	    };
	    PaytableClientHostConsumerBase.prototype.handleRefreshAccount = function () {
	    };
	    PaytableClientHostConsumerBase.prototype.handleError = function (error, data) {
	    };
	    PaytableClientHostConsumerBase.prototype.handleShowDialog = function (request) {
	    };
	    PaytableClientHostConsumerBase.prototype.handleCloseDialog = function () {
	    };
	    PaytableClientHostConsumerBase.prototype.handlePaytableRequest = function (request) {
	    };
	    PaytableClientHostConsumerBase.prototype.handleAutoplayAction = function (action) {
	    };
	    PaytableClientHostConsumerBase.prototype.handleGameplayAction = function (action) {
	    };
	    PaytableClientHostConsumerBase.prototype.handleBlockRequest = function (blocked) {
	    };
	    return PaytableClientHostConsumerBase;
	}(ClientHostConsumerBase_1.ClientHostConsumerBase));
	exports.PaytableClientHostConsumerBase = PaytableClientHostConsumerBase;


/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var GameEngine_1 = __webpack_require__(17);
	var neo_common_1 = __webpack_require__(1);
	var PeakTournaments_1 = __webpack_require__(30);
	var BasePlugin_1 = __webpack_require__(31);
	var PlayerRetentionManager = (function () {
	    function PlayerRetentionManager(clientHub) {
	        var appContext = GameEngine_1.AppContextBase.getInstance();
	        if (appContext == null) {
	            this.log("Missing app context");
	            return;
	        }
	        this._plugins = [];
	        this._openedDialogs = [];
	        this._configuration = appContext.gameConfiguration;
	        this._clientHub = clientHub;
	        this._loadStarted = false;
	        this.createPlugins();
	    }
	    PlayerRetentionManager.prototype.createPlugins = function () {
	        var data = this._configuration.PlayerRetentionPlugins;
	        for (var i = 0; i < data.length; i++) {
	            var pluginArray = data[i].split(';');
	            if (pluginArray.length !== 2) {
	                this.log("Invalid plugin array data - " + pluginArray.toString());
	                continue;
	            }
	            var instanceName = pluginArray[0];
	            var pluginUrl = pluginArray[1];
	            var plugin = this.createPlugin(instanceName, pluginUrl);
	            if (plugin != null) {
	                this._plugins.push(plugin);
	            }
	        }
	    };
	    PlayerRetentionManager.prototype.createPlugin = function (instanceName, pluginUrl) {
	        switch (instanceName) {
	            case 'PeakTournaments':
	                return new PeakTournaments_1.PeakTournaments(instanceName, pluginUrl, this.getGameClientHub(), this._configuration);
	            default:
	                return new BasePlugin_1.BasePlugin(instanceName, pluginUrl, this.getGameClientHub(), this._configuration);
	        }
	    };
	    PlayerRetentionManager.prototype.getGameClientHub = function () {
	        return this._clientHub;
	    };
	    PlayerRetentionManager.prototype.loadProgress = function (progress) {
	        if (this._loadStarted) {
	            return;
	        }
	        this.log("loadStarted");
	        this._loadStarted = true;
	        this.log('Plugins loading');
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].init();
	        }
	    };
	    PlayerRetentionManager.prototype.gameReady = function () {
	    };
	    PlayerRetentionManager.prototype.error = function (code, message) {
	        this.log("error - " + code + " - " + message);
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].error(code, message);
	        }
	    };
	    PlayerRetentionManager.prototype.gameStarted = function (data) {
	        this.log("gameStarted - " + JSON.stringify(data));
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].gameStarted(data);
	        }
	    };
	    PlayerRetentionManager.prototype.roundInit = function () {
	        this.log("roundInit");
	        if (BasePlugin_1.BasePlugin.AsyncRunning) {
	            return;
	        }
	        var functions = [];
	        for (var i = 0; i < this._plugins.length; i++) {
	            functions.push(this._plugins[i].roundInit.bind(this._plugins[i]));
	        }
	        BasePlugin_1.BasePlugin.AsyncRunning = true;
	        Promise.each(functions, function (item, index) {
	            return item();
	        }).finally(function () {
	            BasePlugin_1.BasePlugin.AsyncRunning = false;
	            BasePlugin_1.BasePlugin.runAsyncTasks();
	        }).catch(function (err) {
	            console.log(err);
	        });
	    };
	    PlayerRetentionManager.prototype.roundStarted = function () {
	        this.log("roundStarted");
	        this._openedDialogs = [];
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].roundStarted();
	        }
	    };
	    PlayerRetentionManager.prototype.spinStarted = function () {
	        this.log("spinStarted");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].spinStarted();
	        }
	    };
	    PlayerRetentionManager.prototype.spinReceived = function (args) {
	        this.log("spinReceived - " + (args ? JSON.stringify(args) : 'none'));
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].spinReceived(args);
	        }
	    };
	    PlayerRetentionManager.prototype.spinEnded = function () {
	        this.log("spinEnded");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].spinEnded();
	        }
	    };
	    PlayerRetentionManager.prototype.roundEnded = function () {
	        this.log("roundEnded");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].roundEnded();
	        }
	    };
	    PlayerRetentionManager.prototype.featureStarted = function () {
	        this.log("featureStarted");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].featureStarted();
	        }
	    };
	    PlayerRetentionManager.prototype.featureInit = function () {
	        this.log("featureInit");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].featureInit();
	        }
	    };
	    PlayerRetentionManager.prototype.featureFinished = function () {
	        this.log("featureFinished");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].featureFinished();
	        }
	    };
	    PlayerRetentionManager.prototype.autoplayStarted = function () {
	        this.log("autoplayStarted");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].autoplayStarted();
	        }
	    };
	    PlayerRetentionManager.prototype.autoplayFinished = function (args) {
	        this.log("autoplayFinished - " + (args ? JSON.stringify(args) : 'none'));
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].autoplayFinished(args);
	        }
	    };
	    PlayerRetentionManager.prototype.gotoHelp = function () {
	        this.log("gotoHelp");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].gotoHelp();
	        }
	    };
	    PlayerRetentionManager.prototype.gotoPaytable = function () {
	        this.log("gotoPaytable");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].gotoPaytable();
	        }
	    };
	    PlayerRetentionManager.prototype.gotoSettings = function () {
	        this.log("gotoSettings");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].gotoSettings();
	        }
	    };
	    PlayerRetentionManager.prototype.setVolume = function (level) {
	        this.log("setVolume - " + level);
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].setVolume(level);
	        }
	    };
	    PlayerRetentionManager.prototype.betChanged = function (bet) {
	        this.log("betChanged - " + (bet ? JSON.stringify(bet) : 'none'));
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].betChanged(bet);
	        }
	    };
	    PlayerRetentionManager.prototype.dialogOpened = function (type, isOpen) {
	        this.log("dialogOpened - type: " + type + " - isOpen: " + isOpen);
	        if (isOpen) {
	            if (type === 'frb' && this._openedDialogs.indexOf(type) > -1) {
	                return;
	            }
	            this._openedDialogs.push(type);
	        }
	        else {
	            var itemIndex = this._openedDialogs.indexOf(type);
	            if (itemIndex === -1) {
	                return;
	            }
	            this._openedDialogs.splice(itemIndex, 1);
	            if (this._openedDialogs.length > 0) {
	                return;
	            }
	        }
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].dialogOpened(type, isOpen);
	        }
	    };
	    PlayerRetentionManager.prototype.closeMenu = function () {
	        this.log("closeMenu");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].closeMenu();
	        }
	    };
	    PlayerRetentionManager.prototype.gamePlayStop = function () {
	        this.log("gamePlayStop");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].gamePlayStop();
	        }
	    };
	    PlayerRetentionManager.prototype.gamePlayResume = function () {
	        this.log("gamePlayResume");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].gamePlayResume();
	        }
	    };
	    PlayerRetentionManager.prototype.gamePlayFreeze = function () {
	        this.log("gamePlayFreeze");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].gamePlayFreeze();
	        }
	    };
	    PlayerRetentionManager.prototype.gamePlayUnfreeze = function () {
	        this.log("gamePlayUnfreeze");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].gamePlayUnfreeze();
	        }
	    };
	    PlayerRetentionManager.prototype.webSocketsInitialized = function () {
	        this.log("webSocketsInitialized");
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].webSocketsInitialized();
	        }
	    };
	    PlayerRetentionManager.prototype.iconsCountAvailable = function (count) {
	        this.log("pluginIconSlots - " + count);
	        for (var i = 0; i < this._plugins.length; i++) {
	            this._plugins[i].iconsCountAvailable(count);
	        }
	    };
	    PlayerRetentionManager.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('PlayerRetentionManager', 'PlayerRetentionManager ' + s);
	        }
	    };
	    return PlayerRetentionManager;
	}());
	exports.PlayerRetentionManager = PlayerRetentionManager;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var BasePlugin_1 = __webpack_require__(31);
	var neo_common_1 = __webpack_require__(1);
	var GameEngine_1 = __webpack_require__(17);
	var PeakTournaments = (function (_super) {
	    __extends(PeakTournaments, _super);
	    function PeakTournaments() {
	        _super.apply(this, arguments);
	    }
	    PeakTournaments.prototype.init = function () {
	        var isRestricted = PeakTournaments.restrictedGames.indexOf(GameEngine_1.AppContextBase.getInstance().gameKey) !== -1;
	        if (isRestricted)
	            return;
	        if (!this.validateUrl(this._pluginUrl)) {
	            this.log("PluginUrl - " + this._pluginUrl + " is not valid");
	            return;
	        }
	        var _self = this;
	        var versionPath = neo_common_1.UriHelper.setTimeStamp(this._pluginUrl.replace('index.js', 'version.txt'));
	        neo_common_1.FileUtils.readLocalFile(versionPath, 'text', false)
	            .then(function (response) {
	            _self.versionLoaded(response);
	        });
	        this.log("Load version.txt");
	    };
	    PeakTournaments.prototype.versionLoaded = function (response) {
	        var timestamp = Date.now().toString();
	        if (!neo_common_1.StringUtils.isNullOrEmpty(response)) {
	            var versionData = neo_common_1.ArrayUtils.stringArray(response, '|');
	            if (versionData.length === 2) {
	                timestamp = versionData[1];
	            }
	        }
	        var script = document.createElement('script');
	        script.setAttribute('type', 'text/javascript');
	        script.setAttribute('src', neo_common_1.UriHelper.setTimeStamp(this._pluginUrl, timestamp));
	        script.setAttribute('type', 'module');
	        script.onload = this.onPluginLoaded.bind(this, this._instanceName);
	        document.head.appendChild(script);
	        this.log("Loading plugin started");
	    };
	    PeakTournaments.prototype.onPluginLoaded = function (instanceName) {
	        if (window[instanceName] === null) {
	            this.log("Instance - " + instanceName + " was not found");
	            return;
	        }
	        var instance = window[instanceName];
	        instance.init(this._clientHub, this._clientEvents, {
	            panelIconPlaceholderId: 'peakIconHolder',
	            menuIconPlaceholderId: 'peakMenuBtn',
	            contentPlaceholderId: 'peakContentHolder',
	            tournamentEventTrackerEnabled: this._configuration.TournamentEventTrackerEnabled,
	            gameCode: GameEngine_1.AppContextBase.getInstance().gameKey
	        });
	        this.log("Plugin loaded, call init: panelIconPlaceholderId: peakIconHolder, menuIconPlaceholderId: peakMenuBtn, \n        contentPlaceholderId: peakContentHolder, tournamentEventTrackerEnabled: " + this._configuration.TournamentEventTrackerEnabled.toString() + "\n        , gameCode: " + GameEngine_1.AppContextBase.getInstance().gameKey);
	        if (this._callStart && !this._started) {
	            this.gameStarted(this._startData);
	        }
	        if (this._idle) {
	            this.roundInit().then(function (value) { });
	        }
	    };
	    PeakTournaments.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('PeakTournaments', 'PeakTournaments ' + s);
	        }
	    };
	    PeakTournaments.restrictedGames = ['EuropeanRoulette', 'EuropeanRouletteVip', 'FireWitchX'];
	    return PeakTournaments;
	}(BasePlugin_1.BasePlugin));
	exports.PeakTournaments = PeakTournaments;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var neo_common_2 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(10);
	var BasePlugin = (function () {
	    function BasePlugin(instanceName, pluinUrl, clientHub, gameConfiguration) {
	        this._configuration = gameConfiguration;
	        this._instanceName = instanceName;
	        this._pluginUrl = pluinUrl;
	        this._clientHub = clientHub;
	        this._callbacks = {};
	        this._clientEvents = this.getGameClientEvents();
	        this._idle = false;
	        this._started = false;
	        this._callStart = false;
	        this._hasWin = false;
	        this._callbackCall = false;
	        this._inFeature = false;
	        this._stopped = false;
	        this._freezed = false;
	    }
	    BasePlugin.prototype.getGameClientEvents = function () {
	        var _this = this;
	        var _self = this;
	        return {
	            on: {
	                error: _self._error.bind(_self),
	                gameStarted: _self._gameStarted.bind(_self),
	                roundInit: _self._roundInit.bind(_self),
	                roundStarted: _self._roundStarted.bind(_self),
	                spinStarted: _self._spinStarted.bind(_self),
	                spinEnded: _self._spinEnded.bind(_self),
	                roundEnded: _self._roundEnded.bind(_self),
	                featureStarted: _self._featureStarted.bind(_self),
	                featureInit: _self._featureInit.bind(_self),
	                featureFinished: _self._featureFinished.bind(_self),
	                autoplayStarted: _self._autoplayStarted.bind(_self),
	                autoplayFinished: _self._autoplayFinished.bind(_self),
	                gotoHelp: _self._gotoHelp.bind(_self),
	                gotoPaytable: _self._gotoPaytable.bind(_self),
	                gotoSettings: _self._gotoSettings.bind(_self),
	                setVolume: _self._setVolume.bind(_self),
	                betChanged: _self._betChanged.bind(_self),
	                closeMenu: _self._closeMenu.bind(_self),
	                dialogOpened: _self._dialogOpened.bind(_self),
	                gamePlayStop: _self._gamePlayStop.bind(_self),
	                gamePlayResume: _self._gamePlayResume.bind(_self),
	                gamePlayFreeze: _self._gamePlayFreeze.bind(_self),
	                gamePlayUnfreeze: _self._gamePlayUnfreeze.bind(_self),
	                webSocketsInitialized: _self._webSocketsInitialized.bind(_self),
	                iconsCountAvailable: _self._iconsCountAvailable.bind(_self)
	            },
	            send: {
	                stopAutoplay: function () {
	                    _self.log("P2G - stopAutoplay");
	                    Platforms_1.Platforms.stopAutoplay();
	                },
	                gamePlaySupressSpinOnCollect: function () {
	                    if (_this._inFeature) {
	                        return;
	                    }
	                    if (!_self._idle) {
	                        if (_this._hasWin) {
	                            _self.log("P2G - gamePlaySupressSpinOnCollect");
	                            Platforms_1.Platforms.gamePlaySupressSpinOnCollect();
	                        }
	                        else {
	                            _self.log("P2G - stopAutoplay");
	                            Platforms_1.Platforms.stopAutoplay();
	                        }
	                    }
	                },
	                restoreAutoplay: function () {
	                    _self.log("P2G - restoreAutoplay");
	                    Platforms_1.Platforms.restoreAutoplay();
	                },
	                resizeGame: function () {
	                    _self.log("P2G - resizeGame");
	                    Platforms_1.Platforms.resizeGame();
	                },
	                refreshBalance: function () {
	                    _self.log("P2G - refreshBalance");
	                    Platforms_1.Platforms.refreshBalance();
	                },
	                gamePlayStop: function () {
	                    if (_this._stopped) {
	                        return;
	                    }
	                    if (_this._idle) {
	                        _self._stopped = true;
	                    }
	                    _self.log("P2G - gamePlayStop");
	                    _self._callbackCall = true;
	                    Platforms_1.Platforms.gamePlayStop(true);
	                },
	                gamePlayResume: function () {
	                    if (!_this._stopped) {
	                        return;
	                    }
	                    _self.log("P2G - gamePlayResume");
	                    _self._stopped = false;
	                    _self._callbackCall = true;
	                    Platforms_1.Platforms.gamePlayResume();
	                },
	                gamePlayFreeze: function () {
	                    if (_this._freezed) {
	                        return;
	                    }
	                    _self.log("P2G - gamePlayFreeze");
	                    _self._freezed = true;
	                    _self._callbackCall = true;
	                    Platforms_1.Platforms.gamePlayFreeze();
	                },
	                gamePlayUnfreeze: function () {
	                    if (!_this._freezed) {
	                        return;
	                    }
	                    _self.log("P2G - gamePlayUnfreeze");
	                    _self._freezed = false;
	                    _self._callbackCall = true;
	                    Platforms_1.Platforms.gamePlayUnfreeze();
	                },
	                gameAudioEnable: function () {
	                    _self.log("P2G - gameAudioEnable");
	                    Platforms_1.Platforms.gameAudioEnable();
	                },
	                gameAudioMute: function () {
	                    _self.log("P2G - gameAudioMute");
	                    Platforms_1.Platforms.gameAudioMute();
	                },
	                showHelp: function () {
	                    _self.log("P2G - showHelp");
	                    Platforms_1.Platforms.showHelp();
	                },
	                hideHelp: function () {
	                    _self.log("P2G - hideHelp");
	                    Platforms_1.Platforms.hideHelp();
	                },
	                toggleHelp: function () {
	                    _self.log("P2G - toggleHelp");
	                    Platforms_1.Platforms.toggleHelp();
	                },
	                showPaytable: function () {
	                    _self.log("P2G - showPaytable");
	                    Platforms_1.Platforms.showPaytable();
	                },
	                hidePaytable: function () {
	                    _self.log("P2G - hidePaytable");
	                    Platforms_1.Platforms.hidePaytable();
	                },
	                togglePaytable: function () {
	                    _self.log("P2G - togglePaytable");
	                    Platforms_1.Platforms.togglePaytable();
	                },
	                closeMenu: function () {
	                    _self.log("P2G - closeMenu");
	                    _self._callbackCall = true;
	                    Platforms_1.Platforms.closeMenu();
	                },
	                updateUI: function () {
	                    _self.log("P2G - updateUI");
	                    Platforms_1.Platforms.updateUI();
	                },
	                asyncTask: _self.asyncTask
	            },
	            get: {
	                getTimeData: function () { return Platforms_1.Platforms.getTimeData(); },
	                getGameTime: function (utcTime) { return Platforms_1.Platforms.getGameTime(utcTime); }
	            }
	        };
	    };
	    BasePlugin.prototype.error = function (code, message) {
	        if (this._callbacks['error'] != null) {
	            this.log("G2P - Error - " + code + " - " + message);
	            var fn = this._callbacks['error'];
	            fn(code, message);
	        }
	        else if (!this._started) {
	            this._callbacks['_error'] = { code: code, message: message };
	        }
	    };
	    BasePlugin.prototype._error = function (fnc) {
	        this._callbacks['error'] = fnc;
	        if (this._callbacks['_error'] != null) {
	            this.log("G2P - Error - " + this._callbacks['_error']['code'] + " - " + this._callbacks['_error']['message']);
	            fnc(this._callbacks['_error']['code'], this._callbacks['_error']['message']);
	            this._callbacks['_error'] = null;
	        }
	    };
	    BasePlugin.prototype.gameStarted = function (data) {
	        this._callStart = true;
	        this._startData = data;
	        if (this._callbacks['gameStarted'] != null && !this._started) {
	            this.log("G2P - gameStarted - " + JSON.stringify(data));
	            var fn = this._callbacks['gameStarted'];
	            fn(data);
	            this._started = true;
	            this._callStart = false;
	        }
	    };
	    BasePlugin.prototype._gameStarted = function (fnc) {
	        this._callbacks['gameStarted'] = fnc;
	    };
	    BasePlugin.prototype.roundInit = function () {
	        this._idle = true;
	        if (this._callbacks['roundInit'] != null) {
	            this.log("G2P - roundInit");
	            var fn = this._callbacks['roundInit'];
	            return fn();
	        }
	        return Promise.resolve();
	    };
	    BasePlugin.prototype._roundInit = function (fnc) {
	        this._callbacks['roundInit'] = fnc;
	    };
	    BasePlugin.prototype.roundStarted = function () {
	        this._idle = false;
	        if (this._callbacks['roundStarted'] != null) {
	            this.log("G2P - roundStarted");
	            var fn = this._callbacks['roundStarted'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_roundStarted'] = true;
	        }
	    };
	    BasePlugin.prototype._roundStarted = function (fnc) {
	        this._callbacks['roundStarted'] = fnc;
	        if (this._callbacks['_roundStarted'] != null) {
	            this.log("G2P - roundStarted");
	            fnc();
	            this._callbacks['_roundStarted'] = null;
	        }
	    };
	    BasePlugin.prototype.spinStarted = function () {
	        this._hasWin = false;
	        if (this._callbacks['spinStarted'] != null) {
	            this.log("G2P - spinStarted");
	            var fn = this._callbacks['spinStarted'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_spinStarted'] = true;
	        }
	    };
	    BasePlugin.prototype._spinStarted = function (fnc) {
	        this._callbacks['spinStarted'] = fnc;
	        if (this._callbacks['_spinStarted'] != null) {
	            this.log("G2P - spinStarted");
	            fnc();
	            this._callbacks['_spinStarted'] = null;
	        }
	    };
	    BasePlugin.prototype.spinReceived = function (args) {
	        if (args != null) {
	            this._hasWin = args.win > 0;
	        }
	    };
	    BasePlugin.prototype.spinEnded = function () {
	        if (this._callbacks['spinEnded'] != null) {
	            this.log("G2P - spinEnded");
	            var fn = this._callbacks['spinEnded'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_spinEnded'] = true;
	        }
	    };
	    BasePlugin.prototype._spinEnded = function (fnc) {
	        this._callbacks['spinEnded'] = fnc;
	        if (this._callbacks['_spinEnded'] != null) {
	            this.log("G2P - spinEnded");
	            fnc();
	            this._callbacks['_spinEnded'] = null;
	        }
	    };
	    BasePlugin.prototype.roundEnded = function () {
	        if (this._callbacks['roundEnded'] != null) {
	            this.log("G2P - roundEnded");
	            var fn = this._callbacks['roundEnded'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_roundEnded'] = true;
	        }
	    };
	    BasePlugin.prototype._roundEnded = function (fnc) {
	        this._callbacks['roundEnded'] = fnc;
	        if (this._callbacks['_roundEnded'] != null) {
	            this.log("G2P - roundEnded");
	            fnc();
	            this._callbacks['_roundEnded'] = null;
	        }
	    };
	    BasePlugin.prototype.featureStarted = function () {
	        this._inFeature = true;
	        if (this._callbacks['featureStarted'] != null) {
	            this.log("G2P - featureStarted");
	            var fn = this._callbacks['featureStarted'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_featureStarted'] = true;
	        }
	    };
	    BasePlugin.prototype._featureStarted = function (fnc) {
	        this._callbacks['featureStarted'] = fnc;
	        if (this._callbacks['_featureStarted'] != null) {
	            this.log("G2P - featureStarted");
	            fnc();
	            this._callbacks['_featureStarted'] = null;
	        }
	    };
	    BasePlugin.prototype.featureInit = function () {
	        this._inFeature = true;
	        if (this._callbacks['featureInit'] != null) {
	            this.log("G2P - featureInit");
	            var fn = this._callbacks['featureInit'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_featureInit'] = true;
	        }
	    };
	    BasePlugin.prototype._featureInit = function (fnc) {
	        this._callbacks['featureInit'] = fnc;
	        if (this._callbacks['_featureInit'] != null) {
	            this.log("G2P - featureInit");
	            fnc();
	            this._callbacks['_featureInit'] = null;
	        }
	    };
	    BasePlugin.prototype.featureFinished = function () {
	        this._inFeature = false;
	        if (this._callbacks['featureFinished'] != null) {
	            this.log("G2P - featureFinished");
	            var fn = this._callbacks['featureFinished'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_featureFinished'] = true;
	        }
	    };
	    BasePlugin.prototype._featureFinished = function (fnc) {
	        this._callbacks['featureFinished'] = fnc;
	        if (this._callbacks['_featureFinished'] != null) {
	            this.log("G2P - featureFinished");
	            fnc();
	            this._callbacks['_featureFinished'] = null;
	        }
	    };
	    BasePlugin.prototype.autoplayStarted = function () {
	        if (this._callbacks['autoplayStarted'] != null) {
	            this.log("G2P - autoplayStarted");
	            var fn = this._callbacks['autoplayStarted'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_autoplayStarted'] = true;
	        }
	    };
	    BasePlugin.prototype._autoplayStarted = function (fnc) {
	        this._callbacks['autoplayStarted'] = fnc;
	        if (this._callbacks['_autoplayStarted'] != null) {
	            this.log("G2P - autoplayStarted");
	            fnc();
	            this._callbacks['_autoplayStarted'] = null;
	        }
	    };
	    BasePlugin.prototype.autoplayFinished = function (args) {
	        if (this._callbacks['autoplayFinished'] != null) {
	            this.log("G2P - autoplayFinished - " + (args ? JSON.stringify(args) : 'none'));
	            var fn = this._callbacks['autoplayFinished'];
	            fn(args);
	        }
	        else if (!this._started) {
	            this._callbacks['_autoplayFinished'] = true;
	        }
	    };
	    BasePlugin.prototype._autoplayFinished = function (fnc) {
	        this._callbacks['autoplayFinished'] = fnc;
	        if (this._callbacks['_autoplayFinished'] != null) {
	            this.log("G2P - autoplayFinished");
	            fnc();
	            this._callbacks['_autoplayFinished'] = null;
	        }
	    };
	    BasePlugin.prototype.gotoHelp = function () {
	        if (this._callbacks['gotoHelp'] != null) {
	            this.log("G2P - gotoHelp");
	            var fn = this._callbacks['gotoHelp'];
	            fn();
	        }
	    };
	    BasePlugin.prototype._gotoHelp = function (fnc) {
	        this._callbacks['gotoHelp'] = fnc;
	    };
	    BasePlugin.prototype.gotoPaytable = function () {
	        if (this._callbacks['gotoPaytable'] != null) {
	            this.log("G2P - gotoPaytable");
	            var fn = this._callbacks['gotoPaytable'];
	            fn();
	        }
	    };
	    BasePlugin.prototype._gotoPaytable = function (fnc) {
	        this._callbacks['gotoPaytable'] = fnc;
	    };
	    BasePlugin.prototype.gotoSettings = function () {
	        if (this._callbacks['gotoSettings'] != null) {
	            this.log("G2P - gotoSettings");
	            var fn = this._callbacks['gotoSettings'];
	            fn();
	        }
	    };
	    BasePlugin.prototype._gotoSettings = function (fnc) {
	        this._callbacks['gotoSettings'] = fnc;
	    };
	    BasePlugin.prototype.setVolume = function (level) {
	        if (this._callbacks['setVolume'] != null) {
	            this.log("G2P - setVolume - " + level);
	            var fn = this._callbacks['setVolume'];
	            fn(level);
	        }
	        else if (!this._started) {
	            this._callbacks['_setVolume'] = { level: level };
	        }
	    };
	    BasePlugin.prototype._setVolume = function (fnc) {
	        this._callbacks['setVolume'] = fnc;
	        if (this._callbacks['_setVolume'] != null) {
	            this.log("G2P - setVolume - " + this._callbacks['_setVolume']['level']);
	            fnc(this._callbacks['_setVolume']['level']);
	            this._callbacks['_setVolume'] = null;
	        }
	    };
	    BasePlugin.prototype.betChanged = function (bet) {
	        if (this._callbacks['bet'] != null) {
	            this.log("G2P - betChanged - " + (bet ? JSON.stringify(bet) : 'none'));
	            var fn = this._callbacks['bet'];
	            fn(bet);
	        }
	    };
	    BasePlugin.prototype._betChanged = function (fnc) {
	        this._callbacks['bet'] = fnc;
	    };
	    BasePlugin.prototype.dialogOpened = function (type, isOpen) {
	        this._idle = !isOpen;
	        if (this._callbacks['dialogOpened'] != null) {
	            this.log("G2P - dialogOpened - " + type + " - " + isOpen);
	            var fn = this._callbacks['dialogOpened'];
	            fn(type, isOpen);
	        }
	        else if (!this._started) {
	            this._callbacks['_dialogOpened'] = { type: type, isOpen: isOpen };
	        }
	    };
	    BasePlugin.prototype._dialogOpened = function (fnc) {
	        this._callbacks['dialogOpened'] = fnc;
	        if (this._callbacks['_dialogOpened'] != null) {
	            this.log("G2P - dialogOpened - " + this._callbacks['_dialogOpened']['type'] + " - " + this._callbacks['_dialogOpened']['isOpen']);
	            fnc(this._callbacks['_dialogOpened']['type'], this._callbacks['_dialogOpened']['isOpen']);
	            this._callbacks['_dialogOpened'] = null;
	        }
	    };
	    BasePlugin.prototype._closeMenu = function (fnc) {
	        this._callbacks['closeMenu'] = fnc;
	    };
	    BasePlugin.prototype.closeMenu = function () {
	        if (this._callbackCall) {
	            this._callbackCall = false;
	            return;
	        }
	        if (this._callbacks['closeMenu'] != null) {
	            this.log("G2P - closeMenu");
	            var fn = this._callbacks['closeMenu'];
	            fn();
	        }
	    };
	    BasePlugin.prototype._gamePlayStop = function (fnc) {
	        this._callbacks['gamePlayStop'] = fnc;
	        if (this._callbacks['_gamePlayStop'] != null) {
	            this.log("G2P - gamePlayStop");
	            fnc();
	            this._callbacks['_gamePlayStop'] = null;
	        }
	    };
	    BasePlugin.prototype.gamePlayStop = function () {
	        if (this._callbackCall) {
	            this._callbackCall = false;
	            return;
	        }
	        if (this._callbacks['gamePlayStop'] != null) {
	            this.log("G2P - gamePlayStop");
	            var fn = this._callbacks['gamePlayStop'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_gamePlayStop'] = true;
	        }
	    };
	    BasePlugin.prototype._gamePlayResume = function (fnc) {
	        this._callbacks['gamePlayResume'] = fnc;
	        if (this._callbacks['_gamePlayResume'] != null) {
	            this.log("G2P - gamePlayResume");
	            fnc();
	            this._callbacks['_gamePlayResume'] = null;
	        }
	    };
	    BasePlugin.prototype.gamePlayResume = function () {
	        if (this._callbackCall) {
	            this._callbackCall = false;
	            return;
	        }
	        if (this._callbacks['gamePlayResume'] != null) {
	            this.log("G2P - gamePlayResume");
	            var fn = this._callbacks['gamePlayResume'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_gamePlayResume'] = true;
	        }
	    };
	    BasePlugin.prototype._gamePlayFreeze = function (fnc) {
	        this._callbacks['gamePlayFreeze'] = fnc;
	        if (this._callbacks['_gamePlayFreeze'] != null) {
	            this.log("G2P - gamePlayFreeze");
	            fnc();
	            this._callbacks['_gamePlayFreeze'] = null;
	        }
	    };
	    BasePlugin.prototype.gamePlayFreeze = function () {
	        if (this._callbackCall) {
	            this._callbackCall = false;
	            return;
	        }
	        if (this._callbacks['gamePlayFreeze'] != null) {
	            this.log("G2P - gamePlayFreeze");
	            var fn = this._callbacks['gamePlayFreeze'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_gamePlayFreeze'] = true;
	        }
	    };
	    BasePlugin.prototype._gamePlayUnfreeze = function (fnc) {
	        this._callbacks['gamePlayUnfreeze'] = fnc;
	        if (this._callbacks['_gamePlayUnfreeze'] != null) {
	            this.log("G2P - gamePlayUnfreeze");
	            fnc();
	            this._callbacks['_gamePlayUnfreeze'] = null;
	        }
	    };
	    BasePlugin.prototype.gamePlayUnfreeze = function () {
	        if (this._callbackCall) {
	            this._callbackCall = false;
	            return;
	        }
	        if (this._callbacks['gamePlayUnfreeze'] != null) {
	            this.log("G2P - gamePlayUnfreeze");
	            var fn = this._callbacks['gamePlayUnfreeze'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_gamePlayUnfreeze'] = true;
	        }
	    };
	    BasePlugin.prototype.webSocketsInitialized = function () {
	        if (this._callbacks['webSocketsInitialized'] != null) {
	            this.log("G2P - webSocketsInitialized");
	            var fn = this._callbacks['webSocketsInitialized'];
	            fn();
	        }
	        else if (!this._started) {
	            this._callbacks['_webSocketsInitialized'] = true;
	        }
	    };
	    BasePlugin.prototype._webSocketsInitialized = function (fnc) {
	        this._callbacks['webSocketsInitialized'] = fnc;
	        if (this._callbacks['_webSocketsInitialized'] != null) {
	            this.log("G2P - webSocketsInitialized");
	            fnc();
	            this._callbacks['_webSocketsInitialized'] = null;
	        }
	    };
	    BasePlugin.prototype.iconsCountAvailable = function (count) {
	        if (this._callbacks['iconsCountAvailable'] != null) {
	            this.log("G2P - iconsCountAvailable - " + count);
	            var fn = this._callbacks['iconsCountAvailable'];
	            fn(count);
	        }
	        else if (!this._started) {
	            this._callbacks['_iconsCountAvailable'] = count;
	        }
	    };
	    BasePlugin.prototype._iconsCountAvailable = function (fnc) {
	        this._callbacks['iconsCountAvailable'] = fnc;
	        if (this._callbacks['_iconsCountAvailable'] != null) {
	            this.log("G2P - iconsCountAvailable - " + this._callbacks['_iconsCountAvailable']);
	            fnc(this._callbacks['_iconsCountAvailable']);
	            this._callbacks['_iconsCountAvailable'] = null;
	        }
	    };
	    BasePlugin.prototype.asyncTask = function (fnc) {
	        if (fnc != null) {
	            BasePlugin.AsyncTasks.push(fnc);
	        }
	        BasePlugin.runAsyncTasks();
	    };
	    BasePlugin.runAsyncTasks = function (finished) {
	        if (finished === void 0) { finished = false; }
	        if (BasePlugin.AsyncRunning) {
	            return;
	        }
	        if (BasePlugin.AsyncTasks.length === 0) {
	            if (finished) {
	                Platforms_1.Platforms.roundInit();
	            }
	            return;
	        }
	        var fnc = BasePlugin.AsyncTasks.shift();
	        if (fnc != null) {
	            BasePlugin.AsyncRunning = true;
	            fnc().then(function (value) {
	                BasePlugin.AsyncRunning = false;
	                BasePlugin.runAsyncTasks(true);
	            });
	        }
	    };
	    BasePlugin.prototype.init = function () {
	        if (!this.validateUrl(this._pluginUrl)) {
	            this.log("PluginUrl - " + this._pluginUrl + " is not valid");
	            return;
	        }
	        var script = document.createElement('script');
	        script.setAttribute('type', 'text/javascript');
	        script.setAttribute('src', neo_common_1.UriHelper.setTimeStamp(this._pluginUrl, neo_common_1.Preloader.getVersionId()));
	        script.setAttribute('type', 'module');
	        script.onload = this.onPluginLoaded.bind(this, this._instanceName);
	        document.head.appendChild(script);
	        this.log("Loading plugin started");
	    };
	    BasePlugin.prototype.onPluginLoaded = function (instanceName) {
	        if (window[instanceName] === null) {
	            this.log("Instance - " + instanceName + " was not found");
	            return;
	        }
	        var instance = window[instanceName];
	        instance.init(this._clientHub, this._clientEvents);
	        this.log("Plugin loaded, call init");
	        if (this._callStart && !this._started) {
	            this.gameStarted(this._startData);
	        }
	        if (this._idle) {
	            this.roundInit().then(function (value) { });
	        }
	    };
	    BasePlugin.prototype.validateUrl = function (url) {
	        try {
	            var uri = new URL(url);
	            return true;
	        }
	        catch (e) {
	            if (false) {
	                neo_common_2.Logger.debugGroup('Platforms', "Provided url for getting origin is not valid, returning '*'.");
	            }
	        }
	        return false;
	    };
	    BasePlugin.prototype.log = function (s) {
	        if (false) {
	            neo_common_2.Logger.debugGroup('BasePlugin', 'BasePlugin ' + s);
	        }
	    };
	    BasePlugin.AsyncTasks = [];
	    BasePlugin.AsyncRunning = false;
	    return BasePlugin;
	}());
	exports.BasePlugin = BasePlugin;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var PlatformGan = (function () {
	    function PlatformGan() {
	        this._roundEnded = false;
	    }
	    PlatformGan.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        if (false) {
	            this.log('create');
	        }
	        this.createPlugin();
	    };
	    PlatformGan.prototype.loadProgress = function (progress) { };
	    PlatformGan.prototype.gameReady = function () {
	        if (false) {
	            this.log('gameReady');
	        }
	        if (window.ganEventDispatch != null) {
	            window.ganEventDispatch('gameLoaded');
	        }
	    };
	    PlatformGan.prototype.gameFailed = function () {
	        if (false) {
	            this.log('gameLoadFailed');
	        }
	        if (window.ganEventDispatch != null) {
	            window.ganEventDispatch('gameLoadFailed');
	        }
	    };
	    PlatformGan.prototype.gameClosing = function () {
	        if (false) {
	            this.log('gameClosing');
	        }
	        if (window.ganEventDispatch != null) {
	            window.ganEventDispatch('gameClosing');
	        }
	    };
	    PlatformGan.prototype.gameReloading = function () { };
	    PlatformGan.prototype.gameChange = function (gameCode) { };
	    PlatformGan.prototype.error = function (code, message) {
	        if (false) {
	            this.log('error');
	        }
	        if (window.ganEventDispatch != null) {
	            window.ganEventDispatch('fatalError');
	        }
	    };
	    PlatformGan.prototype.clientError = function (id, message) { };
	    PlatformGan.prototype.roundInit = function () { };
	    PlatformGan.prototype.roundStarted = function () {
	        this._roundEnded = false;
	        if (false) {
	            this.log('roundStarted');
	        }
	        if (window.ganEventDispatch != null) {
	            window.ganEventDispatch('playStarted');
	        }
	    };
	    PlatformGan.prototype.spinStarted = function () { };
	    PlatformGan.prototype.spinReceived = function () { };
	    PlatformGan.prototype.spinEnded = function () { };
	    PlatformGan.prototype.roundEnded = function () {
	        if (false) {
	            this.log('roundEnded');
	        }
	        if (!this._roundEnded && window.ganEventDispatch != null) {
	            window.ganEventDispatch('playStopped');
	        }
	        this._roundEnded = true;
	    };
	    PlatformGan.prototype.featureStarted = function () { };
	    PlatformGan.prototype.featureInit = function () { };
	    PlatformGan.prototype.featureFinished = function () { };
	    PlatformGan.prototype.autoplayStarted = function () { };
	    PlatformGan.prototype.autoplayFinished = function () { };
	    PlatformGan.prototype.gotoCasier = function () { };
	    PlatformGan.prototype.gotoHistory = function () { };
	    PlatformGan.prototype.gotoHelp = function () { };
	    PlatformGan.prototype.gotoPaytable = function () { };
	    PlatformGan.prototype.balanceUpdated = function () { };
	    PlatformGan.prototype.sendPluginMessage = function (message) { };
	    PlatformGan.prototype.setVolume = function (level) { };
	    PlatformGan.prototype.quickSpinEnabled = function (enabled) { };
	    PlatformGan.prototype.bet = function (value) { };
	    PlatformGan.prototype.win = function (value) { };
	    PlatformGan.prototype.userAction = function (action, data) { };
	    PlatformGan.prototype.gameDataLoaded = function (args) { };
	    PlatformGan.prototype.dialogOpened = function (type, isOpen) { };
	    PlatformGan.prototype.fullscreen = function (enabled) { };
	    PlatformGan.prototype.createPlugin = function () {
	        if (false) {
	            this.log('createPlugin');
	        }
	        if (Platforms_1.Platforms.pluginUrl != null) {
	            var script = document.createElement('script');
	            script.setAttribute('type', 'text/javascript');
	            script.setAttribute('src', Platforms_1.Platforms.pluginUrl);
	            script.onload = this.loadPlugin.bind(this);
	            document.head.appendChild(script);
	        }
	    };
	    PlatformGan.prototype.loadPlugin = function () {
	        if (false) {
	            this.log('loadPlugin');
	        }
	        if (window['gan'] != null) {
	            window['gan'].addGANOnEventReceiveCallback(this.receiveMessage.bind(this));
	        }
	        Platforms_1.Platforms.canPlay = true;
	    };
	    PlatformGan.prototype.receiveMessage = function (event) {
	        if (false) {
	            this.log('receiveMessage' + event);
	        }
	        if (event != null) {
	            switch (event) {
	                case 'gameProceed':
	                    break;
	                case 'gamePause':
	                    Platforms_1.Platforms.gamePlayStop();
	                    break;
	                case 'refreshBalance':
	                    Platforms_1.Platforms.refreshBalance();
	                    break;
	                case 'failedCommunication':
	                    break;
	                case 'connectionEstablished':
	                    break;
	                case 'wrapperReady':
	                    break;
	                case 'resizeGame':
	                    break;
	            }
	        }
	    };
	    PlatformGan.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('Gan', 'Gan ' + s);
	        }
	    };
	    return PlatformGan;
	}());
	exports.PlatformGan = PlatformGan;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var PlatformGel = (function () {
	    function PlatformGel() {
	    }
	    PlatformGel.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        Platforms_1.Platforms.handleFullscreen = true;
	        if (false) {
	            this.log('create');
	        }
	        window.addEventListener('message', this.receiveMessage.bind(this));
	    };
	    PlatformGel.prototype.loadProgress = function (progress) { };
	    PlatformGel.prototype.gameReady = function () {
	        if (false) {
	            this.log('gameReady');
	        }
	        if (Platforms_1.Platforms.gameOrigin != null && Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.loaded',
	                'data': {
	                    'gameOrigin': Platforms_1.Platforms.gameOrigin
	                }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformGel.prototype.gameFailed = function () { };
	    PlatformGel.prototype.gameClosing = function () {
	        if (false) {
	            this.log('gameClosing');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.end'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformGel.prototype.gameReloading = function () { };
	    PlatformGel.prototype.gameChange = function (gameCode) { };
	    PlatformGel.prototype.error = function (code, message) { };
	    PlatformGel.prototype.clientError = function (id, message) { };
	    PlatformGel.prototype.roundInit = function () { };
	    PlatformGel.prototype.roundStarted = function () {
	        if (false) {
	            this.log('roundStarted');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.round.started'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformGel.prototype.spinStarted = function () {
	        if (false) {
	            this.log('spinStarted');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.spin.started'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformGel.prototype.spinReceived = function () { };
	    PlatformGel.prototype.spinEnded = function () {
	        if (false) {
	            this.log('spinEnded');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.spin.ended'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformGel.prototype.roundEnded = function () {
	        if (false) {
	            this.log('roundEnded');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.round.ended'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformGel.prototype.featureStarted = function () { };
	    PlatformGel.prototype.featureInit = function () { };
	    PlatformGel.prototype.featureFinished = function () { };
	    PlatformGel.prototype.autoplayStarted = function () { };
	    PlatformGel.prototype.autoplayFinished = function () { };
	    PlatformGel.prototype.gotoCasier = function () {
	        if (false) {
	            this.log('gotoCasier');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.goto.cashier'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformGel.prototype.gotoHistory = function () {
	        if (false) {
	            this.log('gotoHistory');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.goto.history'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformGel.prototype.gotoHelp = function () { };
	    PlatformGel.prototype.gotoPaytable = function () { };
	    PlatformGel.prototype.balanceUpdated = function () { };
	    PlatformGel.prototype.sendPluginMessage = function (message) {
	        if (false) {
	            this.log('sendPluginMessage');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'method': 'game.handleWalletMessage', 'data': { 'message': message }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformGel.prototype.setVolume = function (level) { };
	    PlatformGel.prototype.quickSpinEnabled = function (enabled) { };
	    PlatformGel.prototype.bet = function (value) { };
	    PlatformGel.prototype.win = function (value) { };
	    PlatformGel.prototype.userAction = function (action, data) { };
	    PlatformGel.prototype.gameDataLoaded = function (args) { };
	    PlatformGel.prototype.dialogOpened = function (type, isOpen) { };
	    PlatformGel.prototype.fullscreen = function (enabled) { };
	    PlatformGel.prototype.receiveMessage = function (event) {
	        if (false) {
	            this.log('receiveMessage');
	        }
	        if (event != null && event.data != null) {
	            if (event.data.method != null) {
	                switch (event.data.method) {
	                    case 'gel.autoPlay.stop':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.stopAutoplay();
	                        }
	                        break;
	                    case 'gel.gamePlay.stop':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayStop();
	                        }
	                        break;
	                    case 'gel.gamePlay.resume':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayResume();
	                        }
	                        break;
	                    case 'gel.audio.enable':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gameAudioEnable();
	                        }
	                        break;
	                    case 'gel.audio.mute':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gameAudioMute();
	                        }
	                        break;
	                    case 'gel.balance.reload':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.refreshBalance();
	                        }
	                        break;
	                }
	            }
	        }
	    };
	    PlatformGel.prototype.checkOrigin = function (origin) {
	        if (Platforms_1.Platforms.pluginOrigin !== '*' && origin !== Platforms_1.Platforms.pluginOrigin) {
	            return false;
	        }
	        return true;
	    };
	    PlatformGel.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('Gel', 'Gel ' + s);
	        }
	    };
	    return PlatformGel;
	}());
	exports.PlatformGel = PlatformGel;


/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var PlatformEveryMatrix = (function () {
	    function PlatformEveryMatrix() {
	    }
	    PlatformEveryMatrix.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        this.currentBalance = -1;
	        this.inSpin = false;
	        if (false) {
	            this.log('create');
	        }
	        window.addEventListener('message', this.receiveMessage.bind(this));
	    };
	    PlatformEveryMatrix.prototype.loadProgress = function (progress) {
	        if (false) {
	            this.log('loadProgress');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'loadProgress', 'sender': 'game', 'data': progress
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformEveryMatrix.prototype.gameReady = function () {
	        if (false) {
	            this.log('gameReady');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'loadCompleted', 'sender': 'game'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformEveryMatrix.prototype.gameFailed = function () { };
	    PlatformEveryMatrix.prototype.gameClosing = function () {
	        if (false) {
	            this.log('gameClosing');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'closed', 'sender': 'game'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformEveryMatrix.prototype.gameReloading = function () { };
	    PlatformEveryMatrix.prototype.gameChange = function (gameCode) { };
	    PlatformEveryMatrix.prototype.error = function (code, message) {
	        if (false) {
	            this.log('error');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'errorMessage', 'sender': 'game', 'data': { 'errorCode': code, 'errorMessage': message }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformEveryMatrix.prototype.clientError = function (id, message) { };
	    PlatformEveryMatrix.prototype.roundInit = function () { };
	    PlatformEveryMatrix.prototype.roundStarted = function () {
	        if (false) {
	            this.log('roundStarted');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'roundStart', 'sender': 'game'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformEveryMatrix.prototype.spinStarted = function () {
	        this.inSpin = true;
	    };
	    PlatformEveryMatrix.prototype.spinReceived = function () { };
	    PlatformEveryMatrix.prototype.spinEnded = function () {
	        this.inSpin = false;
	    };
	    PlatformEveryMatrix.prototype.roundEnded = function () {
	        if (false) {
	            this.log('roundEnded');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'roundEnd', 'sender': 'game'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformEveryMatrix.prototype.featureStarted = function () { };
	    PlatformEveryMatrix.prototype.featureInit = function () { };
	    PlatformEveryMatrix.prototype.featureFinished = function () { };
	    PlatformEveryMatrix.prototype.autoplayStarted = function () { };
	    PlatformEveryMatrix.prototype.autoplayFinished = function () { };
	    PlatformEveryMatrix.prototype.gotoCasier = function () { };
	    PlatformEveryMatrix.prototype.gotoHistory = function () { };
	    PlatformEveryMatrix.prototype.gotoHelp = function () { };
	    PlatformEveryMatrix.prototype.gotoPaytable = function () { };
	    PlatformEveryMatrix.prototype.balanceUpdated = function (args) {
	        if (false) {
	            this.log('balanceUpdated');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null && args != null) {
	            var data = {
	                balance: args.amount,
	                previousBalance: this.currentBalance,
	                totalBet: this.currentBet,
	            };
	            var win = parseFloat(neo_common_1.NumberUtils.subtract(args.amount, this.currentBalance));
	            if (win < 0) {
	                win = 0;
	            }
	            if (this.inSpin && win > 0) {
	                win = parseFloat(neo_common_1.NumberUtils.add(win, this.currentBet));
	            }
	            if (this.currentBalance === args.amount) {
	                return;
	            }
	            data['totalWin'] = win;
	            window.parent.postMessage({
	                'name': 'balanceUpdate',
	                'sender': 'game',
	                data: data
	            }, Platforms_1.Platforms.pluginOrigin);
	            this.currentBalance = args.amount;
	        }
	    };
	    PlatformEveryMatrix.prototype.sendPluginMessage = function (message) { };
	    PlatformEveryMatrix.prototype.setVolume = function (level) {
	        if (false) {
	            this.log('setVolume');
	        }
	        var audio = level > 0;
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'audioToggle', 'sender': 'game', 'data': audio
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformEveryMatrix.prototype.quickSpinEnabled = function (enabled) { };
	    PlatformEveryMatrix.prototype.bet = function (value) {
	        if (false) {
	            this.log('bet');
	        }
	        this.currentBet = value;
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'stakeUpdate', 'sender': 'game', 'data': value
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformEveryMatrix.prototype.win = function (value) {
	        if (false) {
	            this.log('win');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'winUpdate', 'sender': 'game', 'data': value
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformEveryMatrix.prototype.userAction = function (action, data) { };
	    PlatformEveryMatrix.prototype.gameDataLoaded = function (args) {
	        if (false) {
	            this.log('gameDataLoaded');
	        }
	        if (args.Bet != null) {
	            this.bet(args.Bet);
	        }
	        if (args.Balance != null) {
	            this.currentBalance = args.Balance;
	        }
	        this.setVolume(1);
	    };
	    PlatformEveryMatrix.prototype.dialogOpened = function (type, isOpen) { };
	    PlatformEveryMatrix.prototype.fullscreen = function (enabled) { };
	    PlatformEveryMatrix.prototype.receiveMessage = function (event) {
	        if (false) {
	            this.log('receiveMessage');
	        }
	        if (event != null && event.data != null) {
	            if (event.data.name != null) {
	                switch (event.data.name) {
	                    case 'updateBalance':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.refreshBalance();
	                        }
	                        break;
	                    case 'setAudio':
	                        if (this.checkOrigin(event.origin)) {
	                            if (event.data.data) {
	                                Platforms_1.Platforms.gameAudioEnable();
	                            }
	                            else {
	                                Platforms_1.Platforms.gameAudioMute();
	                            }
	                        }
	                        break;
	                    case 'showHelp':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.showHelp();
	                        }
	                        break;
	                    case 'togglePaytable':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.togglePaytable();
	                        }
	                        break;
	                    case 'modalWindowOpened':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayStop();
	                        }
	                        break;
	                    case 'modalWindowClosed':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayResume();
	                        }
	                        break;
	                    case 'stopAutospins':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.stopAutoplay();
	                        }
	                        break;
	                }
	            }
	        }
	    };
	    PlatformEveryMatrix.prototype.checkOrigin = function (origin) {
	        if (Platforms_1.Platforms.pluginOrigin !== '*' && origin !== Platforms_1.Platforms.pluginOrigin) {
	            return false;
	        }
	        return true;
	    };
	    PlatformEveryMatrix.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('EveryMatrix', 'EveryMatrix' + s);
	        }
	    };
	    return PlatformEveryMatrix;
	}());
	exports.PlatformEveryMatrix = PlatformEveryMatrix;


/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var PlatformRelax = (function () {
	    function PlatformRelax() {
	    }
	    PlatformRelax.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        if (false) {
	            this.log('create');
	        }
	        this.createPlugin();
	    };
	    PlatformRelax.prototype.loadProgress = function (progress) { };
	    PlatformRelax.prototype.gameReady = function () {
	        if (false) {
	            this.log('gameReady');
	        }
	        if (window['RgPostMessageAPI'] != null) {
	            window['RgPostMessageAPI'].reportGameReady();
	        }
	    };
	    PlatformRelax.prototype.gameFailed = function () { };
	    PlatformRelax.prototype.gameClosing = function () { };
	    PlatformRelax.prototype.gameReloading = function () { };
	    PlatformRelax.prototype.gameChange = function (gameCode) { };
	    PlatformRelax.prototype.error = function (code, message) { };
	    PlatformRelax.prototype.clientError = function (id, message) { };
	    PlatformRelax.prototype.roundInit = function () { };
	    PlatformRelax.prototype.roundStarted = function () {
	        if (false) {
	            this.log('roundStarted');
	        }
	        if (window['RgPostMessageAPI'] != null) {
	            window['RgPostMessageAPI'].gameRoundStarted();
	        }
	    };
	    PlatformRelax.prototype.spinStarted = function () { };
	    PlatformRelax.prototype.spinReceived = function () { };
	    PlatformRelax.prototype.spinEnded = function () { };
	    PlatformRelax.prototype.roundEnded = function () {
	        if (false) {
	            this.log('roundEnded');
	        }
	        if (window['RgPostMessageAPI'] != null) {
	            window['RgPostMessageAPI'].gameRoundEnded();
	        }
	    };
	    PlatformRelax.prototype.featureStarted = function () { };
	    PlatformRelax.prototype.featureInit = function () { };
	    PlatformRelax.prototype.featureFinished = function () { };
	    PlatformRelax.prototype.autoplayStarted = function () { };
	    PlatformRelax.prototype.autoplayFinished = function () { };
	    PlatformRelax.prototype.gotoCasier = function () { };
	    PlatformRelax.prototype.gotoHistory = function () { };
	    PlatformRelax.prototype.gotoHelp = function () { };
	    PlatformRelax.prototype.gotoPaytable = function () { };
	    PlatformRelax.prototype.balanceUpdated = function () { };
	    PlatformRelax.prototype.sendPluginMessage = function (message) { };
	    PlatformRelax.prototype.setVolume = function (level) { };
	    PlatformRelax.prototype.quickSpinEnabled = function (enabled) { };
	    PlatformRelax.prototype.bet = function (value) { };
	    PlatformRelax.prototype.win = function (value) { };
	    PlatformRelax.prototype.userAction = function (action, data) {
	        if (false) {
	            this.log('userAction');
	        }
	        if (action === 'exit') {
	            if (data['url'] != null) {
	                if (window['RgPostMessageAPI'] != null) {
	                    window['RgPostMessageAPI'].userAction(data['url']);
	                }
	            }
	        }
	    };
	    PlatformRelax.prototype.gameDataLoaded = function (args) { };
	    PlatformRelax.prototype.dialogOpened = function (type, isOpen) { };
	    PlatformRelax.prototype.fullscreen = function (enabled) { };
	    PlatformRelax.prototype.createPlugin = function () {
	        if (false) {
	            this.log('createPlugin');
	        }
	        if (Platforms_1.Platforms.pluginUrl != null) {
	            var script = document.createElement('script');
	            script.setAttribute('type', 'text/javascript');
	            script.setAttribute('src', Platforms_1.Platforms.pluginUrl);
	            script.onload = this.loadPlugin.bind(this);
	            document.head.appendChild(script);
	        }
	    };
	    PlatformRelax.prototype.loadPlugin = function () {
	        if (false) {
	            this.log('loadPlugin');
	        }
	        window.addEventListener('rg_pause', this.pause.bind(this));
	        window.addEventListener('rg_resume', this.resume.bind(this));
	        window.addEventListener('rg_updateBalance', this.updateBalance.bind(this));
	        if (window['RgPostMessageAPI'] != null) {
	            window['RgPostMessageAPI'].init(true);
	        }
	        Platforms_1.Platforms.canPlay = true;
	    };
	    PlatformRelax.prototype.pause = function (e) {
	        if (false) {
	            this.log('pause');
	        }
	        if (e.data && e.data.autoPlayOnly) {
	            Platforms_1.Platforms.stopAutoplay();
	        }
	        else {
	            Platforms_1.Platforms.gamePlayStop();
	            if (window['RgPostMessageAPI'] != null) {
	                window['RgPostMessageAPI'].reportPaused();
	            }
	        }
	    };
	    PlatformRelax.prototype.resume = function () {
	        if (false) {
	            this.log('resume');
	        }
	        Platforms_1.Platforms.gamePlayResume();
	    };
	    PlatformRelax.prototype.updateBalance = function () {
	        if (false) {
	            this.log('updateBalance');
	        }
	        Platforms_1.Platforms.refreshBalance();
	    };
	    PlatformRelax.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('Relax', 'Relax ' + s);
	        }
	    };
	    return PlatformRelax;
	}());
	exports.PlatformRelax = PlatformRelax;


/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var PlatformPariplay = (function () {
	    function PlatformPariplay() {
	    }
	    PlatformPariplay.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        this.messageData = [];
	        if (false) {
	            this.log('create');
	        }
	        window.addEventListener('message', this.receiveMessage.bind(this));
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            var messageObject = {
	                type: 'onAppFrameReady',
	                sender: Platforms_1.Platforms.gameKey,
	                lang: Platforms_1.Platforms.lang
	            };
	            window.parent.postMessage(messageObject, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformPariplay.prototype.loadProgress = function (progress) { };
	    PlatformPariplay.prototype.gameReady = function () {
	        if (false) {
	            this.log('gameReady');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            var messageObject = {
	                type: 'gameReady',
	                sender: Platforms_1.Platforms.gameKey,
	                lang: Platforms_1.Platforms.lang
	            };
	            window.parent.postMessage(messageObject, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformPariplay.prototype.gameFailed = function () { };
	    PlatformPariplay.prototype.gameClosing = function () {
	        if (false) {
	            this.log('gameClosing');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            var messageObject = {
	                type: 'quit',
	                sender: Platforms_1.Platforms.gameKey,
	                lang: Platforms_1.Platforms.lang
	            };
	            window.parent.postMessage(messageObject, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformPariplay.prototype.gameReloading = function () { };
	    PlatformPariplay.prototype.gameChange = function (gameCode) { };
	    PlatformPariplay.prototype.error = function (code, message) { };
	    PlatformPariplay.prototype.clientError = function (id, message) { };
	    PlatformPariplay.prototype.roundInit = function () { };
	    PlatformPariplay.prototype.roundStarted = function (args) {
	        if (false) {
	            this.log('roundStarted');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            if (args != null && args.totalBet != null) {
	                var messageObject = {
	                    type: 'roundStart',
	                    sender: Platforms_1.Platforms.gameKey,
	                    lang: Platforms_1.Platforms.lang
	                };
	                messageObject['data'] = { 'totalBet': args.totalBet };
	                window.parent.postMessage(messageObject, Platforms_1.Platforms.pluginOrigin);
	            }
	        }
	    };
	    PlatformPariplay.prototype.spinStarted = function () { };
	    PlatformPariplay.prototype.spinReceived = function (args) {
	        if (false) {
	            this.log('spinReceived');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            if (args != null && args.roundId != null && args.balance != null) {
	                var messageObject_roundStarted = {
	                    type: 'roundStarted',
	                    sender: Platforms_1.Platforms.gameKey,
	                    lang: Platforms_1.Platforms.lang
	                };
	                messageObject_roundStarted['data'] = { 'id': args.roundId, 'balanceBefore': args.balance };
	                window.parent.postMessage(messageObject_roundStarted, Platforms_1.Platforms.pluginOrigin);
	            }
	            if (args != null && args.totalBet != null && args.win != null && args.balance != null) {
	                var messageObject_ticketReceived = {
	                    type: 'ticketReceived',
	                    sender: Platforms_1.Platforms.gameKey,
	                    lang: Platforms_1.Platforms.lang
	                };
	                messageObject_ticketReceived['data'] = { 'BetAmount': args.totalBet, 'WinAmount': args.win, 'Balance': args.balance, 'Status': { 'ErrCode': 0 } };
	                if (this.messageData.length > 0) {
	                    messageObject_ticketReceived['data']['Message'] = this.messageData;
	                    this.messageData = [];
	                }
	                this.log("TicketReceived - " + JSON.stringify(messageObject_ticketReceived));
	                window.parent.postMessage(messageObject_ticketReceived, Platforms_1.Platforms.pluginOrigin);
	            }
	        }
	    };
	    PlatformPariplay.prototype.spinEnded = function () { };
	    PlatformPariplay.prototype.roundEnded = function (args) {
	        if (false) {
	            this.log('roundEnded');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            if (args != null && args.id != null && args.win != null && args.balanceAfter != null) {
	                var messageObject = {
	                    type: 'roundEnded',
	                    sender: Platforms_1.Platforms.gameKey,
	                    lang: Platforms_1.Platforms.lang
	                };
	                messageObject['data'] = { 'id': args.id, 'win': args.win, 'balanceAfter': args.balanceAfter };
	                window.parent.postMessage(messageObject, Platforms_1.Platforms.pluginOrigin);
	            }
	        }
	    };
	    PlatformPariplay.prototype.featureStarted = function () { };
	    PlatformPariplay.prototype.featureInit = function () { };
	    PlatformPariplay.prototype.featureFinished = function () { };
	    PlatformPariplay.prototype.autoplayStarted = function () { };
	    PlatformPariplay.prototype.autoplayFinished = function () { };
	    PlatformPariplay.prototype.gotoCasier = function (args) {
	        if (false) {
	            this.log('gotoCashier');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            var messageObject = {
	                type: 'cashier',
	                sender: Platforms_1.Platforms.gameKey,
	                lang: Platforms_1.Platforms.lang
	            };
	            if (args != null) {
	                if (args.reason != null) {
	                    if (messageObject['data'] == null) {
	                        messageObject['data'] = {};
	                    }
	                    messageObject['data']['reason'] = args.reason;
	                }
	                if (args.target != null) {
	                    if (messageObject['data'] == null) {
	                        messageObject['data'] = {};
	                    }
	                    messageObject['data']['target'] = args.target;
	                }
	            }
	            window.parent.postMessage(messageObject, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformPariplay.prototype.gotoHistory = function (args) {
	        if (false) {
	            this.log('gotoHistory');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            if (args != null && args.target != null) {
	                var messageObject = {
	                    type: 'history',
	                    sender: Platforms_1.Platforms.gameKey,
	                    lang: Platforms_1.Platforms.lang
	                };
	                messageObject['data'] = { 'reason': 'RealityCheck', 'target': args.target };
	                window.parent.postMessage(messageObject, Platforms_1.Platforms.pluginOrigin);
	            }
	        }
	    };
	    PlatformPariplay.prototype.gotoHelp = function (args) {
	        if (false) {
	            this.log('gotoHelp');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            if (args != null && args.target != null) {
	                var messageObject = {
	                    type: 'help',
	                    sender: Platforms_1.Platforms.gameKey,
	                    lang: Platforms_1.Platforms.lang
	                };
	                messageObject['data'] = { 'reason': 'Ribbon', 'target': args.target };
	                window.parent.postMessage(messageObject, Platforms_1.Platforms.pluginOrigin);
	            }
	        }
	    };
	    PlatformPariplay.prototype.gotoPaytable = function () { };
	    PlatformPariplay.prototype.balanceUpdated = function (args) {
	        if (false) {
	            this.log('balanceUpdated');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            if (args != null && args.amount != null) {
	                var messageObject = {
	                    type: 'balance',
	                    sender: Platforms_1.Platforms.gameKey,
	                    lang: Platforms_1.Platforms.lang
	                };
	                messageObject['data'] = { 'amount': args.amount };
	                window.parent.postMessage(messageObject, Platforms_1.Platforms.pluginOrigin);
	            }
	        }
	    };
	    PlatformPariplay.prototype.sendPluginMessage = function (message) {
	        if (false) {
	            this.log('sendPluginMessage');
	        }
	        if (message === '') {
	            return;
	        }
	        this.messageData.push(JSON.parse(message));
	    };
	    PlatformPariplay.prototype.setVolume = function (level) { };
	    PlatformPariplay.prototype.quickSpinEnabled = function (enabled) { };
	    PlatformPariplay.prototype.bet = function (value) { };
	    PlatformPariplay.prototype.win = function (value) { };
	    PlatformPariplay.prototype.userAction = function (action, data) { };
	    PlatformPariplay.prototype.gameDataLoaded = function (args) {
	        if (false) {
	            this.log('gameDataLoaded');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            if (args != null) {
	                var messageObject = {
	                    type: 'gameDataLoaded',
	                    sender: Platforms_1.Platforms.gameKey,
	                    lang: Platforms_1.Platforms.lang
	                };
	                messageObject['data'] = { 'LoadGameData': {} };
	                if (args.GameName != null) {
	                    messageObject['data']['LoadGameData']['GameName'] = args.GameName;
	                }
	                if (args.HomeUrl != null) {
	                    messageObject['data']['LoadGameData']['HomeUrl'] = args.HomeUrl;
	                }
	                if (args.ClientToken != null) {
	                    messageObject['data']['LoadGameData']['ClientToken'] = args.ClientToken;
	                }
	                if (args.SessionData != null) {
	                    messageObject['data']['LoadGameData']['SessionData'] = args.SessionData;
	                }
	                if (args.CurrencyCode != null) {
	                    messageObject['data']['LoadGameData']['CurrencyCode'] = args.CurrencyCode;
	                }
	                if (args.PlayerTokenId != null) {
	                    messageObject['data']['LoadGameData']['PlayerTokenId'] = args.PlayerTokenId;
	                    window.parent.postMessage(messageObject, Platforms_1.Platforms.pluginOrigin);
	                }
	            }
	        }
	    };
	    PlatformPariplay.prototype.dialogOpened = function (type, isOpen) { };
	    PlatformPariplay.prototype.fullscreen = function (enabled) { };
	    PlatformPariplay.prototype.receiveMessage = function (event) {
	        if (false) {
	            this.log('receiveMessage');
	        }
	        if (event != null && event.data != null) {
	            if (event.data.type != null) {
	                switch (event.data.type) {
	                    case 'stopAutobet':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.stopAutoplay();
	                        }
	                        break;
	                    case 'enableSpin':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayResume();
	                        }
	                        break;
	                    case 'disableSpin':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayStop(true);
	                        }
	                        break;
	                    case 'pause':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayStop(true);
	                        }
	                        break;
	                    case 'resume':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayResume();
	                        }
	                        break;
	                }
	            }
	        }
	    };
	    PlatformPariplay.prototype.checkOrigin = function (origin) {
	        if (Platforms_1.Platforms.pluginOrigin !== '*' && origin !== Platforms_1.Platforms.pluginOrigin) {
	            return false;
	        }
	        return true;
	    };
	    PlatformPariplay.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('Pariplay', 'Pariplay ' + s);
	        }
	    };
	    return PlatformPariplay;
	}());
	exports.PlatformPariplay = PlatformPariplay;


/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var PlatformRelaxFEIM = (function () {
	    function PlatformRelaxFEIM() {
	        this.roundTypes = {
	            NORMAL: 'normal',
	            DEMO: 'demo',
	            FREE_ROUNDS: 'freerounds',
	            FEATURE_FREE_ROUNDS: 'featurefreerounds'
	        };
	    }
	    PlatformRelaxFEIM.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        if (false) {
	            this.log('create');
	        }
	        this.loadStarted = false;
	        this.createPlugin();
	    };
	    PlatformRelaxFEIM.prototype.loadProgress = function (progress) {
	        if (false) {
	            this.log('gameReady');
	        }
	        if (window['FEIM'] != null) {
	            if (!this.loadStarted) {
	                this.loadStarted = true;
	                window['FEIM'].send.gameLoadStarted();
	            }
	            window['FEIM'].send.gameLoadProgress(progress);
	        }
	    };
	    PlatformRelaxFEIM.prototype.gameReady = function () {
	        if (false) {
	            this.log('gameReady');
	        }
	        if (window['FEIM'] != null) {
	            window['FEIM'].send.gameLoadCompleted();
	        }
	    };
	    PlatformRelaxFEIM.prototype.gameFailed = function () { };
	    PlatformRelaxFEIM.prototype.gameClosing = function () {
	        if (false) {
	            this.log('gameClosing');
	        }
	        if (window['FEIM'] != null) {
	            window['FEIM'].send.exitGame();
	        }
	    };
	    PlatformRelaxFEIM.prototype.gameReloading = function () { };
	    PlatformRelaxFEIM.prototype.gameChange = function (gameCode) { };
	    PlatformRelaxFEIM.prototype.error = function (code, message) {
	        if (false) {
	            this.log('error');
	        }
	        if (window['FEIM'] != null) {
	            var configuration = window['FEIM'].getConfiguration();
	            if (configuration != null) {
	                var operatorHandlesErrors = configuration['operatorHandlesErrors'];
	                if (operatorHandlesErrors) {
	                    Platforms_1.Platforms.handleShowErrorDialog = true;
	                }
	            }
	            window['FEIM'].send.errorMessage({
	                'errorCode': code,
	                'errorMessage': message
	            });
	        }
	    };
	    PlatformRelaxFEIM.prototype.clientError = function (id, message) { };
	    PlatformRelaxFEIM.prototype.roundInit = function () { };
	    PlatformRelaxFEIM.prototype.roundStarted = function (args) {
	        if (false) {
	            this.log('roundStarted');
	        }
	        if (args != null) {
	            this.lastBet = args.totalBet;
	            this.freeRound = args.freeRound;
	        }
	        else {
	            this.lastBet = null;
	            this.freeRound = false;
	        }
	        if (window['FEIM'] != null) {
	            window['FEIM'].send.roundStarted({ balance: this.lastUpdatedBalance });
	        }
	    };
	    PlatformRelaxFEIM.prototype.spinStarted = function () { };
	    PlatformRelaxFEIM.prototype.spinReceived = function (args) {
	        if (args != null) {
	            if (args.roundId != null) {
	                this.lastRoundId = args.roundId;
	            }
	        }
	    };
	    PlatformRelaxFEIM.prototype.spinEnded = function () { };
	    PlatformRelaxFEIM.prototype.roundEnded = function (args) {
	        if (false) {
	            this.log('roundEnded');
	        }
	        this.roundType = this.roundTypes.NORMAL;
	        if (this.freeRound) {
	            this.roundType = this.roundTypes.FREE_ROUNDS;
	        }
	        if (this.lastRoundId === -1) {
	            this.roundType = this.roundTypes.DEMO;
	        }
	        if (window['FEIM'] != null && args != null) {
	            window['FEIM'].send.roundFinished({
	                balance: parseInt(neo_common_1.NumberUtils.multiply(args.balanceAfter, 100)),
	                win: { win: parseInt(neo_common_1.NumberUtils.multiply(args.win, 100)) },
	                bet: this.lastBet ? parseInt(neo_common_1.NumberUtils.multiply(this.lastBet, 100)) : undefined,
	                playResponse: { roundType: this.roundType }
	            });
	        }
	    };
	    PlatformRelaxFEIM.prototype.featureStarted = function (args) {
	        if (false) {
	            this.log('featureStarted');
	        }
	        if (window['FEIM'] != null && args != null) {
	            window['FEIM'].send.featureStarted({ 'type': args.type });
	        }
	    };
	    PlatformRelaxFEIM.prototype.featureInit = function () { };
	    PlatformRelaxFEIM.prototype.featureFinished = function (args) {
	        if (false) {
	            this.log('featureFinished');
	        }
	        if (window['FEIM'] != null && args != null) {
	            window['FEIM'].send.featureFinished({ 'type': args.type });
	        }
	    };
	    PlatformRelaxFEIM.prototype.autoplayStarted = function () {
	        if (false) {
	            this.log('autoplayStarted');
	        }
	        if (window['FEIM'] != null) {
	            window['FEIM'].send.autoPlayStarted();
	        }
	    };
	    PlatformRelaxFEIM.prototype.autoplayFinished = function () {
	        if (false) {
	            this.log('autoplayFinished');
	        }
	        if (window['FEIM'] != null) {
	            window['FEIM'].send.autoPlayFinished();
	        }
	    };
	    PlatformRelaxFEIM.prototype.gotoCasier = function () {
	        if (false) {
	            this.log('gotoCasier');
	        }
	        if (window['FEIM'] != null) {
	            window['FEIM'].send.openQuickDeposit();
	        }
	    };
	    PlatformRelaxFEIM.prototype.gotoHistory = function () {
	        if (false) {
	            this.log('gotoHistory');
	        }
	        if (window['FEIM'] != null) {
	            window['FEIM'].send.showHistory();
	        }
	    };
	    PlatformRelaxFEIM.prototype.gotoHelp = function () { };
	    PlatformRelaxFEIM.prototype.gotoPaytable = function () { };
	    PlatformRelaxFEIM.prototype.balanceUpdated = function (args) {
	        if (false) {
	            this.log('balanceUpdated');
	        }
	        if (window['FEIM'] != null && args != null) {
	            this.lastUpdatedBalance = parseInt(neo_common_1.NumberUtils.multiply(args.amount, 100));
	            window['FEIM'].send.balanceUpdate(this.lastUpdatedBalance);
	        }
	    };
	    PlatformRelaxFEIM.prototype.sendPluginMessage = function (message) { };
	    PlatformRelaxFEIM.prototype.setVolume = function (level) {
	        if (false) {
	            this.log('setVolume');
	        }
	        if (window['FEIM'] != null) {
	            window['FEIM'].send.updateSettings({
	                'sounds': level > 0
	            });
	        }
	    };
	    PlatformRelaxFEIM.prototype.quickSpinEnabled = function (enabled) {
	        if (false) {
	            this.log('quickSpinEnabled');
	        }
	        if (window['FEIM'] != null) {
	            window['FEIM'].send.updateSettings({
	                'fastPlay': enabled
	            });
	        }
	    };
	    PlatformRelaxFEIM.prototype.bet = function (value) {
	        if (false) {
	            this.log('bet');
	        }
	        if (window['FEIM'] != null) {
	            window['FEIM'].send.betUpdate(parseInt(neo_common_1.NumberUtils.multiply(value, 100)));
	        }
	    };
	    PlatformRelaxFEIM.prototype.win = function (value, cumulative) {
	        if (false) {
	            this.log('win');
	        }
	        if (window['FEIM'] != null) {
	            if (cumulative) {
	                return;
	            }
	            window['FEIM'].send.winUpdate({ win: parseInt(neo_common_1.NumberUtils.multiply(value, 100)) });
	        }
	    };
	    PlatformRelaxFEIM.prototype.userAction = function (action, data) {
	        if (false) {
	            this.log('userAction');
	        }
	        if (action === 'exit') {
	            if (data['url'] != null) {
	                if (window['FEIM'] != null) {
	                    window['FEIM'].send.navigate(data['url']);
	                }
	            }
	        }
	    };
	    PlatformRelaxFEIM.prototype.gameDataLoaded = function (args) {
	        if (window['FEIM'] != null && args != null) {
	            window['FEIM'].configure({
	                p2pConfig: { currency: args.CurrencyCode }
	            });
	            if (args.Balance != null) {
	                this.balanceUpdated({ amount: args.Balance });
	            }
	            if (args.Bet != null) {
	                this.bet(args.Bet);
	            }
	        }
	    };
	    PlatformRelaxFEIM.prototype.dialogOpened = function (type, isOpen) { };
	    PlatformRelaxFEIM.prototype.fullscreen = function (enabled) { };
	    PlatformRelaxFEIM.prototype.createPlugin = function () {
	        if (false) {
	            this.log('createPlugin');
	        }
	        if (Platforms_1.Platforms.pluginUrl != null) {
	            var script = document.createElement('script');
	            script.setAttribute('type', 'text/javascript');
	            script.setAttribute('src', Platforms_1.Platforms.pluginUrl);
	            script.onload = this.loadPlugin.bind(this);
	            document.head.appendChild(script);
	        }
	    };
	    PlatformRelaxFEIM.prototype.loadPlugin = function () {
	        if (false) {
	            this.log('loadPlugin');
	        }
	        var self = this;
	        if (window['FEIM'] != null) {
	            window['FEIM'].configure({
	                handleRgPostMessageAPI: true
	            });
	            window['FEIM'].on.refreshBalance(this.updateBalance.bind(this));
	            window['FEIM'].on.freeze(this.freeze.bind(this));
	            window['FEIM'].on.unfreeze(this.unfreeze.bind(this));
	            window['FEIM'].on.pauseAutoPlay(this.pauseAutoPlay.bind(this));
	            window['FEIM'].on.errorMessageDismissed(this.errorMessageDismissed.bind(this));
	            window['FEIM'].on.toggleGameHelp(function (action) {
	                self.toggleGameHelp(action);
	            });
	            window['FEIM'].on.togglePaytable(function (action) {
	                self.togglePaytable(action);
	            });
	            window['FEIM'].on.updateSettings(function (data) {
	                self.updateSettings(data);
	            });
	            window.addEventListener('message', function (event) {
	                if (event != null) {
	                    var data = event.data;
	                    if (data != null && data['feimOpEvent'] != null) {
	                        if (data['feimOpEvent'] === 'pause-when-idle') {
	                            self.pauseWhenIdle();
	                        }
	                    }
	                }
	            });
	        }
	        Platforms_1.Platforms.canPlay = true;
	    };
	    PlatformRelaxFEIM.prototype.freeze = function () {
	        if (false) {
	            this.log('freeze');
	        }
	        Platforms_1.Platforms.gamePlayFreeze();
	    };
	    PlatformRelaxFEIM.prototype.unfreeze = function () {
	        if (false) {
	            this.log('unfreeze');
	        }
	        Platforms_1.Platforms.gamePlayUnfreeze();
	    };
	    PlatformRelaxFEIM.prototype.pauseWhenIdle = function () {
	        if (false) {
	            this.log('pauseWhenIdle');
	        }
	        Platforms_1.Platforms.gamePlaySupressSpinOnCollect();
	    };
	    PlatformRelaxFEIM.prototype.pauseAutoPlay = function () {
	        if (false) {
	            this.log('pauseAutoPlay');
	        }
	        Platforms_1.Platforms.stopAutoplay();
	    };
	    PlatformRelaxFEIM.prototype.toggleGameHelp = function (action) {
	        if (false) {
	            this.log('toggleGameHelp');
	        }
	        if (action != null && action['type'] != null) {
	            switch (action['type']) {
	                case 'show':
	                    Platforms_1.Platforms.showHelp();
	                    break;
	                case 'hide':
	                    Platforms_1.Platforms.hideHelp();
	                    break;
	                default:
	                    Platforms_1.Platforms.toggleHelp();
	            }
	        }
	        else {
	            Platforms_1.Platforms.toggleHelp();
	        }
	    };
	    PlatformRelaxFEIM.prototype.togglePaytable = function (action) {
	        if (false) {
	            this.log('togglePaytable');
	        }
	        if (action != null && action['type'] != null) {
	            switch (action['type']) {
	                case 'show':
	                    Platforms_1.Platforms.showPaytable();
	                    break;
	                case 'hide':
	                    Platforms_1.Platforms.hidePaytable();
	                    break;
	                default:
	                    Platforms_1.Platforms.togglePaytable();
	            }
	        }
	        else {
	            Platforms_1.Platforms.togglePaytable();
	        }
	    };
	    PlatformRelaxFEIM.prototype.updateSettings = function (data) {
	        if (false) {
	            this.log('updateSettings');
	        }
	        if (data != null) {
	            if (data['fastPlay'] != null) {
	                Platforms_1.Platforms.gameQuickSpin(data['fastPlay']);
	            }
	            if (data['sounds'] != null) {
	                if (data['sounds']) {
	                    Platforms_1.Platforms.gameAudioEnable();
	                }
	                else {
	                    Platforms_1.Platforms.gameAudioMute();
	                }
	            }
	        }
	    };
	    PlatformRelaxFEIM.prototype.errorMessageDismissed = function () {
	        if (false) {
	            this.log('errorMessageDismissed');
	        }
	        Platforms_1.Platforms.platformErrorMessageDismissed();
	    };
	    PlatformRelaxFEIM.prototype.updateBalance = function () {
	        if (false) {
	            this.log('updateBalance');
	        }
	        Platforms_1.Platforms.refreshBalance();
	    };
	    PlatformRelaxFEIM.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('Relax', 'Relax ' + s);
	        }
	    };
	    return PlatformRelaxFEIM;
	}());
	exports.PlatformRelaxFEIM = PlatformRelaxFEIM;


/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var PlatformBetFair = (function () {
	    function PlatformBetFair() {
	    }
	    PlatformBetFair.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        Platforms_1.Platforms.handleShowErrorDialog = true;
	        if (false) {
	            this.log('create');
	        }
	        window.addEventListener('message', this.receiveMessage.bind(this));
	    };
	    PlatformBetFair.prototype.loadProgress = function (progress) {
	        if (false) {
	            this.log('loadProgress');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'loadProgress', 'sender': 'game', 'data': progress
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformBetFair.prototype.gameReady = function () {
	        if (false) {
	            this.log('gameReady');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'loadCompleted', 'sender': 'game'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformBetFair.prototype.gameFailed = function () { };
	    PlatformBetFair.prototype.gameClosing = function () {
	        if (false) {
	            this.log('gameClosing');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'closed', 'sender': 'game'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformBetFair.prototype.gameReloading = function () { };
	    PlatformBetFair.prototype.gameChange = function (gameCode) { };
	    PlatformBetFair.prototype.error = function (code, message) {
	        if (false) {
	            this.log('error');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'errorMessage', 'sender': 'game', 'data': { 'errorCode': code, 'errorMessage': message }
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformBetFair.prototype.clientError = function (id, message) { };
	    PlatformBetFair.prototype.roundInit = function () { };
	    PlatformBetFair.prototype.roundStarted = function () {
	        if (false) {
	            this.log('roundStarted');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'roundStart', 'sender': 'game'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformBetFair.prototype.spinStarted = function () { };
	    PlatformBetFair.prototype.spinReceived = function () { };
	    PlatformBetFair.prototype.spinEnded = function () { };
	    PlatformBetFair.prototype.roundEnded = function () {
	        if (false) {
	            this.log('roundEnded');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'roundEnd', 'sender': 'game'
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformBetFair.prototype.featureStarted = function () { };
	    PlatformBetFair.prototype.featureInit = function () { };
	    PlatformBetFair.prototype.featureFinished = function () { };
	    PlatformBetFair.prototype.autoplayStarted = function () { };
	    PlatformBetFair.prototype.autoplayFinished = function () { };
	    PlatformBetFair.prototype.gotoCasier = function () { };
	    PlatformBetFair.prototype.gotoHistory = function () { };
	    PlatformBetFair.prototype.gotoHelp = function () { };
	    PlatformBetFair.prototype.gotoPaytable = function () { };
	    PlatformBetFair.prototype.balanceUpdated = function () { };
	    PlatformBetFair.prototype.sendPluginMessage = function (message) { };
	    PlatformBetFair.prototype.setVolume = function (level) {
	        if (false) {
	            this.log('setVolume');
	        }
	        var audio = level > 0;
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'audioToggle', 'sender': 'game', 'data': audio
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformBetFair.prototype.quickSpinEnabled = function (enabled) { };
	    PlatformBetFair.prototype.bet = function (value) {
	        if (false) {
	            this.log('bet');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'stakeUpdate', 'sender': 'game', 'data': value
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformBetFair.prototype.win = function (value) {
	        if (false) {
	            this.log('win');
	        }
	        if (Platforms_1.Platforms.pluginOrigin != null) {
	            window.parent.postMessage({
	                'name': 'winUpdate', 'sender': 'game', 'data': value
	            }, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformBetFair.prototype.userAction = function (action, data) { };
	    PlatformBetFair.prototype.gameDataLoaded = function (args) {
	        if (false) {
	            this.log('gameDataLoaded');
	        }
	        if (args.Bet != null) {
	            this.bet(args.Bet);
	        }
	        this.setVolume(1);
	    };
	    PlatformBetFair.prototype.dialogOpened = function (type, isOpen) { };
	    PlatformBetFair.prototype.fullscreen = function (enabled) { };
	    PlatformBetFair.prototype.receiveMessage = function (event) {
	        if (false) {
	            this.log('receiveMessage');
	        }
	        if (event != null && event.data != null) {
	            if (event.data.name != null) {
	                switch (event.data.name) {
	                    case 'updateBalance':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.refreshBalance();
	                        }
	                        break;
	                    case 'setAudio':
	                        if (this.checkOrigin(event.origin)) {
	                            if (event.data.data) {
	                                Platforms_1.Platforms.gameAudioEnable();
	                            }
	                            else {
	                                Platforms_1.Platforms.gameAudioMute();
	                            }
	                        }
	                        break;
	                    case 'showHelp':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.showHelp();
	                        }
	                        break;
	                    case 'togglePaytable':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.togglePaytable();
	                        }
	                        break;
	                    case 'modalWindowOpened':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayStop();
	                        }
	                        break;
	                    case 'modalWindowClosed':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.gamePlayResume();
	                        }
	                        break;
	                    case 'stopAutospins':
	                        if (this.checkOrigin(event.origin)) {
	                            Platforms_1.Platforms.stopAutoplay();
	                        }
	                        break;
	                }
	            }
	        }
	    };
	    PlatformBetFair.prototype.checkOrigin = function (origin) {
	        if (Platforms_1.Platforms.pluginOrigin !== '*' && origin !== Platforms_1.Platforms.pluginOrigin) {
	            return false;
	        }
	        return true;
	    };
	    PlatformBetFair.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('EveryMatrix', 'EveryMatrix' + s);
	        }
	    };
	    return PlatformBetFair;
	}());
	exports.PlatformBetFair = PlatformBetFair;


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var PlatformSynotAPI = (function () {
	    function PlatformSynotAPI() {
	        this.isGameRoundFinished = true;
	        this.gamePlayDisabled = false;
	        this.logger = false;
	    }
	    PlatformSynotAPI.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        window.addEventListener('message', this.receiveMessage.bind(this));
	    };
	    PlatformSynotAPI.prototype.loadProgress = function (progress) {
	        if (this.progress === 100) {
	            return;
	        }
	        this.sendMessage('g2p.loadProgress', { progress: progress });
	        this.progress = progress;
	    };
	    PlatformSynotAPI.prototype.gameReady = function () {
	        this.sendMessage('g2p.gameReady');
	    };
	    PlatformSynotAPI.prototype.gameFailed = function () {
	        this.sendMessage('g2p.gameFailed');
	    };
	    PlatformSynotAPI.prototype.gameClosing = function () {
	        this.sendMessage('g2p.gameClosing');
	    };
	    PlatformSynotAPI.prototype.gameReloading = function () {
	        this.sendMessage('g2p.gameReloading');
	    };
	    PlatformSynotAPI.prototype.gameChange = function (gameCode) {
	        this.sendMessage('g2p.gameChange', { gameCode: gameCode });
	    };
	    PlatformSynotAPI.prototype.error = function (code, message) {
	        this.sendMessage('g2p.error', { code: code, message: message });
	    };
	    PlatformSynotAPI.prototype.clientError = function (id, message) { };
	    PlatformSynotAPI.prototype.roundInit = function (args) {
	        this.sendMessage('g2p.roundInit', args);
	    };
	    PlatformSynotAPI.prototype.roundStarted = function (args) {
	        this.isGameRoundFinished = false;
	        this.sendMessage('g2p.roundStarted', args);
	    };
	    PlatformSynotAPI.prototype.spinStarted = function () {
	        this.sendMessage('g2p.spinStarted');
	    };
	    PlatformSynotAPI.prototype.spinReceived = function (args) {
	        this.sendMessage('g2p.spinReceived', args);
	    };
	    PlatformSynotAPI.prototype.spinEnded = function () {
	        this.sendMessage('g2p.spinEnded');
	    };
	    PlatformSynotAPI.prototype.roundEnded = function (args) {
	        var data = {};
	        if (args != null) {
	            if (args.id != null) {
	                data['roundId'] = args.id;
	            }
	            if (args.win != null) {
	                data['win'] = args.win;
	            }
	            if (args.balanceAfter != null) {
	                data['balance'] = args.balanceAfter;
	            }
	        }
	        this.isGameRoundFinished = true;
	        this.sendMessage('g2p.roundEnded', data);
	    };
	    PlatformSynotAPI.prototype.featureStarted = function (args) {
	        this.sendMessage('g2p.featureStarted', args);
	    };
	    PlatformSynotAPI.prototype.featureInit = function (args) {
	        this.sendMessage('g2p.featureInit', args);
	    };
	    PlatformSynotAPI.prototype.featureFinished = function (args) {
	        this.sendMessage('g2p.featureFinished', args);
	    };
	    PlatformSynotAPI.prototype.autoplayStarted = function () {
	        this.sendMessage('g2p.autoplayStarted');
	    };
	    PlatformSynotAPI.prototype.autoplayFinished = function () {
	        this.sendMessage('g2p.autoplayFinished');
	    };
	    PlatformSynotAPI.prototype.gotoCasier = function (args) {
	        this.sendMessage('g2p.goToCashier', args);
	    };
	    PlatformSynotAPI.prototype.gotoHistory = function (args) {
	        this.sendMessage('g2p.goToHistory', args);
	    };
	    PlatformSynotAPI.prototype.gotoHelp = function (args) {
	        this.sendMessage('g2p.goToHelp', args);
	    };
	    PlatformSynotAPI.prototype.gotoPaytable = function (args) {
	        this.sendMessage('g2p.goToPaytable', args);
	    };
	    PlatformSynotAPI.prototype.balanceUpdated = function (args) {
	        var data = {};
	        if (args != null) {
	            if (args.amount != null) {
	                data['balance'] = args.amount;
	            }
	        }
	        this.sendMessage('g2p.balanceUpdated', data);
	    };
	    PlatformSynotAPI.prototype.setVolume = function (level) {
	        this.sendMessage('g2p.setVolume', { level: level });
	    };
	    PlatformSynotAPI.prototype.quickSpinEnabled = function (enabled) {
	        this.sendMessage('g2p.quickSpin', { enabled: enabled });
	    };
	    PlatformSynotAPI.prototype.bet = function (value) {
	        this.sendMessage('g2p.betChanged', { bet: value });
	    };
	    PlatformSynotAPI.prototype.win = function (value, cumulative) {
	        this.sendMessage('g2p.win', { win: value, cumulative: cumulative });
	    };
	    PlatformSynotAPI.prototype.gameDataLoaded = function (args) {
	        var data = {};
	        if (args != null) {
	            if (args.PlayerTokenId != null) {
	                data['playerTokenId'] = args.PlayerTokenId;
	            }
	            if (args.GameName != null) {
	                data['gameName'] = args.GameName;
	            }
	            if (args.HomeUrl != null) {
	                data['homeUrl'] = args.HomeUrl;
	            }
	            if (args.ClientToken != null) {
	                data['clientToken'] = args.ClientToken;
	            }
	            if (args.SessionData != null) {
	                data['sessionData'] = {};
	                if (args.SessionData.SessionBalance) {
	                    data['sessionData']['balance'] = args.SessionData.SessionBalance;
	                }
	                if (args.SessionData.TotalWin) {
	                    data['sessionData']['totalWin'] = args.SessionData.TotalWin;
	                }
	                if (args.SessionData.TotalBet) {
	                    data['sessionData']['totalBet'] = args.SessionData.TotalBet;
	                }
	            }
	            if (args.CurrencyCode != null) {
	                data['currencyCode'] = args.CurrencyCode;
	            }
	            if (args.Balance != null) {
	                data['balance'] = args.Balance;
	            }
	            if (args.Bet != null) {
	                data['bet'] = args.Bet;
	            }
	        }
	        this.sendMessage('g2p.gameDataLoaded', data);
	    };
	    PlatformSynotAPI.prototype.dialogOpened = function (type, isOpen) { };
	    PlatformSynotAPI.prototype.fullscreen = function (enabled) {
	        var data = { 'enabled': enabled };
	        this.sendMessage('g2p.fullscreen', data);
	    };
	    PlatformSynotAPI.prototype.sendPluginMessage = function (message) { };
	    PlatformSynotAPI.prototype.userAction = function (action, data) { };
	    PlatformSynotAPI.prototype.sendMessage = function (event, data) {
	        if (Platforms_1.Platforms.pluginOrigin == null) {
	            if (false) {
	                this.log('Error - missing plugin origin parameter!');
	            }
	            return;
	        }
	        var message = { event: event };
	        if (data != null) {
	            message['data'] = data;
	        }
	        if (this.logger) {
	            console.log("Synot Platform API - Sending event: " + event + " " + (data ? JSON.stringify(data) : ''));
	        }
	        if (parent != null) {
	            parent.postMessage(message, Platforms_1.Platforms.pluginOrigin);
	        }
	    };
	    PlatformSynotAPI.prototype.receiveMessage = function (event) {
	        if (false) {
	            this.log('receiveMessage');
	        }
	        if (event != null && event.data != null) {
	            if (!this.checkOrigin(event.origin)) {
	                if (false) {
	                    this.log('Received message with incorrect origin.');
	                }
	                return;
	            }
	            if (event.data.event != null) {
	                if (this.logger) {
	                    console.log("Synot Platform API - Received event: " + event.data.event + " " + (event.data.data ? JSON.stringify(event.data.data) : ''));
	                }
	                switch (event.data.event) {
	                    case 'p2g.stopAutoplay':
	                        Platforms_1.Platforms.stopAutoplay();
	                        break;
	                    case 'p2g.refreshBalance':
	                        Platforms_1.Platforms.refreshBalance();
	                        break;
	                    case 'p2g.gamePlayDisable':
	                        this.gamePlayDisabled = true;
	                        Platforms_1.Platforms.gamePlayStop(this.isGameRoundFinished);
	                        break;
	                    case 'p2g.gamePlayResume':
	                        if (this.gamePlayDisabled && this.isGameRoundFinished) {
	                            this.gamePlayDisabled = false;
	                            Platforms_1.Platforms.gamePlayResume();
	                        }
	                        break;
	                    case 'p2g.gamePlayFreeze':
	                        Platforms_1.Platforms.gamePlayFreeze();
	                        break;
	                    case 'p2g.gamePlayUnfreeze':
	                        Platforms_1.Platforms.gamePlayUnfreeze();
	                        break;
	                    case 'p2g.gameAudioEnable':
	                        Platforms_1.Platforms.gameAudioEnable();
	                        break;
	                    case 'p2g.gameAudioMute':
	                        Platforms_1.Platforms.gameAudioMute();
	                        break;
	                    case 'p2g.gameEnableQuickSpin':
	                        Platforms_1.Platforms.gameQuickSpin(true);
	                        break;
	                    case 'p2g.gameDisableQuickSpin':
	                        Platforms_1.Platforms.gameQuickSpin(false);
	                        break;
	                    case 'p2g.showHelp':
	                        Platforms_1.Platforms.showHelp();
	                        break;
	                    case 'p2g.hideHelp':
	                        Platforms_1.Platforms.hideHelp();
	                        break;
	                    case 'p2g.toggleHelp':
	                        Platforms_1.Platforms.toggleHelp();
	                        break;
	                    case 'p2g.showPaytable':
	                        Platforms_1.Platforms.showPaytable();
	                        break;
	                    case 'p2g.hidePaytable':
	                        Platforms_1.Platforms.hidePaytable();
	                        break;
	                    case 'p2g.togglePaytable':
	                        Platforms_1.Platforms.togglePaytable();
	                        break;
	                    case 'p2g.configure':
	                        this.configure(event.data.data);
	                        break;
	                }
	            }
	        }
	    };
	    PlatformSynotAPI.prototype.configure = function (data) {
	        if (data == null) {
	            return;
	        }
	        if (data['handleErrorDialog'] != null) {
	            Platforms_1.Platforms.handleShowErrorDialog = data['handleErrorDialog'];
	        }
	        if (data['logger'] != null) {
	            this.logger = data['logger'];
	        }
	    };
	    PlatformSynotAPI.prototype.checkOrigin = function (origin) {
	        if (Platforms_1.Platforms.pluginOrigin !== '*' && origin !== Platforms_1.Platforms.pluginOrigin) {
	            console.log("Synot Platform API - Wrong origin - expected: " + Platforms_1.Platforms.pluginOrigin + " get: " + origin);
	            return false;
	        }
	        return true;
	    };
	    PlatformSynotAPI.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('PlatformSynotAPI', 'PlatformSynotAPI' + s);
	        }
	    };
	    return PlatformSynotAPI;
	}());
	exports.PlatformSynotAPI = PlatformSynotAPI;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var GameEngine_1 = __webpack_require__(17);
	var PlatformPlaytech = (function () {
	    function PlatformPlaytech() {
	    }
	    PlatformPlaytech.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        this.freezeGameWhenIdle = false;
	        this.initialized = false;
	        this.loadStarted = false;
	        this.currentBalance = -1;
	        this.gameRoundClosed = true;
	        this.openedDialogs = [];
	        this.activeAutoplay = false;
	        this.restoreAutoplay = false;
	        this.winValue = 0;
	        this.closeGameRequest = false;
	        this.inSpin = false;
	        this.inFeature = false;
	        this.inPause = false;
	        this._eventStack = [];
	        var context = GameEngine_1.AppContextBase.getInstance();
	        if (context != null) {
	            this._configuration = context.gameConfiguration;
	        }
	        if (false) {
	            this.log('create');
	        }
	        this.createPlugin();
	    };
	    PlatformPlaytech.prototype.createPlugin = function () {
	        if (false) {
	            this.log('createPlugin');
	        }
	        this.supportedFeatures = [];
	        this.w2gMappings = {
	            'ucip.basic.w2gInitializationResponse': this.initializeResponseHandler.bind(this),
	            'ucip.autoplay.w2gInterruptGameplayCommand': this.interruptGameplayHandler.bind(this),
	            'ucip.pause.w2gPauseCommand': this.gamePauseHandler.bind(this),
	            'ucip.displaystatus.w2gVisibilityChangeNotification': this.visibilityChangeHandler.bind(this),
	            'ucip.sound.w2gSoundUpdateNotification': this.soundUpdateHandler.bind(this),
	            'ucip.balancerefresh.w2gRefreshBalanceCommand': this.refreshBalanceHandler.bind(this),
	            'ucip.closegame.w2gCloseGameRequest': this.closeGameHandler.bind(this)
	        };
	        window.addEventListener('message', this.handleMessageReceived.bind(this));
	        this.initRequest();
	    };
	    PlatformPlaytech.prototype.handleMessageReceived = function (event) {
	        if (event && event.data != null) {
	            var jsonObj = JSON.parse(event.data);
	            if (jsonObj != null && jsonObj._type != null) {
	                if (this.w2gMappings && this.w2gMappings[jsonObj._type] != null) {
	                    this.w2gMappings[jsonObj._type](jsonObj);
	                }
	                else {
	                    if (false) {
	                        this.log('[GAME ERROR]: Undefined request');
	                    }
	                }
	            }
	        }
	    };
	    PlatformPlaytech.prototype.handleMessageSend = function (data, init) {
	        if (init === void 0) { init = false; }
	        if (!init && !this.initialized) {
	            return;
	        }
	        if (data != null) {
	            var requestString = JSON.stringify(data);
	            window.parent.postMessage(requestString, '*');
	        }
	    };
	    PlatformPlaytech.prototype.initRequest = function () {
	        if (false) {
	            this.log('initRequest - g2wInitializationRequest');
	        }
	        var features = ['pause', 'autoplay', 'closegame', 'sound', 'openpage', 'switchgame', 'gamechange', 'loadingstatus', 'errors', 'gameround', 'balanceupdate', 'balancerefresh', 'betupdate', 'displaystatus'];
	        if (this._configuration != null) {
	            if (this._configuration['ShowSimilarGames'] === false || this._configuration['StaticContentUrl'] === '' || this._configuration['SimilarGamesList'].length === 0) {
	                features.splice(features.indexOf('switchgame'), 1);
	                features.splice(features.indexOf('gamechange'), 1);
	            }
	        }
	        var data = {
	            _type: 'ucip.basic.g2wInitializationRequest',
	            version: '1.0.0',
	            features: features
	        };
	        this.handleMessageSend(data, true);
	    };
	    PlatformPlaytech.prototype.autoplayFinished = function (args) {
	        if (false) {
	            this.log('autoplayFinished - g2wAutoplayEndNotification');
	        }
	        this.activeAutoplay = false;
	        this.autoplayData = args;
	        if (this.winValue > 0 && this.restoreAutoplay) {
	            var count = parseInt(this.autoplayData.autoplayCount);
	            if (!isNaN(count)) {
	                this.autoplayData.autoplayCount = (count + 1).toString();
	            }
	        }
	        var data = {
	            _type: 'ucip.autoplay.g2wAutoplayEndNotification'
	        };
	        if (!this.isSupported('autoplay')) {
	            return;
	        }
	        this.handleMessageSend(data);
	    };
	    PlatformPlaytech.prototype.autoplayStarted = function () {
	        if (false) {
	            this.log('autoplayStarted - g2wAutoplayStartNotification');
	        }
	        this.activeAutoplay = true;
	        var data = {
	            _type: 'ucip.autoplay.g2wAutoplayStartNotification'
	        };
	        if (!this.isSupported('autoplay')) {
	            return;
	        }
	        this.handleMessageSend(data);
	    };
	    PlatformPlaytech.prototype.balanceUpdated = function (args) {
	        if (false) {
	            this.log('balanceUpdated - g2wBalanceUpdateNotification');
	        }
	        this._balanceData = args;
	        if (this.inPause) {
	            return;
	        }
	        if (args != null) {
	            var win = parseFloat(neo_common_1.NumberUtils.subtract(args.amount, this.currentBalance));
	            if (win < 0) {
	                win = 0;
	            }
	            if (this.inSpin && win > 0) {
	                win = parseFloat(neo_common_1.NumberUtils.add(win, this.currentBet));
	            }
	            var data = {
	                _type: 'ucip.balanceupdate.g2wBalanceUpdateNotification',
	                balance: {
	                    value: args.amount,
	                    winAmount: args.forced === true ? 0 : win
	                }
	            };
	            if (this.currentBalance === args.amount) {
	                return;
	            }
	            this.handleMessageSend(data);
	            this.currentBalance = args.amount;
	        }
	    };
	    PlatformPlaytech.prototype.bet = function (value) {
	        if (false) {
	            this.log('bet - g2wBetUpdateNotification');
	        }
	        var data = {
	            _type: 'ucip.betupdate.g2wBetUpdateNotification',
	            totalBet: value
	        };
	        this.currentBet = value;
	        if (this.isSupported('betupdate')) {
	            this.handleMessageSend(data);
	        }
	        else {
	            if (!this.initialized) {
	                this.addToStack('betupdate', data);
	            }
	        }
	    };
	    PlatformPlaytech.prototype.error = function (code, message) {
	        if (false) {
	            this.log('error - g2wErrorNotification');
	        }
	        if (!this.isSupported('errors')) {
	            return;
	        }
	        var httpStatus = code.split('-');
	        var type = 'GENERIC_ERROR';
	        if (httpStatus.length > 0) {
	            switch (httpStatus[0]) {
	                case '0':
	                    type = 'CONNECTION_ERROR';
	                    break;
	                case '401':
	                    type = 'AUTHENTICATION_ERROR';
	                    break;
	                case '500':
	                    if (httpStatus.length === 2 && httpStatus[1] === '2005') {
	                        type = 'INSUFFICIENT_FUNDS';
	                    }
	                    break;
	            }
	        }
	        var data = {
	            _type: 'ucip.errors.g2wErrorNotification',
	            error: {
	                type: type,
	                description: message
	            }
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformPlaytech.prototype.clientError = function (id, message) {
	        if (false) {
	            this.log('client error - g2wClientErrorNotification');
	        }
	        var type = 'GENERIC_ERROR';
	        switch (id) {
	            case 'NOT_ENOUGH_CREDIT':
	                type = 'INSUFFICIENT_FUNDS';
	                break;
	        }
	        var data = {
	            _type: 'ucip.errors.g2wErrorNotification',
	            error: {
	                type: type,
	                description: message
	            }
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformPlaytech.prototype.featureFinished = function (args) {
	        this.inFeature = false;
	    };
	    PlatformPlaytech.prototype.featureStarted = function (args) {
	        this.inFeature = true;
	    };
	    PlatformPlaytech.prototype.featureInit = function () {
	        this.inFeature = true;
	    };
	    PlatformPlaytech.prototype.gameChange = function (gameCode) {
	        var command = Platforms_1.Platforms.handleChangeGame ? 'ucip.switchgame.g2wSwitchGameCommand' : 'ucip.gamechange.g2wGameChangeNotification';
	        if (false) {
	            this.log('gameChange - ' + command.split('.')[2]);
	        }
	        var data = {
	            _type: command,
	            gameCode: gameCode
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformPlaytech.prototype.gameClosing = function () {
	        if (false) {
	            this.log('gameClosing - g2wCloseGameResponse');
	        }
	        var closeType = 'ucip.basic.g2wCloseGameFrameCommand';
	        if (this.closeGameRequest) {
	            closeType = 'ucip.closegame.g2wCloseGameResponse';
	        }
	        var data = {
	            _type: closeType
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformPlaytech.prototype.gameReloading = function () { };
	    PlatformPlaytech.prototype.gameDataLoaded = function (args) {
	        var data = {
	            _type: 'ucip.loadingstatus.g2wGameReadyNotification'
	        };
	        if (this.isSupported('loadingstatus')) {
	            this.handleMessageSend(data);
	        }
	        else {
	            this.addToStack('loadingstatus', data);
	        }
	        if (args) {
	            this.currentBalance = args.Balance;
	            this.bet(args.Bet);
	        }
	    };
	    PlatformPlaytech.prototype.dialogOpened = function (type, isOpen) {
	        if (false) {
	            this.log('dialogOpened - g2wUiStateNotification');
	        }
	        if (isOpen) {
	            this.restoreAutoplay = false;
	            this.openedDialogs.push(type);
	        }
	        else {
	            var itemIndex = this.openedDialogs.indexOf(type);
	            if (itemIndex === -1) {
	                return;
	            }
	            this.openedDialogs.splice(itemIndex, 1);
	            if (this.openedDialogs.length > 0) {
	                return;
	            }
	        }
	        var data = {
	            _type: 'ucip.displaystatus.g2wUiStateNotification',
	            busy: isOpen
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformPlaytech.prototype.fullscreen = function (enabled) { };
	    PlatformPlaytech.prototype.gameFailed = function () {
	    };
	    PlatformPlaytech.prototype.gameReady = function () {
	        if (false) {
	            this.log('gameReady');
	        }
	        var data = {};
	        data = {
	            _type: 'ucip.loadingstatus.g2wLoadingProgressNotification',
	            progress: 100
	        };
	        if (this.isSupported('loadingstatus')) {
	            this.handleMessageSend(data);
	        }
	        else {
	            this.addToStack('loadingstatus', data);
	        }
	        data = {
	            _type: 'ucip.loadingstatus.g2wLoadingEndNotification'
	        };
	        if (this.isSupported('loadingstatus')) {
	            this.handleMessageSend(data);
	        }
	        else {
	            this.addToStack('loadingstatus', data);
	        }
	    };
	    PlatformPlaytech.prototype.gotoCasier = function (args) {
	        if (false) {
	            this.log('gotoCasier - g2wOpenPageCommand');
	        }
	        if (args != null) {
	            var data = {
	                _type: 'ucip.openpage.g2wOpenPageCommand',
	                pageID: 'cashier',
	                url: args.target
	            };
	            this.handleMessageSend(data);
	        }
	    };
	    PlatformPlaytech.prototype.gotoHelp = function (args) {
	    };
	    PlatformPlaytech.prototype.gotoHistory = function (args) {
	        if (false) {
	            this.log('gotoHistory - g2wOpenPageCommand');
	        }
	        if (args != null) {
	            var data = {
	                _type: 'ucip.openpage.g2wOpenPageCommand',
	                pageID: 'game_history',
	                url: args.target
	            };
	            this.handleMessageSend(data);
	        }
	    };
	    PlatformPlaytech.prototype.gotoPaytable = function (args) {
	    };
	    PlatformPlaytech.prototype.loadProgress = function (progress) {
	        if (false) {
	            this.log('loadProgress');
	        }
	        var initStart = false;
	        var data = {};
	        if (!this.loadStarted) {
	            data = {
	                _type: 'ucip.loadingstatus.g2wLoadingStartNotification'
	            };
	            initStart = true;
	            this.loadStarted = true;
	        }
	        else {
	            data = {
	                _type: 'ucip.loadingstatus.g2wLoadingProgressNotification',
	                progress: progress
	            };
	        }
	        if (progress < 100) {
	            if (this.isSupported('loadingstatus')) {
	                this.handleMessageSend(data);
	            }
	            else if (initStart) {
	                this.addToStack('loadingstatus', data);
	            }
	        }
	    };
	    PlatformPlaytech.prototype.quickSpinEnabled = function (enabled) {
	    };
	    PlatformPlaytech.prototype.roundEnded = function (args) {
	        if (false) {
	            this.log('roundEnded - g2wGameRoundEndNotification');
	        }
	        this.winValue = args ? args.win : 0;
	        this.gameRoundClosed = true;
	        var balanceNotificationSend = false;
	        var data = {
	            _type: 'ucip.gameround.g2wGameRoundEndNotification'
	        };
	        this.handleMessageSend(data);
	        if (args && args.inSpin) {
	            var balanceWithWin = parseFloat(neo_common_1.NumberUtils.add(this.currentBalance, args.win));
	            var data_1 = {
	                _type: 'ucip.balanceupdate.g2wBalanceUpdateNotification',
	                balance: {
	                    value: balanceWithWin,
	                    winAmount: args.win
	                }
	            };
	            balanceNotificationSend = true;
	            this.handleMessageSend(data_1);
	            this.currentBalance = balanceWithWin;
	        }
	        if (this.freezeGameWhenIdle) {
	            if (false) {
	                this.log('gamePlayFreeze - g2wPauseNotification');
	            }
	            var balanceWithWin = parseFloat(neo_common_1.NumberUtils.add(this.currentBalance, args.win));
	            var balanceData = {
	                _type: 'ucip.balanceupdate.g2wBalanceUpdateNotification',
	                balance: {
	                    value: balanceWithWin,
	                    winAmount: args.win
	                }
	            };
	            if (balanceWithWin !== this.currentBalance && !balanceNotificationSend) {
	                this.handleMessageSend(balanceData);
	                this.currentBalance = balanceWithWin;
	            }
	            Platforms_1.Platforms.gamePlayFreeze();
	            var data_2 = {
	                _type: 'ucip.pause.g2wPauseNotification',
	                pause: true
	            };
	            this.inPause = true;
	            this.handleMessageSend(data_2);
	        }
	    };
	    PlatformPlaytech.prototype.roundInit = function () { };
	    PlatformPlaytech.prototype.roundStarted = function (args) {
	        if (false) {
	            this.log('roundStarted - g2wGameRoundStartNotification');
	        }
	        this.winValue = 0;
	        this.gameRoundClosed = false;
	        var data = {
	            _type: 'ucip.gameround.g2wGameRoundStartNotification'
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformPlaytech.prototype.sendPluginMessage = function (message) {
	    };
	    PlatformPlaytech.prototype.setVolume = function (level) {
	        if (false) {
	            this.log('setVolume');
	        }
	        var data = {
	            _type: 'ucip.sound.g2wSoundUpdateNotification',
	            mute: level === 0,
	            level: Math.round((level / 3) * 100)
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformPlaytech.prototype.spinEnded = function () {
	        this.inSpin = false;
	    };
	    PlatformPlaytech.prototype.spinReceived = function (args) {
	    };
	    PlatformPlaytech.prototype.spinStarted = function () {
	        this.inSpin = true;
	    };
	    PlatformPlaytech.prototype.userAction = function (action, data) {
	    };
	    PlatformPlaytech.prototype.win = function (value, cumulative) { };
	    PlatformPlaytech.prototype.initializeResponseHandler = function (data) {
	        if (false) {
	            this.log('initializeResponseHandler');
	        }
	        if (data == null || data['features'] == null) {
	            return;
	        }
	        for (var i = 0; i < data['features'].length; i++) {
	            var feature = data['features'][i];
	            if (Array.isArray(feature) && feature.length === 2) {
	                var featureName = feature[0];
	                var featureData = feature[1];
	                switch (featureName) {
	                    case 'openpage':
	                        var delegatePages = featureData['delegatePages'];
	                        if (delegatePages != null && Array.isArray(delegatePages)) {
	                            for (var j = 0; j < delegatePages.length; j++) {
	                                if (delegatePages[j] === 'cashier') {
	                                    Platforms_1.Platforms.handleOpenCashierPage = true;
	                                }
	                                if (delegatePages[j] === 'history') {
	                                    Platforms_1.Platforms.handleOpenHistoryPage = true;
	                                }
	                            }
	                        }
	                        break;
	                    case 'sound':
	                        this.soundUpdateHandler(featureData);
	                        break;
	                }
	                this.supportedFeatures.push(feature[0]);
	            }
	            else {
	                switch (feature) {
	                    case 'switchgame':
	                        Platforms_1.Platforms.handleChangeGame = true;
	                        break;
	                }
	                this.supportedFeatures.push(feature);
	            }
	        }
	        this.initialized = true;
	        for (var i = 0; i < this._eventStack.length; i++) {
	            var event_1 = this._eventStack[i];
	            for (var key in event_1) {
	                if (!this.isSupported(key)) {
	                    continue;
	                }
	                this.handleMessageSend(event_1[key]);
	            }
	        }
	    };
	    PlatformPlaytech.prototype.interruptGameplayHandler = function (data) {
	        if (false) {
	            this.log('interruptGameplayHandler');
	        }
	        Platforms_1.Platforms.stopAutoplay();
	    };
	    PlatformPlaytech.prototype.gamePauseHandler = function (data) {
	        if (false) {
	            this.log('gamePauseHandler');
	        }
	        if (!this.isSupported('pause')) {
	            return;
	        }
	        if (data.pause) {
	            if (this.gameRoundClosed) {
	                Platforms_1.Platforms.gamePlayFreeze();
	                var data_3 = {
	                    _type: 'ucip.pause.g2wPauseNotification',
	                    pause: true
	                };
	                this.inPause = true;
	                this.handleMessageSend(data_3);
	            }
	            else {
	                Platforms_1.Platforms.gamePlaySupressSpinOnCollect();
	                this.freezeGameWhenIdle = true;
	                this.restoreAutoplay = this.activeAutoplay;
	            }
	        }
	        else {
	            Platforms_1.Platforms.gamePlayUnfreeze();
	            this.freezeGameWhenIdle = false;
	            var data_4 = {
	                _type: 'ucip.pause.g2wPauseNotification',
	                pause: false
	            };
	            this.handleMessageSend(data_4);
	            if (this.restoreAutoplay) {
	                Platforms_1.Platforms.restoreAutoplay(this.autoplayData);
	            }
	            this.inPause = false;
	            if (this.restoreAutoplay && this._balanceData != null) {
	                this.balanceUpdated(this._balanceData);
	            }
	            this.restoreAutoplay = false;
	        }
	    };
	    PlatformPlaytech.prototype.visibilityChangeHandler = function (data) {
	        if (false) {
	            this.log('visibilityChangeHandler');
	        }
	        if (data == null) {
	            return;
	        }
	        var visible = data['visible'];
	        if (visible === true) {
	            Platforms_1.Platforms.gamePlayUnfreeze();
	        }
	        else {
	            Platforms_1.Platforms.gamePlayFreeze();
	        }
	    };
	    PlatformPlaytech.prototype.soundUpdateHandler = function (data) {
	        if (false) {
	            this.log('soundUpdateHandler');
	        }
	        if (data.mute) {
	            Platforms_1.Platforms.gameAudioMute();
	        }
	        else {
	            Platforms_1.Platforms.gameAudioSet(Math.round((data.level / 100) * 3));
	        }
	    };
	    PlatformPlaytech.prototype.refreshBalanceHandler = function (data) {
	        if (false) {
	            this.log('refreshBalanceHandler');
	        }
	        Platforms_1.Platforms.refreshBalance();
	    };
	    PlatformPlaytech.prototype.closeGameHandler = function (data) {
	        if (false) {
	            this.log('closeGameHandler');
	        }
	        if (this.inSpin || this.inFeature) {
	            var data_5 = {
	                _type: 'ucip.closegame.g2wCloseGameErrorResponse'
	            };
	            this.handleMessageSend(data_5);
	            return;
	        }
	        this.closeGameRequest = true;
	        Platforms_1.Platforms.closeGame();
	    };
	    PlatformPlaytech.prototype.isSupported = function (featureName) {
	        if (this.supportedFeatures.indexOf(featureName) === -1) {
	            this.log("Feature: " + featureName + " is not supported");
	            return false;
	        }
	        else {
	            return true;
	        }
	    };
	    PlatformPlaytech.prototype.addToStack = function (featureName, data) {
	        var obj = {};
	        obj[featureName] = data;
	        this._eventStack.push(obj);
	    };
	    PlatformPlaytech.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('Playtech', 'Playtech ' + s);
	        }
	    };
	    return PlatformPlaytech;
	}());
	exports.PlatformPlaytech = PlatformPlaytech;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var Platforms_1 = __webpack_require__(12);
	var PlatformMicrogaming = (function () {
	    function PlatformMicrogaming() {
	        this._requestHistory = {};
	        this._isPaused = false;
	        this._openedDialogs = [];
	    }
	    PlatformMicrogaming.prototype.create = function () {
	        Platforms_1.Platforms.canPlay = true;
	        if (false) {
	            this.log('create');
	        }
	        this.createPlugin();
	    };
	    PlatformMicrogaming.prototype.createPlugin = function () {
	        if (false) {
	            this.log('createPlugin');
	        }
	        Platforms_1.Platforms.handleOpenCashierPage = true;
	        Platforms_1.Platforms.handleOpenHistoryPage = true;
	        Platforms_1.Platforms.handleChangeGame = true;
	        window.addEventListener('message', this.handleMessageReceived.bind(this));
	        this.sendInitRequest();
	    };
	    PlatformMicrogaming.prototype.sendInitRequest = function () {
	        var data = {
	            Type: 'REQUEST',
	            Name: 'bridge_api_ready',
	            Origin: 'embeddedgame',
	            SenderId: window.name,
	            Body: null,
	            Id: this.getGUID()
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.handleMessageReceived = function (event) {
	        if (event == null || event.data == null) {
	            return;
	        }
	        var data;
	        if (typeof event.data === 'string') {
	            data = JSON.parse(event.data);
	        }
	        else {
	            data = event.data;
	        }
	        var error = this.validMessage(data);
	        if (error != null) {
	            data.Error = error;
	            this.handleMessageSend(data);
	            return;
	        }
	        if (data.Type.toLowerCase() === 'request') {
	            switch (data.Name.toLowerCase()) {
	                case "pause_gameplay":
	                    this.handlePauseGameplay(data);
	                    break;
	                case "resume_gameplay":
	                    this.handleResumeGameplay(data);
	                    break;
	            }
	        }
	        else if (data.Type.toLowerCase() === 'response') {
	            this.handleReponse(data);
	        }
	    };
	    PlatformMicrogaming.prototype.handleReponse = function (data) {
	        if (this._requestHistory[data.Name.toLowerCase()] == null) {
	            return;
	        }
	        if (data.Error != null) {
	            switch (data.Error.ErrorCode) {
	                case 1201:
	                    this.log("Error 1201 - User already logged out. " + (data.Error.Description ? 'Description: ' + data.Error.Description : ''));
	                    break;
	                case 1202:
	                    this.log("Error 1202 - User not logged in. " + (data.Error.Description ? 'Description: ' + data.Error.Description : ''));
	                    break;
	                case 1205:
	                    this.log("Error 1205 - Logout failed. " + (data.Error.Description ? 'Description: ' + data.Error.Description : ''));
	                    break;
	                case 1301:
	                    this.log("Error 1301 - Cancelled by user or unspported destination. " + (data.Error.Description ? 'Description: ' + data.Error.Description : ''));
	                    break;
	                case 1303:
	                    this.log("Error 1303 - Unspported destination. " + (data.Error.Description ? 'Description: ' + data.Error.Description : ''));
	                    break;
	            }
	        }
	        this._requestHistory[data.Name.toLowerCase()] = null;
	    };
	    PlatformMicrogaming.prototype.validMessage = function (data) {
	        if (data == null) {
	            return { ErrorCode: 1000 };
	        }
	        var validTypes = ['request', 'response', 'notification'];
	        if (validTypes.indexOf(data.Type.toLowerCase()) === -1) {
	            return { ErrorCode: 1000, Description: "Unsupported message type: " + data.Type.toLowerCase() };
	        }
	        return null;
	    };
	    PlatformMicrogaming.prototype.handleMessageSend = function (data) {
	        if (data.Type.toLowerCase() === 'request') {
	            this._requestHistory[data.Name.toLowerCase()] = data;
	        }
	        window.top.postMessage(data, '*');
	    };
	    PlatformMicrogaming.prototype.autoplayFinished = function (args) {
	    };
	    PlatformMicrogaming.prototype.autoplayStarted = function () {
	    };
	    PlatformMicrogaming.prototype.balanceUpdated = function (args) {
	    };
	    PlatformMicrogaming.prototype.bet = function (value) {
	    };
	    PlatformMicrogaming.prototype.error = function (code, message) {
	        if (false) {
	            this.log('error');
	        }
	        var httpStatus = code.split('-');
	        var reason = 106;
	        if (httpStatus.length > 0) {
	            switch (httpStatus[0]) {
	                case '0':
	                    reason = 101;
	                    break;
	                case '401':
	                    reason = 104;
	                    break;
	            }
	        }
	        var data = {
	            Type: 'REQUEST',
	            Name: 'logout',
	            Origin: 'embeddedgame',
	            SenderId: window.name,
	            Body: {
	                "reason": reason
	            },
	            Id: this.getGUID()
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.clientError = function (id, message) {
	    };
	    PlatformMicrogaming.prototype.featureFinished = function (args) {
	    };
	    PlatformMicrogaming.prototype.featureInit = function () { };
	    PlatformMicrogaming.prototype.featureStarted = function (args) {
	    };
	    PlatformMicrogaming.prototype.gameChange = function (gameCode) {
	        if (false) {
	            this.log('gameChange');
	        }
	        var data = {
	            Type: 'REQUEST',
	            Name: 'launch_game',
	            Origin: 'embeddedgame',
	            SenderId: window.name,
	            Body: {
	                "game_id": gameCode
	            },
	            Id: this.getGUID()
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.gameClosing = function () {
	        if (false) {
	            this.log('gameClosing');
	        }
	        var data = {
	            Type: 'NOTIFICATION',
	            Name: 'close_application',
	            Origin: 'embeddedgame',
	            SenderId: window.name,
	            Body: null,
	            Id: this.getGUID()
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.gameReloading = function () {
	        if (false) {
	            this.log('gameReloading');
	        }
	        var data = {
	            Type: 'REQUEST',
	            Name: 'reload_game',
	            Origin: 'embeddedgame',
	            SenderId: window.name,
	            Body: null,
	            Id: this.getGUID()
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.gameDataLoaded = function (args) {
	    };
	    PlatformMicrogaming.prototype.dialogOpened = function (type, isOpen) {
	        if (false) {
	            this.log('dialogOpened');
	        }
	        if (isOpen) {
	            this._openedDialogs.push(type);
	        }
	        else {
	            var itemIndex = this._openedDialogs.indexOf(type);
	            if (itemIndex === -1) {
	                return;
	            }
	            this._openedDialogs.splice(itemIndex, 1);
	            if (this._openedDialogs.length > 0) {
	                return;
	            }
	        }
	        var data = {
	            Type: 'NOTIFICATION',
	            Name: isOpen ? 'busy' : 'idle',
	            Origin: 'embeddedgame',
	            SenderId: window.name,
	            Body: null,
	            Id: this.getGUID()
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.fullscreen = function (enabled) { };
	    PlatformMicrogaming.prototype.gameFailed = function () {
	    };
	    PlatformMicrogaming.prototype.gameReady = function () {
	    };
	    PlatformMicrogaming.prototype.gotoCasier = function (args) {
	        if (false) {
	            this.log('gotoCasier');
	        }
	        var data = {
	            Type: 'REQUEST',
	            Name: 'launch_banking',
	            Origin: 'embeddedgame',
	            SenderId: window.name,
	            Body: null,
	            Id: this.getGUID()
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.gotoHelp = function (args) {
	    };
	    PlatformMicrogaming.prototype.gotoHistory = function (args) {
	        if (false) {
	            this.log('gotoHistory');
	        }
	        var data = {
	            Type: 'REQUEST',
	            Name: 'launch_game_history',
	            Origin: 'embeddedgame',
	            SenderId: window.name,
	            Body: null,
	            Id: this.getGUID()
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.gotoPaytable = function (args) {
	    };
	    PlatformMicrogaming.prototype.loadProgress = function (progress) {
	    };
	    PlatformMicrogaming.prototype.quickSpinEnabled = function (enabled) {
	    };
	    PlatformMicrogaming.prototype.roundEnded = function (args) {
	    };
	    PlatformMicrogaming.prototype.roundInit = function () {
	    };
	    PlatformMicrogaming.prototype.roundStarted = function (args) {
	    };
	    PlatformMicrogaming.prototype.sendPluginMessage = function (message) {
	    };
	    PlatformMicrogaming.prototype.setVolume = function (level) {
	    };
	    PlatformMicrogaming.prototype.spinEnded = function () {
	    };
	    PlatformMicrogaming.prototype.spinReceived = function (args) {
	    };
	    PlatformMicrogaming.prototype.spinStarted = function () {
	        var data = {
	            Type: 'REQUEST',
	            Name: 'player_activity',
	            Origin: 'embeddedgame',
	            SenderId: window.name,
	            Body: null,
	            Id: this.getGUID()
	        };
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.userAction = function (action, data) {
	    };
	    PlatformMicrogaming.prototype.win = function (value, cumulative) { };
	    PlatformMicrogaming.prototype.handlePauseGameplay = function (data) {
	        if (!this._isPaused) {
	            Platforms_1.Platforms.gamePlayFreeze();
	            this._isPaused = true;
	        }
	        data.Origin = 'embeddedgame';
	        data.SenderId = window.name;
	        data.Type = 'RESPONSE';
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.handleResumeGameplay = function (data) {
	        if (this._isPaused) {
	            Platforms_1.Platforms.gamePlayUnfreeze();
	            this._isPaused = false;
	        }
	        data.Origin = 'embeddedgame';
	        data.SenderId = window.name;
	        data.Type = 'RESPONSE';
	        this.handleMessageSend(data);
	    };
	    PlatformMicrogaming.prototype.getGUID = function () {
	        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
	            return v.toString(16);
	        });
	    };
	    PlatformMicrogaming.prototype.log = function (s) {
	        if (false) {
	            neo_common_1.Logger.debugGroup('Playtech', 'Playtech ' + s);
	        }
	    };
	    return PlatformMicrogaming;
	}());
	exports.PlatformMicrogaming = PlatformMicrogaming;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Constants_1 = __webpack_require__(8);
	var GameEvents = (function () {
	    function GameEvents() {
	    }
	    GameEvents.PrimaryGameEscrow = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.PrimaryGameEscrow, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.PrimaryGameStarted = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.PrimaryGameStarted, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.PrimaryGameEnded = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.PrimaryGameEnded, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.SecondaryGameEntered = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.SecondaryGameEntered, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.SecondaryGameHalved = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.SecondaryGameHalved, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.SecondaryGameEscrow = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.SecondaryGameEscrow, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.SecondaryGameStarted = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.SecondaryGameStarted, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.GameCollectEscrow = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.GameCollectEscrow, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.SecondaryGameCollectEscrow = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.SecondaryGameCollectEscrow, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.SecondaryGameEnded = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.SecondaryGameEnded, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.GameEnded = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.GameEnded, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.AutoPlayStarted = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.AutoPlayStarted, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.AutoPlayEnded = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.AutoPlayEnded, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.GamePlayEnabled = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.GamePlayEnabled, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.GamePlayDisabled = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.GamePlayDisabled, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.BonusGameStarted = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.BonusGameStarted, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.BonusGameTriggered = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.BonusGameTriggered, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.BonusGameEscrow = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.BonusGameEscrow, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.BonusGameEnded = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.BonusGameEnded, messageId, unpaidWin, gameRoundId, customData);
	    };
	    GameEvents.GameLoaded = function (messageId, unpaidWin, gameRoundId, customData) {
	        return createGameEvent(Constants_1.DefaultGameEventTypes.GameLoaded, messageId, unpaidWin, gameRoundId, customData);
	    };
	    return GameEvents;
	}());
	exports.GameEvents = GameEvents;
	function createGameEvent(event, messageId, unpaidWin, gameRoundId, customData) {
	    return {
	        event: event,
	        messageId: messageId,
	        unpaidWin: unpaidWin,
	        gameRoundId: gameRoundId,
	        customData: customData
	    };
	}


/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var Game = __webpack_require__(44);
	exports.Game = Game;
	var Launch = __webpack_require__(123);
	exports.Launch = Launch;


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var GameClient_1 = __webpack_require__(45);
	exports.GameClient = GameClient_1.GameClient;
	exports.MessageIdGenerator = GameClient_1.MessageIdGenerator;
	var GameClientOptions_1 = __webpack_require__(24);
	exports.GameClientOptions = GameClientOptions_1.GameClientOptions;
	var GameModules_1 = __webpack_require__(68);
	exports.GameModules = GameModules_1.GameModules;
	var GameClientInterceptorFactory_1 = __webpack_require__(73);
	exports.gameClientInterceptor = GameClientInterceptorFactory_1.gameClientInterceptor;
	exports.GameClientInterceptorFactory = GameClientInterceptorFactory_1.GameClientInterceptorFactory;
	exports.GameClientInterceptorError = GameClientInterceptorFactory_1.GameClientInterceptorError;
	exports.GameClientInterceptorErrorTypes = GameClientInterceptorFactory_1.GameClientInterceptorErrorTypes;
	var BetType_1 = __webpack_require__(108);
	exports.BetType = BetType_1.BetType;
	var Color_1 = __webpack_require__(109);
	exports.Color = Color_1.Color;
	var GameModuleStatus_1 = __webpack_require__(110);
	exports.GameModuleStatus = GameModuleStatus_1.GameModuleStatus;
	var GameStatus_1 = __webpack_require__(111);
	exports.GameStatus = GameStatus_1.GameStatus;
	var LimitType_1 = __webpack_require__(112);
	exports.LimitType = LimitType_1.LimitType;
	var SpinBet_1 = __webpack_require__(113);
	exports.SpinBet = SpinBet_1.SpinBet;
	var Suit_1 = __webpack_require__(114);
	exports.Suit = Suit_1.Suit;
	var WinDirection_1 = __webpack_require__(115);
	exports.WinDirection = WinDirection_1.WinDirection;
	var WinTrigger_1 = __webpack_require__(116);
	exports.WinTrigger = WinTrigger_1.WinTrigger;
	var WinType_1 = __webpack_require__(117);
	exports.WinType = WinType_1.WinType;
	var PickRoundSpotValueType_1 = __webpack_require__(118);
	exports.PickRoundSpotValueType = PickRoundSpotValueType_1.PickRoundSpotValueType;
	var PickRoundSpotStatus_1 = __webpack_require__(119);
	exports.PickRoundSpotStatus = PickRoundSpotStatus_1.PickRoundSpotStatus;
	var RouletteSpinBet_1 = __webpack_require__(120);
	exports.RouletteSpinBet = RouletteSpinBet_1.RouletteSpinBet;
	var BlackJackDealBet_1 = __webpack_require__(121);
	exports.BlackJackDealBet = BlackJackDealBet_1.BlackJackDealBet;
	var TableGameHandStatus_1 = __webpack_require__(122);
	exports.TableGameHandStatus = TableGameHandStatus_1.TableGameHandStatus;
	var CollectRequest_1 = __webpack_require__(51);
	exports.CollectRequest = CollectRequest_1.CollectRequest;
	var InitRequest_1 = __webpack_require__(46);
	exports.InitRequest = InitRequest_1.InitRequest;
	var RespinRequest_1 = __webpack_require__(56);
	exports.RespinRequest = RespinRequest_1.RespinRequest;
	var SpinRequest_1 = __webpack_require__(54);
	exports.SpinRequest = SpinRequest_1.SpinRequest;
	var FreeSpinRequest_1 = __webpack_require__(55);
	exports.FreeSpinRequest = FreeSpinRequest_1.FreeSpinRequest;
	var StartRequest_1 = __webpack_require__(57);
	exports.StartRequest = StartRequest_1.StartRequest;
	var GambleSelectRequest_1 = __webpack_require__(58);
	exports.GambleSelectRequest = GambleSelectRequest_1.GambleSelectRequest;
	var GambleHalveRequest_1 = __webpack_require__(59);
	exports.GambleHalveRequest = GambleHalveRequest_1.GambleHalveRequest;
	var EnterGameRequest_1 = __webpack_require__(61);
	exports.EnterGameRequest = EnterGameRequest_1.EnterGameRequest;
	var LeaveGameRequest_1 = __webpack_require__(63);
	exports.LeaveGameRequest = LeaveGameRequest_1.LeaveGameRequest;
	var EndRequest_1 = __webpack_require__(72);
	exports.EndRequest = EndRequest_1.EndRequest;
	var PickSelectRequest_1 = __webpack_require__(60);
	exports.PickSelectRequest = PickSelectRequest_1.PickSelectRequest;
	var RealityCheckRequest_1 = __webpack_require__(76);
	exports.RealityCheckRequest = RealityCheckRequest_1.RealityCheckRequest;
	var RealityCheckGetInfoRequest_1 = __webpack_require__(86);
	exports.RealityCheckGetInfoRequest = RealityCheckGetInfoRequest_1.RealityCheckGetInfoRequest;
	var FreeRoundsOffersRequest_1 = __webpack_require__(78);
	exports.FreeRoundsOffersRequest = FreeRoundsOffersRequest_1.FreeRoundsOffersRequest;
	var FreeRoundsActivateOfferRequest_1 = __webpack_require__(80);
	exports.FreeRoundsActivateOfferRequest = FreeRoundsActivateOfferRequest_1.FreeRoundsActivateOfferRequest;
	var FreeRoundsDeclineOfferRequest_1 = __webpack_require__(82);
	exports.FreeRoundsDeclineOfferRequest = FreeRoundsDeclineOfferRequest_1.FreeRoundsDeclineOfferRequest;
	var ServerTimeRequest_1 = __webpack_require__(84);
	exports.ServerTimeRequest = ServerTimeRequest_1.ServerTimeRequest;
	var ProgressiveBonusGetInfoRequest_1 = __webpack_require__(88);
	exports.ProgressiveBonusGetInfoRequest = ProgressiveBonusGetInfoRequest_1.ProgressiveBonusGetInfoRequest;
	var MaxPowerBonusInitRequest_1 = __webpack_require__(90);
	exports.MaxPowerBonusInitRequest = MaxPowerBonusInitRequest_1.MaxPowerBonusInitRequest;
	var MaxPowerBonusSpinRequest_1 = __webpack_require__(92);
	exports.MaxPowerBonusSpinRequest = MaxPowerBonusSpinRequest_1.MaxPowerBonusSpinRequest;
	var RouletteSpinRequest_1 = __webpack_require__(94);
	exports.RouletteSpinRequest = RouletteSpinRequest_1.RouletteSpinRequest;
	var BonusRespinsSpinRequest_1 = __webpack_require__(96);
	exports.BonusRespinsSpinRequest = BonusRespinsSpinRequest_1.BonusRespinsSpinRequest;
	var PlayerConfigurationRequest_1 = __webpack_require__(97);
	exports.PlayerConfigurationRequest = PlayerConfigurationRequest_1.PlayerConfigurationRequest;
	var PlayerLogEventsRequest_1 = __webpack_require__(102);
	exports.PlayerLogEventsRequest = PlayerLogEventsRequest_1.PlayerLogEventsRequest;
	var GameModuleBaseResponse_1 = __webpack_require__(65);
	exports.GameModuleBaseResponse = GameModuleBaseResponse_1.GameModuleBaseResponse;
	var GameModuleResponse_1 = __webpack_require__(66);
	exports.GameModuleResponse = GameModuleResponse_1.GameModuleResponse;
	var GameResponse_1 = __webpack_require__(49);
	exports.GameResponse = GameResponse_1.GameResponse;
	var InitResponse_1 = __webpack_require__(48);
	exports.InitResponse = InitResponse_1.InitResponse;
	var BalanceResponse_1 = __webpack_require__(53);
	exports.BalanceResponse = BalanceResponse_1.BalanceResponse;
	var GameModuleGambleResponse_1 = __webpack_require__(67);
	exports.GameModuleGambleResponse = GameModuleGambleResponse_1.GameModuleGambleResponse;
	var GameModuleFreespinResponse_1 = __webpack_require__(69);
	exports.GameModuleFreespinResponse = GameModuleFreespinResponse_1.GameModuleFreespinResponse;
	var GameModulePickResponse_1 = __webpack_require__(70);
	exports.GameModulePickResponse = GameModulePickResponse_1.GameModulePickResponse;
	var EnterGameResponse_1 = __webpack_require__(62);
	exports.EnterGameResponse = EnterGameResponse_1.EnterGameResponse;
	var LeaveGameResponse_1 = __webpack_require__(64);
	exports.LeaveGameResponse = LeaveGameResponse_1.LeaveGameResponse;
	var RealityCheckResponse_1 = __webpack_require__(77);
	exports.RealityCheckResponse = RealityCheckResponse_1.RealityCheckResponse;
	var RealityCheckGetInfoResponse_1 = __webpack_require__(87);
	exports.RealityCheckGetInfoResponse = RealityCheckGetInfoResponse_1.RealityCheckGetInfoResponse;
	var FreeRoundsOffersResponse_1 = __webpack_require__(79);
	exports.FreeRoundsOffersResponse = FreeRoundsOffersResponse_1.FreeRoundsOffersResponse;
	var FreeRoundsActivateOfferResponse_1 = __webpack_require__(81);
	exports.FreeRoundsActivateOfferResponse = FreeRoundsActivateOfferResponse_1.FreeRoundsActivateOfferResponse;
	var FreeRoundsDeclineOfferResponse_1 = __webpack_require__(83);
	exports.FreeRoundsDeclineOfferResponse = FreeRoundsDeclineOfferResponse_1.FreeRoundsDeclineOfferResponse;
	var GameModuleResponseFactory_1 = __webpack_require__(50);
	exports.GameModuleResponseFactory = GameModuleResponseFactory_1.GameModuleResponseFactory;
	var ServerTimeResponse_1 = __webpack_require__(85);
	exports.ServerTimeResponse = ServerTimeResponse_1.ServerTimeResponse;
	var ProgressiveBonusGetInfoResponse_1 = __webpack_require__(89);
	exports.ProgressiveBonusGetInfoResponse = ProgressiveBonusGetInfoResponse_1.ProgressiveBonusGetInfoResponse;
	var MaxPowerBonusInitResponse_1 = __webpack_require__(91);
	exports.MaxPowerBonusInitResponse = MaxPowerBonusInitResponse_1.MaxPowerBonusInitResponse;
	var MaxPowerBonusSpinResponse_1 = __webpack_require__(93);
	exports.MaxPowerBonusSpinResponse = MaxPowerBonusSpinResponse_1.MaxPowerBonusSpinResponse;
	var GameModuleRouletteResponse_1 = __webpack_require__(71);
	exports.GameModuleRouletteResponse = GameModuleRouletteResponse_1.GameModuleRouletteResponse;
	var GameModuleBlackJackResponse_1 = __webpack_require__(107);
	exports.GameModuleBlackJackResponse = GameModuleBlackJackResponse_1.GameModuleBlackJackResponse;
	var GameModuleBonusRespinsResponse_1 = __webpack_require__(95);
	exports.GameModuleBonusRespinsResponse = GameModuleBonusRespinsResponse_1.GameModuleBonusRespinsResponse;
	var PlayerConfigurationResponse_1 = __webpack_require__(98);
	exports.PlayerConfigurationResponse = PlayerConfigurationResponse_1.PlayerConfigurationResponse;
	var PlayerLogEventsResponse_1 = __webpack_require__(103);
	exports.PlayerLogEventsResponse = PlayerLogEventsResponse_1.PlayerLogEventsResponse;


/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var InitRequest_1 = __webpack_require__(46);
	var CollectRequest_1 = __webpack_require__(51);
	var BalanceRequest_1 = __webpack_require__(52);
	var GameResponse_1 = __webpack_require__(49);
	var SpinRequest_1 = __webpack_require__(54);
	var FreeSpinRequest_1 = __webpack_require__(55);
	var RespinRequest_1 = __webpack_require__(56);
	var StartRequest_1 = __webpack_require__(57);
	var GambleSelectRequest_1 = __webpack_require__(58);
	var GambleHalveRequest_1 = __webpack_require__(59);
	var PickSelectRequest_1 = __webpack_require__(60);
	var EnterGameRequest_1 = __webpack_require__(61);
	var LeaveGameRequest_1 = __webpack_require__(63);
	var GameModuleBaseResponse_1 = __webpack_require__(65);
	var GameModuleGambleResponse_1 = __webpack_require__(67);
	var GameModuleFreespinResponse_1 = __webpack_require__(69);
	var GameModulePickResponse_1 = __webpack_require__(70);
	var GameModuleRouletteResponse_1 = __webpack_require__(71);
	var GameModuleResponseFactory_1 = __webpack_require__(50);
	var EndRequest_1 = __webpack_require__(72);
	var GameModules_1 = __webpack_require__(68);
	var GameClientInterceptorFactory_1 = __webpack_require__(73);
	var ConfigurationRequest_1 = __webpack_require__(74);
	var RealityCheckRequest_1 = __webpack_require__(76);
	var FreeRoundsOffersRequest_1 = __webpack_require__(78);
	var FreeRoundsActivateOfferRequest_1 = __webpack_require__(80);
	var FreeRoundsDeclineOfferRequest_1 = __webpack_require__(82);
	var ServerTimeRequest_1 = __webpack_require__(84);
	var RealityCheckGetInfoRequest_1 = __webpack_require__(86);
	var ProgressiveBonusGetInfoRequest_1 = __webpack_require__(88);
	var MaxPowerBonusInitRequest_1 = __webpack_require__(90);
	var MaxPowerBonusSpinRequest_1 = __webpack_require__(92);
	var RouletteSpinRequest_1 = __webpack_require__(94);
	var GameModuleBonusRespinsResponse_1 = __webpack_require__(95);
	var BonusRespinsSpinRequest_1 = __webpack_require__(96);
	var PlayerConfigurationRequest_1 = __webpack_require__(97);
	var PlayerLogErrorRequest_1 = __webpack_require__(99);
	var BuyFeatureRequest_1 = __webpack_require__(101);
	var PlayerLogEventsRequest_1 = __webpack_require__(102);
	var BlackJackDealRequest_1 = __webpack_require__(104);
	var BlackJackHitRequest_1 = __webpack_require__(105);
	var BlackJackStandRequest_1 = __webpack_require__(106);
	var GameModuleBlackJackResponse_1 = __webpack_require__(107);
	var balanceRouteUrl = 'player/balance';
	var playerConfigureRouteUrl = 'player/configure';
	var playerLogErrorUrl = 'player/logError';
	var playerLogEventsUrl = 'player/LogEvents';
	var realityCheckRouteUrls = {
	    close: 'player/closeRealityCheck',
	    reset: 'player/resetRealityCheck',
	    getInfo: 'player/getRealityCheckInfo'
	};
	var freeRoundBonusUrls = {
	    getOffer: 'FreeRounds/GetCurrentOffer',
	    activateOffer: 'FreeRounds/ActivateOffer',
	    declineOffer: 'FreeRounds/DeclineOffer'
	};
	var maxPowerBonusUrls = {
	    init: 'ProgressiveBonus/MaxPowerBonus/Init',
	    spin: 'ProgressiveBonus/MaxPowerBonus/Spin'
	};
	var serverTime = 'ServerTime';
	var MessageIdGenerator = (function () {
	    function MessageIdGenerator() {
	    }
	    MessageIdGenerator.generateId = function () {
	        return new Date().getTime();
	    };
	    return MessageIdGenerator;
	}());
	exports.MessageIdGenerator = MessageIdGenerator;
	var GameClient = (function (_super) {
	    __extends(GameClient, _super);
	    function GameClient(gameKey, options) {
	        _super.call(this, gameKey, options);
	        this._offerId = null;
	        this._bonusId = -1;
	        this._autoplay = false;
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(gameKey, 'gameKey');
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(options.jwtToken, 'options.jwtToken');
	        this._gameKey = gameKey;
	        this._routeUrl = "/game/" + gameKey + "/";
	        this.lastCfgVersion = null;
	    }
	    GameClient.prototype.sendKeepAliveRequest = function () {
	        var error = null;
	        return this.sendRequest(new BalanceRequest_1.BalanceRequest(), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.GET, balanceRouteUrl, {
	            supressHandleError: true,
	            overwriteRetryCount: 0,
	            customHandleError: function (clientError) {
	                if (!neo_common_1.Utils.isNullOrUndefined(clientError.httpStatusCode)) {
	                    if (clientError.httpStatusCode === 401) {
	                        var err = neo_common_1.Utils.isNullOrUndefined(clientError.error) ? null : clientError.error.message;
	                        error = new Error(err || clientError.httpStatusCode.toString());
	                    }
	                }
	            }
	        })
	            .finally(function () {
	            if (!neo_common_1.Utils.isNullOrUndefined(error)) {
	                throw error;
	            }
	        });
	    };
	    GameClient.prototype.setOfferId = function (id) {
	        this._offerId = id;
	    };
	    GameClient.prototype.setBonusId = function (id) {
	        this._bonusId = id;
	    };
	    GameClient.prototype.setAutoplay = function (autoplay) {
	        this._autoplay = autoplay;
	    };
	    GameClient.prototype.sendConfigurationRequest = function (version) {
	        var versionQuery = version === '' ? '' : "?version=" + version;
	        var routeUrl = "configuration/" + this._gameKey + versionQuery;
	        return this.sendRequest(new ConfigurationRequest_1.ConfigurationRequest(), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.GET, routeUrl, {
	            supressHandleError: false,
	            overwriteRetryCount: 0
	        });
	    };
	    GameClient.prototype.sendPlayerConfigurationRequest = function (data) {
	        return this.sendRequest(new PlayerConfigurationRequest_1.PlayerConfigurationRequest(data), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, playerConfigureRouteUrl, {
	            supressHandleError: true,
	            overwriteRetryCount: 0
	        });
	    };
	    GameClient.prototype.sendPlayerLogError = function (message, customData) {
	        return this.sendRequest(new PlayerLogErrorRequest_1.PlayerLogErrorRequest(message, customData), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, playerLogErrorUrl, {
	            supressHandleError: true,
	            overwriteRetryCount: 0
	        });
	    };
	    GameClient.prototype.sendPlayerLogEvents = function (data) {
	        return this.sendRequest(new PlayerLogEventsRequest_1.PlayerLogEventsRequest(data), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, playerLogEventsUrl, {
	            supressHandleError: true,
	            overwriteRetryCount: 0
	        });
	    };
	    GameClient.prototype.sendServerTimerRequest = function () {
	        return this.sendRequest(new ServerTimeRequest_1.ServerTimeRequest(), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.GET, serverTime, {
	            supressHandleError: true,
	            overwriteRetryCount: 0
	        });
	    };
	    GameClient.prototype.sendFreeRoundsOffersRequest = function (gameCode) {
	        var error = null;
	        return this.sendRequest(new FreeRoundsOffersRequest_1.FreeRoundsOffersRequest(gameCode), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, freeRoundBonusUrls.getOffer, {
	            supressHandleError: false,
	            overwriteRetryCount: 0,
	            customHandleError: function (clientError) {
	                var err = neo_common_1.Utils.isNullOrUndefined(clientError.error) ? null : clientError.error.message;
	                error = new Error(err || clientError.httpStatusCode.toString());
	            }
	        }).finally(function () {
	            if (error) {
	                throw error;
	            }
	        });
	    };
	    GameClient.prototype.sendFreeRoundsActivateOfferRequest = function (gameCode, offerId) {
	        var error = null;
	        return this.sendRequest(new FreeRoundsActivateOfferRequest_1.FreeRoundsActivateOfferRequest(gameCode, offerId), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, freeRoundBonusUrls.activateOffer, {
	            supressHandleError: false,
	            overwriteRetryCount: 3,
	            customHandleError: function (clientError) {
	                var err = neo_common_1.Utils.isNullOrUndefined(clientError.error) ? null : clientError.error.message;
	                error = new Error(err || clientError.httpStatusCode.toString());
	            }
	        }).finally(function () {
	            if (error) {
	                throw error;
	            }
	        });
	    };
	    GameClient.prototype.sendFreeRoundsDeclineOfferRequest = function (gameCode, offerId) {
	        return this.sendRequest(new FreeRoundsDeclineOfferRequest_1.FreeRoundsDeclineOfferRequest(gameCode, offerId), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, freeRoundBonusUrls.declineOffer, {
	            supressHandleError: true,
	            overwriteRetryCount: 0
	        });
	    };
	    GameClient.prototype.sendProgressiveBonusGetInfoRequest = function (bonusId) {
	        var error = null;
	        return this.sendRequest(new ProgressiveBonusGetInfoRequest_1.ProgressiveBonusGetInfoRequest(bonusId), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, "ProgressiveBonus/" + this._gameKey + "/GetInfo", {
	            supressHandleError: true,
	            overwriteRetryCount: 3,
	            customHandleError: function (clientError) {
	                if (!neo_common_1.Utils.isNullOrUndefined(clientError.httpStatusCode)) {
	                    if (clientError.httpStatusCode === 401) {
	                        var err = neo_common_1.Utils.isNullOrUndefined(clientError.error) ? null : clientError.error.message;
	                        error = new Error(err || clientError.httpStatusCode.toString());
	                    }
	                }
	            }
	        })
	            .finally(function () {
	            if (!neo_common_1.Utils.isNullOrUndefined(error)) {
	                throw error;
	            }
	        });
	    };
	    GameClient.prototype.sendMaxPowerBonusInitRequest = function (ticket) {
	        if (ticket === void 0) { ticket = null; }
	        return this.sendRequest(new MaxPowerBonusInitRequest_1.MaxPowerBonusInitRequest(ticket), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, maxPowerBonusUrls.init, {
	            supressHandleError: true,
	            overwriteRetryCount: 0
	        });
	    };
	    GameClient.prototype.sendMaxPowerBonusSpinRequest = function (ticket) {
	        if (ticket === void 0) { ticket = null; }
	        return this.sendRequest(new MaxPowerBonusSpinRequest_1.MaxPowerBonusSpinRequest(ticket), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, maxPowerBonusUrls.spin);
	    };
	    GameClient.prototype.sendGameRequest = function (request, module) {
	        return this.internalSendGameRequest(request, module);
	    };
	    GameClient.prototype.internalSendGameRequest = function (request, module) {
	        var _this = this;
	        var requestContext = {
	            request: request,
	            module: module,
	            context: {}
	        };
	        return GameClientInterceptorFactory_1.GameClientInterceptorFactory.onSendGameRequest(requestContext, this.sendGameRequest.bind(this))
	            .then(function () {
	            neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(request.messageId, 'request.messageId');
	            neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(module, 'module');
	            neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(request.actionName, 'request.actionName');
	            var action = request.actionName();
	            neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(action, 'action');
	            if (!neo_common_1.Utils.isNullOrUndefined(_this.lastCfgVersion)) {
	                request.cfgVersion = _this.lastCfgVersion;
	            }
	            var params = '';
	            var paramsArr = [];
	            if (_this._offerId !== null) {
	                paramsArr.push('offerId=' + _this._offerId);
	            }
	            if (_this._bonusId > 0) {
	                paramsArr.push('bonusId=' + _this._bonusId);
	            }
	            if (_this._autoplay) {
	                paramsArr.push('autoplay=true');
	            }
	            if (paramsArr.length > 0) {
	                params = '?';
	                for (var i = 0; i < paramsArr.length; i++) {
	                    if (i === 0) {
	                        params += paramsArr[i];
	                    }
	                    else {
	                        params += '&' + paramsArr[i];
	                    }
	                }
	            }
	            var cfgVer = 'with cfgVersion: ' + (neo_common_1.Utils.valueOrDefault(request.cfgVersion, '-'));
	            var logHeader = "sending request action \"" + action + "\" to module \"" + module + "\" " + cfgVer + " at base url: " + _this._apiUrl + " ...";
	            var routeUrl = ("game/" + _this._gameKey + "/" + module + "/" + action) + params;
	            var sendOptions = {
	                logHeader: logHeader,
	                customHandleError: (function (clientError) {
	                    GameClientInterceptorFactory_1.GameClientInterceptorFactory.onRequestError(requestContext, clientError);
	                })
	            };
	            return _this.sendRequest(request, neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, routeUrl, sendOptions)
	                .then(function (response) {
	                if (response instanceof GameResponse_1.GameResponse && neo_common_1.Utils.isNullOrUndefined(_this.lastCfgVersion)) {
	                    _this.lastCfgVersion = response.cfgVersion;
	                }
	                if (neo_common_1.Utils.isNullOrUndefined(response)) {
	                    return response;
	                }
	                return GameClientInterceptorFactory_1.GameClientInterceptorFactory.onResponseReceived(requestContext, response)
	                    .then(function () {
	                    return response;
	                });
	            });
	        })
	            .finally(function () {
	            GameClientInterceptorFactory_1.GameClientInterceptorFactory.onSendGameRequestFinal(requestContext);
	        });
	    };
	    GameClient.prototype.balance = function () {
	        return this.sendRequest(new BalanceRequest_1.BalanceRequest(), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.GET, balanceRouteUrl);
	    };
	    GameClient.prototype.closeRealityCheck = function () {
	        var error = null;
	        return this.sendRequest(new RealityCheckRequest_1.RealityCheckRequest(), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, realityCheckRouteUrls.close, {
	            customHandleError: function (clientError) {
	                var err = neo_common_1.Utils.isNullOrUndefined(clientError.error) ? null : clientError.error.message;
	                error = new Error(err || clientError.httpStatusCode.toString());
	            }
	        })
	            .finally(function () {
	            if (error) {
	                throw error;
	            }
	        });
	    };
	    GameClient.prototype.resetRealityCheck = function (interval) {
	        var error = null;
	        return this.sendRequest(new RealityCheckRequest_1.RealityCheckRequest(interval), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, realityCheckRouteUrls.reset, {
	            customHandleError: function (clientError) {
	                var err = neo_common_1.Utils.isNullOrUndefined(clientError.error) ? null : clientError.error.message;
	                error = new Error(err || clientError.httpStatusCode.toString());
	            }
	        })
	            .finally(function () {
	            if (error) {
	                throw error;
	            }
	        });
	    };
	    GameClient.prototype.getRealityCheckInfo = function () {
	        return this.sendRequest(new RealityCheckGetInfoRequest_1.RealityCheckGetInfoRequest(), neo_common_1.ApiClientCommunication.ApiClientConsts.HttpMethod.POST, realityCheckRouteUrls.getInfo, {
	            supressHandleError: true,
	            overwriteRetryCount: 0
	        });
	    };
	    GameClient.prototype.init = function (customData) {
	        var request = new InitRequest_1.InitRequest(customData);
	        return this.sendGameRequest(request, GameModules_1.GameModules.Root);
	    };
	    GameClient.prototype.collect = function (customData) {
	        var request = new CollectRequest_1.CollectRequest(customData);
	        return this.sendGameRequest(request, GameModules_1.GameModules.Root);
	    };
	    GameClient.prototype.enterGame = function (customData) {
	        var request = new EnterGameRequest_1.EnterGameRequest(customData);
	        return this.sendGameRequest(request, GameModules_1.GameModules.Root);
	    };
	    GameClient.prototype.leaveGame = function (customData) {
	        var request = new LeaveGameRequest_1.LeaveGameRequest(customData);
	        return this.sendGameRequest(request, GameModules_1.GameModules.Root);
	    };
	    GameClient.prototype.spin = function (module, bet, customData) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(module, 'module');
	        neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(bet, 'bet');
	        var request = new SpinRequest_1.SpinRequest(bet, customData);
	        return this.sendGameRequest(request, module);
	    };
	    GameClient.prototype.rouletteSpin = function (module, bets, lastChip, customData) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(module, 'module');
	        neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(bets, 'bets');
	        var request = new RouletteSpinRequest_1.RouletteSpinRequest(bets, lastChip, customData);
	        return this.sendGameRequest(request, module);
	    };
	    GameClient.prototype.freespin = function (module, customData) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(module, 'module');
	        var request = new FreeSpinRequest_1.FreeSpinRequest(customData);
	        return this.sendGameRequest(request, module);
	    };
	    GameClient.prototype.endFreespin = function (customData) {
	        return this.end(GameModules_1.GameModules.Freespins, customData);
	    };
	    GameClient.prototype.bonusRespinsSpin = function (module, customData) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(module, 'module');
	        var request = new BonusRespinsSpinRequest_1.BonusRespinsSpinRequest(customData);
	        return this.sendGameRequest(request, module);
	    };
	    GameClient.prototype.bonusRespinsStart = function (customData) {
	        return this.start(GameModules_1.GameModules.BonusRespins, customData);
	    };
	    GameClient.prototype.endBonusRespins = function (customData) {
	        return this.end(GameModules_1.GameModules.BonusRespins, customData);
	    };
	    GameClient.prototype.endPick = function (customData) {
	        return this.end(GameModules_1.GameModules.Pick, customData);
	    };
	    GameClient.prototype.end = function (module, customData) {
	        var request = new EndRequest_1.EndRequest(customData);
	        return this.sendGameRequest(request, module);
	    };
	    GameClient.prototype.start = function (module, customData) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(module, 'module');
	        var request = new StartRequest_1.StartRequest(customData);
	        return this.sendGameRequest(request, module);
	    };
	    GameClient.prototype.pickStart = function (customData) {
	        return this.start(GameModules_1.GameModules.Pick, customData);
	    };
	    GameClient.prototype.respin = function (module, reels, customData) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(module, 'module');
	        neo_common_1.ArgValidator.ensureIsNumber(reels, 'reels');
	        var request = new RespinRequest_1.RespinRequest(reels, customData);
	        return this.sendGameRequest(request, module);
	    };
	    GameClient.prototype.gambleSelect = function (color, suit, customData) {
	        var request = new GambleSelectRequest_1.GambleSelectRequest(color, suit, customData);
	        return this.sendGameRequest(request, GameModules_1.GameModules.Gamble);
	    };
	    GameClient.prototype.gambleHalve = function (customData) {
	        var request = new GambleHalveRequest_1.GambleHalveRequest(customData);
	        return this.sendGameRequest(request, GameModules_1.GameModules.Gamble);
	    };
	    GameClient.prototype.pickSelect = function (spot, customData) {
	        var request = new PickSelectRequest_1.PickSelectRequest(spot, customData);
	        return this.sendGameRequest(request, GameModules_1.GameModules.Pick);
	    };
	    GameClient.prototype.buyFeature = function (module, bet, originalBet, buyFeatureName, customData) {
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(module, 'module');
	        neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(bet, 'bet');
	        var request = new BuyFeatureRequest_1.BuyFeatureRequest(bet, originalBet, buyFeatureName, customData);
	        return this.sendGameRequest(request, module);
	    };
	    GameClient.prototype.blackJackDeal = function (bets, customData) {
	        neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(bets, 'bets');
	        var request = new BlackJackDealRequest_1.BlackJackDealRequest(bets, customData);
	        return this.sendGameRequest(request, GameModules_1.GameModules.Base);
	    };
	    GameClient.prototype.blackJackHit = function (hand, customData) {
	        neo_common_1.ArgValidator.ensureIsNumber(hand, 'hand');
	        var request = new BlackJackHitRequest_1.BlackJackHitRequest(hand, customData);
	        return this.sendGameRequest(request, GameModules_1.GameModules.Base);
	    };
	    GameClient.prototype.blackJackStand = function (hand, customData) {
	        neo_common_1.ArgValidator.ensureIsNumber(hand, 'hand');
	        var request = new BlackJackStandRequest_1.BlackJackStandRequest(hand, customData);
	        return this.sendGameRequest(request, GameModules_1.GameModules.Base);
	    };
	    return GameClient;
	}(neo_common_1.ApiClientCommunication.ApiClient));
	exports.GameClient = GameClient;
	GameModuleResponseFactory_1.GameModuleResponseFactory.register(GameModuleBaseResponse_1.GameModuleBaseResponse);
	GameModuleResponseFactory_1.GameModuleResponseFactory.register(GameModuleGambleResponse_1.GameModuleGambleResponse);
	GameModuleResponseFactory_1.GameModuleResponseFactory.register(GameModuleFreespinResponse_1.GameModuleFreespinResponse);
	GameModuleResponseFactory_1.GameModuleResponseFactory.register(GameModulePickResponse_1.GameModulePickResponse);
	GameModuleResponseFactory_1.GameModuleResponseFactory.register(GameModuleRouletteResponse_1.GameModuleRouletteResponse);
	GameModuleResponseFactory_1.GameModuleResponseFactory.register(GameModuleBlackJackResponse_1.GameModuleBlackJackResponse);
	GameModuleResponseFactory_1.GameModuleResponseFactory.register(GameModuleBonusRespinsResponse_1.GameModuleBonusRespinsResponse);


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var InitResponse_1 = __webpack_require__(48);
	var action = 'Init';
	var InitRequest = (function (_super) {
	    __extends(InitRequest, _super);
	    function InitRequest(customData) {
	        _super.call(this, customData);
	    }
	    Object.defineProperty(InitRequest, "requestName", {
	        get: function () {
	            return action;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InitRequest.prototype.actionName = function () {
	        return action;
	    };
	    InitRequest.prototype.createResponse = function (responseJson) {
	        return new InitResponse_1.InitResponse(responseJson);
	    };
	    return InitRequest;
	}(Request_1.Request));
	exports.InitRequest = InitRequest;


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var Request = (function (_super) {
	    __extends(Request, _super);
	    function Request(customData) {
	        _super.call(this);
	        this.messageId = this.generateId();
	        this.customData = customData;
	    }
	    Request.prototype.generateId = function () {
	        return new Date().getTime();
	    };
	    return Request;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.Request = Request;


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var GameResponse_1 = __webpack_require__(49);
	var InitResponse = (function (_super) {
	    __extends(InitResponse, _super);
	    function InitResponse() {
	        _super.apply(this, arguments);
	    }
	    InitResponse.prototype.internalValidate = function (errors) {
	        _super.prototype.internalValidate.call(this, errors);
	        if (neo_common_1.Utils.isNullOrUndefined(this.initData)) {
	            errors.push('Property "initData" is missing or has null/undefined value!');
	        }
	        else {
	            if (neo_common_1.StringUtils.isNullOrEmpty(this.initData.currency)) {
	                errors.push('Property "initData.currency" is missing or has null/undefined value!');
	            }
	            if (neo_common_1.Utils.isNullOrUndefined(this.initData.denomination)) {
	                errors.push('Property "initData.denomination" is missing or has null/undefined value!');
	            }
	            else if (typeof this.initData.denomination !== 'number') {
	                errors.push('Property "initData.denomination" has wrong type, required type is "number"!');
	            }
	        }
	    };
	    return InitResponse;
	}(GameResponse_1.GameResponse));
	exports.InitResponse = InitResponse;


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var GameModuleResponseFactory_1 = __webpack_require__(50);
	var GameResponse = (function (_super) {
	    __extends(GameResponse, _super);
	    function GameResponse() {
	        _super.apply(this, arguments);
	    }
	    GameResponse.prototype.module = function (typeName) {
	        var moduleData = neo_common_1.Utils.isNullOrUndefined(this.modules) ? null : this.modules[typeName];
	        return neo_common_1.Utils.isNullOrUndefined(moduleData)
	            ? null
	            : GameModuleResponseFactory_1.GameModuleResponseFactory.createModuleResponse(typeName, moduleData);
	    };
	    GameResponse.prototype.internalValidate = function (errors) {
	        if (neo_common_1.Utils.isNullOrUndefined(this.messageId)) {
	            errors.push('Property "messageId" is missing or has null/undefined value!');
	        }
	    };
	    return GameResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.GameResponse = GameResponse;


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var GameModuleResponseFactory = (function () {
	    function GameModuleResponseFactory() {
	    }
	    GameModuleResponseFactory.register = function (moduleResponseType) {
	        neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(moduleResponseType, 'moduleResponseType');
	        var temp = new moduleResponseType();
	        var moduleName = temp.moduleName();
	        neo_common_1.ArgValidator.ensureStringIsNotNullOrEmpty(moduleName, 'moduleName');
	        var reg = GameModuleResponseFactory.registrations[moduleName];
	        if (neo_common_1.Utils.isNullOrUndefined(reg)) {
	            GameModuleResponseFactory.registrations[moduleName] = moduleResponseType;
	        }
	    };
	    GameModuleResponseFactory.createModuleResponse = function (typeName, data) {
	        var reg = GameModuleResponseFactory.registrations[typeName];
	        if (neo_common_1.Utils.isNullOrUndefined(reg)) {
	            throw new Error('Could not found game module response registration for type "' + typeName + '"');
	        }
	        var result = new reg(data);
	        return result;
	    };
	    GameModuleResponseFactory.registrations = {};
	    return GameModuleResponseFactory;
	}());
	exports.GameModuleResponseFactory = GameModuleResponseFactory;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Collect';
	var CollectRequest = (function (_super) {
	    __extends(CollectRequest, _super);
	    function CollectRequest(customData) {
	        _super.call(this, customData);
	    }
	    Object.defineProperty(CollectRequest, "requestName", {
	        get: function () {
	            return action;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CollectRequest.prototype.actionName = function () {
	        return action;
	    };
	    CollectRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return CollectRequest;
	}(Request_1.Request));
	exports.CollectRequest = CollectRequest;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var BalanceResponse_1 = __webpack_require__(53);
	var BalanceRequest = (function (_super) {
	    __extends(BalanceRequest, _super);
	    function BalanceRequest() {
	        _super.apply(this, arguments);
	    }
	    BalanceRequest.prototype.createResponse = function (responseJson) {
	        return new BalanceResponse_1.BalanceResponse(responseJson);
	    };
	    return BalanceRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.BalanceRequest = BalanceRequest;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var BalanceResponse = (function (_super) {
	    __extends(BalanceResponse, _super);
	    function BalanceResponse() {
	        _super.apply(this, arguments);
	    }
	    BalanceResponse.prototype.internalValidate = function (errors) {
	        if (neo_common_1.Utils.isNullOrUndefined(this.real)) {
	            errors.push('Property "real" is missing or has null/undefined value!');
	        }
	        if (neo_common_1.Utils.isNullOrUndefined(this.bonus)) {
	            errors.push('Property "bonus" is missing or has null/undefined value!');
	        }
	    };
	    return BalanceResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.BalanceResponse = BalanceResponse;


/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Spin';
	var SpinRequest = (function (_super) {
	    __extends(SpinRequest, _super);
	    function SpinRequest(bet, customData) {
	        _super.call(this, customData);
	        this.bet = bet;
	    }
	    Object.defineProperty(SpinRequest, "requestName", {
	        get: function () {
	            return action;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SpinRequest.prototype.actionName = function () {
	        return action;
	    };
	    SpinRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return SpinRequest;
	}(Request_1.Request));
	exports.SpinRequest = SpinRequest;


/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Spin';
	var FreeSpinRequest = (function (_super) {
	    __extends(FreeSpinRequest, _super);
	    function FreeSpinRequest(customData) {
	        _super.call(this, customData);
	    }
	    FreeSpinRequest.prototype.actionName = function () {
	        return action;
	    };
	    FreeSpinRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return FreeSpinRequest;
	}(Request_1.Request));
	exports.FreeSpinRequest = FreeSpinRequest;


/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Respin';
	var RespinRequest = (function (_super) {
	    __extends(RespinRequest, _super);
	    function RespinRequest(reels, customData) {
	        _super.call(this, customData);
	        this.reels = reels;
	    }
	    RespinRequest.prototype.actionName = function () {
	        return action;
	    };
	    RespinRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return RespinRequest;
	}(Request_1.Request));
	exports.RespinRequest = RespinRequest;


/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Start';
	var StartRequest = (function (_super) {
	    __extends(StartRequest, _super);
	    function StartRequest(customData) {
	        _super.call(this, customData);
	    }
	    StartRequest.prototype.actionName = function () {
	        return action;
	    };
	    StartRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return StartRequest;
	}(Request_1.Request));
	exports.StartRequest = StartRequest;


/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Select';
	var GambleSelectRequest = (function (_super) {
	    __extends(GambleSelectRequest, _super);
	    function GambleSelectRequest(color, suit, customData) {
	        _super.call(this, customData);
	        if (neo_common_1.Utils.isNullOrUndefined(color) && neo_common_1.Utils.isNullOrUndefined(suit)) {
	            throw new Error("Argument \"color\" or \"suit\" is required to be specified!");
	        }
	        this.color = color;
	        this.suit = suit;
	    }
	    GambleSelectRequest.prototype.actionName = function () {
	        return action;
	    };
	    GambleSelectRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return GambleSelectRequest;
	}(Request_1.Request));
	exports.GambleSelectRequest = GambleSelectRequest;


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Halve';
	var GambleHalveRequest = (function (_super) {
	    __extends(GambleHalveRequest, _super);
	    function GambleHalveRequest(customData) {
	        _super.call(this, customData);
	    }
	    GambleHalveRequest.prototype.actionName = function () {
	        return action;
	    };
	    GambleHalveRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return GambleHalveRequest;
	}(Request_1.Request));
	exports.GambleHalveRequest = GambleHalveRequest;


/***/ },
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Select';
	var PickSelectRequest = (function (_super) {
	    __extends(PickSelectRequest, _super);
	    function PickSelectRequest(spot, customData) {
	        _super.call(this, customData);
	        if (neo_common_1.Utils.isNullOrUndefined(spot)) {
	            throw new Error("Argument \"spot\" is required to be specified!");
	        }
	        this.spot = spot;
	    }
	    PickSelectRequest.prototype.actionName = function () {
	        return action;
	    };
	    PickSelectRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return PickSelectRequest;
	}(Request_1.Request));
	exports.PickSelectRequest = PickSelectRequest;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var EnterGameResponse_1 = __webpack_require__(62);
	var action = 'Enter';
	var EnterGameRequest = (function (_super) {
	    __extends(EnterGameRequest, _super);
	    function EnterGameRequest(customData) {
	        _super.call(this, customData);
	    }
	    EnterGameRequest.prototype.actionName = function () {
	        return action;
	    };
	    EnterGameRequest.prototype.createResponse = function (responseJson) {
	        return new EnterGameResponse_1.EnterGameResponse(responseJson);
	    };
	    return EnterGameRequest;
	}(Request_1.Request));
	exports.EnterGameRequest = EnterGameRequest;


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var EnterGameResponse = (function (_super) {
	    __extends(EnterGameResponse, _super);
	    function EnterGameResponse() {
	        _super.apply(this, arguments);
	    }
	    EnterGameResponse.prototype.internalValidate = function (errors) { };
	    return EnterGameResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.EnterGameResponse = EnterGameResponse;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var LeaveGameResponse_1 = __webpack_require__(64);
	var action = 'Leave';
	var LeaveGameRequest = (function (_super) {
	    __extends(LeaveGameRequest, _super);
	    function LeaveGameRequest(customData) {
	        _super.call(this, customData);
	    }
	    LeaveGameRequest.prototype.actionName = function () {
	        return action;
	    };
	    LeaveGameRequest.prototype.createResponse = function (responseJson) {
	        return new LeaveGameResponse_1.LeaveGameResponse(responseJson);
	    };
	    return LeaveGameRequest;
	}(Request_1.Request));
	exports.LeaveGameRequest = LeaveGameRequest;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var LeaveGameResponse = (function (_super) {
	    __extends(LeaveGameResponse, _super);
	    function LeaveGameResponse() {
	        _super.apply(this, arguments);
	    }
	    LeaveGameResponse.prototype.internalValidate = function (errors) {
	    };
	    return LeaveGameResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.LeaveGameResponse = LeaveGameResponse;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var GameModuleResponse_1 = __webpack_require__(66);
	var GameModuleBaseResponse = (function (_super) {
	    __extends(GameModuleBaseResponse, _super);
	    function GameModuleBaseResponse() {
	        _super.apply(this, arguments);
	    }
	    GameModuleBaseResponse.prototype.internalValidate = function (errors) {
	        if (neo_common_1.Utils.isNullOrUndefined(this.spinId)) {
	            errors.push('Property "spinId" is missing or has null/undefined value!');
	        }
	    };
	    GameModuleBaseResponse.prototype.moduleName = function () {
	        return 'base';
	    };
	    return GameModuleBaseResponse;
	}(GameModuleResponse_1.GameModuleResponse));
	exports.GameModuleBaseResponse = GameModuleBaseResponse;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var GameModuleResponse = (function (_super) {
	    __extends(GameModuleResponse, _super);
	    function GameModuleResponse() {
	        _super.apply(this, arguments);
	    }
	    return GameModuleResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.GameModuleResponse = GameModuleResponse;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var GameModuleResponse_1 = __webpack_require__(66);
	var GameModules_1 = __webpack_require__(68);
	var GameModuleGambleResponse = (function (_super) {
	    __extends(GameModuleGambleResponse, _super);
	    function GameModuleGambleResponse() {
	        _super.apply(this, arguments);
	    }
	    GameModuleGambleResponse.prototype.internalValidate = function (errors) {
	    };
	    GameModuleGambleResponse.prototype.moduleName = function () {
	        return GameModules_1.GameModules.Gamble;
	    };
	    return GameModuleGambleResponse;
	}(GameModuleResponse_1.GameModuleResponse));
	exports.GameModuleGambleResponse = GameModuleGambleResponse;


/***/ },
/* 68 */
/***/ function(module, exports) {

	"use strict";
	var GameModules = (function () {
	    function GameModules() {
	    }
	    Object.defineProperty(GameModules, "Root", {
	        get: function () {
	            return 'Root';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameModules, "Base", {
	        get: function () {
	            return 'base';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameModules, "Gamble", {
	        get: function () {
	            return 'gamble';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameModules, "Freespins", {
	        get: function () {
	            return 'freespins';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameModules, "Pick", {
	        get: function () {
	            return 'pick';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameModules, "Roulette", {
	        get: function () {
	            return 'roulette';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GameModules, "BonusRespins", {
	        get: function () {
	            return 'bonusrespins';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return GameModules;
	}());
	exports.GameModules = GameModules;


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var GameModuleBaseResponse_1 = __webpack_require__(65);
	var GameModules_1 = __webpack_require__(68);
	var GameModuleFreespinResponse = (function (_super) {
	    __extends(GameModuleFreespinResponse, _super);
	    function GameModuleFreespinResponse() {
	        _super.apply(this, arguments);
	    }
	    GameModuleFreespinResponse.prototype.internalValidate = function (errors) {
	    };
	    GameModuleFreespinResponse.prototype.moduleName = function () {
	        return GameModules_1.GameModules.Freespins;
	    };
	    return GameModuleFreespinResponse;
	}(GameModuleBaseResponse_1.GameModuleBaseResponse));
	exports.GameModuleFreespinResponse = GameModuleFreespinResponse;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var GameModuleResponse_1 = __webpack_require__(66);
	var GameModules_1 = __webpack_require__(68);
	var GameModulePickResponse = (function (_super) {
	    __extends(GameModulePickResponse, _super);
	    function GameModulePickResponse() {
	        _super.apply(this, arguments);
	    }
	    GameModulePickResponse.prototype.internalValidate = function (errors) {
	    };
	    GameModulePickResponse.prototype.moduleName = function () {
	        return GameModules_1.GameModules.Pick;
	    };
	    return GameModulePickResponse;
	}(GameModuleResponse_1.GameModuleResponse));
	exports.GameModulePickResponse = GameModulePickResponse;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var GameModuleResponse_1 = __webpack_require__(66);
	var GameModuleRouletteResponse = (function (_super) {
	    __extends(GameModuleRouletteResponse, _super);
	    function GameModuleRouletteResponse() {
	        _super.apply(this, arguments);
	    }
	    GameModuleRouletteResponse.prototype.internalValidate = function (errors) {
	    };
	    GameModuleRouletteResponse.prototype.moduleName = function () {
	        return 'roulette';
	    };
	    return GameModuleRouletteResponse;
	}(GameModuleResponse_1.GameModuleResponse));
	exports.GameModuleRouletteResponse = GameModuleRouletteResponse;


/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'End';
	var EndRequest = (function (_super) {
	    __extends(EndRequest, _super);
	    function EndRequest(customData) {
	        _super.call(this, customData);
	    }
	    EndRequest.prototype.actionName = function () {
	        return action;
	    };
	    EndRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return EndRequest;
	}(Request_1.Request));
	exports.EndRequest = EndRequest;


/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	(function (GameClientInterceptorErrorTypes) {
	    GameClientInterceptorErrorTypes[GameClientInterceptorErrorTypes["AbortSendRequest"] = 'AbortSendRequest'] = "AbortSendRequest";
	})(exports.GameClientInterceptorErrorTypes || (exports.GameClientInterceptorErrorTypes = {}));
	var GameClientInterceptorErrorTypes = exports.GameClientInterceptorErrorTypes;
	var GameClientInterceptorError = (function (_super) {
	    __extends(GameClientInterceptorError, _super);
	    function GameClientInterceptorError(type, message) {
	        _super.call(this, message);
	        this.type = type;
	        this.message = message;
	        this.name = 'GameClientInterceptorError';
	    }
	    GameClientInterceptorError.prototype.equalsTo = function (other) {
	        if (other instanceof GameClientInterceptorError) {
	            return this.name === other.name &&
	                this.type === other.type;
	        }
	        return false;
	    };
	    GameClientInterceptorError.AbortSendRequest = function (message) {
	        return new GameClientInterceptorError(GameClientInterceptorErrorTypes.AbortSendRequest, message);
	    };
	    return GameClientInterceptorError;
	}(Error));
	exports.GameClientInterceptorError = GameClientInterceptorError;
	var GameClientInterceptorFactory = (function () {
	    function GameClientInterceptorFactory() {
	    }
	    GameClientInterceptorFactory.register = function (component) {
	        var args = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            args[_i - 1] = arguments[_i];
	        }
	        var instance = null;
	        var cmpName = component.name;
	        if (cmpName === undefined || cmpName === '') {
	            throw new Error('[GameClientInterceptorFactory] specified component does not contain property "name"');
	        }
	        var list = GameClientInterceptorFactory.list;
	        var reg = list[cmpName];
	        if (!reg) {
	            instance = new (component.bind.apply(component, [void 0].concat(args)))();
	            list[cmpName] = {
	                name: cmpName,
	                instance: instance
	            };
	            this.count++;
	            if (false) {
	                neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', "Game client interceptor '" + cmpName + "' was successfully registered (" + this.count + " so far).");
	            }
	        }
	        else {
	            throw new Error("[GameClientInterceptorFactory] Game client interceptor \"" + cmpName + "\" is already registered!");
	        }
	        return instance;
	    };
	    GameClientInterceptorFactory.onSendGameRequest = function (context, sendRequestFn) {
	        if (neo_common_1.ObjectUtils.keyCount(GameClientInterceptorFactory.list) === 0) {
	            return Promise.resolve();
	        }
	        var interceptorCount = 0;
	        return Promise.resolve()
	            .then(function () {
	            var instances = neo_common_1.lodash.map(GameClientInterceptorFactory.list, function (value, key) {
	                return {
	                    name: key,
	                    instance: value.instance
	                };
	            });
	            interceptorCount = instances.length;
	            if (false) {
	                neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', "Executing event 'onSendGameRequest' for " + interceptorCount + " interceptors...");
	            }
	            return Promise.map(instances, function (item) {
	                var instanceName = item.name;
	                var instance = item.instance;
	                return instance.onSendGameRequest(context, sendRequestFn)
	                    .catch(function (err) {
	                    if (false) {
	                        neo_common_1.Logger.errorGroup('GameClientInterceptorFactory', ("[" + instanceName + "].onSendRequest failed: ") + neo_common_1.Utils.getErrorMsg(err));
	                    }
	                });
	            });
	        })
	            .catch(function (err) {
	            if (false) {
	                var errMsg = "Executing game client interceptors for event 'onSendRequest' throws error: " + neo_common_1.Utils.getErrorMsg(err);
	                if (err instanceof GameClientInterceptorError) {
	                    errMsg = "Executing game client interceptors for event 'onSendRequest' was aborted, reason: " + err.type;
	                }
	                neo_common_1.Logger.errorGroup('GameClientInterceptorFactory', errMsg);
	            }
	        })
	            .finally(function () {
	            if (false) {
	                neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', "Executing event 'onSendGameRequest' for " + interceptorCount + " interceptors ends.");
	            }
	        });
	    };
	    GameClientInterceptorFactory.onRequestError = function (context, clientError) {
	        if (neo_common_1.ObjectUtils.keyCount(GameClientInterceptorFactory.list) === 0) {
	            return;
	        }
	        var instances = neo_common_1.lodash.map(GameClientInterceptorFactory.list, function (value, key) {
	            return {
	                name: key,
	                instance: value.instance
	            };
	        });
	        try {
	            if (false) {
	                neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', "Executing event 'onRequestError' for " + instances.length + " interceptors...");
	            }
	            _.each(instances, function (item) {
	                var instanceName = item.name;
	                var instance = item.instance;
	                try {
	                    instance.onRequestError(context, clientError);
	                }
	                catch (err) {
	                    if (false) {
	                        neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', ("[" + instanceName + "].onRequestError failed: ") + neo_common_1.Utils.getErrorMsg(err));
	                    }
	                }
	            });
	        }
	        catch (err) {
	            if (false) {
	                neo_common_1.Logger.errorGroup('GameClientInterceptorFactory', "Executing game client interceptors for event 'onRequestError' throws error: " + neo_common_1.Utils.getErrorMsg(err));
	            }
	        }
	        finally {
	            if (false) {
	                neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', "Executing event 'onRequestError' for " + instances.length + " interceptors ends.");
	            }
	        }
	    };
	    GameClientInterceptorFactory.onResponseReceived = function (context, response) {
	        if (neo_common_1.ObjectUtils.keyCount(GameClientInterceptorFactory.list) === 0) {
	            return Promise.resolve();
	        }
	        var interceptorCount = 0;
	        return Promise.resolve()
	            .then(function () {
	            var instances = neo_common_1.lodash.map(GameClientInterceptorFactory.list, function (value, key) {
	                return {
	                    name: key,
	                    instance: value.instance
	                };
	            });
	            interceptorCount = instances.length;
	            if (false) {
	                neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', "Executing event 'onResponseReceived' for " + interceptorCount + " interceptors...");
	            }
	            return Promise.map(instances, function (item) {
	                var instanceName = item.name;
	                var instance = item.instance;
	                return instance.onResponseReceived(context, response)
	                    .catch(function (err) {
	                    if (false) {
	                        neo_common_1.Logger.errorGroup('GameClientInterceptorFactory', ("[" + instanceName + "].onResponseReceived failed: ") + neo_common_1.Utils.getErrorMsg(err));
	                    }
	                });
	            });
	        })
	            .catch(function (err) {
	            if (false) {
	                neo_common_1.Logger.errorGroup('GameClientInterceptorFactory', "Executing game client interceptors for event 'onResponseReceived' throws error: "
	                    + neo_common_1.Utils.getErrorMsg(err));
	            }
	        })
	            .finally(function () {
	            if (false) {
	                neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', "Executing event 'onResponseReceived' for " + interceptorCount + " interceptors ends.");
	            }
	        });
	    };
	    GameClientInterceptorFactory.onSendGameRequestFinal = function (context) {
	        if (neo_common_1.ObjectUtils.keyCount(GameClientInterceptorFactory.list) === 0) {
	            return;
	        }
	        var instances = neo_common_1.lodash.map(GameClientInterceptorFactory.list, function (value, key) {
	            return {
	                name: key,
	                instance: value.instance
	            };
	        });
	        try {
	            if (false) {
	                neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', "Executing event 'onSendGameRequestFinal' for " + instances.length + " interceptors...");
	            }
	            _.each(instances, function (item) {
	                var instanceName = item.name;
	                var instance = item.instance;
	                try {
	                    instance.onSendGameRequestFinal(context);
	                }
	                catch (err) {
	                    if (false) {
	                        neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', ("[" + instanceName + "].onSendGameRequestFinal failed: ") + neo_common_1.Utils.getErrorMsg(err));
	                    }
	                }
	            });
	        }
	        catch (err) {
	            if (false) {
	                neo_common_1.Logger.errorGroup('GameClientInterceptorFactory', "Executing game client interceptors for event 'onSendGameRequestFinal' throws error: " + neo_common_1.Utils.getErrorMsg(err));
	            }
	        }
	        finally {
	            if (false) {
	                neo_common_1.Logger.debugGroup('GameClientInterceptorFactory', "Executing event 'onSendGameRequestFinal' for " + instances.length + " interceptors ends.");
	            }
	        }
	    };
	    GameClientInterceptorFactory.list = {};
	    GameClientInterceptorFactory.count = 0;
	    return GameClientInterceptorFactory;
	}());
	exports.GameClientInterceptorFactory = GameClientInterceptorFactory;
	function gameClientInterceptor() {
	    return function (component) {
	        GameClientInterceptorFactory.register(component);
	        component.prototype.__componentName__ = component.name;
	    };
	}
	exports.gameClientInterceptor = gameClientInterceptor;
	var isBrowser = typeof window !== 'undefined';
	if (isBrowser) {
	    var win = window;
	    win['gameClientInterceptor'] = gameClientInterceptor;
	}


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var ConfigurationResponse_1 = __webpack_require__(75);
	var ConfigurationRequest = (function (_super) {
	    __extends(ConfigurationRequest, _super);
	    function ConfigurationRequest() {
	        _super.apply(this, arguments);
	    }
	    ConfigurationRequest.prototype.createResponse = function (responseJson) {
	        return new ConfigurationResponse_1.ConfigurationResponse(responseJson);
	    };
	    return ConfigurationRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.ConfigurationRequest = ConfigurationRequest;


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var ConfigurationResponse = (function (_super) {
	    __extends(ConfigurationResponse, _super);
	    function ConfigurationResponse() {
	        _super.apply(this, arguments);
	    }
	    ConfigurationResponse.prototype.internalValidate = function (errors) {
	    };
	    return ConfigurationResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.ConfigurationResponse = ConfigurationResponse;


/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var RealityCheckResponse_1 = __webpack_require__(77);
	var RealityCheckRequest = (function (_super) {
	    __extends(RealityCheckRequest, _super);
	    function RealityCheckRequest(interval) {
	        _super.call(this);
	        this.interval = interval;
	    }
	    RealityCheckRequest.prototype.createResponse = function (responseJson) {
	        return new RealityCheckResponse_1.RealityCheckResponse(responseJson);
	    };
	    return RealityCheckRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.RealityCheckRequest = RealityCheckRequest;


/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var RealityCheckResponse = (function (_super) {
	    __extends(RealityCheckResponse, _super);
	    function RealityCheckResponse() {
	        _super.apply(this, arguments);
	    }
	    RealityCheckResponse.prototype.internalValidate = function (errors) {
	    };
	    return RealityCheckResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.RealityCheckResponse = RealityCheckResponse;


/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var FreeRoundsOffersResponse_1 = __webpack_require__(79);
	var FreeRoundsOffersRequest = (function (_super) {
	    __extends(FreeRoundsOffersRequest, _super);
	    function FreeRoundsOffersRequest(gameCode) {
	        _super.call(this);
	        if (neo_common_1.Utils.isNullOrUndefined(gameCode)) {
	            throw new Error("Argument \"gameCode\" is required to be specified!");
	        }
	        this.gameCode = gameCode;
	    }
	    FreeRoundsOffersRequest.prototype.createResponse = function (responseJson) {
	        return new FreeRoundsOffersResponse_1.FreeRoundsOffersResponse(responseJson);
	    };
	    return FreeRoundsOffersRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.FreeRoundsOffersRequest = FreeRoundsOffersRequest;


/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var FreeRoundsOffersResponse = (function (_super) {
	    __extends(FreeRoundsOffersResponse, _super);
	    function FreeRoundsOffersResponse() {
	        _super.apply(this, arguments);
	    }
	    FreeRoundsOffersResponse.prototype.internalValidate = function (errors) {
	    };
	    return FreeRoundsOffersResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.FreeRoundsOffersResponse = FreeRoundsOffersResponse;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var FreeRoundsActivateOfferResponse_1 = __webpack_require__(81);
	var FreeRoundsActivateOfferRequest = (function (_super) {
	    __extends(FreeRoundsActivateOfferRequest, _super);
	    function FreeRoundsActivateOfferRequest(gameCode, offerId) {
	        _super.call(this);
	        if (neo_common_1.Utils.isNullOrUndefined(gameCode)) {
	            throw new Error("Argument \"gameCode\" is required to be specified!");
	        }
	        if (neo_common_1.Utils.isNullOrUndefined(offerId)) {
	            throw new Error("Argument \"offerId\" is required to be specified!");
	        }
	        this.gameCode = gameCode;
	        this.offerId = offerId;
	    }
	    FreeRoundsActivateOfferRequest.prototype.createResponse = function (responseJson) {
	        return new FreeRoundsActivateOfferResponse_1.FreeRoundsActivateOfferResponse(responseJson);
	    };
	    return FreeRoundsActivateOfferRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.FreeRoundsActivateOfferRequest = FreeRoundsActivateOfferRequest;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var FreeRoundsActivateOfferResponse = (function (_super) {
	    __extends(FreeRoundsActivateOfferResponse, _super);
	    function FreeRoundsActivateOfferResponse() {
	        _super.apply(this, arguments);
	    }
	    FreeRoundsActivateOfferResponse.prototype.internalValidate = function (errors) {
	    };
	    return FreeRoundsActivateOfferResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.FreeRoundsActivateOfferResponse = FreeRoundsActivateOfferResponse;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var FreeRoundsDeclineOfferResponse_1 = __webpack_require__(83);
	var FreeRoundsDeclineOfferRequest = (function (_super) {
	    __extends(FreeRoundsDeclineOfferRequest, _super);
	    function FreeRoundsDeclineOfferRequest(gameCode, offerId) {
	        _super.call(this);
	        if (neo_common_1.Utils.isNullOrUndefined(gameCode)) {
	            throw new Error("Argument \"gameCode\" is required to be specified!");
	        }
	        if (neo_common_1.Utils.isNullOrUndefined(offerId)) {
	            throw new Error("Argument \"offerId\" is required to be specified!");
	        }
	        this.gameCode = gameCode;
	        this.offerId = offerId;
	    }
	    FreeRoundsDeclineOfferRequest.prototype.createResponse = function (responseJson) {
	        return new FreeRoundsDeclineOfferResponse_1.FreeRoundsDeclineOfferResponse(responseJson);
	    };
	    return FreeRoundsDeclineOfferRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.FreeRoundsDeclineOfferRequest = FreeRoundsDeclineOfferRequest;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var FreeRoundsDeclineOfferResponse = (function (_super) {
	    __extends(FreeRoundsDeclineOfferResponse, _super);
	    function FreeRoundsDeclineOfferResponse() {
	        _super.apply(this, arguments);
	    }
	    FreeRoundsDeclineOfferResponse.prototype.internalValidate = function (errors) {
	    };
	    return FreeRoundsDeclineOfferResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.FreeRoundsDeclineOfferResponse = FreeRoundsDeclineOfferResponse;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var ServerTimeResponse_1 = __webpack_require__(85);
	var ServerTimeRequest = (function (_super) {
	    __extends(ServerTimeRequest, _super);
	    function ServerTimeRequest() {
	        _super.apply(this, arguments);
	    }
	    ServerTimeRequest.prototype.createResponse = function (responseJson) {
	        return new ServerTimeResponse_1.ServerTimeResponse(responseJson);
	    };
	    return ServerTimeRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.ServerTimeRequest = ServerTimeRequest;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var ServerTimeResponse = (function (_super) {
	    __extends(ServerTimeResponse, _super);
	    function ServerTimeResponse() {
	        _super.apply(this, arguments);
	    }
	    ServerTimeResponse.prototype.internalValidate = function (errors) {
	    };
	    return ServerTimeResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.ServerTimeResponse = ServerTimeResponse;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var RealityCheckGetInfoResponse_1 = __webpack_require__(87);
	var RealityCheckGetInfoRequest = (function (_super) {
	    __extends(RealityCheckGetInfoRequest, _super);
	    function RealityCheckGetInfoRequest() {
	        _super.apply(this, arguments);
	    }
	    RealityCheckGetInfoRequest.prototype.createResponse = function (responseJson) {
	        return new RealityCheckGetInfoResponse_1.RealityCheckGetInfoResponse(responseJson);
	    };
	    return RealityCheckGetInfoRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.RealityCheckGetInfoRequest = RealityCheckGetInfoRequest;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var RealityCheckGetInfoResponse = (function (_super) {
	    __extends(RealityCheckGetInfoResponse, _super);
	    function RealityCheckGetInfoResponse() {
	        _super.apply(this, arguments);
	    }
	    RealityCheckGetInfoResponse.prototype.internalValidate = function (errors) {
	    };
	    return RealityCheckGetInfoResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.RealityCheckGetInfoResponse = RealityCheckGetInfoResponse;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var ProgressiveBonusGetInfoResponse_1 = __webpack_require__(89);
	var ProgressiveBonusGetInfoRequest = (function (_super) {
	    __extends(ProgressiveBonusGetInfoRequest, _super);
	    function ProgressiveBonusGetInfoRequest(bonusId) {
	        _super.call(this);
	        if (neo_common_1.Utils.isNullOrUndefined(bonusId)) {
	            throw new Error("Argument \"bonusId\" is required to be specified!");
	        }
	        this.bonusId = bonusId;
	    }
	    ProgressiveBonusGetInfoRequest.prototype.createResponse = function (responseJson) {
	        return new ProgressiveBonusGetInfoResponse_1.ProgressiveBonusGetInfoResponse(responseJson);
	    };
	    return ProgressiveBonusGetInfoRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.ProgressiveBonusGetInfoRequest = ProgressiveBonusGetInfoRequest;


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var ProgressiveBonusGetInfoResponse = (function (_super) {
	    __extends(ProgressiveBonusGetInfoResponse, _super);
	    function ProgressiveBonusGetInfoResponse() {
	        _super.apply(this, arguments);
	    }
	    ProgressiveBonusGetInfoResponse.prototype.internalValidate = function (errors) {
	    };
	    return ProgressiveBonusGetInfoResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.ProgressiveBonusGetInfoResponse = ProgressiveBonusGetInfoResponse;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var MaxPowerBonusInitResponse_1 = __webpack_require__(91);
	var MaxPowerBonusInitRequest = (function (_super) {
	    __extends(MaxPowerBonusInitRequest, _super);
	    function MaxPowerBonusInitRequest(ticket) {
	        if (ticket === void 0) { ticket = null; }
	        _super.call(this);
	        if (neo_common_1.Utils.isNullOrUndefined(ticket)) {
	            throw new Error("Argument \"ticket\" is required to be specified!");
	        }
	        this.messageId = this.generateId();
	        this.ticket = ticket;
	    }
	    MaxPowerBonusInitRequest.prototype.generateId = function () {
	        return new Date().getTime();
	    };
	    MaxPowerBonusInitRequest.prototype.createResponse = function (responseJson) {
	        return new MaxPowerBonusInitResponse_1.MaxPowerBonusInitResponse(responseJson);
	    };
	    return MaxPowerBonusInitRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.MaxPowerBonusInitRequest = MaxPowerBonusInitRequest;


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var MaxPowerBonusInitResponse = (function (_super) {
	    __extends(MaxPowerBonusInitResponse, _super);
	    function MaxPowerBonusInitResponse() {
	        _super.apply(this, arguments);
	    }
	    MaxPowerBonusInitResponse.prototype.internalValidate = function (errors) {
	    };
	    return MaxPowerBonusInitResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.MaxPowerBonusInitResponse = MaxPowerBonusInitResponse;


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var MaxPowerBonusSpinResponse_1 = __webpack_require__(93);
	var MaxPowerBonusSpinRequest = (function (_super) {
	    __extends(MaxPowerBonusSpinRequest, _super);
	    function MaxPowerBonusSpinRequest(ticket) {
	        if (ticket === void 0) { ticket = null; }
	        _super.call(this);
	        if (neo_common_1.Utils.isNullOrUndefined(ticket)) {
	            throw new Error("Argument \"ticket\" is required to be specified!");
	        }
	        this.messageId = this.generateId();
	        this.ticket = ticket;
	    }
	    MaxPowerBonusSpinRequest.prototype.generateId = function () {
	        return new Date().getTime();
	    };
	    MaxPowerBonusSpinRequest.prototype.createResponse = function (responseJson) {
	        return new MaxPowerBonusSpinResponse_1.MaxPowerBonusSpinResponse(responseJson);
	    };
	    return MaxPowerBonusSpinRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.MaxPowerBonusSpinRequest = MaxPowerBonusSpinRequest;


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var MaxPowerBonusSpinResponse = (function (_super) {
	    __extends(MaxPowerBonusSpinResponse, _super);
	    function MaxPowerBonusSpinResponse() {
	        _super.apply(this, arguments);
	    }
	    MaxPowerBonusSpinResponse.prototype.internalValidate = function (errors) {
	    };
	    return MaxPowerBonusSpinResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.MaxPowerBonusSpinResponse = MaxPowerBonusSpinResponse;


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Spin';
	var RouletteSpinRequest = (function (_super) {
	    __extends(RouletteSpinRequest, _super);
	    function RouletteSpinRequest(bets, lastChip, customData) {
	        _super.call(this, customData);
	        this.bets = bets;
	        this.lastChip = lastChip;
	    }
	    Object.defineProperty(RouletteSpinRequest, "requestName", {
	        get: function () {
	            return action;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RouletteSpinRequest.prototype.actionName = function () {
	        return action;
	    };
	    RouletteSpinRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return RouletteSpinRequest;
	}(Request_1.Request));
	exports.RouletteSpinRequest = RouletteSpinRequest;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var GameModuleBaseResponse_1 = __webpack_require__(65);
	var GameModules_1 = __webpack_require__(68);
	var GameModuleBonusRespinsResponse = (function (_super) {
	    __extends(GameModuleBonusRespinsResponse, _super);
	    function GameModuleBonusRespinsResponse() {
	        _super.apply(this, arguments);
	    }
	    GameModuleBonusRespinsResponse.prototype.internalValidate = function (errors) {
	    };
	    GameModuleBonusRespinsResponse.prototype.moduleName = function () {
	        return GameModules_1.GameModules.BonusRespins;
	    };
	    return GameModuleBonusRespinsResponse;
	}(GameModuleBaseResponse_1.GameModuleBaseResponse));
	exports.GameModuleBonusRespinsResponse = GameModuleBonusRespinsResponse;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Spin';
	var BonusRespinsSpinRequest = (function (_super) {
	    __extends(BonusRespinsSpinRequest, _super);
	    function BonusRespinsSpinRequest(customData) {
	        _super.call(this, customData);
	    }
	    BonusRespinsSpinRequest.prototype.actionName = function () {
	        return action;
	    };
	    BonusRespinsSpinRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return BonusRespinsSpinRequest;
	}(Request_1.Request));
	exports.BonusRespinsSpinRequest = BonusRespinsSpinRequest;


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var PlayerConfigurationResponse_1 = __webpack_require__(98);
	var PlayerConfigurationRequest = (function (_super) {
	    __extends(PlayerConfigurationRequest, _super);
	    function PlayerConfigurationRequest(data) {
	        _super.call(this);
	        if (neo_common_1.Utils.isNullOrUndefined(data)) {
	            throw new Error("Argument \"data\" is required to be specified!");
	        }
	        for (var key in data) {
	            this[key] = data[key];
	        }
	    }
	    PlayerConfigurationRequest.prototype.createResponse = function (responseJson) {
	        return new PlayerConfigurationResponse_1.PlayerConfigurationResponse(responseJson);
	    };
	    return PlayerConfigurationRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.PlayerConfigurationRequest = PlayerConfigurationRequest;


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var PlayerConfigurationResponse = (function (_super) {
	    __extends(PlayerConfigurationResponse, _super);
	    function PlayerConfigurationResponse() {
	        _super.apply(this, arguments);
	    }
	    PlayerConfigurationResponse.prototype.internalValidate = function (errors) {
	    };
	    return PlayerConfigurationResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.PlayerConfigurationResponse = PlayerConfigurationResponse;


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var PlayerLogErrorResponse_1 = __webpack_require__(100);
	var PlayerLogErrorRequest = (function (_super) {
	    __extends(PlayerLogErrorRequest, _super);
	    function PlayerLogErrorRequest(message, customData) {
	        _super.call(this);
	        if (neo_common_1.Utils.isNullOrUndefined(message)) {
	            throw new Error("Argument \"message\" is required to be specified!");
	        }
	        this.message = message;
	        this.customData = customData;
	    }
	    PlayerLogErrorRequest.prototype.createResponse = function (responseJson) {
	        return new PlayerLogErrorResponse_1.PlayerLogErrorResponse(responseJson);
	    };
	    return PlayerLogErrorRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.PlayerLogErrorRequest = PlayerLogErrorRequest;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var PlayerLogErrorResponse = (function (_super) {
	    __extends(PlayerLogErrorResponse, _super);
	    function PlayerLogErrorResponse() {
	        _super.apply(this, arguments);
	    }
	    PlayerLogErrorResponse.prototype.internalValidate = function (errors) {
	    };
	    return PlayerLogErrorResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.PlayerLogErrorResponse = PlayerLogErrorResponse;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'BuyFeature';
	var BuyFeatureRequest = (function (_super) {
	    __extends(BuyFeatureRequest, _super);
	    function BuyFeatureRequest(bet, originalBet, buyFeatureName, customData) {
	        _super.call(this, customData);
	        this.bet = bet;
	        this.originalBet = originalBet;
	        this.buyFeatureName = buyFeatureName;
	    }
	    Object.defineProperty(BuyFeatureRequest, "requestName", {
	        get: function () {
	            return action;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BuyFeatureRequest.prototype.actionName = function () {
	        return action;
	    };
	    BuyFeatureRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return BuyFeatureRequest;
	}(Request_1.Request));
	exports.BuyFeatureRequest = BuyFeatureRequest;


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var PlayerLogEventsResponse_1 = __webpack_require__(103);
	var PlayerLogEventsRequest = (function (_super) {
	    __extends(PlayerLogEventsRequest, _super);
	    function PlayerLogEventsRequest(data) {
	        _super.call(this);
	        if (neo_common_1.Utils.isNullOrUndefined(data)) {
	            throw new Error("Argument \"data\" is required to be specified!");
	        }
	        this.events = data;
	    }
	    PlayerLogEventsRequest.prototype.createResponse = function (responseJson) {
	        return new PlayerLogEventsResponse_1.PlayerLogEventsResponse(responseJson);
	    };
	    return PlayerLogEventsRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.PlayerLogEventsRequest = PlayerLogEventsRequest;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	var PlayerLogEventsResponse = (function (_super) {
	    __extends(PlayerLogEventsResponse, _super);
	    function PlayerLogEventsResponse() {
	        _super.apply(this, arguments);
	    }
	    PlayerLogEventsResponse.prototype.internalValidate = function (errors) {
	    };
	    return PlayerLogEventsResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.PlayerLogEventsResponse = PlayerLogEventsResponse;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Deal';
	var BlackJackDealRequest = (function (_super) {
	    __extends(BlackJackDealRequest, _super);
	    function BlackJackDealRequest(bets, customData) {
	        _super.call(this, customData);
	        this.bets = bets;
	    }
	    Object.defineProperty(BlackJackDealRequest, "requestName", {
	        get: function () {
	            return action;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BlackJackDealRequest.prototype.actionName = function () {
	        return action;
	    };
	    BlackJackDealRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return BlackJackDealRequest;
	}(Request_1.Request));
	exports.BlackJackDealRequest = BlackJackDealRequest;


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Hit';
	var BlackJackHitRequest = (function (_super) {
	    __extends(BlackJackHitRequest, _super);
	    function BlackJackHitRequest(hand, customData) {
	        _super.call(this, customData);
	        this.hand = hand;
	    }
	    Object.defineProperty(BlackJackHitRequest, "requestName", {
	        get: function () {
	            return action;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BlackJackHitRequest.prototype.actionName = function () {
	        return action;
	    };
	    BlackJackHitRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return BlackJackHitRequest;
	}(Request_1.Request));
	exports.BlackJackHitRequest = BlackJackHitRequest;


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var Request_1 = __webpack_require__(47);
	var GameResponse_1 = __webpack_require__(49);
	var action = 'Stand';
	var BlackJackStandRequest = (function (_super) {
	    __extends(BlackJackStandRequest, _super);
	    function BlackJackStandRequest(hand, customData) {
	        _super.call(this, customData);
	        this.hand = hand;
	    }
	    Object.defineProperty(BlackJackStandRequest, "requestName", {
	        get: function () {
	            return action;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BlackJackStandRequest.prototype.actionName = function () {
	        return action;
	    };
	    BlackJackStandRequest.prototype.createResponse = function (responseJson) {
	        return new GameResponse_1.GameResponse(responseJson);
	    };
	    return BlackJackStandRequest;
	}(Request_1.Request));
	exports.BlackJackStandRequest = BlackJackStandRequest;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var GameModuleResponse_1 = __webpack_require__(66);
	var GameModuleBlackJackResponse = (function (_super) {
	    __extends(GameModuleBlackJackResponse, _super);
	    function GameModuleBlackJackResponse() {
	        _super.apply(this, arguments);
	    }
	    GameModuleBlackJackResponse.prototype.internalValidate = function (errors) {
	    };
	    GameModuleBlackJackResponse.prototype.moduleName = function () {
	        return 'base';
	    };
	    return GameModuleBlackJackResponse;
	}(GameModuleResponse_1.GameModuleResponse));
	exports.GameModuleBlackJackResponse = GameModuleBlackJackResponse;


/***/ },
/* 108 */
/***/ function(module, exports) {

	"use strict";
	(function (BetType) {
	    BetType[BetType["Payline"] = 'payline'] = "Payline";
	    BetType[BetType["Total"] = 'total'] = "Total";
	})(exports.BetType || (exports.BetType = {}));
	var BetType = exports.BetType;


/***/ },
/* 109 */
/***/ function(module, exports) {

	"use strict";
	(function (Color) {
	    Color[Color["Black"] = 'black'] = "Black";
	    Color[Color["Red"] = 'red'] = "Red";
	})(exports.Color || (exports.Color = {}));
	var Color = exports.Color;


/***/ },
/* 110 */
/***/ function(module, exports) {

	"use strict";
	(function (GameModuleStatus) {
	    GameModuleStatus[GameModuleStatus["Disabled"] = 'disabled'] = "Disabled";
	    GameModuleStatus[GameModuleStatus["Enabled"] = 'enabled'] = "Enabled";
	    GameModuleStatus[GameModuleStatus["Active"] = 'active'] = "Active";
	})(exports.GameModuleStatus || (exports.GameModuleStatus = {}));
	var GameModuleStatus = exports.GameModuleStatus;


/***/ },
/* 111 */
/***/ function(module, exports) {

	"use strict";
	(function (GameStatus) {
	    GameStatus[GameStatus["Active"] = 'active'] = "Active";
	    GameStatus[GameStatus["Closed"] = 'closed'] = "Closed";
	})(exports.GameStatus || (exports.GameStatus = {}));
	var GameStatus = exports.GameStatus;


/***/ },
/* 112 */
/***/ function(module, exports) {

	"use strict";
	(function (LimitType) {
	    LimitType[LimitType["Count"] = 'count'] = "Count";
	    LimitType[LimitType["Amount"] = 'amount'] = "Amount";
	})(exports.LimitType || (exports.LimitType = {}));
	var LimitType = exports.LimitType;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var BetType_1 = __webpack_require__(108);
	var SpinBet = (function () {
	    function SpinBet(betType, coinSize, coinCount, paylineCount, totalBet) {
	        this.betType = betType || (typeof coinSize === 'number' ? BetType_1.BetType.Payline : BetType_1.BetType.Total);
	        this.coinSize = coinSize;
	        this.coinCount = coinCount;
	        this.paylineCount = paylineCount;
	        this.totalBet = totalBet;
	        if (this.betType === BetType_1.BetType.Payline) {
	            neo_common_1.ArgValidator.ensureIsNumber(coinSize, 'coinSize');
	            neo_common_1.ArgValidator.ensureIsNumber(coinCount, 'coinCount');
	            neo_common_1.ArgValidator.ensureIsNumber(paylineCount, 'paylineCount');
	        }
	        else {
	            if (coinSize != null && coinCount != null) {
	                neo_common_1.ArgValidator.ensureIsNumber(coinSize, 'coinSize');
	                neo_common_1.ArgValidator.ensureIsNumber(coinCount, 'coinCount');
	            }
	            else {
	                neo_common_1.ArgValidator.ensureIsNumber(totalBet, 'totalBet');
	            }
	        }
	    }
	    return SpinBet;
	}());
	exports.SpinBet = SpinBet;


/***/ },
/* 114 */
/***/ function(module, exports) {

	"use strict";
	(function (Suit) {
	    Suit[Suit["Clubs"] = 'clubs'] = "Clubs";
	    Suit[Suit["Diamonds"] = 'diamonds'] = "Diamonds";
	    Suit[Suit["Hearts"] = 'hearts'] = "Hearts";
	    Suit[Suit["Spades"] = 'spades'] = "Spades";
	})(exports.Suit || (exports.Suit = {}));
	var Suit = exports.Suit;


/***/ },
/* 115 */
/***/ function(module, exports) {

	"use strict";
	(function (WinDirection) {
	    WinDirection[WinDirection["Right"] = 'right'] = "Right";
	    WinDirection[WinDirection["Left"] = 'left'] = "Left";
	})(exports.WinDirection || (exports.WinDirection = {}));
	var WinDirection = exports.WinDirection;


/***/ },
/* 116 */
/***/ function(module, exports) {

	"use strict";
	(function (WinTrigger) {
	    WinTrigger[WinTrigger["Payline"] = 'payline'] = "Payline";
	    WinTrigger[WinTrigger["Scatter"] = 'scatter'] = "Scatter";
	    WinTrigger[WinTrigger["Custom"] = 'custom'] = "Custom";
	    WinTrigger[WinTrigger["Way"] = 'way'] = "Way";
	})(exports.WinTrigger || (exports.WinTrigger = {}));
	var WinTrigger = exports.WinTrigger;


/***/ },
/* 117 */
/***/ function(module, exports) {

	"use strict";
	(function (WinType) {
	    WinType[WinType["Cash"] = 'cash'] = "Cash";
	    WinType[WinType["Module"] = 'module'] = "Module";
	    WinType[WinType["Jackpot"] = 'jackpot'] = "Jackpot";
	    WinType[WinType["Custom"] = 'custom'] = "Custom";
	    WinType[WinType["freeSpins"] = 'freeSpins'] = "freeSpins";
	    WinType[WinType["Feature"] = 'feature'] = "Feature";
	})(exports.WinType || (exports.WinType = {}));
	var WinType = exports.WinType;


/***/ },
/* 118 */
/***/ function(module, exports) {

	"use strict";
	(function (PickRoundSpotValueType) {
	    PickRoundSpotValueType[PickRoundSpotValueType["Cash"] = 'cash'] = "Cash";
	    PickRoundSpotValueType[PickRoundSpotValueType["Count"] = 'count'] = "Count";
	    PickRoundSpotValueType[PickRoundSpotValueType["Multiplier"] = 'multiplier'] = "Multiplier";
	})(exports.PickRoundSpotValueType || (exports.PickRoundSpotValueType = {}));
	var PickRoundSpotValueType = exports.PickRoundSpotValueType;


/***/ },
/* 119 */
/***/ function(module, exports) {

	"use strict";
	(function (PickRoundSpotStatus) {
	    PickRoundSpotStatus[PickRoundSpotStatus["Disabled"] = 'disabled'] = "Disabled";
	    PickRoundSpotStatus[PickRoundSpotStatus["Enabled"] = 'enabled'] = "Enabled";
	    PickRoundSpotStatus[PickRoundSpotStatus["Selected"] = 'selected'] = "Selected";
	    PickRoundSpotStatus[PickRoundSpotStatus["Revealed"] = 'revealed'] = "Revealed";
	    PickRoundSpotStatus[PickRoundSpotStatus["Shown"] = 'shown'] = "Shown";
	})(exports.PickRoundSpotStatus || (exports.PickRoundSpotStatus = {}));
	var PickRoundSpotStatus = exports.PickRoundSpotStatus;


/***/ },
/* 120 */
/***/ function(module, exports) {

	"use strict";
	var RouletteSpinBet = (function () {
	    function RouletteSpinBet(type, selection, value) {
	        this.type = type;
	        this.selection = selection;
	        this.value = value;
	    }
	    return RouletteSpinBet;
	}());
	exports.RouletteSpinBet = RouletteSpinBet;


/***/ },
/* 121 */
/***/ function(module, exports) {

	"use strict";
	var BlackJackDealBet = (function () {
	    function BlackJackDealBet(hand, value) {
	        this.hand = hand;
	        this.value = value;
	    }
	    return BlackJackDealBet;
	}());
	exports.BlackJackDealBet = BlackJackDealBet;


/***/ },
/* 122 */
/***/ function(module, exports) {

	"use strict";
	(function (TableGameHandStatus) {
	    TableGameHandStatus[TableGameHandStatus["Disabled"] = 'disabled'] = "Disabled";
	    TableGameHandStatus[TableGameHandStatus["Enabled"] = 'enabled'] = "Enabled";
	    TableGameHandStatus[TableGameHandStatus["Active"] = 'active'] = "Active";
	    TableGameHandStatus[TableGameHandStatus["Finnished"] = 'finnished'] = "Finnished";
	})(exports.TableGameHandStatus || (exports.TableGameHandStatus = {}));
	var TableGameHandStatus = exports.TableGameHandStatus;


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var LaunchClient_1 = __webpack_require__(124);
	exports.LaunchClient = LaunchClient_1.LaunchClient;
	var LaunchClientOptions_1 = __webpack_require__(129);
	exports.LaunchClientOptions = LaunchClientOptions_1.LaunchClientOptions;


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var lodash_1 = __webpack_require__(125);
	var neo_common_1 = __webpack_require__(1);
	var LaunchClientOptions_1 = __webpack_require__(129);
	var LaunchClientRequest_1 = __webpack_require__(130);
	var LaunchClientResponse_1 = __webpack_require__(131);
	var serviceUrlPath = 'LaunchService';
	var gameHtmlUrl = 'index.html';
	var defaultError = {
	    errorId: '',
	    code: 0,
	    message: 'Unable to launch game!'
	};
	var LaunchClient = (function (_super) {
	    __extends(LaunchClient, _super);
	    function LaunchClient(gameKey) {
	        _super.call(this, gameKey, new neo_common_1.ApiClientCommunication.ApiClientOptions('dummy', null, false, 0));
	        this._initialized = false;
	        this.onHandleError = this.onHandleError.bind(this);
	        this.onErrorResponse = this.onHandleError;
	        this._errorAsWarning = false;
	    }
	    Object.defineProperty(LaunchClient.prototype, "gameUrl", {
	        get: function () {
	            return this._gameUrl;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(LaunchClient.prototype, "errorAsWarning", {
	        get: function () {
	            return this._errorAsWarning;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    LaunchClient.prototype.sendKeepAliveRequest = function () {
	        throw new Error('Not supported!');
	    };
	    LaunchClient.prototype.onHandleError = function (error) {
	        this._responseError = neo_common_1.Utils.isNullOrUndefined(error)
	            ? new neo_common_1.ApiClientCommunication.Types.ApiClientError(0, null, defaultError)
	            : error;
	    };
	    LaunchClient.prototype.initialize = function (options) {
	        this._initialized = false;
	        this._responseError = null;
	        options = neo_common_1.Utils.isNullOrUndefined(options) ? LaunchClientOptions_1.LaunchClientOptions.get() : options;
	        if (neo_common_1.Utils.isNullOrUndefined(options) || neo_common_1.Utils.isNullOrUndefined(options.launchServiceParams) ||
	            lodash_1.keys(options.launchServiceParams).length === 0) {
	            this._responseError = new neo_common_1.ApiClientCommunication.Types.ApiClientError(0, null, defaultError);
	        }
	        else {
	            var apiClientOptions = new neo_common_1.ApiClientCommunication.ApiClientOptions(options.gameServer, null, false, 0);
	            this.setOptions(apiClientOptions);
	            this._launchServiceParams = options.launchServiceParams;
	            this._initialized = true;
	        }
	        if (!neo_common_1.Utils.isNullOrUndefined(this._responseError)) {
	            return Promise.resolve(this._responseError);
	        }
	        var self = this;
	        var request = new LaunchClientRequest_1.LaunchClientRequest(this._launchServiceParams);
	        return this.sendRequest(request, 'GET', serviceUrlPath)
	            .then(function (response) {
	            if (!neo_common_1.Utils.isNullOrUndefined(response)) {
	                var queryString = response.data;
	                var fragment = response.fragment;
	                if (response.action !== LaunchClientResponse_1.LaunchAction.Allow) {
	                    self._responseError = new neo_common_1.ApiClientCommunication.Types.ApiClientError(0, null, {
	                        code: 0,
	                        errorId: '',
	                        message: response.message || defaultError.message
	                    });
	                }
	                if ((neo_common_1.StringUtils.isNullOrEmpty(fragment) || neo_common_1.Utils.isNullOrUndefined(queryString)) &&
	                    neo_common_1.Utils.isNullOrUndefined(self._responseError)) {
	                    self._responseError = new neo_common_1.ApiClientCommunication.Types.ApiClientError(0, null, defaultError);
	                }
	                self._errorAsWarning = response.action === LaunchClientResponse_1.LaunchAction.Warning;
	                if (neo_common_1.Utils.isNullOrUndefined(self._responseError) || self._errorAsWarning) {
	                    var uri = URI();
	                    self._gameUrl = uri.filename(gameHtmlUrl).query(queryString).fragment(fragment).toString();
	                    self._initialized = true;
	                }
	            }
	            return null;
	        })
	            .then(function () {
	            return self._responseError;
	        });
	    };
	    LaunchClient.prototype.redirectToGame = function () {
	        var self = this;
	        return this.initialize()
	            .then(function (error) {
	            if (neo_common_1.Utils.isNullOrUndefined(error)) {
	                if (!neo_common_1.StringUtils.isNullOrEmpty(self._gameUrl)) {
	                    if (false) {
	                        neo_common_1.Logger.debugGroup('LaunchClient', 'redirectToGame, redirects to url: ' + self._gameUrl);
	                    }
	                    location.href = self._gameUrl;
	                }
	            }
	            return error;
	        });
	    };
	    return LaunchClient;
	}(neo_common_1.ApiClientCommunication.ApiClient));
	exports.LaunchClient = LaunchClient;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global, setImmediate) {/**
	 * @license
	 * Lo-Dash 1.0.2 (Custom Build) <http://lodash.com/>
	 * Build: `lodash -o ./dist/lodash.compat.js`
	 * Copyright 2012-2013 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.4.4 <http://underscorejs.org/>
	 * Copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
	 * Available under MIT license <http://lodash.com/license>
	 */
	;(function(window, undefined) {
	
	  /** Detect free variable `exports` */
	  var freeExports = typeof exports == 'object' && exports;
	
	  /** Detect free variable `module` */
	  var freeModule = typeof module == 'object' && module && module.exports == freeExports && module;
	
	  /** Detect free variable `global` and use it as `window` */
	  var freeGlobal = typeof global == 'object' && global;
	  if (freeGlobal.global === freeGlobal) {
	    window = freeGlobal;
	  }
	
	  /** Used for array and object method references */
	  var arrayRef = [],
	      objectRef = {};
	
	  /** Used to generate unique IDs */
	  var idCounter = 0;
	
	  /** Used internally to indicate various things */
	  var indicatorObject = objectRef;
	
	  /** Used by `cachedContains` as the default size when optimizations are enabled for large arrays */
	  var largeArraySize = 30;
	
	  /** Used to restore the original `_` reference in `noConflict` */
	  var oldDash = window._;
	
	  /** Used to match HTML entities */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g;
	
	  /** Used to match empty string literals in compiled template source */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match regexp flags from their coerced string values */
	  var reFlags = /\w*$/;
	
	  /** Used to detect if a method is native */
	  var reNative = RegExp('^' +
	    (objectRef.valueOf + '')
	      .replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
	      .replace(/valueOf|for [^\]]+/g, '.+?') + '$'
	  );
	
	  /**
	   * Used to match ES6 template delimiters
	   * http://people.mozilla.org/~jorendorff/es6-draft.html#sec-7.8.6
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match "interpolate" template delimiters */
	  var reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to ensure capturing order of template delimiters */
	  var reNoMatch = /($^)/;
	
	  /** Used to match HTML characters */
	  var reUnescapedHtml = /[&<>"']/g;
	
	  /** Used to match unescaped characters in compiled string literals */
	  var reUnescapedString = /['\n\r\t\u2028\u2029\\]/g;
	
	  /** Used to fix the JScript [[DontEnum]] bug */
	  var shadowed = [
	    'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable',
	    'toLocaleString', 'toString', 'valueOf'
	  ];
	
	  /** Used to make template sourceURLs easier to identify */
	  var templateCounter = 0;
	
	  /** Native method shortcuts */
	  var ceil = Math.ceil,
	      concat = arrayRef.concat,
	      floor = Math.floor,
	      getPrototypeOf = reNative.test(getPrototypeOf = Object.getPrototypeOf) && getPrototypeOf,
	      hasOwnProperty = objectRef.hasOwnProperty,
	      push = arrayRef.push,
	      toString = objectRef.toString;
	
	  /* Native method shortcuts for methods with the same name as other `lodash` methods */
	  var nativeBind = reNative.test(nativeBind = slice.bind) && nativeBind,
	      nativeIsArray = reNative.test(nativeIsArray = Array.isArray) && nativeIsArray,
	      nativeIsFinite = window.isFinite,
	      nativeIsNaN = window.isNaN,
	      nativeKeys = reNative.test(nativeKeys = Object.keys) && nativeKeys,
	      nativeMax = Math.max,
	      nativeMin = Math.min,
	      nativeRandom = Math.random;
	
	  /** `Object#toString` result shortcuts */
	  var argsClass = '[object Arguments]',
	      arrayClass = '[object Array]',
	      boolClass = '[object Boolean]',
	      dateClass = '[object Date]',
	      funcClass = '[object Function]',
	      numberClass = '[object Number]',
	      objectClass = '[object Object]',
	      regexpClass = '[object RegExp]',
	      stringClass = '[object String]';
	
	  /** Detect various environments */
	  var isIeOpera = !!window.attachEvent,
	      isV8 = nativeBind && !/\n|true/.test(nativeBind + isIeOpera);
	
	  /* Detect if `Function#bind` exists and is inferred to be fast (all but V8) */
	  var isBindFast = nativeBind && !isV8;
	
	  /* Detect if `Object.keys` exists and is inferred to be fast (IE, Opera, V8) */
	  var isKeysFast = nativeKeys && (isIeOpera || isV8);
	
	  /**
	   * Detect the JScript [[DontEnum]] bug:
	   *
	   * In IE < 9 an objects own properties, shadowing non-enumerable ones, are
	   * made non-enumerable as well.
	   */
	  var hasDontEnumBug;
	
	  /**
	   * Detect if a `prototype` properties are enumerable by default:
	   *
	   * Firefox < 3.6, Opera > 9.50 - Opera < 11.60, and Safari < 5.1
	   * (if the prototype or a property on the prototype has been set)
	   * incorrectly sets a function's `prototype` property [[Enumerable]]
	   * value to `true`.
	   */
	  var hasEnumPrototype;
	
	  /** Detect if own properties are iterated after inherited properties (IE < 9) */
	  var iteratesOwnLast;
	
	  /**
	   * Detect if `Array#shift` and `Array#splice` augment array-like objects
	   * incorrectly:
	   *
	   * Firefox < 10, IE compatibility mode, and IE < 9 have buggy Array `shift()`
	   * and `splice()` functions that fail to remove the last element, `value[0]`,
	   * of array-like objects even though the `length` property is set to `0`.
	   * The `shift()` method is buggy in IE 8 compatibility mode, while `splice()`
	   * is buggy regardless of mode in IE < 9 and buggy in compatibility mode in IE 9.
	   */
	  var hasObjectSpliceBug = (hasObjectSpliceBug = { '0': 1, 'length': 1 },
	    arrayRef.splice.call(hasObjectSpliceBug, 0, 1), hasObjectSpliceBug[0]);
	
	  /** Detect if `arguments` object indexes are non-enumerable (Firefox < 4, IE < 9, PhantomJS, Safari < 5.1) */
	  var nonEnumArgs = true;
	
	  (function() {
	    var props = [];
	    function ctor() { this.x = 1; }
	    ctor.prototype = { 'valueOf': 1, 'y': 1 };
	    for (var prop in new ctor) { props.push(prop); }
	    for (prop in arguments) { nonEnumArgs = !prop; }
	
	    hasDontEnumBug = !/valueOf/.test(props);
	    hasEnumPrototype = ctor.propertyIsEnumerable('prototype');
	    iteratesOwnLast = props[0] != 'x';
	  }(1));
	
	  /** Detect if `arguments` objects are `Object` objects (all but Opera < 10.5) */
	  var argsAreObjects = arguments.constructor == Object;
	
	  /** Detect if `arguments` objects [[Class]] is unresolvable (Firefox < 4, IE < 9) */
	  var noArgsClass = !isArguments(arguments);
	
	  /**
	   * Detect lack of support for accessing string characters by index:
	   *
	   * IE < 8 can't access characters by index and IE 8 can only access
	   * characters by index on string literals.
	   */
	  var noCharByIndex = ('x'[0] + Object('x')[0]) != 'xx';
	
	  /**
	   * Detect if a DOM node's [[Class]] is unresolvable (IE < 9)
	   * and that the JS engine won't error when attempting to coerce an object to
	   * a string without a `toString` function.
	   */
	  try {
	    var noNodeClass = toString.call(document) == objectClass && !({ 'toString': 0 } + '');
	  } catch(e) { }
	
	  /** Used to identify object classifications that `_.clone` supports */
	  var cloneableClasses = {};
	  cloneableClasses[funcClass] = false;
	  cloneableClasses[argsClass] = cloneableClasses[arrayClass] =
	  cloneableClasses[boolClass] = cloneableClasses[dateClass] =
	  cloneableClasses[numberClass] = cloneableClasses[objectClass] =
	  cloneableClasses[regexpClass] = cloneableClasses[stringClass] = true;
	
	  /** Used to lookup a built-in constructor by [[Class]] */
	  var ctorByClass = {};
	  ctorByClass[arrayClass] = Array;
	  ctorByClass[boolClass] = Boolean;
	  ctorByClass[dateClass] = Date;
	  ctorByClass[objectClass] = Object;
	  ctorByClass[numberClass] = Number;
	  ctorByClass[regexpClass] = RegExp;
	  ctorByClass[stringClass] = String;
	
	  /** Used to determine if values are of the language type Object */
	  var objectTypes = {
	    'boolean': false,
	    'function': true,
	    'object': true,
	    'number': false,
	    'string': false,
	    'undefined': false
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\t': 't',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates a `lodash` object, that wraps the given `value`, to enable method
	   * chaining.
	   *
	   * In addition to Lo-Dash methods, wrappers also have the following `Array` methods:
	   * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`, `splice`,
	   * and `unshift`
	   *
	   * The chainable wrapper functions are:
	   * `after`, `assign`, `bind`, `bindAll`, `bindKey`, `chain`, `compact`, `compose`,
	   * `concat`, `countBy`, `debounce`, `defaults`, `defer`, `delay`, `difference`,
	   * `filter`, `flatten`, `forEach`, `forIn`, `forOwn`, `functions`, `groupBy`,
	   * `initial`, `intersection`, `invert`, `invoke`, `keys`, `map`, `max`, `memoize`,
	   * `merge`, `min`, `object`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
	   * `pick`, `pluck`, `push`, `range`, `reject`, `rest`, `reverse`, `shuffle`,
	   * `slice`, `sort`, `sortBy`, `splice`, `tap`, `throttle`, `times`, `toArray`,
	   * `union`, `uniq`, `unshift`, `values`, `where`, `without`, `wrap`, and `zip`
	   *
	   * The non-chainable wrapper functions are:
	   * `clone`, `cloneDeep`, `contains`, `escape`, `every`, `find`, `has`, `identity`,
	   * `indexOf`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`, `isEmpty`,
	   * `isEqual`, `isFinite`, `isFunction`, `isNaN`, `isNull`, `isNumber`, `isObject`,
	   * `isPlainObject`, `isRegExp`, `isString`, `isUndefined`, `join`, `lastIndexOf`,
	   * `mixin`, `noConflict`, `pop`, `random`, `reduce`, `reduceRight`, `result`,
	   * `shift`, `size`, `some`, `sortedIndex`, `template`, `unescape`, and `uniqueId`
	   *
	   * The wrapper functions `first` and `last` return wrapped values when `n` is
	   * passed, otherwise they return unwrapped values.
	   *
	   * @name _
	   * @constructor
	   * @category Chaining
	   * @param {Mixed} value The value to wrap in a `lodash` instance.
	   * @returns {Object} Returns a `lodash` instance.
	   */
	  function lodash(value) {
	    // exit early if already wrapped, even if wrapped by a different `lodash` constructor
	    if (value && typeof value == 'object' && value.__wrapped__) {
	      return value;
	    }
	    // allow invoking `lodash` without the `new` operator
	    if (!(this instanceof lodash)) {
	      return new lodash(value);
	    }
	    this.__wrapped__ = value;
	  }
	
	  /**
	   * By default, the template delimiters used by Lo-Dash are similar to those in
	   * embedded Ruby (ERB). Change the following template settings to use alternative
	   * delimiters.
	   *
	   * @static
	   * @memberOf _
	   * @type Object
	   */
	  lodash.templateSettings = {
	
	    /**
	     * Used to detect `data` property values to be HTML-escaped.
	     *
	     * @memberOf _.templateSettings
	     * @type RegExp
	     */
	    'escape': /<%-([\s\S]+?)%>/g,
	
	    /**
	     * Used to detect code to be evaluated.
	     *
	     * @memberOf _.templateSettings
	     * @type RegExp
	     */
	    'evaluate': /<%([\s\S]+?)%>/g,
	
	    /**
	     * Used to detect `data` property values to inject.
	     *
	     * @memberOf _.templateSettings
	     * @type RegExp
	     */
	    'interpolate': reInterpolate,
	
	    /**
	     * Used to reference the data object in the template text.
	     *
	     * @memberOf _.templateSettings
	     * @type String
	     */
	    'variable': '',
	
	    /**
	     * Used to import variables into the compiled template.
	     *
	     * @memberOf _.templateSettings
	     * @type Object
	     */
	    'imports': {
	
	      /**
	       * A reference to the `lodash` function.
	       *
	       * @memberOf _.templateSettings.imports
	       * @type Function
	       */
	      '_': lodash
	    }
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The template used to create iterator functions.
	   *
	   * @private
	   * @param {Obect} data The data object used to populate the text.
	   * @returns {String} Returns the interpolated text.
	   */
	  var iteratorTemplate = function(obj) {
	    
	    var __p = 'var index, iterable = ' +
	    (obj.firstArg ) +
	    ', result = iterable;\nif (!iterable) return result;\n' +
	    (obj.top ) +
	    ';\n';
	     if (obj.arrays) {
	    __p += 'var length = iterable.length; index = -1;\nif (' +
	    (obj.arrays ) +
	    ') {  ';
	     if (obj.noCharByIndex) {
	    __p += '\n  if (isString(iterable)) {\n    iterable = iterable.split(\'\')\n  }  ';
	     } ;
	    __p += '\n  while (++index < length) {\n    ' +
	    (obj.loop ) +
	    '\n  }\n}\nelse {  ';
	      } else if (obj.nonEnumArgs) {
	    __p += '\n  var length = iterable.length; index = -1;\n  if (length && isArguments(iterable)) {\n    while (++index < length) {\n      index += \'\';\n      ' +
	    (obj.loop ) +
	    '\n    }\n  } else {  ';
	     } ;
	    
	     if (obj.hasEnumPrototype) {
	    __p += '\n  var skipProto = typeof iterable == \'function\';\n  ';
	     } ;
	    
	     if (obj.isKeysFast && obj.useHas) {
	    __p += '\n  var ownIndex = -1,\n      ownProps = objectTypes[typeof iterable] ? nativeKeys(iterable) : [],\n      length = ownProps.length;\n\n  while (++ownIndex < length) {\n    index = ownProps[ownIndex];\n    ';
	     if (obj.hasEnumPrototype) {
	    __p += 'if (!(skipProto && index == \'prototype\')) {\n  ';
	     } ;
	    __p += 
	    (obj.loop ) +
	    '';
	     if (obj.hasEnumPrototype) {
	    __p += '}\n';
	     } ;
	    __p += '  }  ';
	     } else {
	    __p += '\n  for (index in iterable) {';
	        if (obj.hasEnumPrototype || obj.useHas) {
	    __p += '\n    if (';
	          if (obj.hasEnumPrototype) {
	    __p += '!(skipProto && index == \'prototype\')';
	     }      if (obj.hasEnumPrototype && obj.useHas) {
	    __p += ' && ';
	     }      if (obj.useHas) {
	    __p += 'hasOwnProperty.call(iterable, index)';
	     }    ;
	    __p += ') {    ';
	     } ;
	    __p += 
	    (obj.loop ) +
	    ';    ';
	     if (obj.hasEnumPrototype || obj.useHas) {
	    __p += '\n    }';
	     } ;
	    __p += '\n  }  ';
	     } ;
	    
	     if (obj.hasDontEnumBug) {
	    __p += '\n\n  var ctor = iterable.constructor;\n    ';
	     for (var k = 0; k < 7; k++) {
	    __p += '\n  index = \'' +
	    (obj.shadowed[k] ) +
	    '\';\n  if (';
	          if (obj.shadowed[k] == 'constructor') {
	    __p += '!(ctor && ctor.prototype === iterable) && ';
	          } ;
	    __p += 'hasOwnProperty.call(iterable, index)) {\n    ' +
	    (obj.loop ) +
	    '\n  }    ';
	     } ;
	    
	     } ;
	    
	     if (obj.arrays || obj.nonEnumArgs) {
	    __p += '\n}';
	     } ;
	    __p += 
	    (obj.bottom ) +
	    ';\nreturn result';
	    
	    
	    return __p
	  };
	
	  /** Reusable iterator options for `assign` and `defaults` */
	  var defaultsIteratorOptions = {
	    'args': 'object, source, guard',
	    'top':
	      'var args = arguments,\n' +
	      '    argsIndex = 0,\n' +
	      "    argsLength = typeof guard == 'number' ? 2 : args.length;\n" +
	      'while (++argsIndex < argsLength) {\n' +
	      '  iterable = args[argsIndex];\n' +
	      '  if (iterable && objectTypes[typeof iterable]) {',
	    'loop': "if (typeof result[index] == 'undefined') result[index] = iterable[index]",
	    'bottom': '  }\n}'
	  };
	
	  /** Reusable iterator options shared by `each`, `forIn`, and `forOwn` */
	  var eachIteratorOptions = {
	    'args': 'collection, callback, thisArg',
	    'top': "callback = callback && typeof thisArg == 'undefined' ? callback : createCallback(callback, thisArg)",
	    'arrays': "typeof length == 'number'",
	    'loop': 'if (callback(iterable[index], index, collection) === false) return result'
	  };
	
	  /** Reusable iterator options for `forIn` and `forOwn` */
	  var forOwnIteratorOptions = {
	    'top': 'if (!objectTypes[typeof iterable]) return result;\n' + eachIteratorOptions.top,
	    'arrays': false
	  };
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates a function optimized to search large arrays for a given `value`,
	   * starting at `fromIndex`, using strict equality for comparisons, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to search.
	   * @param {Mixed} value The value to search for.
	   * @param {Number} [fromIndex=0] The index to search from.
	   * @param {Number} [largeSize=30] The length at which an array is considered large.
	   * @returns {Boolean} Returns `true`, if `value` is found, else `false`.
	   */
	  function cachedContains(array, fromIndex, largeSize) {
	    fromIndex || (fromIndex = 0);
	
	    var length = array.length,
	        isLarge = (length - fromIndex) >= (largeSize || largeArraySize);
	
	    if (isLarge) {
	      var cache = {},
	          index = fromIndex - 1;
	
	      while (++index < length) {
	        // manually coerce `value` to a string because `hasOwnProperty`, in some
	        // older versions of Firefox, coerces objects incorrectly
	        var key = array[index] + '';
	        (hasOwnProperty.call(cache, key) ? cache[key] : (cache[key] = [])).push(array[index]);
	      }
	    }
	    return function(value) {
	      if (isLarge) {
	        var key = value + '';
	        return hasOwnProperty.call(cache, key) && indexOf(cache[key], value) > -1;
	      }
	      return indexOf(array, value, fromIndex) > -1;
	    }
	  }
	
	  /**
	   * Used by `_.max` and `_.min` as the default `callback` when a given
	   * `collection` is a string value.
	   *
	   * @private
	   * @param {String} value The character to inspect.
	   * @returns {Number} Returns the code unit of given character.
	   */
	  function charAtCallback(value) {
	    return value.charCodeAt(0);
	  }
	
	  /**
	   * Used by `sortBy` to compare transformed `collection` values, stable sorting
	   * them in ascending order.
	   *
	   * @private
	   * @param {Object} a The object to compare to `b`.
	   * @param {Object} b The object to compare to `a`.
	   * @returns {Number} Returns the sort order indicator of `1` or `-1`.
	   */
	  function compareAscending(a, b) {
	    var ai = a.index,
	        bi = b.index;
	
	    a = a.criteria;
	    b = b.criteria;
	
	    // ensure a stable sort in V8 and other engines
	    // http://code.google.com/p/v8/issues/detail?id=90
	    if (a !== b) {
	      if (a > b || typeof a == 'undefined') {
	        return 1;
	      }
	      if (a < b || typeof b == 'undefined') {
	        return -1;
	      }
	    }
	    return ai < bi ? -1 : 1;
	  }
	
	  /**
	   * Creates a function that, when called, invokes `func` with the `this` binding
	   * of `thisArg` and prepends any `partialArgs` to the arguments passed to the
	   * bound function.
	   *
	   * @private
	   * @param {Function|String} func The function to bind or the method name.
	   * @param {Mixed} [thisArg] The `this` binding of `func`.
	   * @param {Array} partialArgs An array of arguments to be partially applied.
	   * @param {Object} [rightIndicator] Used to indicate partially applying arguments from the right.
	   * @returns {Function} Returns the new bound function.
	   */
	  function createBound(func, thisArg, partialArgs, rightIndicator) {
	    var isFunc = isFunction(func),
	        isPartial = !partialArgs,
	        key = thisArg;
	
	    // juggle arguments
	    if (isPartial) {
	      partialArgs = thisArg;
	    }
	    if (!isFunc) {
	      thisArg = func;
	    }
	
	    function bound() {
	      // `Function#bind` spec
	      // http://es5.github.com/#x15.3.4.5
	      var args = arguments,
	          thisBinding = isPartial ? this : thisArg;
	
	      if (!isFunc) {
	        func = thisArg[key];
	      }
	      if (partialArgs.length) {
	        args = args.length
	          ? (args = slice(args), rightIndicator ? args.concat(partialArgs) : partialArgs.concat(args))
	          : partialArgs;
	      }
	      if (this instanceof bound) {
	        // ensure `new bound` is an instance of `bound` and `func`
	        noop.prototype = func.prototype;
	        thisBinding = new noop;
	        noop.prototype = null;
	
	        // mimic the constructor's `return` behavior
	        // http://es5.github.com/#x13.2.2
	        var result = func.apply(thisBinding, args);
	        return isObject(result) ? result : thisBinding;
	      }
	      return func.apply(thisBinding, args);
	    }
	    return bound;
	  }
	
	  /**
	   * Produces a callback bound to an optional `thisArg`. If `func` is a property
	   * name, the created callback will return the property value for a given element.
	   * If `func` is an object, the created callback will return `true` for elements
	   * that contain the equivalent object properties, otherwise it will return `false`.
	   *
	   * @private
	   * @param {Mixed} [func=identity] The value to convert to a callback.
	   * @param {Mixed} [thisArg] The `this` binding of the created callback.
	   * @param {Number} [argCount=3] The number of arguments the callback accepts.
	   * @returns {Function} Returns a callback function.
	   */
	  function createCallback(func, thisArg, argCount) {
	    if (func == null) {
	      return identity;
	    }
	    var type = typeof func;
	    if (type != 'function') {
	      if (type != 'object') {
	        return function(object) {
	          return object[func];
	        };
	      }
	      var props = keys(func);
	      return function(object) {
	        var length = props.length,
	            result = false;
	        while (length--) {
	          if (!(result = isEqual(object[props[length]], func[props[length]], indicatorObject))) {
	            break;
	          }
	        }
	        return result;
	      };
	    }
	    if (typeof thisArg != 'undefined') {
	      if (argCount === 1) {
	        return function(value) {
	          return func.call(thisArg, value);
	        };
	      }
	      if (argCount === 2) {
	        return function(a, b) {
	          return func.call(thisArg, a, b);
	        };
	      }
	      if (argCount === 4) {
	        return function(accumulator, value, index, object) {
	          return func.call(thisArg, accumulator, value, index, object);
	        };
	      }
	      return function(value, index, object) {
	        return func.call(thisArg, value, index, object);
	      };
	    }
	    return func;
	  }
	
	  /**
	   * Creates compiled iteration functions.
	   *
	   * @private
	   * @param {Object} [options1, options2, ...] The compile options object(s).
	   *  arrays - A string of code to determine if the iterable is an array or array-like.
	   *  useHas - A boolean to specify using `hasOwnProperty` checks in the object loop.
	   *  args - A string of comma separated arguments the iteration function will accept.
	   *  top - A string of code to execute before the iteration branches.
	   *  loop - A string of code to execute in the object loop.
	   *  bottom - A string of code to execute after the iteration branches.
	   *
	   * @returns {Function} Returns the compiled function.
	   */
	  function createIterator() {
	    var data = {
	      // support properties
	      'hasDontEnumBug': hasDontEnumBug,
	      'hasEnumPrototype': hasEnumPrototype,
	      'isKeysFast': isKeysFast,
	      'nonEnumArgs': nonEnumArgs,
	      'noCharByIndex': noCharByIndex,
	      'shadowed': shadowed,
	
	      // iterator options
	      'arrays': 'isArray(iterable)',
	      'bottom': '',
	      'loop': '',
	      'top': '',
	      'useHas': true
	    };
	
	    // merge options into a template data object
	    for (var object, index = 0; object = arguments[index]; index++) {
	      for (var key in object) {
	        data[key] = object[key];
	      }
	    }
	    var args = data.args;
	    data.firstArg = /^[^,]+/.exec(args)[0];
	
	    // create the function factory
	    var factory = Function(
	        'createCallback, hasOwnProperty, isArguments, isArray, isString, ' +
	        'objectTypes, nativeKeys',
	      'return function(' + args + ') {\n' + iteratorTemplate(data) + '\n}'
	    );
	    // return the compiled function
	    return factory(
	      createCallback, hasOwnProperty, isArguments, isArray, isString,
	      objectTypes, nativeKeys
	    );
	  }
	
	  /**
	   * A function compiled to iterate `arguments` objects, arrays, objects, and
	   * strings consistenly across environments, executing the `callback` for each
	   * element in the `collection`. The `callback` is bound to `thisArg` and invoked
	   * with three arguments; (value, index|key, collection). Callbacks may exit
	   * iteration early by explicitly returning `false`.
	   *
	   * @private
	   * @type Function
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function} [callback=identity] The function called per iteration.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Array|Object|String} Returns `collection`.
	   */
	  var each = createIterator(eachIteratorOptions);
	
	  /**
	   * Used by `template` to escape characters for inclusion in compiled
	   * string literals.
	   *
	   * @private
	   * @param {String} match The matched character to escape.
	   * @returns {String} Returns the escaped character.
	   */
	  function escapeStringChar(match) {
	    return '\\' + stringEscapes[match];
	  }
	
	  /**
	   * Used by `escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {String} match The matched character to escape.
	   * @returns {String} Returns the escaped character.
	   */
	  function escapeHtmlChar(match) {
	    return htmlEscapes[match];
	  }
	
	  /**
	   * Checks if `value` is a DOM node in IE < 9.
	   *
	   * @private
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true` if the `value` is a DOM node, else `false`.
	   */
	  function isNode(value) {
	    // IE < 9 presents DOM nodes as `Object` objects except they have `toString`
	    // methods that are `typeof` "string" and still can coerce nodes to strings
	    return typeof value.toString != 'function' && typeof (value + '') == 'string';
	  }
	
	  /**
	   * A no-operation function.
	   *
	   * @private
	   */
	  function noop() {
	    // no operation performed
	  }
	
	  /**
	   * Slices the `collection` from the `start` index up to, but not including,
	   * the `end` index.
	   *
	   * Note: This function is used, instead of `Array#slice`, to support node lists
	   * in IE < 9 and to ensure dense arrays are returned.
	   *
	   * @private
	   * @param {Array|Object|String} collection The collection to slice.
	   * @param {Number} start The start index.
	   * @param {Number} end The end index.
	   * @returns {Array} Returns the new array.
	   */
	  function slice(array, start, end) {
	    start || (start = 0);
	    if (typeof end == 'undefined') {
	      end = array ? array.length : 0;
	    }
	    var index = -1,
	        length = end - start || 0,
	        result = Array(length < 0 ? 0 : length);
	
	    while (++index < length) {
	      result[index] = array[start + index];
	    }
	    return result;
	  }
	
	  /**
	   * Used by `unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {String} match The matched character to unescape.
	   * @returns {String} Returns the unescaped character.
	   */
	  function unescapeHtmlChar(match) {
	    return htmlUnescapes[match];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Checks if `value` is an `arguments` object.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is an `arguments` object, else `false`.
	   * @example
	   *
	   * (function() { return _.isArguments(arguments); })(1, 2, 3);
	   * // => true
	   *
	   * _.isArguments([1, 2, 3]);
	   * // => false
	   */
	  function isArguments(value) {
	    return toString.call(value) == argsClass;
	  }
	  // fallback for browsers that can't detect `arguments` objects by [[Class]]
	  if (noArgsClass) {
	    isArguments = function(value) {
	      return value ? hasOwnProperty.call(value, 'callee') : false;
	    };
	  }
	
	  /**
	   * Iterates over `object`'s own and inherited enumerable properties, executing
	   * the `callback` for each property. The `callback` is bound to `thisArg` and
	   * invoked with three arguments; (value, key, object). Callbacks may exit iteration
	   * early by explicitly returning `false`.
	   *
	   * @static
	   * @memberOf _
	   * @type Function
	   * @category Objects
	   * @param {Object} object The object to iterate over.
	   * @param {Function} [callback=identity] The function called per iteration.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Object} Returns `object`.
	   * @example
	   *
	   * function Dog(name) {
	   *   this.name = name;
	   * }
	   *
	   * Dog.prototype.bark = function() {
	   *   alert('Woof, woof!');
	   * };
	   *
	   * _.forIn(new Dog('Dagny'), function(value, key) {
	   *   alert(key);
	   * });
	   * // => alerts 'name' and 'bark' (order is not guaranteed)
	   */
	  var forIn = createIterator(eachIteratorOptions, forOwnIteratorOptions, {
	    'useHas': false
	  });
	
	  /**
	   * Iterates over an object's own enumerable properties, executing the `callback`
	   * for each property. The `callback` is bound to `thisArg` and invoked with three
	   * arguments; (value, key, object). Callbacks may exit iteration early by explicitly
	   * returning `false`.
	   *
	   * @static
	   * @memberOf _
	   * @type Function
	   * @category Objects
	   * @param {Object} object The object to iterate over.
	   * @param {Function} [callback=identity] The function called per iteration.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Object} Returns `object`.
	   * @example
	   *
	   * _.forOwn({ '0': 'zero', '1': 'one', 'length': 2 }, function(num, key) {
	   *   alert(key);
	   * });
	   * // => alerts '0', '1', and 'length' (order is not guaranteed)
	   */
	  var forOwn = createIterator(eachIteratorOptions, forOwnIteratorOptions);
	
	  /**
	   * Checks if `value` is an array.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is an array, else `false`.
	   * @example
	   *
	   * (function() { return _.isArray(arguments); })();
	   * // => false
	   *
	   * _.isArray([1, 2, 3]);
	   * // => true
	   */
	  var isArray = nativeIsArray || function(value) {
	    // `instanceof` may cause a memory leak in IE 7 if `value` is a host object
	    // http://ajaxian.com/archives/working-aroung-the-instanceof-memory-leak
	    return (argsAreObjects && value instanceof Array) || toString.call(value) == arrayClass;
	  };
	
	  /**
	   * Creates an array composed of the own enumerable property names of `object`.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Object} object The object to inspect.
	   * @returns {Array} Returns a new array of property names.
	   * @example
	   *
	   * _.keys({ 'one': 1, 'two': 2, 'three': 3 });
	   * // => ['one', 'two', 'three'] (order is not guaranteed)
	   */
	  var keys = !nativeKeys ? shimKeys : function(object) {
	    if (!isObject(object)) {
	      return [];
	    }
	    if ((hasEnumPrototype && typeof object == 'function') ||
	        (nonEnumArgs && object.length && isArguments(object))) {
	      return shimKeys(object);
	    }
	    return nativeKeys(object);
	  };
	
	  /**
	   * A fallback implementation of `isPlainObject` that checks if a given `value`
	   * is an object created by the `Object` constructor, assuming objects created
	   * by the `Object` constructor have no inherited enumerable properties and that
	   * there are no `Object.prototype` extensions.
	   *
	   * @private
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if `value` is a plain object, else `false`.
	   */
	  function shimIsPlainObject(value) {
	    // avoid non-objects and false positives for `arguments` objects
	    var result = false;
	    if (!(value && typeof value == 'object') || isArguments(value)) {
	      return result;
	    }
	    // check that the constructor is `Object` (i.e. `Object instanceof Object`)
	    var ctor = value.constructor;
	    if ((!isFunction(ctor) && (!noNodeClass || !isNode(value))) || ctor instanceof ctor) {
	      // IE < 9 iterates inherited properties before own properties. If the first
	      // iterated property is an object's own property then there are no inherited
	      // enumerable properties.
	      if (iteratesOwnLast) {
	        forIn(value, function(value, key, object) {
	          result = !hasOwnProperty.call(object, key);
	          return false;
	        });
	        return result === false;
	      }
	      // In most environments an object's own properties are iterated before
	      // its inherited properties. If the last iterated property is an object's
	      // own property then there are no inherited enumerable properties.
	      forIn(value, function(value, key) {
	        result = key;
	      });
	      return result === false || hasOwnProperty.call(value, result);
	    }
	    return result;
	  }
	
	  /**
	   * A fallback implementation of `Object.keys` that produces an array of the
	   * given object's own enumerable property names.
	   *
	   * @private
	   * @param {Object} object The object to inspect.
	   * @returns {Array} Returns a new array of property names.
	   */
	  function shimKeys(object) {
	    var result = [];
	    forOwn(object, function(value, key) {
	      result.push(key);
	    });
	    return result;
	  }
	
	  /**
	   * Used to convert characters to HTML entities:
	   *
	   * Though the `>` character is escaped for symmetry, characters like `>` and `/`
	   * don't require escaping in HTML and have no special meaning unless they're part
	   * of a tag or an unquoted attribute value.
	   * http://mathiasbynens.be/notes/ambiguous-ampersands (under "semi-related fun fact")
	   */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to convert HTML entities to characters */
	  var htmlUnescapes = invert(htmlEscapes);
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Assigns own enumerable properties of source object(s) to the destination
	   * object. Subsequent sources will overwrite propery assignments of previous
	   * sources. If a `callback` function is passed, it will be executed to produce
	   * the assigned values. The `callback` is bound to `thisArg` and invoked with
	   * two arguments; (objectValue, sourceValue).
	   *
	   * @static
	   * @memberOf _
	   * @type Function
	   * @alias extend
	   * @category Objects
	   * @param {Object} object The destination object.
	   * @param {Object} [source1, source2, ...] The source objects.
	   * @param {Function} [callback] The function to customize assigning values.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Object} Returns the destination object.
	   * @example
	   *
	   * _.assign({ 'name': 'moe' }, { 'age': 40 });
	   * // => { 'name': 'moe', 'age': 40 }
	   *
	   * var defaults = _.partialRight(_.assign, function(a, b) {
	   *   return typeof a == 'undefined' ? b : a;
	   * });
	   *
	   * var food = { 'name': 'apple' };
	   * defaults(food, { 'name': 'banana', 'type': 'fruit' });
	   * // => { 'name': 'apple', 'type': 'fruit' }
	   */
	  var assign = createIterator(defaultsIteratorOptions, {
	    'top':
	      defaultsIteratorOptions.top.replace(';',
	        ';\n' +
	        "if (argsLength > 3 && typeof args[argsLength - 2] == 'function') {\n" +
	        '  var callback = createCallback(args[--argsLength - 1], args[argsLength--], 2);\n' +
	        "} else if (argsLength > 2 && typeof args[argsLength - 1] == 'function') {\n" +
	        '  callback = args[--argsLength];\n' +
	        '}'
	      ),
	    'loop': 'result[index] = callback ? callback(result[index], iterable[index]) : iterable[index]'
	  });
	
	  /**
	   * Creates a clone of `value`. If `deep` is `true`, nested objects will also
	   * be cloned, otherwise they will be assigned by reference. If a `callback`
	   * function is passed, it will be executed to produce the cloned values. If
	   * `callback` returns `undefined`, cloning will be handled by the method instead.
	   * The `callback` is bound to `thisArg` and invoked with one argument; (value).
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to clone.
	   * @param {Boolean} [deep=false] A flag to indicate a deep clone.
	   * @param {Function} [callback] The function to customize cloning values.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @param- {Array} [stackA=[]] Internally used to track traversed source objects.
	   * @param- {Array} [stackB=[]] Internally used to associate clones with source counterparts.
	   * @returns {Mixed} Returns the cloned `value`.
	   * @example
	   *
	   * var stooges = [
	   *   { 'name': 'moe', 'age': 40 },
	   *   { 'name': 'larry', 'age': 50 }
	   * ];
	   *
	   * var shallow = _.clone(stooges);
	   * shallow[0] === stooges[0];
	   * // => true
	   *
	   * var deep = _.clone(stooges, true);
	   * deep[0] === stooges[0];
	   * // => false
	   *
	   * _.mixin({
	   *   'clone': _.partialRight(_.clone, function(value) {
	   *     return _.isElement(value) ? value.cloneNode(false) : undefined;
	   *   })
	   * });
	   *
	   * var clone = _.clone(document.body);
	   * clone.childNodes.length;
	   * // => 0
	   */
	  function clone(value, deep, callback, thisArg, stackA, stackB) {
	    var result = value;
	
	    // allows working with "Collections" methods without using their `callback`
	    // argument, `index|key`, for this method's `callback`
	    if (typeof deep == 'function') {
	      thisArg = callback;
	      callback = deep;
	      deep = false;
	    }
	    if (typeof callback == 'function') {
	      callback = typeof thisArg == 'undefined' ? callback : createCallback(callback, thisArg, 1);
	      result = callback(result);
	
	      var done = typeof result != 'undefined';
	      if (!done) {
	        result = value;
	      }
	    }
	    // inspect [[Class]]
	    var isObj = isObject(result);
	    if (isObj) {
	      var className = toString.call(result);
	      if (!cloneableClasses[className] || (noNodeClass && isNode(result))) {
	        return result;
	      }
	      var isArr = isArray(result);
	    }
	    // shallow clone
	    if (!isObj || !deep) {
	      return isObj && !done
	        ? (isArr ? slice(result) : assign({}, result))
	        : result;
	    }
	    var ctor = ctorByClass[className];
	    switch (className) {
	      case boolClass:
	      case dateClass:
	        return done ? result : new ctor(+result);
	
	      case numberClass:
	      case stringClass:
	        return done ? result : new ctor(result);
	
	      case regexpClass:
	        return done ? result : ctor(result.source, reFlags.exec(result));
	    }
	    // check for circular references and return corresponding clone
	    stackA || (stackA = []);
	    stackB || (stackB = []);
	
	    var length = stackA.length;
	    while (length--) {
	      if (stackA[length] == value) {
	        return stackB[length];
	      }
	    }
	    // init cloned object
	    if (!done) {
	      result = isArr ? ctor(result.length) : {};
	
	      // add array properties assigned by `RegExp#exec`
	      if (isArr) {
	        if (hasOwnProperty.call(value, 'index')) {
	          result.index = value.index;
	        }
	        if (hasOwnProperty.call(value, 'input')) {
	          result.input = value.input;
	        }
	      }
	    }
	    // add the source value to the stack of traversed objects
	    // and associate it with its clone
	    stackA.push(value);
	    stackB.push(result);
	
	    // recursively populate clone (susceptible to call stack limits)
	    (isArr ? forEach : forOwn)(done ? result : value, function(objValue, key) {
	      result[key] = clone(objValue, deep, callback, undefined, stackA, stackB);
	    });
	
	    return result;
	  }
	
	  /**
	   * Creates a deep clone of `value`. If a `callback` function is passed, it will
	   * be executed to produce the cloned values. If `callback` returns the value it
	   * was passed, cloning will be handled by the method instead. The `callback` is
	   * bound to `thisArg` and invoked with one argument; (value).
	   *
	   * Note: This function is loosely based on the structured clone algorithm. Functions
	   * and DOM nodes are **not** cloned. The enumerable properties of `arguments` objects and
	   * objects created by constructors other than `Object` are cloned to plain `Object` objects.
	   * See http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to deep clone.
	   * @param {Function} [callback] The function to customize cloning values.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Mixed} Returns the deep cloned `value`.
	   * @example
	   *
	   * var stooges = [
	   *   { 'name': 'moe', 'age': 40 },
	   *   { 'name': 'larry', 'age': 50 }
	   * ];
	   *
	   * var deep = _.cloneDeep(stooges);
	   * deep[0] === stooges[0];
	   * // => false
	   *
	   * var view = {
	   *   'label': 'docs',
	   *   'node': element
	   * };
	   *
	   * var clone = _.cloneDeep(view, function(value) {
	   *   return _.isElement(value) ? value.cloneNode(true) : value;
	   * });
	   *
	   * clone.node == view.node;
	   * // => false
	   */
	  function cloneDeep(value, callback, thisArg) {
	    return clone(value, true, callback, thisArg);
	  }
	
	  /**
	   * Assigns own enumerable properties of source object(s) to the destination
	   * object for all destination properties that resolve to `undefined`. Once a
	   * property is set, additional defaults of the same property will be ignored.
	   *
	   * @static
	   * @memberOf _
	   * @type Function
	   * @category Objects
	   * @param {Object} object The destination object.
	   * @param {Object} [source1, source2, ...] The source objects.
	   * @param- {Object} [guard] Internally used to allow working with `_.reduce`
	   *  without using its callback's `key` and `object` arguments as sources.
	   * @returns {Object} Returns the destination object.
	   * @example
	   *
	   * var food = { 'name': 'apple' };
	   * _.defaults(food, { 'name': 'banana', 'type': 'fruit' });
	   * // => { 'name': 'apple', 'type': 'fruit' }
	   */
	  var defaults = createIterator(defaultsIteratorOptions);
	
	  /**
	   * Creates a sorted array of all enumerable properties, own and inherited,
	   * of `object` that have function values.
	   *
	   * @static
	   * @memberOf _
	   * @alias methods
	   * @category Objects
	   * @param {Object} object The object to inspect.
	   * @returns {Array} Returns a new array of property names that have function values.
	   * @example
	   *
	   * _.functions(_);
	   * // => ['all', 'any', 'bind', 'bindAll', 'clone', 'compact', 'compose', ...]
	   */
	  function functions(object) {
	    var result = [];
	    forIn(object, function(value, key) {
	      if (isFunction(value)) {
	        result.push(key);
	      }
	    });
	    return result.sort();
	  }
	
	  /**
	   * Checks if the specified object `property` exists and is a direct property,
	   * instead of an inherited property.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Object} object The object to check.
	   * @param {String} property The property to check for.
	   * @returns {Boolean} Returns `true` if key is a direct property, else `false`.
	   * @example
	   *
	   * _.has({ 'a': 1, 'b': 2, 'c': 3 }, 'b');
	   * // => true
	   */
	  function has(object, property) {
	    return object ? hasOwnProperty.call(object, property) : false;
	  }
	
	  /**
	   * Creates an object composed of the inverted keys and values of the given `object`.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Object} object The object to invert.
	   * @returns {Object} Returns the created inverted object.
	   * @example
	   *
	   *  _.invert({ 'first': 'moe', 'second': 'larry' });
	   * // => { 'moe': 'first', 'larry': 'second' } (order is not guaranteed)
	   */
	  function invert(object) {
	    var index = -1,
	        props = keys(object),
	        length = props.length,
	        result = {};
	
	    while (++index < length) {
	      var key = props[index];
	      result[object[key]] = key;
	    }
	    return result;
	  }
	
	  /**
	   * Checks if `value` is a boolean value.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is a boolean value, else `false`.
	   * @example
	   *
	   * _.isBoolean(null);
	   * // => false
	   */
	  function isBoolean(value) {
	    return value === true || value === false || toString.call(value) == boolClass;
	  }
	
	  /**
	   * Checks if `value` is a date.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is a date, else `false`.
	   * @example
	   *
	   * _.isDate(new Date);
	   * // => true
	   */
	  function isDate(value) {
	    return value instanceof Date || toString.call(value) == dateClass;
	  }
	
	  /**
	   * Checks if `value` is a DOM element.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is a DOM element, else `false`.
	   * @example
	   *
	   * _.isElement(document.body);
	   * // => true
	   */
	  function isElement(value) {
	    return value ? value.nodeType === 1 : false;
	  }
	
	  /**
	   * Checks if `value` is empty. Arrays, strings, or `arguments` objects with a
	   * length of `0` and objects with no own enumerable properties are considered
	   * "empty".
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Array|Object|String} value The value to inspect.
	   * @returns {Boolean} Returns `true`, if the `value` is empty, else `false`.
	   * @example
	   *
	   * _.isEmpty([1, 2, 3]);
	   * // => false
	   *
	   * _.isEmpty({});
	   * // => true
	   *
	   * _.isEmpty('');
	   * // => true
	   */
	  function isEmpty(value) {
	    var result = true;
	    if (!value) {
	      return result;
	    }
	    var className = toString.call(value),
	        length = value.length;
	
	    if ((className == arrayClass || className == stringClass ||
	        className == argsClass || (noArgsClass && isArguments(value))) ||
	        (className == objectClass && typeof length == 'number' && isFunction(value.splice))) {
	      return !length;
	    }
	    forOwn(value, function() {
	      return (result = false);
	    });
	    return result;
	  }
	
	  /**
	   * Performs a deep comparison between two values to determine if they are
	   * equivalent to each other. If `callback` is passed, it will be executed to
	   * compare values. If `callback` returns `undefined`, comparisons will be handled
	   * by the method instead. The `callback` is bound to `thisArg` and invoked with
	   * two arguments; (a, b).
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} a The value to compare.
	   * @param {Mixed} b The other value to compare.
	   * @param {Function} [callback] The function to customize comparing values.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @param- {Object} [stackA=[]] Internally used track traversed `a` objects.
	   * @param- {Object} [stackB=[]] Internally used track traversed `b` objects.
	   * @returns {Boolean} Returns `true`, if the values are equvalent, else `false`.
	   * @example
	   *
	   * var moe = { 'name': 'moe', 'age': 40 };
	   * var copy = { 'name': 'moe', 'age': 40 };
	   *
	   * moe == copy;
	   * // => false
	   *
	   * _.isEqual(moe, copy);
	   * // => true
	   *
	   * var words = ['hello', 'goodbye'];
	   * var otherWords = ['hi', 'goodbye'];
	   *
	   * _.isEqual(words, otherWords, function(a, b) {
	   *   var reGreet = /^(?:hello|hi)$/i,
	   *       aGreet = _.isString(a) && reGreet.test(a),
	   *       bGreet = _.isString(b) && reGreet.test(b);
	   *
	   *   return (aGreet || bGreet) ? (aGreet == bGreet) : undefined;
	   * });
	   * // => true
	   */
	  function isEqual(a, b, callback, thisArg, stackA, stackB) {
	    // used to indicate that when comparing objects, `a` has at least the properties of `b`
	    var whereIndicator = callback === indicatorObject;
	    if (callback && !whereIndicator) {
	      callback = typeof thisArg == 'undefined' ? callback : createCallback(callback, thisArg, 2);
	      var result = callback(a, b);
	      if (typeof result != 'undefined') {
	        return !!result;
	      }
	    }
	    // exit early for identical values
	    if (a === b) {
	      // treat `+0` vs. `-0` as not equal
	      return a !== 0 || (1 / a == 1 / b);
	    }
	    var type = typeof a,
	        otherType = typeof b;
	
	    // exit early for unlike primitive values
	    if (a === a &&
	        (!a || (type != 'function' && type != 'object')) &&
	        (!b || (otherType != 'function' && otherType != 'object'))) {
	      return false;
	    }
	    // exit early for `null` and `undefined`, avoiding ES3's Function#call behavior
	    // http://es5.github.com/#x15.3.4.4
	    if (a == null || b == null) {
	      return a === b;
	    }
	    // compare [[Class]] names
	    var className = toString.call(a),
	        otherClass = toString.call(b);
	
	    if (className == argsClass) {
	      className = objectClass;
	    }
	    if (otherClass == argsClass) {
	      otherClass = objectClass;
	    }
	    if (className != otherClass) {
	      return false;
	    }
	    switch (className) {
	      case boolClass:
	      case dateClass:
	        // coerce dates and booleans to numbers, dates to milliseconds and booleans
	        // to `1` or `0`, treating invalid dates coerced to `NaN` as not equal
	        return +a == +b;
	
	      case numberClass:
	        // treat `NaN` vs. `NaN` as equal
	        return a != +a
	          ? b != +b
	          // but treat `+0` vs. `-0` as not equal
	          : (a == 0 ? (1 / a == 1 / b) : a == +b);
	
	      case regexpClass:
	      case stringClass:
	        // coerce regexes to strings (http://es5.github.com/#x15.10.6.4)
	        // treat string primitives and their corresponding object instances as equal
	        return a == b + '';
	    }
	    var isArr = className == arrayClass;
	    if (!isArr) {
	      // unwrap any `lodash` wrapped values
	      if (a.__wrapped__ || b.__wrapped__) {
	        return isEqual(a.__wrapped__ || a, b.__wrapped__ || b, callback, thisArg, stackA, stackB);
	      }
	      // exit for functions and DOM nodes
	      if (className != objectClass || (noNodeClass && (isNode(a) || isNode(b)))) {
	        return false;
	      }
	      // in older versions of Opera, `arguments` objects have `Array` constructors
	      var ctorA = !argsAreObjects && isArguments(a) ? Object : a.constructor,
	          ctorB = !argsAreObjects && isArguments(b) ? Object : b.constructor;
	
	      // non `Object` object instances with different constructors are not equal
	      if (ctorA != ctorB && !(
	            isFunction(ctorA) && ctorA instanceof ctorA &&
	            isFunction(ctorB) && ctorB instanceof ctorB
	          )) {
	        return false;
	      }
	    }
	    // assume cyclic structures are equal
	    // the algorithm for detecting cyclic structures is adapted from ES 5.1
	    // section 15.12.3, abstract operation `JO` (http://es5.github.com/#x15.12.3)
	    stackA || (stackA = []);
	    stackB || (stackB = []);
	
	    var length = stackA.length;
	    while (length--) {
	      if (stackA[length] == a) {
	        return stackB[length] == b;
	      }
	    }
	    var size = 0;
	    result = true;
	
	    // add `a` and `b` to the stack of traversed objects
	    stackA.push(a);
	    stackB.push(b);
	
	    // recursively compare objects and arrays (susceptible to call stack limits)
	    if (isArr) {
	      length = a.length;
	      size = b.length;
	
	      // compare lengths to determine if a deep comparison is necessary
	      result = size == a.length;
	      if (!result && !whereIndicator) {
	        return result;
	      }
	      // deep compare the contents, ignoring non-numeric properties
	      while (size--) {
	        var index = length,
	            value = b[size];
	
	        if (whereIndicator) {
	          while (index--) {
	            if ((result = isEqual(a[index], value, callback, thisArg, stackA, stackB))) {
	              break;
	            }
	          }
	        } else if (!(result = isEqual(a[size], value, callback, thisArg, stackA, stackB))) {
	          break;
	        }
	      }
	      return result;
	    }
	    // deep compare objects using `forIn`, instead of `forOwn`, to avoid `Object.keys`
	    // which, in this case, is more costly
	    forIn(b, function(value, key, b) {
	      if (hasOwnProperty.call(b, key)) {
	        // count the number of properties.
	        size++;
	        // deep compare each property value.
	        return (result = hasOwnProperty.call(a, key) && isEqual(a[key], value, callback, thisArg, stackA, stackB));
	      }
	    });
	
	    if (result && !whereIndicator) {
	      // ensure both objects have the same number of properties
	      forIn(a, function(value, key, a) {
	        if (hasOwnProperty.call(a, key)) {
	          // `size` will be `-1` if `a` has more properties than `b`
	          return (result = --size > -1);
	        }
	      });
	    }
	    return result;
	  }
	
	  /**
	   * Checks if `value` is, or can be coerced to, a finite number.
	   *
	   * Note: This is not the same as native `isFinite`, which will return true for
	   * booleans and empty strings. See http://es5.github.com/#x15.1.2.5.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is finite, else `false`.
	   * @example
	   *
	   * _.isFinite(-101);
	   * // => true
	   *
	   * _.isFinite('10');
	   * // => true
	   *
	   * _.isFinite(true);
	   * // => false
	   *
	   * _.isFinite('');
	   * // => false
	   *
	   * _.isFinite(Infinity);
	   * // => false
	   */
	  function isFinite(value) {
	    return nativeIsFinite(value) && !nativeIsNaN(parseFloat(value));
	  }
	
	  /**
	   * Checks if `value` is a function.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is a function, else `false`.
	   * @example
	   *
	   * _.isFunction(_);
	   * // => true
	   */
	  function isFunction(value) {
	    return typeof value == 'function';
	  }
	  // fallback for older versions of Chrome and Safari
	  if (isFunction(/x/)) {
	    isFunction = function(value) {
	      return value instanceof Function || toString.call(value) == funcClass;
	    };
	  }
	
	  /**
	   * Checks if `value` is the language type of Object.
	   * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is an object, else `false`.
	   * @example
	   *
	   * _.isObject({});
	   * // => true
	   *
	   * _.isObject([1, 2, 3]);
	   * // => true
	   *
	   * _.isObject(1);
	   * // => false
	   */
	  function isObject(value) {
	    // check if the value is the ECMAScript language type of Object
	    // http://es5.github.com/#x8
	    // and avoid a V8 bug
	    // http://code.google.com/p/v8/issues/detail?id=2291
	    return value ? objectTypes[typeof value] : false;
	  }
	
	  /**
	   * Checks if `value` is `NaN`.
	   *
	   * Note: This is not the same as native `isNaN`, which will return `true` for
	   * `undefined` and other values. See http://es5.github.com/#x15.1.2.4.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is `NaN`, else `false`.
	   * @example
	   *
	   * _.isNaN(NaN);
	   * // => true
	   *
	   * _.isNaN(new Number(NaN));
	   * // => true
	   *
	   * isNaN(undefined);
	   * // => true
	   *
	   * _.isNaN(undefined);
	   * // => false
	   */
	  function isNaN(value) {
	    // `NaN` as a primitive is the only value that is not equal to itself
	    // (perform the [[Class]] check first to avoid errors with some host objects in IE)
	    return isNumber(value) && value != +value
	  }
	
	  /**
	   * Checks if `value` is `null`.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is `null`, else `false`.
	   * @example
	   *
	   * _.isNull(null);
	   * // => true
	   *
	   * _.isNull(undefined);
	   * // => false
	   */
	  function isNull(value) {
	    return value === null;
	  }
	
	  /**
	   * Checks if `value` is a number.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is a number, else `false`.
	   * @example
	   *
	   * _.isNumber(8.4 * 5);
	   * // => true
	   */
	  function isNumber(value) {
	    return typeof value == 'number' || toString.call(value) == numberClass;
	  }
	
	  /**
	   * Checks if a given `value` is an object created by the `Object` constructor.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if `value` is a plain object, else `false`.
	   * @example
	   *
	   * function Stooge(name, age) {
	   *   this.name = name;
	   *   this.age = age;
	   * }
	   *
	   * _.isPlainObject(new Stooge('moe', 40));
	   * // => false
	   *
	   * _.isPlainObject([1, 2, 3]);
	   * // => false
	   *
	   * _.isPlainObject({ 'name': 'moe', 'age': 40 });
	   * // => true
	   */
	  var isPlainObject = !getPrototypeOf ? shimIsPlainObject : function(value) {
	    if (!(value && typeof value == 'object')) {
	      return false;
	    }
	    var valueOf = value.valueOf,
	        objProto = typeof valueOf == 'function' && (objProto = getPrototypeOf(valueOf)) && getPrototypeOf(objProto);
	
	    return objProto
	      ? value == objProto || (getPrototypeOf(value) == objProto && !isArguments(value))
	      : shimIsPlainObject(value);
	  };
	
	  /**
	   * Checks if `value` is a regular expression.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is a regular expression, else `false`.
	   * @example
	   *
	   * _.isRegExp(/moe/);
	   * // => true
	   */
	  function isRegExp(value) {
	    return value instanceof RegExp || toString.call(value) == regexpClass;
	  }
	
	  /**
	   * Checks if `value` is a string.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is a string, else `false`.
	   * @example
	   *
	   * _.isString('moe');
	   * // => true
	   */
	  function isString(value) {
	    return typeof value == 'string' || toString.call(value) == stringClass;
	  }
	
	  /**
	   * Checks if `value` is `undefined`.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Mixed} value The value to check.
	   * @returns {Boolean} Returns `true`, if the `value` is `undefined`, else `false`.
	   * @example
	   *
	   * _.isUndefined(void 0);
	   * // => true
	   */
	  function isUndefined(value) {
	    return typeof value == 'undefined';
	  }
	
	  /**
	   * Recursively merges own enumerable properties of the source object(s), that
	   * don't resolve to `undefined`, into the destination object. Subsequent sources
	   * will overwrite propery assignments of previous sources. If a `callback` function
	   * is passed, it will be executed to produce the merged values of the destination
	   * and source properties. If `callback` returns `undefined`, merging will be
	   * handled by the method instead. The `callback` is bound to `thisArg` and
	   * invoked with two arguments; (objectValue, sourceValue).
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Object} object The destination object.
	   * @param {Object} [source1, source2, ...] The source objects.
	   * @param {Function} [callback] The function to customize merging properties.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @param- {Object} [deepIndicator] Internally used to indicate that `stackA`
	   *  and `stackB` are arrays of traversed objects instead of source objects.
	   * @param- {Array} [stackA=[]] Internally used to track traversed source objects.
	   * @param- {Array} [stackB=[]] Internally used to associate values with their
	   *  source counterparts.
	   * @returns {Object} Returns the destination object.
	   * @example
	   *
	   * var names = {
	   *   'stooges': [
	   *     { 'name': 'moe' },
	   *     { 'name': 'larry' }
	   *   ]
	   * };
	   *
	   * var ages = {
	   *   'stooges': [
	   *     { 'age': 40 },
	   *     { 'age': 50 }
	   *   ]
	   * };
	   *
	   * _.merge(names, ages);
	   * // => { 'stooges': [{ 'name': 'moe', 'age': 40 }, { 'name': 'larry', 'age': 50 }] }
	   *
	   * var food = {
	   *   'fruits': ['apple'],
	   *   'vegetables': ['beet']
	   * };
	   *
	   * var otherFood = {
	   *   'fruits': ['banana'],
	   *   'vegetables': ['carrot']
	   * };
	   *
	   * _.merge(food, otherFood, function(a, b) {
	   *   return _.isArray(a) ? a.concat(b) : undefined;
	   * });
	   * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot] }
	   */
	  function merge(object, source, deepIndicator) {
	    var args = arguments,
	        index = 0,
	        length = 2;
	
	    if (!isObject(object)) {
	      return object;
	    }
	    if (deepIndicator === indicatorObject) {
	      var callback = args[3],
	          stackA = args[4],
	          stackB = args[5];
	    } else {
	      stackA = [];
	      stackB = [];
	
	      // allows working with `_.reduce` and `_.reduceRight` without
	      // using their `callback` arguments, `index|key` and `collection`
	      if (typeof deepIndicator != 'number') {
	        length = args.length;
	      }
	      if (length > 3 && typeof args[length - 2] == 'function') {
	        callback = createCallback(args[--length - 1], args[length--], 2);
	      } else if (length > 2 && typeof args[length - 1] == 'function') {
	        callback = args[--length];
	      }
	    }
	    while (++index < length) {
	      (isArray(args[index]) ? forEach : forOwn)(args[index], function(source, key) {
	        var found,
	            isArr,
	            result = source,
	            value = object[key];
	
	        if (source && ((isArr = isArray(source)) || isPlainObject(source))) {
	          // avoid merging previously merged cyclic sources
	          var stackLength = stackA.length;
	          while (stackLength--) {
	            if ((found = stackA[stackLength] == source)) {
	              value = stackB[stackLength];
	              break;
	            }
	          }
	          if (!found) {
	            value = isArr
	              ? (isArray(value) ? value : [])
	              : (isPlainObject(value) ? value : {});
	
	            if (callback) {
	              result = callback(value, source);
	              if (typeof result != 'undefined') {
	                value = result;
	              }
	            }
	            // add `source` and associated `value` to the stack of traversed objects
	            stackA.push(source);
	            stackB.push(value);
	
	            // recursively merge objects and arrays (susceptible to call stack limits)
	            if (!callback) {
	              value = merge(value, source, indicatorObject, callback, stackA, stackB);
	            }
	          }
	        }
	        else {
	          if (callback) {
	            result = callback(value, source);
	            if (typeof result == 'undefined') {
	              result = source;
	            }
	          }
	          if (typeof result != 'undefined') {
	            value = result;
	          }
	        }
	        object[key] = value;
	      });
	    }
	    return object;
	  }
	
	  /**
	   * Creates a shallow clone of `object` excluding the specified properties.
	   * Property names may be specified as individual arguments or as arrays of
	   * property names. If a `callback` function is passed, it will be executed
	   * for each property in the `object`, omitting the properties `callback`
	   * returns truthy for. The `callback` is bound to `thisArg` and invoked
	   * with three arguments; (value, key, object).
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Object} object The source object.
	   * @param {Function|String} callback|[prop1, prop2, ...] The properties to omit
	   *  or the function called per iteration.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Object} Returns an object without the omitted properties.
	   * @example
	   *
	   * _.omit({ 'name': 'moe', 'age': 40 }, 'age');
	   * // => { 'name': 'moe' }
	   *
	   * _.omit({ 'name': 'moe', 'age': 40 }, function(value) {
	   *   return typeof value == 'number';
	   * });
	   * // => { 'name': 'moe' }
	   */
	  function omit(object, callback, thisArg) {
	    var isFunc = typeof callback == 'function',
	        result = {};
	
	    if (isFunc) {
	      callback = createCallback(callback, thisArg);
	    } else {
	      var props = concat.apply(arrayRef, arguments);
	    }
	    forIn(object, function(value, key, object) {
	      if (isFunc
	            ? !callback(value, key, object)
	            : indexOf(props, key, 1) < 0
	          ) {
	        result[key] = value;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * Creates a two dimensional array of the given object's key-value pairs,
	   * i.e. `[[key1, value1], [key2, value2]]`.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Object} object The object to inspect.
	   * @returns {Array} Returns new array of key-value pairs.
	   * @example
	   *
	   * _.pairs({ 'moe': 30, 'larry': 40 });
	   * // => [['moe', 30], ['larry', 40]] (order is not guaranteed)
	   */
	  function pairs(object) {
	    var index = -1,
	        props = keys(object),
	        length = props.length,
	        result = Array(length);
	
	    while (++index < length) {
	      var key = props[index];
	      result[index] = [key, object[key]];
	    }
	    return result;
	  }
	
	  /**
	   * Creates a shallow clone of `object` composed of the specified properties.
	   * Property names may be specified as individual arguments or as arrays of property
	   * names. If `callback` is passed, it will be executed for each property in the
	   * `object`, picking the properties `callback` returns truthy for. The `callback`
	   * is bound to `thisArg` and invoked with three arguments; (value, key, object).
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Object} object The source object.
	   * @param {Array|Function|String} callback|[prop1, prop2, ...] The function called
	   *  per iteration or properties to pick, either as individual arguments or arrays.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Object} Returns an object composed of the picked properties.
	   * @example
	   *
	   * _.pick({ 'name': 'moe', '_userid': 'moe1' }, 'name');
	   * // => { 'name': 'moe' }
	   *
	   * _.pick({ 'name': 'moe', '_userid': 'moe1' }, function(value, key) {
	   *   return key.charAt(0) != '_';
	   * });
	   * // => { 'name': 'moe' }
	   */
	  function pick(object, callback, thisArg) {
	    var result = {};
	    if (typeof callback != 'function') {
	      var index = 0,
	          props = concat.apply(arrayRef, arguments),
	          length = isObject(object) ? props.length : 0;
	
	      while (++index < length) {
	        var key = props[index];
	        if (key in object) {
	          result[key] = object[key];
	        }
	      }
	    } else {
	      callback = createCallback(callback, thisArg);
	      forIn(object, function(value, key, object) {
	        if (callback(value, key, object)) {
	          result[key] = value;
	        }
	      });
	    }
	    return result;
	  }
	
	  /**
	   * Creates an array composed of the own enumerable property values of `object`.
	   *
	   * @static
	   * @memberOf _
	   * @category Objects
	   * @param {Object} object The object to inspect.
	   * @returns {Array} Returns a new array of property values.
	   * @example
	   *
	   * _.values({ 'one': 1, 'two': 2, 'three': 3 });
	   * // => [1, 2, 3]
	   */
	  function values(object) {
	    var index = -1,
	        props = keys(object),
	        length = props.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = object[props[index]];
	    }
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates an array of elements from the specified indexes, or keys, of the
	   * `collection`. Indexes may be specified as individual arguments or as arrays
	   * of indexes.
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Array|Number|String} [index1, index2, ...] The indexes of
	   *  `collection` to retrieve, either as individual arguments or arrays.
	   * @returns {Array} Returns a new array of elements corresponding to the
	   *  provided indexes.
	   * @example
	   *
	   * _.at(['a', 'b', 'c', 'd', 'e'], [0, 2, 4]);
	   * // => ['a', 'c', 'e']
	   *
	   * _.at(['moe', 'larry', 'curly'], 0, 2);
	   * // => ['moe', 'curly']
	   */
	  function at(collection) {
	    var index = -1,
	        props = concat.apply(arrayRef, slice(arguments, 1)),
	        length = props.length,
	        result = Array(length);
	
	    if (noCharByIndex && isString(collection)) {
	      collection = collection.split('');
	    }
	    while(++index < length) {
	      result[index] = collection[props[index]];
	    }
	    return result;
	  }
	
	  /**
	   * Checks if a given `target` element is present in a `collection` using strict
	   * equality for comparisons, i.e. `===`. If `fromIndex` is negative, it is used
	   * as the offset from the end of the collection.
	   *
	   * @static
	   * @memberOf _
	   * @alias include
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Mixed} target The value to check for.
	   * @param {Number} [fromIndex=0] The index to search from.
	   * @returns {Boolean} Returns `true` if the `target` element is found, else `false`.
	   * @example
	   *
	   * _.contains([1, 2, 3], 1);
	   * // => true
	   *
	   * _.contains([1, 2, 3], 1, 2);
	   * // => false
	   *
	   * _.contains({ 'name': 'moe', 'age': 40 }, 'moe');
	   * // => true
	   *
	   * _.contains('curly', 'ur');
	   * // => true
	   */
	  function contains(collection, target, fromIndex) {
	    var index = -1,
	        length = collection ? collection.length : 0,
	        result = false;
	
	    fromIndex = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex) || 0;
	    if (typeof length == 'number') {
	      result = (isString(collection)
	        ? collection.indexOf(target, fromIndex)
	        : indexOf(collection, target, fromIndex)
	      ) > -1;
	    } else {
	      each(collection, function(value) {
	        if (++index >= fromIndex) {
	          return !(result = value === target);
	        }
	      });
	    }
	    return result;
	  }
	
	  /**
	   * Creates an object composed of keys returned from running each element of the
	   * `collection` through the given `callback`. The corresponding value of each key
	   * is the number of times the key was returned by the `callback`. The `callback`
	   * is bound to `thisArg` and invoked with three arguments; (value, index|key, collection).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Object} Returns the composed aggregate object.
	   * @example
	   *
	   * _.countBy([4.3, 6.1, 6.4], function(num) { return Math.floor(num); });
	   * // => { '4': 1, '6': 2 }
	   *
	   * _.countBy([4.3, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
	   * // => { '4': 1, '6': 2 }
	   *
	   * _.countBy(['one', 'two', 'three'], 'length');
	   * // => { '3': 2, '5': 1 }
	   */
	  function countBy(collection, callback, thisArg) {
	    var result = {};
	    callback = createCallback(callback, thisArg);
	
	    forEach(collection, function(value, key, collection) {
	      key = callback(value, key, collection) + '';
	      (hasOwnProperty.call(result, key) ? result[key]++ : result[key] = 1);
	    });
	    return result;
	  }
	
	  /**
	   * Checks if the `callback` returns a truthy value for **all** elements of a
	   * `collection`. The `callback` is bound to `thisArg` and invoked with three
	   * arguments; (value, index|key, collection).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias all
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Boolean} Returns `true` if all elements pass the callback check,
	   *  else `false`.
	   * @example
	   *
	   * _.every([true, 1, null, 'yes'], Boolean);
	   * // => false
	   *
	   * var stooges = [
	   *   { 'name': 'moe', 'age': 40 },
	   *   { 'name': 'larry', 'age': 50 }
	   * ];
	   *
	   * // using "_.pluck" callback shorthand
	   * _.every(stooges, 'age');
	   * // => true
	   *
	   * // using "_.where" callback shorthand
	   * _.every(stooges, { 'age': 50 });
	   * // => false
	   */
	  function every(collection, callback, thisArg) {
	    var result = true;
	    callback = createCallback(callback, thisArg);
	
	    if (isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      while (++index < length) {
	        if (!(result = !!callback(collection[index], index, collection))) {
	          break;
	        }
	      }
	    } else {
	      each(collection, function(value, index, collection) {
	        return (result = !!callback(value, index, collection));
	      });
	    }
	    return result;
	  }
	
	  /**
	   * Examines each element in a `collection`, returning an array of all elements
	   * the `callback` returns truthy for. The `callback` is bound to `thisArg` and
	   * invoked with three arguments; (value, index|key, collection).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias select
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Array} Returns a new array of elements that passed the callback check.
	   * @example
	   *
	   * var evens = _.filter([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
	   * // => [2, 4, 6]
	   *
	   * var food = [
	   *   { 'name': 'apple',  'organic': false, 'type': 'fruit' },
	   *   { 'name': 'carrot', 'organic': true,  'type': 'vegetable' }
	   * ];
	   *
	   * // using "_.pluck" callback shorthand
	   * _.filter(food, 'organic');
	   * // => [{ 'name': 'carrot', 'organic': true, 'type': 'vegetable' }]
	   *
	   * // using "_.where" callback shorthand
	   * _.filter(food, { 'type': 'fruit' });
	   * // => [{ 'name': 'apple', 'organic': false, 'type': 'fruit' }]
	   */
	  function filter(collection, callback, thisArg) {
	    var result = [];
	    callback = createCallback(callback, thisArg);
	
	    if (isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      while (++index < length) {
	        var value = collection[index];
	        if (callback(value, index, collection)) {
	          result.push(value);
	        }
	      }
	    } else {
	      each(collection, function(value, index, collection) {
	        if (callback(value, index, collection)) {
	          result.push(value);
	        }
	      });
	    }
	    return result;
	  }
	
	  /**
	   * Examines each element in a `collection`, returning the first that the `callback`
	   * returns truthy for. The `callback` is bound to `thisArg` and invoked with three
	   * arguments; (value, index|key, collection).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias detect
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Mixed} Returns the element that passed the callback check,
	   *  else `undefined`.
	   * @example
	   *
	   * var even = _.find([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
	   * // => 2
	   *
	   * var food = [
	   *   { 'name': 'apple',  'organic': false, 'type': 'fruit' },
	   *   { 'name': 'banana', 'organic': true,  'type': 'fruit' },
	   *   { 'name': 'beet',   'organic': false, 'type': 'vegetable' },
	   *   { 'name': 'carrot', 'organic': true,  'type': 'vegetable' }
	   * ];
	   *
	   * // using "_.where" callback shorthand
	   * var veggie = _.find(food, { 'type': 'vegetable' });
	   * // => { 'name': 'beet', 'organic': false, 'type': 'vegetable' }
	   *
	   * // using "_.pluck" callback shorthand
	   * var healthy = _.find(food, 'organic');
	   * // => { 'name': 'banana', 'organic': true, 'type': 'fruit' }
	   */
	  function find(collection, callback, thisArg) {
	    var result;
	    callback = createCallback(callback, thisArg);
	
	    forEach(collection, function(value, index, collection) {
	      if (callback(value, index, collection)) {
	        result = value;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * Iterates over a `collection`, executing the `callback` for each element in
	   * the `collection`. The `callback` is bound to `thisArg` and invoked with three
	   * arguments; (value, index|key, collection). Callbacks may exit iteration early
	   * by explicitly returning `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias each
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function} [callback=identity] The function called per iteration.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Array|Object|String} Returns `collection`.
	   * @example
	   *
	   * _([1, 2, 3]).forEach(alert).join(',');
	   * // => alerts each number and returns '1,2,3'
	   *
	   * _.forEach({ 'one': 1, 'two': 2, 'three': 3 }, alert);
	   * // => alerts each number value (order is not guaranteed)
	   */
	  function forEach(collection, callback, thisArg) {
	    if (callback && typeof thisArg == 'undefined' && isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      while (++index < length) {
	        if (callback(collection[index], index, collection) === false) {
	          break;
	        }
	      }
	    } else {
	      each(collection, callback, thisArg);
	    }
	    return collection;
	  }
	
	  /**
	   * Creates an object composed of keys returned from running each element of the
	   * `collection` through the `callback`. The corresponding value of each key is
	   * an array of elements passed to `callback` that returned the key. The `callback`
	   * is bound to `thisArg` and invoked with three arguments; (value, index|key, collection).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Object} Returns the composed aggregate object.
	   * @example
	   *
	   * _.groupBy([4.2, 6.1, 6.4], function(num) { return Math.floor(num); });
	   * // => { '4': [4.2], '6': [6.1, 6.4] }
	   *
	   * _.groupBy([4.2, 6.1, 6.4], function(num) { return this.floor(num); }, Math);
	   * // => { '4': [4.2], '6': [6.1, 6.4] }
	   *
	   * // using "_.pluck" callback shorthand
	   * _.groupBy(['one', 'two', 'three'], 'length');
	   * // => { '3': ['one', 'two'], '5': ['three'] }
	   */
	  function groupBy(collection, callback, thisArg) {
	    var result = {};
	    callback = createCallback(callback, thisArg);
	
	    forEach(collection, function(value, key, collection) {
	      key = callback(value, key, collection) + '';
	      (hasOwnProperty.call(result, key) ? result[key] : result[key] = []).push(value);
	    });
	    return result;
	  }
	
	  /**
	   * Invokes the method named by `methodName` on each element in the `collection`,
	   * returning an array of the results of each invoked method. Additional arguments
	   * will be passed to each invoked method. If `methodName` is a function, it will
	   * be invoked for, and `this` bound to, each element in the `collection`.
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|String} methodName The name of the method to invoke or
	   *  the function invoked per iteration.
	   * @param {Mixed} [arg1, arg2, ...] Arguments to invoke the method with.
	   * @returns {Array} Returns a new array of the results of each invoked method.
	   * @example
	   *
	   * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
	   * // => [[1, 5, 7], [1, 2, 3]]
	   *
	   * _.invoke([123, 456], String.prototype.split, '');
	   * // => [['1', '2', '3'], ['4', '5', '6']]
	   */
	  function invoke(collection, methodName) {
	    var args = slice(arguments, 2),
	        index = -1,
	        isFunc = typeof methodName == 'function',
	        length = collection ? collection.length : 0,
	        result = Array(typeof length == 'number' ? length : 0);
	
	    forEach(collection, function(value) {
	      result[++index] = (isFunc ? methodName : value[methodName]).apply(value, args);
	    });
	    return result;
	  }
	
	  /**
	   * Creates an array of values by running each element in the `collection`
	   * through the `callback`. The `callback` is bound to `thisArg` and invoked with
	   * three arguments; (value, index|key, collection).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias collect
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Array} Returns a new array of the results of each `callback` execution.
	   * @example
	   *
	   * _.map([1, 2, 3], function(num) { return num * 3; });
	   * // => [3, 6, 9]
	   *
	   * _.map({ 'one': 1, 'two': 2, 'three': 3 }, function(num) { return num * 3; });
	   * // => [3, 6, 9] (order is not guaranteed)
	   *
	   * var stooges = [
	   *   { 'name': 'moe', 'age': 40 },
	   *   { 'name': 'larry', 'age': 50 }
	   * ];
	   *
	   * // using "_.pluck" callback shorthand
	   * _.map(stooges, 'name');
	   * // => ['moe', 'larry']
	   */
	  function map(collection, callback, thisArg) {
	    var index = -1,
	        length = collection ? collection.length : 0,
	        result = Array(typeof length == 'number' ? length : 0);
	
	    callback = createCallback(callback, thisArg);
	    if (isArray(collection)) {
	      while (++index < length) {
	        result[index] = callback(collection[index], index, collection);
	      }
	    } else {
	      each(collection, function(value, key, collection) {
	        result[++index] = callback(value, key, collection);
	      });
	    }
	    return result;
	  }
	
	  /**
	   * Retrieves the maximum value of an `array`. If `callback` is passed,
	   * it will be executed for each value in the `array` to generate the
	   * criterion by which the value is ranked. The `callback` is bound to
	   * `thisArg` and invoked with three arguments; (value, index, collection).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Mixed} Returns the maximum value.
	   * @example
	   *
	   * _.max([4, 2, 8, 6]);
	   * // => 8
	   *
	   * var stooges = [
	   *   { 'name': 'moe', 'age': 40 },
	   *   { 'name': 'larry', 'age': 50 }
	   * ];
	   *
	   * _.max(stooges, function(stooge) { return stooge.age; });
	   * // => { 'name': 'larry', 'age': 50 };
	   *
	   * // using "_.pluck" callback shorthand
	   * _.max(stooges, 'age');
	   * // => { 'name': 'larry', 'age': 50 };
	   */
	  function max(collection, callback, thisArg) {
	    var computed = -Infinity,
	        result = computed;
	
	    if (!callback && isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      while (++index < length) {
	        var value = collection[index];
	        if (value > result) {
	          result = value;
	        }
	      }
	    } else {
	      callback = !callback && isString(collection)
	        ? charAtCallback
	        : createCallback(callback, thisArg);
	
	      each(collection, function(value, index, collection) {
	        var current = callback(value, index, collection);
	        if (current > computed) {
	          computed = current;
	          result = value;
	        }
	      });
	    }
	    return result;
	  }
	
	  /**
	   * Retrieves the minimum value of an `array`. If `callback` is passed,
	   * it will be executed for each value in the `array` to generate the
	   * criterion by which the value is ranked. The `callback` is bound to `thisArg`
	   * and invoked with three arguments; (value, index, collection).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Mixed} Returns the minimum value.
	   * @example
	   *
	   * _.min([4, 2, 8, 6]);
	   * // => 2
	   *
	   * var stooges = [
	   *   { 'name': 'moe', 'age': 40 },
	   *   { 'name': 'larry', 'age': 50 }
	   * ];
	   *
	   * _.min(stooges, function(stooge) { return stooge.age; });
	   * // => { 'name': 'moe', 'age': 40 };
	   *
	   * // using "_.pluck" callback shorthand
	   * _.min(stooges, 'age');
	   * // => { 'name': 'moe', 'age': 40 };
	   */
	  function min(collection, callback, thisArg) {
	    var computed = Infinity,
	        result = computed;
	
	    if (!callback && isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      while (++index < length) {
	        var value = collection[index];
	        if (value < result) {
	          result = value;
	        }
	      }
	    } else {
	      callback = !callback && isString(collection)
	        ? charAtCallback
	        : createCallback(callback, thisArg);
	
	      each(collection, function(value, index, collection) {
	        var current = callback(value, index, collection);
	        if (current < computed) {
	          computed = current;
	          result = value;
	        }
	      });
	    }
	    return result;
	  }
	
	  /**
	   * Retrieves the value of a specified property from all elements in the `collection`.
	   *
	   * @static
	   * @memberOf _
	   * @type Function
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {String} property The property to pluck.
	   * @returns {Array} Returns a new array of property values.
	   * @example
	   *
	   * var stooges = [
	   *   { 'name': 'moe', 'age': 40 },
	   *   { 'name': 'larry', 'age': 50 }
	   * ];
	   *
	   * _.pluck(stooges, 'name');
	   * // => ['moe', 'larry']
	   */
	  var pluck = map;
	
	  /**
	   * Reduces a `collection` to a value that is the accumulated result of running
	   * each element in the `collection` through the `callback`, where each successive
	   * `callback` execution consumes the return value of the previous execution.
	   * If `accumulator` is not passed, the first element of the `collection` will be
	   * used as the initial `accumulator` value. The `callback` is bound to `thisArg`
	   * and invoked with four arguments; (accumulator, value, index|key, collection).
	   *
	   * @static
	   * @memberOf _
	   * @alias foldl, inject
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function} [callback=identity] The function called per iteration.
	   * @param {Mixed} [accumulator] Initial value of the accumulator.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Mixed} Returns the accumulated value.
	   * @example
	   *
	   * var sum = _.reduce([1, 2, 3], function(sum, num) {
	   *   return sum + num;
	   * });
	   * // => 6
	   *
	   * var mapped = _.reduce({ 'a': 1, 'b': 2, 'c': 3 }, function(result, num, key) {
	   *   result[key] = num * 3;
	   *   return result;
	   * }, {});
	   * // => { 'a': 3, 'b': 6, 'c': 9 }
	   */
	  function reduce(collection, callback, accumulator, thisArg) {
	    var noaccum = arguments.length < 3;
	    callback = createCallback(callback, thisArg, 4);
	
	    if (isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      if (noaccum) {
	        accumulator = collection[++index];
	      }
	      while (++index < length) {
	        accumulator = callback(accumulator, collection[index], index, collection);
	      }
	    } else {
	      each(collection, function(value, index, collection) {
	        accumulator = noaccum
	          ? (noaccum = false, value)
	          : callback(accumulator, value, index, collection)
	      });
	    }
	    return accumulator;
	  }
	
	  /**
	   * This method is similar to `_.reduce`, except that it iterates over a
	   * `collection` from right to left.
	   *
	   * @static
	   * @memberOf _
	   * @alias foldr
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function} [callback=identity] The function called per iteration.
	   * @param {Mixed} [accumulator] Initial value of the accumulator.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Mixed} Returns the accumulated value.
	   * @example
	   *
	   * var list = [[0, 1], [2, 3], [4, 5]];
	   * var flat = _.reduceRight(list, function(a, b) { return a.concat(b); }, []);
	   * // => [4, 5, 2, 3, 0, 1]
	   */
	  function reduceRight(collection, callback, accumulator, thisArg) {
	    var iterable = collection,
	        length = collection ? collection.length : 0,
	        noaccum = arguments.length < 3;
	
	    if (typeof length != 'number') {
	      var props = keys(collection);
	      length = props.length;
	    } else if (noCharByIndex && isString(collection)) {
	      iterable = collection.split('');
	    }
	    callback = createCallback(callback, thisArg, 4);
	    forEach(collection, function(value, index, collection) {
	      index = props ? props[--length] : --length;
	      accumulator = noaccum
	        ? (noaccum = false, iterable[index])
	        : callback(accumulator, iterable[index], index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The opposite of `_.filter`, this method returns the elements of a
	   * `collection` that `callback` does **not** return truthy for.
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Array} Returns a new array of elements that did **not** pass the
	   *  callback check.
	   * @example
	   *
	   * var odds = _.reject([1, 2, 3, 4, 5, 6], function(num) { return num % 2 == 0; });
	   * // => [1, 3, 5]
	   *
	   * var food = [
	   *   { 'name': 'apple',  'organic': false, 'type': 'fruit' },
	   *   { 'name': 'carrot', 'organic': true,  'type': 'vegetable' }
	   * ];
	   *
	   * // using "_.pluck" callback shorthand
	   * _.reject(food, 'organic');
	   * // => [{ 'name': 'apple', 'organic': false, 'type': 'fruit' }]
	   *
	   * // using "_.where" callback shorthand
	   * _.reject(food, { 'type': 'fruit' });
	   * // => [{ 'name': 'carrot', 'organic': true, 'type': 'vegetable' }]
	   */
	  function reject(collection, callback, thisArg) {
	    callback = createCallback(callback, thisArg);
	    return filter(collection, function(value, index, collection) {
	      return !callback(value, index, collection);
	    });
	  }
	
	  /**
	   * Creates an array of shuffled `array` values, using a version of the
	   * Fisher-Yates shuffle. See http://en.wikipedia.org/wiki/Fisher-Yates_shuffle.
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to shuffle.
	   * @returns {Array} Returns a new shuffled collection.
	   * @example
	   *
	   * _.shuffle([1, 2, 3, 4, 5, 6]);
	   * // => [4, 1, 6, 3, 5, 2]
	   */
	  function shuffle(collection) {
	    var index = -1,
	        length = collection ? collection.length : 0,
	        result = Array(typeof length == 'number' ? length : 0);
	
	    forEach(collection, function(value) {
	      var rand = floor(nativeRandom() * (++index + 1));
	      result[index] = result[rand];
	      result[rand] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Gets the size of the `collection` by returning `collection.length` for arrays
	   * and array-like objects or the number of own enumerable properties for objects.
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to inspect.
	   * @returns {Number} Returns `collection.length` or number of own enumerable properties.
	   * @example
	   *
	   * _.size([1, 2]);
	   * // => 2
	   *
	   * _.size({ 'one': 1, 'two': 2, 'three': 3 });
	   * // => 3
	   *
	   * _.size('curly');
	   * // => 5
	   */
	  function size(collection) {
	    var length = collection ? collection.length : 0;
	    return typeof length == 'number' ? length : keys(collection).length;
	  }
	
	  /**
	   * Checks if the `callback` returns a truthy value for **any** element of a
	   * `collection`. The function returns as soon as it finds passing value, and
	   * does not iterate over the entire `collection`. The `callback` is bound to
	   * `thisArg` and invoked with three arguments; (value, index|key, collection).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias any
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Boolean} Returns `true` if any element passes the callback check,
	   *  else `false`.
	   * @example
	   *
	   * _.some([null, 0, 'yes', false], Boolean);
	   * // => true
	   *
	   * var food = [
	   *   { 'name': 'apple',  'organic': false, 'type': 'fruit' },
	   *   { 'name': 'carrot', 'organic': true,  'type': 'vegetable' }
	   * ];
	   *
	   * // using "_.pluck" callback shorthand
	   * _.some(food, 'organic');
	   * // => true
	   *
	   * // using "_.where" callback shorthand
	   * _.some(food, { 'type': 'meat' });
	   * // => false
	   */
	  function some(collection, callback, thisArg) {
	    var result;
	    callback = createCallback(callback, thisArg);
	
	    if (isArray(collection)) {
	      var index = -1,
	          length = collection.length;
	
	      while (++index < length) {
	        if ((result = callback(collection[index], index, collection))) {
	          break;
	        }
	      }
	    } else {
	      each(collection, function(value, index, collection) {
	        return !(result = callback(value, index, collection));
	      });
	    }
	    return !!result;
	  }
	
	  /**
	   * Creates an array of elements, sorted in ascending order by the results of
	   * running each element in the `collection` through the `callback`. This method
	   * performs a stable sort, that is, it will preserve the original sort order of
	   * equal elements. The `callback` is bound to `thisArg` and invoked with three
	   * arguments; (value, index|key, collection).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Array} Returns a new array of sorted elements.
	   * @example
	   *
	   * _.sortBy([1, 2, 3], function(num) { return Math.sin(num); });
	   * // => [3, 1, 2]
	   *
	   * _.sortBy([1, 2, 3], function(num) { return this.sin(num); }, Math);
	   * // => [3, 1, 2]
	   *
	   * // using "_.pluck" callback shorthand
	   * _.sortBy(['banana', 'strawberry', 'apple'], 'length');
	   * // => ['apple', 'banana', 'strawberry']
	   */
	  function sortBy(collection, callback, thisArg) {
	    var index = -1,
	        length = collection ? collection.length : 0,
	        result = Array(typeof length == 'number' ? length : 0);
	
	    callback = createCallback(callback, thisArg);
	    forEach(collection, function(value, key, collection) {
	      result[++index] = {
	        'criteria': callback(value, key, collection),
	        'index': index,
	        'value': value
	      };
	    });
	
	    length = result.length;
	    result.sort(compareAscending);
	    while (length--) {
	      result[length] = result[length].value;
	    }
	    return result;
	  }
	
	  /**
	   * Converts the `collection` to an array.
	   *
	   * @static
	   * @memberOf _
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to convert.
	   * @returns {Array} Returns the new converted array.
	   * @example
	   *
	   * (function() { return _.toArray(arguments).slice(1); })(1, 2, 3, 4);
	   * // => [2, 3, 4]
	   */
	  function toArray(collection) {
	    if (collection && typeof collection.length == 'number') {
	      return noCharByIndex && isString(collection)
	        ? collection.split('')
	        : slice(collection);
	    }
	    return values(collection);
	  }
	
	  /**
	   * Examines each element in a `collection`, returning an array of all elements
	   * that have the given `properties`. When checking `properties`, this method
	   * performs a deep comparison between values to determine if they are equivalent
	   * to each other.
	   *
	   * @static
	   * @memberOf _
	   * @type Function
	   * @category Collections
	   * @param {Array|Object|String} collection The collection to iterate over.
	   * @param {Object} properties The object of property values to filter by.
	   * @returns {Array} Returns a new array of elements that have the given `properties`.
	   * @example
	   *
	   * var stooges = [
	   *   { 'name': 'moe', 'age': 40 },
	   *   { 'name': 'larry', 'age': 50 }
	   * ];
	   *
	   * _.where(stooges, { 'age': 40 });
	   * // => [{ 'name': 'moe', 'age': 40 }]
	   */
	  var where = filter;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates an array with all falsey values of `array` removed. The values
	   * `false`, `null`, `0`, `""`, `undefined` and `NaN` are all falsey.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} array The array to compact.
	   * @returns {Array} Returns a new filtered array.
	   * @example
	   *
	   * _.compact([0, 1, false, 2, '', 3]);
	   * // => [1, 2, 3]
	   */
	  function compact(array) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Creates an array of `array` elements not present in the other arrays
	   * using strict equality for comparisons, i.e. `===`.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} array The array to process.
	   * @param {Array} [array1, array2, ...] Arrays to check.
	   * @returns {Array} Returns a new array of `array` elements not present in the
	   *  other arrays.
	   * @example
	   *
	   * _.difference([1, 2, 3, 4, 5], [5, 2, 10]);
	   * // => [1, 3, 4]
	   */
	  function difference(array) {
	    var index = -1,
	        length = array ? array.length : 0,
	        flattened = concat.apply(arrayRef, arguments),
	        contains = cachedContains(flattened, length),
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (!contains(value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the first element of the `array`. If a number `n` is passed, the first
	   * `n` elements of the `array` are returned. If a `callback` function is passed,
	   * the first elements the `callback` returns truthy for are returned. The `callback`
	   * is bound to `thisArg` and invoked with three arguments; (value, index, array).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias head, take
	   * @category Arrays
	   * @param {Array} array The array to query.
	   * @param {Function|Object|Number|String} [callback|n] The function called
	   *  per element or the number of elements to return. If a property name or
	   *  object is passed, it will be used to create a "_.pluck" or "_.where"
	   *  style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Mixed} Returns the first element(s) of `array`.
	   * @example
	   *
	   * _.first([1, 2, 3]);
	   * // => 1
	   *
	   * _.first([1, 2, 3], 2);
	   * // => [1, 2]
	   *
	   * _.first([1, 2, 3], function(num) {
	   *   return num < 3;
	   * });
	   * // => [1, 2]
	   *
	   * var food = [
	   *   { 'name': 'banana', 'organic': true },
	   *   { 'name': 'beet',   'organic': false },
	   * ];
	   *
	   * // using "_.pluck" callback shorthand
	   * _.first(food, 'organic');
	   * // => [{ 'name': 'banana', 'organic': true }]
	   *
	   * var food = [
	   *   { 'name': 'apple',  'type': 'fruit' },
	   *   { 'name': 'banana', 'type': 'fruit' },
	   *   { 'name': 'beet',   'type': 'vegetable' }
	   * ];
	   *
	   * // using "_.where" callback shorthand
	   * _.first(food, { 'type': 'fruit' });
	   * // => [{ 'name': 'apple', 'type': 'fruit' }, { 'name': 'banana', 'type': 'fruit' }]
	   */
	  function first(array, callback, thisArg) {
	    if (array) {
	      var n = 0,
	          length = array.length;
	
	      if (typeof callback != 'number' && callback != null) {
	        var index = -1;
	        callback = createCallback(callback, thisArg);
	        while (++index < length && callback(array[index], index, array)) {
	          n++;
	        }
	      } else {
	        n = callback;
	        if (n == null || thisArg) {
	          return array[0];
	        }
	      }
	      return slice(array, 0, nativeMin(nativeMax(0, n), length));
	    }
	  }
	
	  /**
	   * Flattens a nested array (the nesting can be to any depth). If `shallow` is
	   * truthy, `array` will only be flattened a single level.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} array The array to compact.
	   * @param {Boolean} shallow A flag to indicate only flattening a single level.
	   * @returns {Array} Returns a new flattened array.
	   * @example
	   *
	   * _.flatten([1, [2], [3, [[4]]]]);
	   * // => [1, 2, 3, 4];
	   *
	   * _.flatten([1, [2], [3, [[4]]]], true);
	   * // => [1, 2, 3, [[4]]];
	   */
	  function flatten(array, shallow) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	
	      // recursively flatten arrays (susceptible to call stack limits)
	      if (isArray(value)) {
	        push.apply(result, shallow ? value : flatten(value));
	      } else {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the index at which the first occurrence of `value` is found using
	   * strict equality for comparisons, i.e. `===`. If the `array` is already
	   * sorted, passing `true` for `fromIndex` will run a faster binary search.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} array The array to search.
	   * @param {Mixed} value The value to search for.
	   * @param {Boolean|Number} [fromIndex=0] The index to search from or `true` to
	   *  perform a binary search on a sorted `array`.
	   * @returns {Number} Returns the index of the matched value or `-1`.
	   * @example
	   *
	   * _.indexOf([1, 2, 3, 1, 2, 3], 2);
	   * // => 1
	   *
	   * _.indexOf([1, 2, 3, 1, 2, 3], 2, 3);
	   * // => 4
	   *
	   * _.indexOf([1, 1, 2, 2, 3, 3], 2, true);
	   * // => 2
	   */
	  function indexOf(array, value, fromIndex) {
	    var index = -1,
	        length = array ? array.length : 0;
	
	    if (typeof fromIndex == 'number') {
	      index = (fromIndex < 0 ? nativeMax(0, length + fromIndex) : fromIndex || 0) - 1;
	    } else if (fromIndex) {
	      index = sortedIndex(array, value);
	      return array[index] === value ? index : -1;
	    }
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Gets all but the last element of `array`. If a number `n` is passed, the
	   * last `n` elements are excluded from the result. If a `callback` function
	   * is passed, the last elements the `callback` returns truthy for are excluded
	   * from the result. The `callback` is bound to `thisArg` and invoked with three
	   * arguments; (value, index, array).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} array The array to query.
	   * @param {Function|Object|Number|String} [callback|n=1] The function called
	   *  per element or the number of elements to exclude. If a property name or
	   *  object is passed, it will be used to create a "_.pluck" or "_.where"
	   *  style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Array} Returns a slice of `array`.
	   * @example
	   *
	   * _.initial([1, 2, 3]);
	   * // => [1, 2]
	   *
	   * _.initial([1, 2, 3], 2);
	   * // => [1]
	   *
	   * _.initial([1, 2, 3], function(num) {
	   *   return num > 1;
	   * });
	   * // => [1]
	   *
	   * var food = [
	   *   { 'name': 'beet',   'organic': false },
	   *   { 'name': 'carrot', 'organic': true }
	   * ];
	   *
	   * // using "_.pluck" callback shorthand
	   * _.initial(food, 'organic');
	   * // => [{ 'name': 'beet',   'organic': false }]
	   *
	   * var food = [
	   *   { 'name': 'banana', 'type': 'fruit' },
	   *   { 'name': 'beet',   'type': 'vegetable' },
	   *   { 'name': 'carrot', 'type': 'vegetable' }
	   * ];
	   *
	   * // using "_.where" callback shorthand
	   * _.initial(food, { 'type': 'vegetable' });
	   * // => [{ 'name': 'banana', 'type': 'fruit' }]
	   */
	  function initial(array, callback, thisArg) {
	    if (!array) {
	      return [];
	    }
	    var n = 0,
	        length = array.length;
	
	    if (typeof callback != 'number' && callback != null) {
	      var index = length;
	      callback = createCallback(callback, thisArg);
	      while (index-- && callback(array[index], index, array)) {
	        n++;
	      }
	    } else {
	      n = (callback == null || thisArg) ? 1 : callback || n;
	    }
	    return slice(array, 0, nativeMin(nativeMax(0, length - n), length));
	  }
	
	  /**
	   * Computes the intersection of all the passed-in arrays using strict equality
	   * for comparisons, i.e. `===`.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} [array1, array2, ...] Arrays to process.
	   * @returns {Array} Returns a new array of unique elements that are present
	   *  in **all** of the arrays.
	   * @example
	   *
	   * _.intersection([1, 2, 3], [101, 2, 1, 10], [2, 1]);
	   * // => [1, 2]
	   */
	  function intersection(array) {
	    var args = arguments,
	        argsLength = args.length,
	        cache = { '0': {} },
	        index = -1,
	        length = array ? array.length : 0,
	        isLarge = length >= 100,
	        result = [],
	        seen = result;
	
	    outer:
	    while (++index < length) {
	      var value = array[index];
	      if (isLarge) {
	        var key = value + '';
	        var inited = hasOwnProperty.call(cache[0], key)
	          ? !(seen = cache[0][key])
	          : (seen = cache[0][key] = []);
	      }
	      if (inited || indexOf(seen, value) < 0) {
	        if (isLarge) {
	          seen.push(value);
	        }
	        var argsIndex = argsLength;
	        while (--argsIndex) {
	          if (!(cache[argsIndex] || (cache[argsIndex] = cachedContains(args[argsIndex], 0, 100)))(value)) {
	            continue outer;
	          }
	        }
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Gets the last element of the `array`. If a number `n` is passed, the last
	   * `n` elements of the `array` are returned. If a `callback` function is passed,
	   * the last elements the `callback` returns truthy for are returned. The `callback`
	   * is bound to `thisArg` and invoked with three arguments; (value, index, array).
	   *
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} array The array to query.
	   * @param {Function|Object|Number|String} [callback|n] The function called
	   *  per element or the number of elements to return. If a property name or
	   *  object is passed, it will be used to create a "_.pluck" or "_.where"
	   *  style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Mixed} Returns the last element(s) of `array`.
	   * @example
	   *
	   * _.last([1, 2, 3]);
	   * // => 3
	   *
	   * _.last([1, 2, 3], 2);
	   * // => [2, 3]
	   *
	   * _.last([1, 2, 3], function(num) {
	   *   return num > 1;
	   * });
	   * // => [2, 3]
	   *
	   * var food = [
	   *   { 'name': 'beet',   'organic': false },
	   *   { 'name': 'carrot', 'organic': true }
	   * ];
	   *
	   * // using "_.pluck" callback shorthand
	   * _.last(food, 'organic');
	   * // => [{ 'name': 'carrot', 'organic': true }]
	   *
	   * var food = [
	   *   { 'name': 'banana', 'type': 'fruit' },
	   *   { 'name': 'beet',   'type': 'vegetable' },
	   *   { 'name': 'carrot', 'type': 'vegetable' }
	   * ];
	   *
	   * // using "_.where" callback shorthand
	   * _.last(food, { 'type': 'vegetable' });
	   * // => [{ 'name': 'beet', 'type': 'vegetable' }, { 'name': 'carrot', 'type': 'vegetable' }]
	   */
	  function last(array, callback, thisArg) {
	    if (array) {
	      var n = 0,
	          length = array.length;
	
	      if (typeof callback != 'number' && callback != null) {
	        var index = length;
	        callback = createCallback(callback, thisArg);
	        while (index-- && callback(array[index], index, array)) {
	          n++;
	        }
	      } else {
	        n = callback;
	        if (n == null || thisArg) {
	          return array[length - 1];
	        }
	      }
	      return slice(array, nativeMax(0, length - n));
	    }
	  }
	
	  /**
	   * Gets the index at which the last occurrence of `value` is found using strict
	   * equality for comparisons, i.e. `===`. If `fromIndex` is negative, it is used
	   * as the offset from the end of the collection.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} array The array to search.
	   * @param {Mixed} value The value to search for.
	   * @param {Number} [fromIndex=array.length-1] The index to search from.
	   * @returns {Number} Returns the index of the matched value or `-1`.
	   * @example
	   *
	   * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2);
	   * // => 4
	   *
	   * _.lastIndexOf([1, 2, 3, 1, 2, 3], 2, 3);
	   * // => 1
	   */
	  function lastIndexOf(array, value, fromIndex) {
	    var index = array ? array.length : 0;
	    if (typeof fromIndex == 'number') {
	      index = (fromIndex < 0 ? nativeMax(0, index + fromIndex) : nativeMin(fromIndex, index - 1)) + 1;
	    }
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * Creates an object composed from arrays of `keys` and `values`. Pass either
	   * a single two dimensional array, i.e. `[[key1, value1], [key2, value2]]`, or
	   * two arrays, one of `keys` and one of corresponding `values`.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} keys The array of keys.
	   * @param {Array} [values=[]] The array of values.
	   * @returns {Object} Returns an object composed of the given keys and
	   *  corresponding values.
	   * @example
	   *
	   * _.object(['moe', 'larry'], [30, 40]);
	   * // => { 'moe': 30, 'larry': 40 }
	   */
	  function object(keys, values) {
	    var index = -1,
	        length = keys ? keys.length : 0,
	        result = {};
	
	    while (++index < length) {
	      var key = keys[index];
	      if (values) {
	        result[key] = values[index];
	      } else {
	        result[key[0]] = key[1];
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Creates an array of numbers (positive and/or negative) progressing from
	   * `start` up to but not including `end`.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Number} [start=0] The start of the range.
	   * @param {Number} end The end of the range.
	   * @param {Number} [step=1] The value to increment or descrement by.
	   * @returns {Array} Returns a new range array.
	   * @example
	   *
	   * _.range(10);
	   * // => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]
	   *
	   * _.range(1, 11);
	   * // => [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
	   *
	   * _.range(0, 30, 5);
	   * // => [0, 5, 10, 15, 20, 25]
	   *
	   * _.range(0, -10, -1);
	   * // => [0, -1, -2, -3, -4, -5, -6, -7, -8, -9]
	   *
	   * _.range(0);
	   * // => []
	   */
	  function range(start, end, step) {
	    start = +start || 0;
	    step = +step || 1;
	
	    if (end == null) {
	      end = start;
	      start = 0;
	    }
	    // use `Array(length)` so V8 will avoid the slower "dictionary" mode
	    // http://youtu.be/XAqIpGU8ZZk#t=17m25s
	    var index = -1,
	        length = nativeMax(0, ceil((end - start) / step)),
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = start;
	      start += step;
	    }
	    return result;
	  }
	
	  /**
	   * The opposite of `_.initial`, this method gets all but the first value of `array`.
	   * If a number `n` is passed, the first `n` values are excluded from the result.
	   * If a `callback` function is passed, the first elements the `callback` returns
	   * truthy for are excluded from the result. The `callback` is bound to `thisArg`
	   * and invoked with three arguments; (value, index, array).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias drop, tail
	   * @category Arrays
	   * @param {Array} array The array to query.
	   * @param {Function|Object|Number|String} [callback|n=1] The function called
	   *  per element or the number of elements to exclude. If a property name or
	   *  object is passed, it will be used to create a "_.pluck" or "_.where"
	   *  style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Array} Returns a slice of `array`.
	   * @example
	   *
	   * _.rest([1, 2, 3]);
	   * // => [2, 3]
	   *
	   * _.rest([1, 2, 3], 2);
	   * // => [3]
	   *
	   * _.rest([1, 2, 3], function(num) {
	   *   return num < 3;
	   * });
	   * // => [3]
	   *
	   * var food = [
	   *   { 'name': 'banana', 'organic': true },
	   *   { 'name': 'beet',   'organic': false },
	   * ];
	   *
	   * // using "_.pluck" callback shorthand
	   * _.rest(food, 'organic');
	   * // => [{ 'name': 'beet', 'organic': false }]
	   *
	   * var food = [
	   *   { 'name': 'apple',  'type': 'fruit' },
	   *   { 'name': 'banana', 'type': 'fruit' },
	   *   { 'name': 'beet',   'type': 'vegetable' }
	   * ];
	   *
	   * // using "_.where" callback shorthand
	   * _.rest(food, { 'type': 'fruit' });
	   * // => [{ 'name': 'beet', 'type': 'vegetable' }]
	   */
	  function rest(array, callback, thisArg) {
	    if (typeof callback != 'number' && callback != null) {
	      var n = 0,
	          index = -1,
	          length = array ? array.length : 0;
	
	      callback = createCallback(callback, thisArg);
	      while (++index < length && callback(array[index], index, array)) {
	        n++;
	      }
	    } else {
	      n = (callback == null || thisArg) ? 1 : nativeMax(0, callback);
	    }
	    return slice(array, n);
	  }
	
	  /**
	   * Uses a binary search to determine the smallest index at which the `value`
	   * should be inserted into `array` in order to maintain the sort order of the
	   * sorted `array`. If `callback` is passed, it will be executed for `value` and
	   * each element in `array` to compute their sort ranking. The `callback` is
	   * bound to `thisArg` and invoked with one argument; (value).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} array The array to iterate over.
	   * @param {Mixed} value The value to evaluate.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Number} Returns the index at which the value should be inserted
	   *  into `array`.
	   * @example
	   *
	   * _.sortedIndex([20, 30, 50], 40);
	   * // => 2
	   *
	   * // using "_.pluck" callback shorthand
	   * _.sortedIndex([{ 'x': 20 }, { 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
	   * // => 2
	   *
	   * var dict = {
	   *   'wordToNumber': { 'twenty': 20, 'thirty': 30, 'fourty': 40, 'fifty': 50 }
	   * };
	   *
	   * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
	   *   return dict.wordToNumber[word];
	   * });
	   * // => 2
	   *
	   * _.sortedIndex(['twenty', 'thirty', 'fifty'], 'fourty', function(word) {
	   *   return this.wordToNumber[word];
	   * }, dict);
	   * // => 2
	   */
	  function sortedIndex(array, value, callback, thisArg) {
	    var low = 0,
	        high = array ? array.length : low;
	
	    // explicitly reference `identity` for better inlining in Firefox
	    callback = callback ? createCallback(callback, thisArg, 1) : identity;
	    value = callback(value);
	
	    while (low < high) {
	      var mid = (low + high) >>> 1;
	      callback(array[mid]) < value
	        ? low = mid + 1
	        : high = mid;
	    }
	    return low;
	  }
	
	  /**
	   * Computes the union of the passed-in arrays using strict equality for
	   * comparisons, i.e. `===`.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} [array1, array2, ...] Arrays to process.
	   * @returns {Array} Returns a new array of unique values, in order, that are
	   *  present in one or more of the arrays.
	   * @example
	   *
	   * _.union([1, 2, 3], [101, 2, 1, 10], [2, 1]);
	   * // => [1, 2, 3, 101, 10]
	   */
	  function union() {
	    return uniq(concat.apply(arrayRef, arguments));
	  }
	
	  /**
	   * Creates a duplicate-value-free version of the `array` using strict equality
	   * for comparisons, i.e. `===`. If the `array` is already sorted, passing `true`
	   * for `isSorted` will run a faster algorithm. If `callback` is passed, each
	   * element of `array` is passed through a callback` before uniqueness is computed.
	   * The `callback` is bound to `thisArg` and invoked with three arguments; (value, index, array).
	   *
	   * If a property name is passed for `callback`, the created "_.pluck" style
	   * callback will return the property value of the given element.
	   *
	   * If an object is passed for `callback`, the created "_.where" style callback
	   * will return `true` for elements that have the propeties of the given object,
	   * else `false`.
	   *
	   * @static
	   * @memberOf _
	   * @alias unique
	   * @category Arrays
	   * @param {Array} array The array to process.
	   * @param {Boolean} [isSorted=false] A flag to indicate that the `array` is already sorted.
	   * @param {Function|Object|String} [callback=identity] The function called per
	   *  iteration. If a property name or object is passed, it will be used to create
	   *  a "_.pluck" or "_.where" style callback, respectively.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Array} Returns a duplicate-value-free array.
	   * @example
	   *
	   * _.uniq([1, 2, 1, 3, 1]);
	   * // => [1, 2, 3]
	   *
	   * _.uniq([1, 1, 2, 2, 3], true);
	   * // => [1, 2, 3]
	   *
	   * _.uniq([1, 2, 1.5, 3, 2.5], function(num) { return Math.floor(num); });
	   * // => [1, 2, 3]
	   *
	   * _.uniq([1, 2, 1.5, 3, 2.5], function(num) { return this.floor(num); }, Math);
	   * // => [1, 2, 3]
	   *
	   * // using "_.pluck" callback shorthand
	   * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	   * // => [{ 'x': 1 }, { 'x': 2 }]
	   */
	  function uniq(array, isSorted, callback, thisArg) {
	    var index = -1,
	        length = array ? array.length : 0,
	        result = [],
	        seen = result;
	
	    // juggle arguments
	    if (typeof isSorted == 'function') {
	      thisArg = callback;
	      callback = isSorted;
	      isSorted = false;
	    }
	    // init value cache for large arrays
	    var isLarge = !isSorted && length >= 75;
	    if (isLarge) {
	      var cache = {};
	    }
	    if (callback) {
	      seen = [];
	      callback = createCallback(callback, thisArg);
	    }
	    while (++index < length) {
	      var value = array[index],
	          computed = callback ? callback(value, index, array) : value;
	
	      if (isLarge) {
	        var key = computed + '';
	        var inited = hasOwnProperty.call(cache, key)
	          ? !(seen = cache[key])
	          : (seen = cache[key] = []);
	      }
	      if (isSorted
	            ? !index || seen[seen.length - 1] !== computed
	            : inited || indexOf(seen, computed) < 0
	          ) {
	        if (callback || isLarge) {
	          seen.push(computed);
	        }
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Creates an array with all occurrences of the passed values removed using
	   * strict equality for comparisons, i.e. `===`.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} array The array to filter.
	   * @param {Mixed} [value1, value2, ...] Values to remove.
	   * @returns {Array} Returns a new filtered array.
	   * @example
	   *
	   * _.without([1, 2, 1, 0, 3, 1, 4], 0, 1);
	   * // => [2, 3, 4]
	   */
	  function without(array) {
	    var index = -1,
	        length = array ? array.length : 0,
	        contains = cachedContains(arguments, 1),
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (!contains(value)) {
	        result.push(value);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Groups the elements of each array at their corresponding indexes. Useful for
	   * separate data sources that are coordinated through matching array indexes.
	   * For a matrix of nested arrays, `_.zip.apply(...)` can transpose the matrix
	   * in a similar fashion.
	   *
	   * @static
	   * @memberOf _
	   * @category Arrays
	   * @param {Array} [array1, array2, ...] Arrays to process.
	   * @returns {Array} Returns a new array of grouped elements.
	   * @example
	   *
	   * _.zip(['moe', 'larry'], [30, 40], [true, false]);
	   * // => [['moe', 30, true], ['larry', 40, false]]
	   */
	  function zip(array) {
	    var index = -1,
	        length = array ? max(pluck(arguments, 'length')) : 0,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = pluck(arguments, index);
	    }
	    return result;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Creates a function that is restricted to executing `func` only after it is
	   * called `n` times. The `func` is executed with the `this` binding of the
	   * created function.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Number} n The number of times the function must be called before
	   * it is executed.
	   * @param {Function} func The function to restrict.
	   * @returns {Function} Returns the new restricted function.
	   * @example
	   *
	   * var renderNotes = _.after(notes.length, render);
	   * _.forEach(notes, function(note) {
	   *   note.asyncSave({ 'success': renderNotes });
	   * });
	   * // `renderNotes` is run once, after all notes have saved
	   */
	  function after(n, func) {
	    if (n < 1) {
	      return func();
	    }
	    return function() {
	      if (--n < 1) {
	        return func.apply(this, arguments);
	      }
	    };
	  }
	
	  /**
	   * Creates a function that, when called, invokes `func` with the `this`
	   * binding of `thisArg` and prepends any additional `bind` arguments to those
	   * passed to the bound function.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Function} func The function to bind.
	   * @param {Mixed} [thisArg] The `this` binding of `func`.
	   * @param {Mixed} [arg1, arg2, ...] Arguments to be partially applied.
	   * @returns {Function} Returns the new bound function.
	   * @example
	   *
	   * var func = function(greeting) {
	   *   return greeting + ' ' + this.name;
	   * };
	   *
	   * func = _.bind(func, { 'name': 'moe' }, 'hi');
	   * func();
	   * // => 'hi moe'
	   */
	  function bind(func, thisArg) {
	    // use `Function#bind` if it exists and is fast
	    // (in V8 `Function#bind` is slower except when partially applied)
	    return isBindFast || (nativeBind && arguments.length > 2)
	      ? nativeBind.call.apply(nativeBind, arguments)
	      : createBound(func, thisArg, slice(arguments, 2));
	  }
	
	  /**
	   * Binds methods on `object` to `object`, overwriting the existing method.
	   * Method names may be specified as individual arguments or as arrays of method
	   * names. If no method names are provided, all the function properties of `object`
	   * will be bound.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Object} object The object to bind and assign the bound methods to.
	   * @param {String} [methodName1, methodName2, ...] Method names on the object to bind.
	   * @returns {Object} Returns `object`.
	   * @example
	   *
	   * var view = {
	   *  'label': 'docs',
	   *  'onClick': function() { alert('clicked ' + this.label); }
	   * };
	   *
	   * _.bindAll(view);
	   * jQuery('#docs').on('click', view.onClick);
	   * // => alerts 'clicked docs', when the button is clicked
	   */
	  function bindAll(object) {
	    var funcs = concat.apply(arrayRef, arguments),
	        index = funcs.length > 1 ? 0 : (funcs = functions(object), -1),
	        length = funcs.length;
	
	    while (++index < length) {
	      var key = funcs[index];
	      object[key] = bind(object[key], object);
	    }
	    return object;
	  }
	
	  /**
	   * Creates a function that, when called, invokes the method at `object[key]`
	   * and prepends any additional `bindKey` arguments to those passed to the bound
	   * function. This method differs from `_.bind` by allowing bound functions to
	   * reference methods that will be redefined or don't yet exist.
	   * See http://michaux.ca/articles/lazy-function-definition-pattern.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Object} object The object the method belongs to.
	   * @param {String} key The key of the method.
	   * @param {Mixed} [arg1, arg2, ...] Arguments to be partially applied.
	   * @returns {Function} Returns the new bound function.
	   * @example
	   *
	   * var object = {
	   *   'name': 'moe',
	   *   'greet': function(greeting) {
	   *     return greeting + ' ' + this.name;
	   *   }
	   * };
	   *
	   * var func = _.bindKey(object, 'greet', 'hi');
	   * func();
	   * // => 'hi moe'
	   *
	   * object.greet = function(greeting) {
	   *   return greeting + ', ' + this.name + '!';
	   * };
	   *
	   * func();
	   * // => 'hi, moe!'
	   */
	  function bindKey(object, key) {
	    return createBound(object, key, slice(arguments, 2));
	  }
	
	  /**
	   * Creates a function that is the composition of the passed functions,
	   * where each function consumes the return value of the function that follows.
	   * For example, composing the functions `f()`, `g()`, and `h()` produces `f(g(h()))`.
	   * Each function is executed with the `this` binding of the composed function.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Function} [func1, func2, ...] Functions to compose.
	   * @returns {Function} Returns the new composed function.
	   * @example
	   *
	   * var greet = function(name) { return 'hi ' + name; };
	   * var exclaim = function(statement) { return statement + '!'; };
	   * var welcome = _.compose(exclaim, greet);
	   * welcome('moe');
	   * // => 'hi moe!'
	   */
	  function compose() {
	    var funcs = arguments;
	    return function() {
	      var args = arguments,
	          length = funcs.length;
	
	      while (length--) {
	        args = [funcs[length].apply(this, args)];
	      }
	      return args[0];
	    };
	  }
	
	  /**
	   * Creates a function that will delay the execution of `func` until after
	   * `wait` milliseconds have elapsed since the last time it was invoked. Pass
	   * `true` for `immediate` to cause debounce to invoke `func` on the leading,
	   * instead of the trailing, edge of the `wait` timeout. Subsequent calls to
	   * the debounced function will return the result of the last `func` call.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Function} func The function to debounce.
	   * @param {Number} wait The number of milliseconds to delay.
	   * @param {Boolean} immediate A flag to indicate execution is on the leading
	   *  edge of the timeout.
	   * @returns {Function} Returns the new debounced function.
	   * @example
	   *
	   * var lazyLayout = _.debounce(calculateLayout, 300);
	   * jQuery(window).on('resize', lazyLayout);
	   */
	  function debounce(func, wait, immediate) {
	    var args,
	        result,
	        thisArg,
	        timeoutId;
	
	    function delayed() {
	      timeoutId = null;
	      if (!immediate) {
	        result = func.apply(thisArg, args);
	      }
	    }
	    return function() {
	      var isImmediate = immediate && !timeoutId;
	      args = arguments;
	      thisArg = this;
	
	      clearTimeout(timeoutId);
	      timeoutId = setTimeout(delayed, wait);
	
	      if (isImmediate) {
	        result = func.apply(thisArg, args);
	      }
	      return result;
	    };
	  }
	
	  /**
	   * Executes the `func` function after `wait` milliseconds. Additional arguments
	   * will be passed to `func` when it is invoked.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Function} func The function to delay.
	   * @param {Number} wait The number of milliseconds to delay execution.
	   * @param {Mixed} [arg1, arg2, ...] Arguments to invoke the function with.
	   * @returns {Number} Returns the `setTimeout` timeout id.
	   * @example
	   *
	   * var log = _.bind(console.log, console);
	   * _.delay(log, 1000, 'logged later');
	   * // => 'logged later' (Appears after one second.)
	   */
	  function delay(func, wait) {
	    var args = slice(arguments, 2);
	    return setTimeout(function() { func.apply(undefined, args); }, wait);
	  }
	
	  /**
	   * Defers executing the `func` function until the current call stack has cleared.
	   * Additional arguments will be passed to `func` when it is invoked.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Function} func The function to defer.
	   * @param {Mixed} [arg1, arg2, ...] Arguments to invoke the function with.
	   * @returns {Number} Returns the `setTimeout` timeout id.
	   * @example
	   *
	   * _.defer(function() { alert('deferred'); });
	   * // returns from the function before `alert` is called
	   */
	  function defer(func) {
	    var args = slice(arguments, 1);
	    return setTimeout(function() { func.apply(undefined, args); }, 1);
	  }
	  // use `setImmediate` if it's available in Node.js
	  if (isV8 && freeModule && typeof setImmediate == 'function') {
	    defer = bind(setImmediate, window);
	  }
	
	  /**
	   * Creates a function that memoizes the result of `func`. If `resolver` is
	   * passed, it will be used to determine the cache key for storing the result
	   * based on the arguments passed to the memoized function. By default, the first
	   * argument passed to the memoized function is used as the cache key. The `func`
	   * is executed with the `this` binding of the memoized function.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Function} func The function to have its output memoized.
	   * @param {Function} [resolver] A function used to resolve the cache key.
	   * @returns {Function} Returns the new memoizing function.
	   * @example
	   *
	   * var fibonacci = _.memoize(function(n) {
	   *   return n < 2 ? n : fibonacci(n - 1) + fibonacci(n - 2);
	   * });
	   */
	  function memoize(func, resolver) {
	    var cache = {};
	    return function() {
	      var key = (resolver ? resolver.apply(this, arguments) : arguments[0]) + '';
	      return hasOwnProperty.call(cache, key)
	        ? cache[key]
	        : (cache[key] = func.apply(this, arguments));
	    };
	  }
	
	  /**
	   * Creates a function that is restricted to execute `func` once. Repeat calls to
	   * the function will return the value of the first call. The `func` is executed
	   * with the `this` binding of the created function.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Function} func The function to restrict.
	   * @returns {Function} Returns the new restricted function.
	   * @example
	   *
	   * var initialize = _.once(createApplication);
	   * initialize();
	   * initialize();
	   * // `initialize` executes `createApplication` once
	   */
	  function once(func) {
	    var ran,
	        result;
	
	    return function() {
	      if (ran) {
	        return result;
	      }
	      ran = true;
	      result = func.apply(this, arguments);
	
	      // clear the `func` variable so the function may be garbage collected
	      func = null;
	      return result;
	    };
	  }
	
	  /**
	   * Creates a function that, when called, invokes `func` with any additional
	   * `partial` arguments prepended to those passed to the new function. This
	   * method is similar to `_.bind`, except it does **not** alter the `this` binding.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Function} func The function to partially apply arguments to.
	   * @param {Mixed} [arg1, arg2, ...] Arguments to be partially applied.
	   * @returns {Function} Returns the new partially applied function.
	   * @example
	   *
	   * var greet = function(greeting, name) { return greeting + ' ' + name; };
	   * var hi = _.partial(greet, 'hi');
	   * hi('moe');
	   * // => 'hi moe'
	   */
	  function partial(func) {
	    return createBound(func, slice(arguments, 1));
	  }
	
	  /**
	   * This method is similar to `_.partial`, except that `partial` arguments are
	   * appended to those passed to the new function.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Function} func The function to partially apply arguments to.
	   * @param {Mixed} [arg1, arg2, ...] Arguments to be partially applied.
	   * @returns {Function} Returns the new partially applied function.
	   * @example
	   *
	   * var defaultsDeep = _.partialRight(_.merge, _.defaults);
	   *
	   * var options = {
	   *   'variable': 'data',
	   *   'imports': { 'jq': $ }
	   * };
	   *
	   * defaultsDeep(options, _.templateSettings);
	   *
	   * options.variable
	   * // => 'data'
	   *
	   * options.imports
	   * // => { '_': _, 'jq': $ }
	   */
	  function partialRight(func) {
	    return createBound(func, slice(arguments, 1), null, indicatorObject);
	  }
	
	  /**
	   * Creates a function that, when executed, will only call the `func`
	   * function at most once per every `wait` milliseconds. If the throttled
	   * function is invoked more than once during the `wait` timeout, `func` will
	   * also be called on the trailing edge of the timeout. Subsequent calls to the
	   * throttled function will return the result of the last `func` call.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Function} func The function to throttle.
	   * @param {Number} wait The number of milliseconds to throttle executions to.
	   * @returns {Function} Returns the new throttled function.
	   * @example
	   *
	   * var throttled = _.throttle(updatePosition, 100);
	   * jQuery(window).on('scroll', throttled);
	   */
	  function throttle(func, wait) {
	    var args,
	        result,
	        thisArg,
	        timeoutId,
	        lastCalled = 0;
	
	    function trailingCall() {
	      lastCalled = new Date;
	      timeoutId = null;
	      result = func.apply(thisArg, args);
	    }
	    return function() {
	      var now = new Date,
	          remaining = wait - (now - lastCalled);
	
	      args = arguments;
	      thisArg = this;
	
	      if (remaining <= 0) {
	        clearTimeout(timeoutId);
	        timeoutId = null;
	        lastCalled = now;
	        result = func.apply(thisArg, args);
	      }
	      else if (!timeoutId) {
	        timeoutId = setTimeout(trailingCall, remaining);
	      }
	      return result;
	    };
	  }
	
	  /**
	   * Creates a function that passes `value` to the `wrapper` function as its
	   * first argument. Additional arguments passed to the function are appended
	   * to those passed to the `wrapper` function. The `wrapper` is executed with
	   * the `this` binding of the created function.
	   *
	   * @static
	   * @memberOf _
	   * @category Functions
	   * @param {Mixed} value The value to wrap.
	   * @param {Function} wrapper The wrapper function.
	   * @returns {Function} Returns the new function.
	   * @example
	   *
	   * var hello = function(name) { return 'hello ' + name; };
	   * hello = _.wrap(hello, function(func) {
	   *   return 'before, ' + func('moe') + ', after';
	   * });
	   * hello();
	   * // => 'before, hello moe, after'
	   */
	  function wrap(value, wrapper) {
	    return function() {
	      var args = [value];
	      push.apply(args, arguments);
	      return wrapper.apply(this, args);
	    };
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Converts the characters `&`, `<`, `>`, `"`, and `'` in `string` to their
	   * corresponding HTML entities.
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @param {String} string The string to escape.
	   * @returns {String} Returns the escaped string.
	   * @example
	   *
	   * _.escape('Moe, Larry & Curly');
	   * // => 'Moe, Larry &amp; Curly'
	   */
	  function escape(string) {
	    return string == null ? '' : (string + '').replace(reUnescapedHtml, escapeHtmlChar);
	  }
	
	  /**
	   * This function returns the first argument passed to it.
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @param {Mixed} value Any value.
	   * @returns {Mixed} Returns `value`.
	   * @example
	   *
	   * var moe = { 'name': 'moe' };
	   * moe === _.identity(moe);
	   * // => true
	   */
	  function identity(value) {
	    return value;
	  }
	
	  /**
	   * Adds functions properties of `object` to the `lodash` function and chainable
	   * wrapper.
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @param {Object} object The object of function properties to add to `lodash`.
	   * @example
	   *
	   * _.mixin({
	   *   'capitalize': function(string) {
	   *     return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
	   *   }
	   * });
	   *
	   * _.capitalize('moe');
	   * // => 'Moe'
	   *
	   * _('moe').capitalize();
	   * // => 'Moe'
	   */
	  function mixin(object) {
	    forEach(functions(object), function(methodName) {
	      var func = lodash[methodName] = object[methodName];
	
	      lodash.prototype[methodName] = function() {
	        var args = [this.__wrapped__];
	        push.apply(args, arguments);
	        return new lodash(func.apply(lodash, args));
	      };
	    });
	  }
	
	  /**
	   * Reverts the '_' variable to its previous value and returns a reference to
	   * the `lodash` function.
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @returns {Function} Returns the `lodash` function.
	   * @example
	   *
	   * var lodash = _.noConflict();
	   */
	  function noConflict() {
	    window._ = oldDash;
	    return this;
	  }
	
	  /**
	   * Produces a random number between `min` and `max` (inclusive). If only one
	   * argument is passed, a number between `0` and the given number will be returned.
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @param {Number} [min=0] The minimum possible value.
	   * @param {Number} [max=1] The maximum possible value.
	   * @returns {Number} Returns a random number.
	   * @example
	   *
	   * _.random(0, 5);
	   * // => a number between 0 and 5
	   *
	   * _.random(5);
	   * // => also a number between 0 and 5
	   */
	  function random(min, max) {
	    if (min == null && max == null) {
	      max = 1;
	    }
	    min = +min || 0;
	    if (max == null) {
	      max = min;
	      min = 0;
	    }
	    return min + floor(nativeRandom() * ((+max || 0) - min + 1));
	  }
	
	  /**
	   * Resolves the value of `property` on `object`. If `property` is a function,
	   * it will be invoked and its result returned, else the property value is
	   * returned. If `object` is falsey, then `null` is returned.
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @param {Object} object The object to inspect.
	   * @param {String} property The property to get the value of.
	   * @returns {Mixed} Returns the resolved value.
	   * @example
	   *
	   * var object = {
	   *   'cheese': 'crumpets',
	   *   'stuff': function() {
	   *     return 'nonsense';
	   *   }
	   * };
	   *
	   * _.result(object, 'cheese');
	   * // => 'crumpets'
	   *
	   * _.result(object, 'stuff');
	   * // => 'nonsense'
	   */
	  function result(object, property) {
	    var value = object ? object[property] : undefined;
	    return isFunction(value) ? object[property]() : value;
	  }
	
	  /**
	   * A micro-templating method that handles arbitrary delimiters, preserves
	   * whitespace, and correctly escapes quotes within interpolated code.
	   *
	   * Note: In the development build, `_.template` utilizes sourceURLs for easier
	   * debugging. See http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
	   *
	   * Note: Lo-Dash may be used in Chrome extensions by either creating a `lodash csp`
	   * build and using precompiled templates, or loading Lo-Dash in a sandbox.
	   *
	   * For more information on precompiling templates see:
	   * http://lodash.com/#custom-builds
	   *
	   * For more information on Chrome extension sandboxes see:
	   * http://developer.chrome.com/stable/extensions/sandboxingEval.html
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @param {String} text The template text.
	   * @param {Obect} data The data object used to populate the text.
	   * @param {Object} options The options object.
	   *  escape - The "escape" delimiter regexp.
	   *  evaluate - The "evaluate" delimiter regexp.
	   *  interpolate - The "interpolate" delimiter regexp.
	   *  sourceURL - The sourceURL of the template's compiled source.
	   *  variable - The data object variable name.
	   *
	   * @returns {Function|String} Returns a compiled function when no `data` object
	   *  is given, else it returns the interpolated text.
	   * @example
	   *
	   * // using a compiled template
	   * var compiled = _.template('hello <%= name %>');
	   * compiled({ 'name': 'moe' });
	   * // => 'hello moe'
	   *
	   * var list = '<% _.forEach(people, function(name) { %><li><%= name %></li><% }); %>';
	   * _.template(list, { 'people': ['moe', 'larry'] });
	   * // => '<li>moe</li><li>larry</li>'
	   *
	   * // using the "escape" delimiter to escape HTML in data property values
	   * _.template('<b><%- value %></b>', { 'value': '<script>' });
	   * // => '<b>&lt;script&gt;</b>'
	   *
	   * // using the ES6 delimiter as an alternative to the default "interpolate" delimiter
	   * _.template('hello ${ name }', { 'name': 'curly' });
	   * // => 'hello curly'
	   *
	   * // using the internal `print` function in "evaluate" delimiters
	   * _.template('<% print("hello " + epithet); %>!', { 'epithet': 'stooge' });
	   * // => 'hello stooge!'
	   *
	   * // using custom template delimiters
	   * _.templateSettings = {
	   *   'interpolate': /{{([\s\S]+?)}}/g
	   * };
	   *
	   * _.template('hello {{ name }}!', { 'name': 'mustache' });
	   * // => 'hello mustache!'
	   *
	   * // using the `sourceURL` option to specify a custom sourceURL for the template
	   * var compiled = _.template('hello <%= name %>', null, { 'sourceURL': '/basic/greeting.jst' });
	   * compiled(data);
	   * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
	   *
	   * // using the `variable` option to ensure a with-statement isn't used in the compiled template
	   * var compiled = _.template('hi <%= data.name %>!', null, { 'variable': 'data' });
	   * compiled.source;
	   * // => function(data) {
	   *   var __t, __p = '', __e = _.escape;
	   *   __p += 'hi ' + ((__t = ( data.name )) == null ? '' : __t) + '!';
	   *   return __p;
	   * }
	   *
	   * // using the `source` property to inline compiled templates for meaningful
	   * // line numbers in error messages and a stack trace
	   * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
	   *   var JST = {\
	   *     "main": ' + _.template(mainText).source + '\
	   *   };\
	   * ');
	   */
	  function template(text, data, options) {
	    // based on John Resig's `tmpl` implementation
	    // http://ejohn.org/blog/javascript-micro-templating/
	    // and Laura Doktorova's doT.js
	    // https://github.com/olado/doT
	    var settings = lodash.templateSettings;
	    text || (text = '');
	
	    // avoid missing dependencies when `iteratorTemplate` is not defined
	    options = defaults({}, options, settings);
	
	    var imports = defaults({}, options.imports, settings.imports),
	        importsKeys = keys(imports),
	        importsValues = values(imports);
	
	    var isEvaluating,
	        index = 0,
	        interpolate = options.interpolate || reNoMatch,
	        source = "__p += '";
	
	    // compile regexp to match each delimiter
	    var reDelimiters = RegExp(
	      (options.escape || reNoMatch).source + '|' +
	      interpolate.source + '|' +
	      (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	      (options.evaluate || reNoMatch).source + '|$'
	    , 'g');
	
	    text.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	      interpolateValue || (interpolateValue = esTemplateValue);
	
	      // escape characters that cannot be included in string literals
	      source += text.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	      // replace delimiters with snippets
	      if (escapeValue) {
	        source += "' +\n__e(" + escapeValue + ") +\n'";
	      }
	      if (evaluateValue) {
	        isEvaluating = true;
	        source += "';\n" + evaluateValue + ";\n__p += '";
	      }
	      if (interpolateValue) {
	        source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	      }
	      index = offset + match.length;
	
	      // the JS engine embedded in Adobe products requires returning the `match`
	      // string in order to produce the correct `offset` value
	      return match;
	    });
	
	    source += "';\n";
	
	    // if `variable` is not specified and the template contains "evaluate"
	    // delimiters, wrap a with-statement around the generated code to add the
	    // data object to the top of the scope chain
	    var variable = options.variable,
	        hasVariable = variable;
	
	    if (!hasVariable) {
	      variable = 'obj';
	      source = 'with (' + variable + ') {\n' + source + '\n}\n';
	    }
	    // cleanup code by stripping empty strings
	    source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	      .replace(reEmptyStringMiddle, '$1')
	      .replace(reEmptyStringTrailing, '$1;');
	
	    // frame code as the function body
	    source = 'function(' + variable + ') {\n' +
	      (hasVariable ? '' : variable + ' || (' + variable + ' = {});\n') +
	      "var __t, __p = '', __e = _.escape" +
	      (isEvaluating
	        ? ', __j = Array.prototype.join;\n' +
	          "function print() { __p += __j.call(arguments, '') }\n"
	        : ';\n'
	      ) +
	      source +
	      'return __p\n}';
	
	    // Use a sourceURL for easier debugging and wrap in a multi-line comment to
	    // avoid issues with Narwhal, IE conditional compilation, and the JS engine
	    // embedded in Adobe products.
	    // http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl
	    var sourceURL = '\n/*\n//@ sourceURL=' + (options.sourceURL || '/lodash/template/source[' + (templateCounter++) + ']') + '\n*/';
	
	    try {
	      var result = Function(importsKeys, 'return ' + source + sourceURL).apply(undefined, importsValues);
	    } catch(e) {
	      e.source = source;
	      throw e;
	    }
	    if (data) {
	      return result(data);
	    }
	    // provide the compiled function's source via its `toString` method, in
	    // supported environments, or the `source` property as a convenience for
	    // inlining compiled templates during the build process
	    result.source = source;
	    return result;
	  }
	
	  /**
	   * Executes the `callback` function `n` times, returning an array of the results
	   * of each `callback` execution. The `callback` is bound to `thisArg` and invoked
	   * with one argument; (index).
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @param {Number} n The number of times to execute the callback.
	   * @param {Function} callback The function called per iteration.
	   * @param {Mixed} [thisArg] The `this` binding of `callback`.
	   * @returns {Array} Returns a new array of the results of each `callback` execution.
	   * @example
	   *
	   * var diceRolls = _.times(3, _.partial(_.random, 1, 6));
	   * // => [3, 6, 4]
	   *
	   * _.times(3, function(n) { mage.castSpell(n); });
	   * // => calls `mage.castSpell(n)` three times, passing `n` of `0`, `1`, and `2` respectively
	   *
	   * _.times(3, function(n) { this.cast(n); }, mage);
	   * // => also calls `mage.castSpell(n)` three times
	   */
	  function times(n, callback, thisArg) {
	    n = +n || 0;
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = callback.call(thisArg, index);
	    }
	    return result;
	  }
	
	  /**
	   * The opposite of `_.escape`, this method converts the HTML entities
	   * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to their
	   * corresponding characters.
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @param {String} string The string to unescape.
	   * @returns {String} Returns the unescaped string.
	   * @example
	   *
	   * _.unescape('Moe, Larry &amp; Curly');
	   * // => 'Moe, Larry & Curly'
	   */
	  function unescape(string) {
	    return string == null ? '' : (string + '').replace(reEscapedHtml, unescapeHtmlChar);
	  }
	
	  /**
	   * Generates a unique ID. If `prefix` is passed, the ID will be appended to it.
	   *
	   * @static
	   * @memberOf _
	   * @category Utilities
	   * @param {String} [prefix] The value to prefix the ID with.
	   * @returns {String} Returns the unique ID.
	   * @example
	   *
	   * _.uniqueId('contact_');
	   * // => 'contact_104'
	   *
	   * _.uniqueId();
	   * // => '105'
	   */
	  function uniqueId(prefix) {
	    var id = ++idCounter;
	    return (prefix == null ? '' : prefix + '') + id;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Invokes `interceptor` with the `value` as the first argument, and then
	   * returns `value`. The purpose of this method is to "tap into" a method chain,
	   * in order to perform operations on intermediate results within the chain.
	   *
	   * @static
	   * @memberOf _
	   * @category Chaining
	   * @param {Mixed} value The value to pass to `interceptor`.
	   * @param {Function} interceptor The function to invoke.
	   * @returns {Mixed} Returns `value`.
	   * @example
	   *
	   * _([1, 2, 3, 4])
	   *  .filter(function(num) { return num % 2 == 0; })
	   *  .tap(alert)
	   *  .map(function(num) { return num * num; })
	   *  .value();
	   * // => // [2, 4] (alerted)
	   * // => [4, 16]
	   */
	  function tap(value, interceptor) {
	    interceptor(value);
	    return value;
	  }
	
	  /**
	   * Produces the `toString` result of the wrapped value.
	   *
	   * @name toString
	   * @memberOf _
	   * @category Chaining
	   * @returns {String} Returns the string result.
	   * @example
	   *
	   * _([1, 2, 3]).toString();
	   * // => '1,2,3'
	   */
	  function wrapperToString() {
	    return this.__wrapped__ + '';
	  }
	
	  /**
	   * Extracts the wrapped value.
	   *
	   * @name valueOf
	   * @memberOf _
	   * @alias value
	   * @category Chaining
	   * @returns {Mixed} Returns the wrapped value.
	   * @example
	   *
	   * _([1, 2, 3]).valueOf();
	   * // => [1, 2, 3]
	   */
	  function wrapperValueOf() {
	    return this.__wrapped__;
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // add functions that return wrapped values when chaining
	  lodash.after = after;
	  lodash.assign = assign;
	  lodash.at = at;
	  lodash.bind = bind;
	  lodash.bindAll = bindAll;
	  lodash.bindKey = bindKey;
	  lodash.compact = compact;
	  lodash.compose = compose;
	  lodash.countBy = countBy;
	  lodash.debounce = debounce;
	  lodash.defaults = defaults;
	  lodash.defer = defer;
	  lodash.delay = delay;
	  lodash.difference = difference;
	  lodash.filter = filter;
	  lodash.flatten = flatten;
	  lodash.forEach = forEach;
	  lodash.forIn = forIn;
	  lodash.forOwn = forOwn;
	  lodash.functions = functions;
	  lodash.groupBy = groupBy;
	  lodash.initial = initial;
	  lodash.intersection = intersection;
	  lodash.invert = invert;
	  lodash.invoke = invoke;
	  lodash.keys = keys;
	  lodash.map = map;
	  lodash.max = max;
	  lodash.memoize = memoize;
	  lodash.merge = merge;
	  lodash.min = min;
	  lodash.object = object;
	  lodash.omit = omit;
	  lodash.once = once;
	  lodash.pairs = pairs;
	  lodash.partial = partial;
	  lodash.partialRight = partialRight;
	  lodash.pick = pick;
	  lodash.pluck = pluck;
	  lodash.range = range;
	  lodash.reject = reject;
	  lodash.rest = rest;
	  lodash.shuffle = shuffle;
	  lodash.sortBy = sortBy;
	  lodash.tap = tap;
	  lodash.throttle = throttle;
	  lodash.times = times;
	  lodash.toArray = toArray;
	  lodash.union = union;
	  lodash.uniq = uniq;
	  lodash.values = values;
	  lodash.where = where;
	  lodash.without = without;
	  lodash.wrap = wrap;
	  lodash.zip = zip;
	
	  // add aliases
	  lodash.collect = map;
	  lodash.drop = rest;
	  lodash.each = forEach;
	  lodash.extend = assign;
	  lodash.methods = functions;
	  lodash.select = filter;
	  lodash.tail = rest;
	  lodash.unique = uniq;
	
	  // add functions to `lodash.prototype`
	  mixin(lodash);
	
	  /*--------------------------------------------------------------------------*/
	
	  // add functions that return unwrapped values when chaining
	  lodash.clone = clone;
	  lodash.cloneDeep = cloneDeep;
	  lodash.contains = contains;
	  lodash.escape = escape;
	  lodash.every = every;
	  lodash.find = find;
	  lodash.has = has;
	  lodash.identity = identity;
	  lodash.indexOf = indexOf;
	  lodash.isArguments = isArguments;
	  lodash.isArray = isArray;
	  lodash.isBoolean = isBoolean;
	  lodash.isDate = isDate;
	  lodash.isElement = isElement;
	  lodash.isEmpty = isEmpty;
	  lodash.isEqual = isEqual;
	  lodash.isFinite = isFinite;
	  lodash.isFunction = isFunction;
	  lodash.isNaN = isNaN;
	  lodash.isNull = isNull;
	  lodash.isNumber = isNumber;
	  lodash.isObject = isObject;
	  lodash.isPlainObject = isPlainObject;
	  lodash.isRegExp = isRegExp;
	  lodash.isString = isString;
	  lodash.isUndefined = isUndefined;
	  lodash.lastIndexOf = lastIndexOf;
	  lodash.mixin = mixin;
	  lodash.noConflict = noConflict;
	  lodash.random = random;
	  lodash.reduce = reduce;
	  lodash.reduceRight = reduceRight;
	  lodash.result = result;
	  lodash.size = size;
	  lodash.some = some;
	  lodash.sortedIndex = sortedIndex;
	  lodash.template = template;
	  lodash.unescape = unescape;
	  lodash.uniqueId = uniqueId;
	
	  // add aliases
	  lodash.all = every;
	  lodash.any = some;
	  lodash.detect = find;
	  lodash.foldl = reduce;
	  lodash.foldr = reduceRight;
	  lodash.include = contains;
	  lodash.inject = reduce;
	
	  forOwn(lodash, function(func, methodName) {
	    if (!lodash.prototype[methodName]) {
	      lodash.prototype[methodName] = function() {
	        var args = [this.__wrapped__];
	        push.apply(args, arguments);
	        return func.apply(lodash, args);
	      };
	    }
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // add functions capable of returning wrapped and unwrapped values when chaining
	  lodash.first = first;
	  lodash.last = last;
	
	  // add aliases
	  lodash.take = first;
	  lodash.head = first;
	
	  forOwn(lodash, function(func, methodName) {
	    if (!lodash.prototype[methodName]) {
	      lodash.prototype[methodName]= function(callback, thisArg) {
	        var result = func(this.__wrapped__, callback, thisArg);
	        return callback == null || (thisArg && typeof callback != 'function')
	          ? result
	          : new lodash(result);
	      };
	    }
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * The semantic version number.
	   *
	   * @static
	   * @memberOf _
	   * @type String
	   */
	  lodash.VERSION = '1.0.2';
	
	  // add "Chaining" functions to the wrapper
	  lodash.prototype.toString = wrapperToString;
	  lodash.prototype.value = wrapperValueOf;
	  lodash.prototype.valueOf = wrapperValueOf;
	
	  // add `Array` functions that return unwrapped values
	  each(['join', 'pop', 'shift'], function(methodName) {
	    var func = arrayRef[methodName];
	    lodash.prototype[methodName] = function() {
	      return func.apply(this.__wrapped__, arguments);
	    };
	  });
	
	  // add `Array` functions that return the wrapped value
	  each(['push', 'reverse', 'sort', 'unshift'], function(methodName) {
	    var func = arrayRef[methodName];
	    lodash.prototype[methodName] = function() {
	      func.apply(this.__wrapped__, arguments);
	      return this;
	    };
	  });
	
	  // add `Array` functions that return new wrapped values
	  each(['concat', 'slice', 'splice'], function(methodName) {
	    var func = arrayRef[methodName];
	    lodash.prototype[methodName] = function() {
	      return new lodash(func.apply(this.__wrapped__, arguments));
	    };
	  });
	
	  // avoid array-like object bugs with `Array#shift` and `Array#splice`
	  // in Firefox < 10 and IE < 9
	  if (hasObjectSpliceBug) {
	    each(['pop', 'shift', 'splice'], function(methodName) {
	      var func = arrayRef[methodName],
	          isSplice = methodName == 'splice';
	
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            result = func.apply(value, arguments);
	
	        if (value.length === 0) {
	          delete value[0];
	        }
	        return isSplice ? new lodash(result) : result;
	      };
	    });
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  // expose Lo-Dash
	  // some AMD build optimizers, like r.js, check for specific condition patterns like the following:
	  if (true) {
	    // Expose Lo-Dash to the global object even when an AMD loader is present in
	    // case Lo-Dash was injected by a third-party script and not intended to be
	    // loaded as a module. The global assignment can be reverted in the Lo-Dash
	    // module via its `noConflict()` method.
	    window._ = lodash;
	
	    // define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return lodash;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // check for `exports` after `define` in case a build optimizer adds an `exports` object
	  else if (freeExports) {
	    // in Node.js or RingoJS v0.8.0+
	    if (freeModule) {
	      (freeModule.exports = lodash)._ = lodash;
	    }
	    // in Narwhal or RingoJS v0.7.0-
	    else {
	      freeExports._ = lodash;
	    }
	  }
	  else {
	    // in a browser or Rhino
	    window._ = lodash;
	  }
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(126)(module), (function() { return this; }()), __webpack_require__(127).setImmediate))

/***/ },
/* 126 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(128).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(127).setImmediate, __webpack_require__(127).clearImmediate))

/***/ },
/* 128 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var lodash_1 = __webpack_require__(125);
	var LaunchClientOptions = (function () {
	    function LaunchClientOptions() {
	    }
	    LaunchClientOptions.get = function () {
	        var uri = neo_common_1.Utils.getURIQuery();
	        var gameServer = uri['gameServer'];
	        var customerCode = uri['customerCode'];
	        var channelCode = uri['channelCode'];
	        var gameCode = uri['gameCode'];
	        var operationCode = uri['operationCode'];
	        var error = false;
	        if (neo_common_1.StringUtils.isNullOrEmpty(gameServer)) {
	            neo_common_1.Logger.errorGroup('LaunchClient', 'Missing query string parameter "gameServer" !');
	            error = true;
	        }
	        if (neo_common_1.StringUtils.isNullOrEmpty(customerCode)) {
	            neo_common_1.Logger.errorGroup('LaunchClient', 'Missing query string parameter "customerCode" !');
	            error = true;
	        }
	        if (neo_common_1.StringUtils.isNullOrEmpty(channelCode)) {
	            neo_common_1.Logger.errorGroup('LaunchClient', 'Missing query string parameter "channelCode" !');
	            error = true;
	        }
	        if (neo_common_1.StringUtils.isNullOrEmpty(gameCode)) {
	            neo_common_1.Logger.errorGroup('LaunchClient', 'Missing query string parameter "gameCode" !');
	            error = true;
	        }
	        if (neo_common_1.StringUtils.isNullOrEmpty(operationCode)) {
	            neo_common_1.Logger.errorGroup('LaunchClient', 'Missing query string parameter "operationCode" !');
	            error = true;
	        }
	        if (error) {
	            return null;
	        }
	        var options = new LaunchClientOptions();
	        options.gameServer = gameServer;
	        options.launchServiceParams = lodash_1.omit(uri, ['gameServer']);
	        return options;
	    };
	    return LaunchClientOptions;
	}());
	exports.LaunchClientOptions = LaunchClientOptions;


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var lodash_1 = __webpack_require__(125);
	var neo_common_1 = __webpack_require__(1);
	var LaunchClientResponse_1 = __webpack_require__(131);
	var LaunchClientRequest = (function (_super) {
	    __extends(LaunchClientRequest, _super);
	    function LaunchClientRequest(params) {
	        _super.call(this);
	        lodash_1.assign(this, params);
	    }
	    LaunchClientRequest.prototype.createResponse = function (responseJson) {
	        return new LaunchClientResponse_1.LaunchClientResponse(responseJson);
	    };
	    return LaunchClientRequest;
	}(neo_common_1.ApiClientCommunication.RequestBase));
	exports.LaunchClientRequest = LaunchClientRequest;


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var neo_common_1 = __webpack_require__(1);
	(function (LaunchAction) {
	    LaunchAction[LaunchAction["Allow"] = 'allow'] = "Allow";
	    LaunchAction[LaunchAction["Warning"] = 'warning'] = "Warning";
	    LaunchAction[LaunchAction["Deny"] = 'deny'] = "Deny";
	})(exports.LaunchAction || (exports.LaunchAction = {}));
	var LaunchAction = exports.LaunchAction;
	var LaunchClientResponse = (function (_super) {
	    __extends(LaunchClientResponse, _super);
	    function LaunchClientResponse() {
	        _super.apply(this, arguments);
	    }
	    LaunchClientResponse.prototype.internalValidate = function (errors) {
	    };
	    return LaunchClientResponse;
	}(neo_common_1.ApiClientCommunication.ResponseBase));
	exports.LaunchClientResponse = LaunchClientResponse;


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var RealityCheckFactory_1 = __webpack_require__(25);
	exports.RealityCheckFactory = RealityCheckFactory_1.RealityCheckFactory;
	exports.registerRealityCheck = RealityCheckFactory_1.registerRealityCheck;
	var DefaultRealityCheck_1 = __webpack_require__(133);
	exports.DefaultRealityCheck = DefaultRealityCheck_1.DefaultRealityCheck;
	var RealityCheckBase_1 = __webpack_require__(134);
	exports.RealityCheckBase = RealityCheckBase_1.RealityCheckBase;


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var neo_common_1 = __webpack_require__(1);
	var Types_1 = __webpack_require__(7);
	var RealityCheckBase_1 = __webpack_require__(134);
	var RealityCheckFactory_1 = __webpack_require__(25);
	var DefaultInterval = 300;
	var loggerName = 'DefaultRealityCheck';
	var typeName = 'Default';
	var DefaultRealityCheck = (function (_super) {
	    __extends(DefaultRealityCheck, _super);
	    function DefaultRealityCheck() {
	        _super.apply(this, arguments);
	    }
	    Object.defineProperty(DefaultRealityCheck.prototype, "name", {
	        get: function () {
	            return 'Default';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultRealityCheck.prototype, "version", {
	        get: function () {
	            return '1.0';
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DefaultRealityCheck.prototype, "loggerName", {
	        get: function () {
	            return loggerName;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DefaultRealityCheck.prototype.doInitialize = function () {
	        this._interval = this._gameConfiguration.RealityCheckInterval;
	        if (this._interval <= 0) {
	            if (false) {
	                neo_common_1.Logger.debugGroup(loggerName, ("'RealityCheckInterval' has invalid value (" + this._interval + "), ") +
	                    ("changed to default value (" + DefaultInterval + ")."));
	            }
	            this._interval = DefaultInterval;
	        }
	        this._startInterval = this._gameConfiguration.RealityCheckStartInterval;
	        if (this._startInterval <= 0) {
	            if (false) {
	                neo_common_1.Logger.debugGroup(loggerName, ("'RealityCheckStartInterval' has invalid value (" + this._startInterval + "), ") +
	                    ("changed to interval value (" + this._interval + ")."));
	            }
	            this._startInterval = this._interval;
	        }
	        this._startTime = new Date(new Date().getTime());
	        this._timerHandle = undefined;
	        this.handleTimer = this.handleTimer.bind(this);
	    };
	    DefaultRealityCheck.prototype.start = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup(loggerName, "Starting reality check, 1st dialog will shows after " + this._startInterval + " seconds from now");
	        }
	        this._timerData = {
	            exit: !neo_common_1.StringUtils.isNullOrEmpty(this._gameConfiguration.ExitUrl),
	            history: !neo_common_1.StringUtils.isNullOrEmpty(this._gameConfiguration.HistoryUrl),
	            continue: true,
	            startTime: this._startTime,
	            interval: this._interval
	        };
	        this.resetTimer(this._startInterval);
	    };
	    DefaultRealityCheck.prototype.reset = function () {
	        if (false) {
	            neo_common_1.Logger.debugGroup(loggerName, "Restarting reality check, dialog will shows after " + this._interval + " seconds from now");
	        }
	        this.resetTimer(this._interval);
	    };
	    DefaultRealityCheck.prototype.resetTimer = function (interval) {
	        this.clearTimer();
	        this._timerHandle = setTimeout(this.handleTimer, interval * 1000);
	    };
	    DefaultRealityCheck.prototype.clearTimer = function () {
	        if (this._timerHandle) {
	            clearTimeout(this._timerHandle);
	            this._timerHandle = undefined;
	        }
	    };
	    DefaultRealityCheck.prototype.handleTimer = function () {
	        this.clearTimer();
	        var request = {
	            type: Types_1.ClientHostDialogType.Responsible1,
	            text: '',
	            error: null,
	            data: this._timerData
	        };
	        this.invokeTimerExpired(request);
	    };
	    DefaultRealityCheck = __decorate([
	        RealityCheckFactory_1.registerRealityCheck(typeName)
	    ], DefaultRealityCheck);
	    return DefaultRealityCheck;
	}(RealityCheckBase_1.RealityCheckBase));
	exports.DefaultRealityCheck = DefaultRealityCheck;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var neo_common_1 = __webpack_require__(1);
	var RealityCheckBase = (function () {
	    function RealityCheckBase() {
	        this._initialized = false;
	    }
	    RealityCheckBase.prototype.initialize = function (app, timerExpiredCallback) {
	        if (!this._initialized) {
	            neo_common_1.ArgValidator.ensureIsNotNullOrUndefined(timerExpiredCallback, 'timerExpiredCallback');
	            this._app = app;
	            this._gameConfiguration = app.gameConfiguration;
	            this._timerExpiredCallback = timerExpiredCallback;
	            this.doInitialize();
	            this._initialized = true;
	        }
	    };
	    Object.defineProperty(RealityCheckBase.prototype, "loggerName", {
	        get: function () { },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RealityCheckBase.prototype, "name", {
	        get: function () { },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RealityCheckBase.prototype, "version", {
	        get: function () { },
	        enumerable: true,
	        configurable: true
	    });
	    RealityCheckBase.prototype.invokeTimerExpired = function (request) {
	        if (false) {
	            neo_common_1.Logger.debugGroup(this.loggerName, "Timer interval elapsed");
	        }
	        this._timerExpiredCallback(request);
	    };
	    return RealityCheckBase;
	}());
	exports.RealityCheckBase = RealityCheckBase;


/***/ }
/******/ ])
});
;


/** WEBPACK FOOTER **
 ** ./wwwroot/scripts/neo-games.min.js
 **/